// Auto-generated file - Do not edit manually
// Generated on 2025-12-24T11:53:33.212Z

export const ICON_STYLES = {
    FILLED: 'filled',
    OUTLINE: 'outline'
};

export const FILLED_ICONS = [
  {
    "name": "accessible",
    "label": "Accessible",
    "path": "accessible.svg"
  },
  {
    "name": "ad",
    "label": "Ad",
    "path": "ad.svg"
  },
  {
    "name": "ad-circle",
    "label": "Ad Circle",
    "path": "ad-circle.svg"
  },
  {
    "name": "adjustments",
    "label": "Adjustments",
    "path": "adjustments.svg"
  },
  {
    "name": "aerial-lift",
    "label": "Aerial Lift",
    "path": "aerial-lift.svg"
  },
  {
    "name": "affiliate",
    "label": "Affiliate",
    "path": "affiliate.svg"
  },
  {
    "name": "air-balloon",
    "label": "Air Balloon",
    "path": "air-balloon.svg"
  },
  {
    "name": "alarm",
    "label": "Alarm",
    "path": "alarm.svg"
  },
  {
    "name": "alarm-minus",
    "label": "Alarm Minus",
    "path": "alarm-minus.svg"
  },
  {
    "name": "alarm-plus",
    "label": "Alarm Plus",
    "path": "alarm-plus.svg"
  },
  {
    "name": "alarm-snooze",
    "label": "Alarm Snooze",
    "path": "alarm-snooze.svg"
  },
  {
    "name": "alert-circle",
    "label": "Alert Circle",
    "path": "alert-circle.svg"
  },
  {
    "name": "alert-hexagon",
    "label": "Alert Hexagon",
    "path": "alert-hexagon.svg"
  },
  {
    "name": "alert-octagon",
    "label": "Alert Octagon",
    "path": "alert-octagon.svg"
  },
  {
    "name": "alert-square",
    "label": "Alert Square",
    "path": "alert-square.svg"
  },
  {
    "name": "alert-square-rounded",
    "label": "Alert Square Rounded",
    "path": "alert-square-rounded.svg"
  },
  {
    "name": "alert-triangle",
    "label": "Alert Triangle",
    "path": "alert-triangle.svg"
  },
  {
    "name": "alien",
    "label": "Alien",
    "path": "alien.svg"
  },
  {
    "name": "align-box-bottom-center",
    "label": "Align Box Bottom Center",
    "path": "align-box-bottom-center.svg"
  },
  {
    "name": "align-box-bottom-left",
    "label": "Align Box Bottom Left",
    "path": "align-box-bottom-left.svg"
  },
  {
    "name": "align-box-bottom-right",
    "label": "Align Box Bottom Right",
    "path": "align-box-bottom-right.svg"
  },
  {
    "name": "align-box-center-middle",
    "label": "Align Box Center Middle",
    "path": "align-box-center-middle.svg"
  },
  {
    "name": "align-box-left-bottom",
    "label": "Align Box Left Bottom",
    "path": "align-box-left-bottom.svg"
  },
  {
    "name": "align-box-left-middle",
    "label": "Align Box Left Middle",
    "path": "align-box-left-middle.svg"
  },
  {
    "name": "align-box-left-top",
    "label": "Align Box Left Top",
    "path": "align-box-left-top.svg"
  },
  {
    "name": "align-box-right-bottom",
    "label": "Align Box Right Bottom",
    "path": "align-box-right-bottom.svg"
  },
  {
    "name": "align-box-right-middle",
    "label": "Align Box Right Middle",
    "path": "align-box-right-middle.svg"
  },
  {
    "name": "align-box-right-top",
    "label": "Align Box Right Top",
    "path": "align-box-right-top.svg"
  },
  {
    "name": "align-box-top-center",
    "label": "Align Box Top Center",
    "path": "align-box-top-center.svg"
  },
  {
    "name": "align-box-top-left",
    "label": "Align Box Top Left",
    "path": "align-box-top-left.svg"
  },
  {
    "name": "align-box-top-right",
    "label": "Align Box Top Right",
    "path": "align-box-top-right.svg"
  },
  {
    "name": "analyze",
    "label": "Analyze",
    "path": "analyze.svg"
  },
  {
    "name": "app-window",
    "label": "App Window",
    "path": "app-window.svg"
  },
  {
    "name": "apple",
    "label": "Apple",
    "path": "apple.svg"
  },
  {
    "name": "apps",
    "label": "Apps",
    "path": "apps.svg"
  },
  {
    "name": "archive",
    "label": "Archive",
    "path": "archive.svg"
  },
  {
    "name": "arrow-autofit-content",
    "label": "Arrow Autofit Content",
    "path": "arrow-autofit-content.svg"
  },
  {
    "name": "arrow-autofit-down",
    "label": "Arrow Autofit Down",
    "path": "arrow-autofit-down.svg"
  },
  {
    "name": "arrow-autofit-height",
    "label": "Arrow Autofit Height",
    "path": "arrow-autofit-height.svg"
  },
  {
    "name": "arrow-autofit-left",
    "label": "Arrow Autofit Left",
    "path": "arrow-autofit-left.svg"
  },
  {
    "name": "arrow-autofit-right",
    "label": "Arrow Autofit Right",
    "path": "arrow-autofit-right.svg"
  },
  {
    "name": "arrow-autofit-up",
    "label": "Arrow Autofit Up",
    "path": "arrow-autofit-up.svg"
  },
  {
    "name": "arrow-autofit-width",
    "label": "Arrow Autofit Width",
    "path": "arrow-autofit-width.svg"
  },
  {
    "name": "arrow-badge-down",
    "label": "Arrow Badge Down",
    "path": "arrow-badge-down.svg"
  },
  {
    "name": "arrow-badge-left",
    "label": "Arrow Badge Left",
    "path": "arrow-badge-left.svg"
  },
  {
    "name": "arrow-badge-right",
    "label": "Arrow Badge Right",
    "path": "arrow-badge-right.svg"
  },
  {
    "name": "arrow-badge-up",
    "label": "Arrow Badge Up",
    "path": "arrow-badge-up.svg"
  },
  {
    "name": "arrow-big-down",
    "label": "Arrow Big Down",
    "path": "arrow-big-down.svg"
  },
  {
    "name": "arrow-big-down-line",
    "label": "Arrow Big Down Line",
    "path": "arrow-big-down-line.svg"
  },
  {
    "name": "arrow-big-down-lines",
    "label": "Arrow Big Down Lines",
    "path": "arrow-big-down-lines.svg"
  },
  {
    "name": "arrow-big-left",
    "label": "Arrow Big Left",
    "path": "arrow-big-left.svg"
  },
  {
    "name": "arrow-big-left-line",
    "label": "Arrow Big Left Line",
    "path": "arrow-big-left-line.svg"
  },
  {
    "name": "arrow-big-left-lines",
    "label": "Arrow Big Left Lines",
    "path": "arrow-big-left-lines.svg"
  },
  {
    "name": "arrow-big-right",
    "label": "Arrow Big Right",
    "path": "arrow-big-right.svg"
  },
  {
    "name": "arrow-big-right-line",
    "label": "Arrow Big Right Line",
    "path": "arrow-big-right-line.svg"
  },
  {
    "name": "arrow-big-right-lines",
    "label": "Arrow Big Right Lines",
    "path": "arrow-big-right-lines.svg"
  },
  {
    "name": "arrow-big-up",
    "label": "Arrow Big Up",
    "path": "arrow-big-up.svg"
  },
  {
    "name": "arrow-big-up-line",
    "label": "Arrow Big Up Line",
    "path": "arrow-big-up-line.svg"
  },
  {
    "name": "arrow-big-up-lines",
    "label": "Arrow Big Up Lines",
    "path": "arrow-big-up-lines.svg"
  },
  {
    "name": "arrow-down-circle",
    "label": "Arrow Down Circle",
    "path": "arrow-down-circle.svg"
  },
  {
    "name": "arrow-down-rhombus",
    "label": "Arrow Down Rhombus",
    "path": "arrow-down-rhombus.svg"
  },
  {
    "name": "arrow-down-square",
    "label": "Arrow Down Square",
    "path": "arrow-down-square.svg"
  },
  {
    "name": "arrow-guide",
    "label": "Arrow Guide",
    "path": "arrow-guide.svg"
  },
  {
    "name": "arrow-left-circle",
    "label": "Arrow Left Circle",
    "path": "arrow-left-circle.svg"
  },
  {
    "name": "arrow-left-rhombus",
    "label": "Arrow Left Rhombus",
    "path": "arrow-left-rhombus.svg"
  },
  {
    "name": "arrow-left-square",
    "label": "Arrow Left Square",
    "path": "arrow-left-square.svg"
  },
  {
    "name": "arrow-move-down",
    "label": "Arrow Move Down",
    "path": "arrow-move-down.svg"
  },
  {
    "name": "arrow-move-left",
    "label": "Arrow Move Left",
    "path": "arrow-move-left.svg"
  },
  {
    "name": "arrow-move-right",
    "label": "Arrow Move Right",
    "path": "arrow-move-right.svg"
  },
  {
    "name": "arrow-move-up",
    "label": "Arrow Move Up",
    "path": "arrow-move-up.svg"
  },
  {
    "name": "arrow-right-circle",
    "label": "Arrow Right Circle",
    "path": "arrow-right-circle.svg"
  },
  {
    "name": "arrow-right-rhombus",
    "label": "Arrow Right Rhombus",
    "path": "arrow-right-rhombus.svg"
  },
  {
    "name": "arrow-right-square",
    "label": "Arrow Right Square",
    "path": "arrow-right-square.svg"
  },
  {
    "name": "arrow-up-circle",
    "label": "Arrow Up Circle",
    "path": "arrow-up-circle.svg"
  },
  {
    "name": "arrow-up-rhombus",
    "label": "Arrow Up Rhombus",
    "path": "arrow-up-rhombus.svg"
  },
  {
    "name": "arrow-up-square",
    "label": "Arrow Up Square",
    "path": "arrow-up-square.svg"
  },
  {
    "name": "artboard",
    "label": "Artboard",
    "path": "artboard.svg"
  },
  {
    "name": "article",
    "label": "Article",
    "path": "article.svg"
  },
  {
    "name": "aspect-ratio",
    "label": "Aspect Ratio",
    "path": "aspect-ratio.svg"
  },
  {
    "name": "assembly",
    "label": "Assembly",
    "path": "assembly.svg"
  },
  {
    "name": "asset",
    "label": "Asset",
    "path": "asset.svg"
  },
  {
    "name": "atom-2",
    "label": "Atom 2",
    "path": "atom-2.svg"
  },
  {
    "name": "automatic-gearbox",
    "label": "Automatic Gearbox",
    "path": "automatic-gearbox.svg"
  },
  {
    "name": "award",
    "label": "Award",
    "path": "award.svg"
  },
  {
    "name": "baby-carriage",
    "label": "Baby Carriage",
    "path": "baby-carriage.svg"
  },
  {
    "name": "backspace",
    "label": "Backspace",
    "path": "backspace.svg"
  },
  {
    "name": "badge",
    "label": "Badge",
    "path": "badge.svg"
  },
  {
    "name": "badge-3d",
    "label": "Badge 3d",
    "path": "badge-3d.svg"
  },
  {
    "name": "badge-4k",
    "label": "Badge 4k",
    "path": "badge-4k.svg"
  },
  {
    "name": "badge-8k",
    "label": "Badge 8k",
    "path": "badge-8k.svg"
  },
  {
    "name": "badge-ad",
    "label": "Badge Ad",
    "path": "badge-ad.svg"
  },
  {
    "name": "badge-ar",
    "label": "Badge Ar",
    "path": "badge-ar.svg"
  },
  {
    "name": "badge-cc",
    "label": "Badge Cc",
    "path": "badge-cc.svg"
  },
  {
    "name": "badge-hd",
    "label": "Badge Hd",
    "path": "badge-hd.svg"
  },
  {
    "name": "badge-sd",
    "label": "Badge Sd",
    "path": "badge-sd.svg"
  },
  {
    "name": "badge-tm",
    "label": "Badge Tm",
    "path": "badge-tm.svg"
  },
  {
    "name": "badge-vo",
    "label": "Badge Vo",
    "path": "badge-vo.svg"
  },
  {
    "name": "badge-vr",
    "label": "Badge Vr",
    "path": "badge-vr.svg"
  },
  {
    "name": "badge-wc",
    "label": "Badge Wc",
    "path": "badge-wc.svg"
  },
  {
    "name": "badges",
    "label": "Badges",
    "path": "badges.svg"
  },
  {
    "name": "balloon",
    "label": "Balloon",
    "path": "balloon.svg"
  },
  {
    "name": "ballpen",
    "label": "Ballpen",
    "path": "ballpen.svg"
  },
  {
    "name": "bandage",
    "label": "Bandage",
    "path": "bandage.svg"
  },
  {
    "name": "barbell",
    "label": "Barbell",
    "path": "barbell.svg"
  },
  {
    "name": "barrier-block",
    "label": "Barrier Block",
    "path": "barrier-block.svg"
  },
  {
    "name": "basket",
    "label": "Basket",
    "path": "basket.svg"
  },
  {
    "name": "bath",
    "label": "Bath",
    "path": "bath.svg"
  },
  {
    "name": "battery",
    "label": "Battery",
    "path": "battery.svg"
  },
  {
    "name": "battery-1",
    "label": "Battery 1",
    "path": "battery-1.svg"
  },
  {
    "name": "battery-2",
    "label": "Battery 2",
    "path": "battery-2.svg"
  },
  {
    "name": "battery-3",
    "label": "Battery 3",
    "path": "battery-3.svg"
  },
  {
    "name": "battery-4",
    "label": "Battery 4",
    "path": "battery-4.svg"
  },
  {
    "name": "battery-automotive",
    "label": "Battery Automotive",
    "path": "battery-automotive.svg"
  },
  {
    "name": "battery-vertical",
    "label": "Battery Vertical",
    "path": "battery-vertical.svg"
  },
  {
    "name": "battery-vertical-1",
    "label": "Battery Vertical 1",
    "path": "battery-vertical-1.svg"
  },
  {
    "name": "battery-vertical-2",
    "label": "Battery Vertical 2",
    "path": "battery-vertical-2.svg"
  },
  {
    "name": "battery-vertical-3",
    "label": "Battery Vertical 3",
    "path": "battery-vertical-3.svg"
  },
  {
    "name": "battery-vertical-4",
    "label": "Battery Vertical 4",
    "path": "battery-vertical-4.svg"
  },
  {
    "name": "bed",
    "label": "Bed",
    "path": "bed.svg"
  },
  {
    "name": "bed-flat",
    "label": "Bed Flat",
    "path": "bed-flat.svg"
  },
  {
    "name": "beer",
    "label": "Beer",
    "path": "beer.svg"
  },
  {
    "name": "bell",
    "label": "Bell",
    "path": "bell.svg"
  },
  {
    "name": "bell-minus",
    "label": "Bell Minus",
    "path": "bell-minus.svg"
  },
  {
    "name": "bell-plus",
    "label": "Bell Plus",
    "path": "bell-plus.svg"
  },
  {
    "name": "bell-ringing",
    "label": "Bell Ringing",
    "path": "bell-ringing.svg"
  },
  {
    "name": "bell-ringing-2",
    "label": "Bell Ringing 2",
    "path": "bell-ringing-2.svg"
  },
  {
    "name": "bell-x",
    "label": "Bell X",
    "path": "bell-x.svg"
  },
  {
    "name": "bell-z",
    "label": "Bell Z",
    "path": "bell-z.svg"
  },
  {
    "name": "bike",
    "label": "Bike",
    "path": "bike.svg"
  },
  {
    "name": "binary-tree",
    "label": "Binary Tree",
    "path": "binary-tree.svg"
  },
  {
    "name": "binary-tree-2",
    "label": "Binary Tree 2",
    "path": "binary-tree-2.svg"
  },
  {
    "name": "binoculars",
    "label": "Binoculars",
    "path": "binoculars.svg"
  },
  {
    "name": "biohazard",
    "label": "Biohazard",
    "path": "biohazard.svg"
  },
  {
    "name": "blade",
    "label": "Blade",
    "path": "blade.svg"
  },
  {
    "name": "blender",
    "label": "Blender",
    "path": "blender.svg"
  },
  {
    "name": "blob",
    "label": "Blob",
    "path": "blob.svg"
  },
  {
    "name": "bolt",
    "label": "Bolt",
    "path": "bolt.svg"
  },
  {
    "name": "bomb",
    "label": "Bomb",
    "path": "bomb.svg"
  },
  {
    "name": "bone",
    "label": "Bone",
    "path": "bone.svg"
  },
  {
    "name": "bong",
    "label": "Bong",
    "path": "bong.svg"
  },
  {
    "name": "book",
    "label": "Book",
    "path": "book.svg"
  },
  {
    "name": "bookmark",
    "label": "Bookmark",
    "path": "bookmark.svg"
  },
  {
    "name": "bookmarks",
    "label": "Bookmarks",
    "path": "bookmarks.svg"
  },
  {
    "name": "boom",
    "label": "Boom",
    "path": "boom.svg"
  },
  {
    "name": "bottle",
    "label": "Bottle",
    "path": "bottle.svg"
  },
  {
    "name": "bounce-left",
    "label": "Bounce Left",
    "path": "bounce-left.svg"
  },
  {
    "name": "bounce-right",
    "label": "Bounce Right",
    "path": "bounce-right.svg"
  },
  {
    "name": "bow",
    "label": "Bow",
    "path": "bow.svg"
  },
  {
    "name": "bowl",
    "label": "Bowl",
    "path": "bowl.svg"
  },
  {
    "name": "bowl-chopsticks",
    "label": "Bowl Chopsticks",
    "path": "bowl-chopsticks.svg"
  },
  {
    "name": "bowl-spoon",
    "label": "Bowl Spoon",
    "path": "bowl-spoon.svg"
  },
  {
    "name": "box-align-bottom",
    "label": "Box Align Bottom",
    "path": "box-align-bottom.svg"
  },
  {
    "name": "box-align-bottom-left",
    "label": "Box Align Bottom Left",
    "path": "box-align-bottom-left.svg"
  },
  {
    "name": "box-align-bottom-right",
    "label": "Box Align Bottom Right",
    "path": "box-align-bottom-right.svg"
  },
  {
    "name": "box-align-left",
    "label": "Box Align Left",
    "path": "box-align-left.svg"
  },
  {
    "name": "box-align-right",
    "label": "Box Align Right",
    "path": "box-align-right.svg"
  },
  {
    "name": "box-align-top",
    "label": "Box Align Top",
    "path": "box-align-top.svg"
  },
  {
    "name": "box-align-top-left",
    "label": "Box Align Top Left",
    "path": "box-align-top-left.svg"
  },
  {
    "name": "box-align-top-right",
    "label": "Box Align Top Right",
    "path": "box-align-top-right.svg"
  },
  {
    "name": "box-multiple",
    "label": "Box Multiple",
    "path": "box-multiple.svg"
  },
  {
    "name": "brand-angular",
    "label": "Brand Angular",
    "path": "brand-angular.svg"
  },
  {
    "name": "brand-apple",
    "label": "Brand Apple",
    "path": "brand-apple.svg"
  },
  {
    "name": "brand-bitbucket",
    "label": "Brand Bitbucket",
    "path": "brand-bitbucket.svg"
  },
  {
    "name": "brand-discord",
    "label": "Brand Discord",
    "path": "brand-discord.svg"
  },
  {
    "name": "brand-dribbble",
    "label": "Brand Dribbble",
    "path": "brand-dribbble.svg"
  },
  {
    "name": "brand-facebook",
    "label": "Brand Facebook",
    "path": "brand-facebook.svg"
  },
  {
    "name": "brand-github",
    "label": "Brand Github",
    "path": "brand-github.svg"
  },
  {
    "name": "brand-google",
    "label": "Brand Google",
    "path": "brand-google.svg"
  },
  {
    "name": "brand-instagram",
    "label": "Brand Instagram",
    "path": "brand-instagram.svg"
  },
  {
    "name": "brand-kick",
    "label": "Brand Kick",
    "path": "brand-kick.svg"
  },
  {
    "name": "brand-linkedin",
    "label": "Brand Linkedin",
    "path": "brand-linkedin.svg"
  },
  {
    "name": "brand-messenger",
    "label": "Brand Messenger",
    "path": "brand-messenger.svg"
  },
  {
    "name": "brand-open-source",
    "label": "Brand Open Source",
    "path": "brand-open-source.svg"
  },
  {
    "name": "brand-opera",
    "label": "Brand Opera",
    "path": "brand-opera.svg"
  },
  {
    "name": "brand-patreon",
    "label": "Brand Patreon",
    "path": "brand-patreon.svg"
  },
  {
    "name": "brand-paypal",
    "label": "Brand Paypal",
    "path": "brand-paypal.svg"
  },
  {
    "name": "brand-pinterest",
    "label": "Brand Pinterest",
    "path": "brand-pinterest.svg"
  },
  {
    "name": "brand-sketch",
    "label": "Brand Sketch",
    "path": "brand-sketch.svg"
  },
  {
    "name": "brand-snapchat",
    "label": "Brand Snapchat",
    "path": "brand-snapchat.svg"
  },
  {
    "name": "brand-spotify",
    "label": "Brand Spotify",
    "path": "brand-spotify.svg"
  },
  {
    "name": "brand-steam",
    "label": "Brand Steam",
    "path": "brand-steam.svg"
  },
  {
    "name": "brand-stripe",
    "label": "Brand Stripe",
    "path": "brand-stripe.svg"
  },
  {
    "name": "brand-tabler",
    "label": "Brand Tabler",
    "path": "brand-tabler.svg"
  },
  {
    "name": "brand-tiktok",
    "label": "Brand Tiktok",
    "path": "brand-tiktok.svg"
  },
  {
    "name": "brand-tinder",
    "label": "Brand Tinder",
    "path": "brand-tinder.svg"
  },
  {
    "name": "brand-tumblr",
    "label": "Brand Tumblr",
    "path": "brand-tumblr.svg"
  },
  {
    "name": "brand-twitter",
    "label": "Brand Twitter",
    "path": "brand-twitter.svg"
  },
  {
    "name": "brand-vercel",
    "label": "Brand Vercel",
    "path": "brand-vercel.svg"
  },
  {
    "name": "brand-vimeo",
    "label": "Brand Vimeo",
    "path": "brand-vimeo.svg"
  },
  {
    "name": "brand-weibo",
    "label": "Brand Weibo",
    "path": "brand-weibo.svg"
  },
  {
    "name": "brand-whatsapp",
    "label": "Brand Whatsapp",
    "path": "brand-whatsapp.svg"
  },
  {
    "name": "brand-windows",
    "label": "Brand Windows",
    "path": "brand-windows.svg"
  },
  {
    "name": "brand-x",
    "label": "Brand X",
    "path": "brand-x.svg"
  },
  {
    "name": "brand-youtube",
    "label": "Brand Youtube",
    "path": "brand-youtube.svg"
  },
  {
    "name": "bread",
    "label": "Bread",
    "path": "bread.svg"
  },
  {
    "name": "briefcase",
    "label": "Briefcase",
    "path": "briefcase.svg"
  },
  {
    "name": "briefcase-2",
    "label": "Briefcase 2",
    "path": "briefcase-2.svg"
  },
  {
    "name": "brightness",
    "label": "Brightness",
    "path": "brightness.svg"
  },
  {
    "name": "brightness-auto",
    "label": "Brightness Auto",
    "path": "brightness-auto.svg"
  },
  {
    "name": "brightness-down",
    "label": "Brightness Down",
    "path": "brightness-down.svg"
  },
  {
    "name": "brightness-up",
    "label": "Brightness Up",
    "path": "brightness-up.svg"
  },
  {
    "name": "bubble",
    "label": "Bubble",
    "path": "bubble.svg"
  },
  {
    "name": "bubble-text",
    "label": "Bubble Text",
    "path": "bubble-text.svg"
  },
  {
    "name": "bug",
    "label": "Bug",
    "path": "bug.svg"
  },
  {
    "name": "building-bridge-2",
    "label": "Building Bridge 2",
    "path": "building-bridge-2.svg"
  },
  {
    "name": "building-broadcast-tower",
    "label": "Building Broadcast Tower",
    "path": "building-broadcast-tower.svg"
  },
  {
    "name": "bulb",
    "label": "Bulb",
    "path": "bulb.svg"
  },
  {
    "name": "bus",
    "label": "Bus",
    "path": "bus.svg"
  },
  {
    "name": "butterfly",
    "label": "Butterfly",
    "path": "butterfly.svg"
  },
  {
    "name": "cactus",
    "label": "Cactus",
    "path": "cactus.svg"
  },
  {
    "name": "calculator",
    "label": "Calculator",
    "path": "calculator.svg"
  },
  {
    "name": "calendar",
    "label": "Calendar",
    "path": "calendar.svg"
  },
  {
    "name": "calendar-event",
    "label": "Calendar Event",
    "path": "calendar-event.svg"
  },
  {
    "name": "calendar-month",
    "label": "Calendar Month",
    "path": "calendar-month.svg"
  },
  {
    "name": "calendar-week",
    "label": "Calendar Week",
    "path": "calendar-week.svg"
  },
  {
    "name": "camera",
    "label": "Camera",
    "path": "camera.svg"
  },
  {
    "name": "campfire",
    "label": "Campfire",
    "path": "campfire.svg"
  },
  {
    "name": "candle",
    "label": "Candle",
    "path": "candle.svg"
  },
  {
    "name": "cannabis",
    "label": "Cannabis",
    "path": "cannabis.svg"
  },
  {
    "name": "capsule",
    "label": "Capsule",
    "path": "capsule.svg"
  },
  {
    "name": "capsule-horizontal",
    "label": "Capsule Horizontal",
    "path": "capsule-horizontal.svg"
  },
  {
    "name": "capture",
    "label": "Capture",
    "path": "capture.svg"
  },
  {
    "name": "car",
    "label": "Car",
    "path": "car.svg"
  },
  {
    "name": "car-4wd",
    "label": "Car 4wd",
    "path": "car-4wd.svg"
  },
  {
    "name": "car-crane",
    "label": "Car Crane",
    "path": "car-crane.svg"
  },
  {
    "name": "car-fan",
    "label": "Car Fan",
    "path": "car-fan.svg"
  },
  {
    "name": "car-suv",
    "label": "Car Suv",
    "path": "car-suv.svg"
  },
  {
    "name": "carambola",
    "label": "Carambola",
    "path": "carambola.svg"
  },
  {
    "name": "caravan",
    "label": "Caravan",
    "path": "caravan.svg"
  },
  {
    "name": "cardboards",
    "label": "Cardboards",
    "path": "cardboards.svg"
  },
  {
    "name": "cards",
    "label": "Cards",
    "path": "cards.svg"
  },
  {
    "name": "caret-down",
    "label": "Caret Down",
    "path": "caret-down.svg"
  },
  {
    "name": "caret-left",
    "label": "Caret Left",
    "path": "caret-left.svg"
  },
  {
    "name": "caret-left-right",
    "label": "Caret Left Right",
    "path": "caret-left-right.svg"
  },
  {
    "name": "caret-right",
    "label": "Caret Right",
    "path": "caret-right.svg"
  },
  {
    "name": "caret-up",
    "label": "Caret Up",
    "path": "caret-up.svg"
  },
  {
    "name": "caret-up-down",
    "label": "Caret Up Down",
    "path": "caret-up-down.svg"
  },
  {
    "name": "carousel-horizontal",
    "label": "Carousel Horizontal",
    "path": "carousel-horizontal.svg"
  },
  {
    "name": "carousel-vertical",
    "label": "Carousel Vertical",
    "path": "carousel-vertical.svg"
  },
  {
    "name": "cash-banknote",
    "label": "Cash Banknote",
    "path": "cash-banknote.svg"
  },
  {
    "name": "category",
    "label": "Category",
    "path": "category.svg"
  },
  {
    "name": "charging-pile",
    "label": "Charging Pile",
    "path": "charging-pile.svg"
  },
  {
    "name": "chart-area",
    "label": "Chart Area",
    "path": "chart-area.svg"
  },
  {
    "name": "chart-area-line",
    "label": "Chart Area Line",
    "path": "chart-area-line.svg"
  },
  {
    "name": "chart-bubble",
    "label": "Chart Bubble",
    "path": "chart-bubble.svg"
  },
  {
    "name": "chart-candle",
    "label": "Chart Candle",
    "path": "chart-candle.svg"
  },
  {
    "name": "chart-donut",
    "label": "Chart Donut",
    "path": "chart-donut.svg"
  },
  {
    "name": "chart-dots",
    "label": "Chart Dots",
    "path": "chart-dots.svg"
  },
  {
    "name": "chart-dots-2",
    "label": "Chart Dots 2",
    "path": "chart-dots-2.svg"
  },
  {
    "name": "chart-dots-3",
    "label": "Chart Dots 3",
    "path": "chart-dots-3.svg"
  },
  {
    "name": "chart-funnel",
    "label": "Chart Funnel",
    "path": "chart-funnel.svg"
  },
  {
    "name": "chart-grid-dots",
    "label": "Chart Grid Dots",
    "path": "chart-grid-dots.svg"
  },
  {
    "name": "chart-pie",
    "label": "Chart Pie",
    "path": "chart-pie.svg"
  },
  {
    "name": "chart-pie-2",
    "label": "Chart Pie 2",
    "path": "chart-pie-2.svg"
  },
  {
    "name": "chart-pie-3",
    "label": "Chart Pie 3",
    "path": "chart-pie-3.svg"
  },
  {
    "name": "chart-pie-4",
    "label": "Chart Pie 4",
    "path": "chart-pie-4.svg"
  },
  {
    "name": "chef-hat",
    "label": "Chef Hat",
    "path": "chef-hat.svg"
  },
  {
    "name": "cherry",
    "label": "Cherry",
    "path": "cherry.svg"
  },
  {
    "name": "chess",
    "label": "Chess",
    "path": "chess.svg"
  },
  {
    "name": "chess-bishop",
    "label": "Chess Bishop",
    "path": "chess-bishop.svg"
  },
  {
    "name": "chess-king",
    "label": "Chess King",
    "path": "chess-king.svg"
  },
  {
    "name": "chess-knight",
    "label": "Chess Knight",
    "path": "chess-knight.svg"
  },
  {
    "name": "chess-queen",
    "label": "Chess Queen",
    "path": "chess-queen.svg"
  },
  {
    "name": "chess-rook",
    "label": "Chess Rook",
    "path": "chess-rook.svg"
  },
  {
    "name": "christmas-tree",
    "label": "Christmas Tree",
    "path": "christmas-tree.svg"
  },
  {
    "name": "circle",
    "label": "Circle",
    "path": "circle.svg"
  },
  {
    "name": "circle-arrow-down",
    "label": "Circle Arrow Down",
    "path": "circle-arrow-down.svg"
  },
  {
    "name": "circle-arrow-down-left",
    "label": "Circle Arrow Down Left",
    "path": "circle-arrow-down-left.svg"
  },
  {
    "name": "circle-arrow-down-right",
    "label": "Circle Arrow Down Right",
    "path": "circle-arrow-down-right.svg"
  },
  {
    "name": "circle-arrow-left",
    "label": "Circle Arrow Left",
    "path": "circle-arrow-left.svg"
  },
  {
    "name": "circle-arrow-right",
    "label": "Circle Arrow Right",
    "path": "circle-arrow-right.svg"
  },
  {
    "name": "circle-arrow-up",
    "label": "Circle Arrow Up",
    "path": "circle-arrow-up.svg"
  },
  {
    "name": "circle-arrow-up-left",
    "label": "Circle Arrow Up Left",
    "path": "circle-arrow-up-left.svg"
  },
  {
    "name": "circle-arrow-up-right",
    "label": "Circle Arrow Up Right",
    "path": "circle-arrow-up-right.svg"
  },
  {
    "name": "circle-caret-down",
    "label": "Circle Caret Down",
    "path": "circle-caret-down.svg"
  },
  {
    "name": "circle-caret-left",
    "label": "Circle Caret Left",
    "path": "circle-caret-left.svg"
  },
  {
    "name": "circle-caret-right",
    "label": "Circle Caret Right",
    "path": "circle-caret-right.svg"
  },
  {
    "name": "circle-caret-up",
    "label": "Circle Caret Up",
    "path": "circle-caret-up.svg"
  },
  {
    "name": "circle-check",
    "label": "Circle Check",
    "path": "circle-check.svg"
  },
  {
    "name": "circle-chevron-down",
    "label": "Circle Chevron Down",
    "path": "circle-chevron-down.svg"
  },
  {
    "name": "circle-chevron-left",
    "label": "Circle Chevron Left",
    "path": "circle-chevron-left.svg"
  },
  {
    "name": "circle-chevron-right",
    "label": "Circle Chevron Right",
    "path": "circle-chevron-right.svg"
  },
  {
    "name": "circle-chevron-up",
    "label": "Circle Chevron Up",
    "path": "circle-chevron-up.svg"
  },
  {
    "name": "circle-chevrons-down",
    "label": "Circle Chevrons Down",
    "path": "circle-chevrons-down.svg"
  },
  {
    "name": "circle-chevrons-left",
    "label": "Circle Chevrons Left",
    "path": "circle-chevrons-left.svg"
  },
  {
    "name": "circle-chevrons-right",
    "label": "Circle Chevrons Right",
    "path": "circle-chevrons-right.svg"
  },
  {
    "name": "circle-chevrons-up",
    "label": "Circle Chevrons Up",
    "path": "circle-chevrons-up.svg"
  },
  {
    "name": "circle-dot",
    "label": "Circle Dot",
    "path": "circle-dot.svg"
  },
  {
    "name": "circle-key",
    "label": "Circle Key",
    "path": "circle-key.svg"
  },
  {
    "name": "circle-letter-a",
    "label": "Circle Letter A",
    "path": "circle-letter-a.svg"
  },
  {
    "name": "circle-letter-b",
    "label": "Circle Letter B",
    "path": "circle-letter-b.svg"
  },
  {
    "name": "circle-letter-c",
    "label": "Circle Letter C",
    "path": "circle-letter-c.svg"
  },
  {
    "name": "circle-letter-d",
    "label": "Circle Letter D",
    "path": "circle-letter-d.svg"
  },
  {
    "name": "circle-letter-e",
    "label": "Circle Letter E",
    "path": "circle-letter-e.svg"
  },
  {
    "name": "circle-letter-f",
    "label": "Circle Letter F",
    "path": "circle-letter-f.svg"
  },
  {
    "name": "circle-letter-g",
    "label": "Circle Letter G",
    "path": "circle-letter-g.svg"
  },
  {
    "name": "circle-letter-h",
    "label": "Circle Letter H",
    "path": "circle-letter-h.svg"
  },
  {
    "name": "circle-letter-i",
    "label": "Circle Letter I",
    "path": "circle-letter-i.svg"
  },
  {
    "name": "circle-letter-j",
    "label": "Circle Letter J",
    "path": "circle-letter-j.svg"
  },
  {
    "name": "circle-letter-k",
    "label": "Circle Letter K",
    "path": "circle-letter-k.svg"
  },
  {
    "name": "circle-letter-l",
    "label": "Circle Letter L",
    "path": "circle-letter-l.svg"
  },
  {
    "name": "circle-letter-m",
    "label": "Circle Letter M",
    "path": "circle-letter-m.svg"
  },
  {
    "name": "circle-letter-n",
    "label": "Circle Letter N",
    "path": "circle-letter-n.svg"
  },
  {
    "name": "circle-letter-o",
    "label": "Circle Letter O",
    "path": "circle-letter-o.svg"
  },
  {
    "name": "circle-letter-p",
    "label": "Circle Letter P",
    "path": "circle-letter-p.svg"
  },
  {
    "name": "circle-letter-q",
    "label": "Circle Letter Q",
    "path": "circle-letter-q.svg"
  },
  {
    "name": "circle-letter-r",
    "label": "Circle Letter R",
    "path": "circle-letter-r.svg"
  },
  {
    "name": "circle-letter-s",
    "label": "Circle Letter S",
    "path": "circle-letter-s.svg"
  },
  {
    "name": "circle-letter-t",
    "label": "Circle Letter T",
    "path": "circle-letter-t.svg"
  },
  {
    "name": "circle-letter-u",
    "label": "Circle Letter U",
    "path": "circle-letter-u.svg"
  },
  {
    "name": "circle-letter-v",
    "label": "Circle Letter V",
    "path": "circle-letter-v.svg"
  },
  {
    "name": "circle-letter-w",
    "label": "Circle Letter W",
    "path": "circle-letter-w.svg"
  },
  {
    "name": "circle-letter-x",
    "label": "Circle Letter X",
    "path": "circle-letter-x.svg"
  },
  {
    "name": "circle-letter-y",
    "label": "Circle Letter Y",
    "path": "circle-letter-y.svg"
  },
  {
    "name": "circle-letter-z",
    "label": "Circle Letter Z",
    "path": "circle-letter-z.svg"
  },
  {
    "name": "circle-number-0",
    "label": "Circle Number 0",
    "path": "circle-number-0.svg"
  },
  {
    "name": "circle-number-1",
    "label": "Circle Number 1",
    "path": "circle-number-1.svg"
  },
  {
    "name": "circle-number-2",
    "label": "Circle Number 2",
    "path": "circle-number-2.svg"
  },
  {
    "name": "circle-number-3",
    "label": "Circle Number 3",
    "path": "circle-number-3.svg"
  },
  {
    "name": "circle-number-4",
    "label": "Circle Number 4",
    "path": "circle-number-4.svg"
  },
  {
    "name": "circle-number-5",
    "label": "Circle Number 5",
    "path": "circle-number-5.svg"
  },
  {
    "name": "circle-number-6",
    "label": "Circle Number 6",
    "path": "circle-number-6.svg"
  },
  {
    "name": "circle-number-7",
    "label": "Circle Number 7",
    "path": "circle-number-7.svg"
  },
  {
    "name": "circle-number-8",
    "label": "Circle Number 8",
    "path": "circle-number-8.svg"
  },
  {
    "name": "circle-number-9",
    "label": "Circle Number 9",
    "path": "circle-number-9.svg"
  },
  {
    "name": "circle-percentage",
    "label": "Circle Percentage",
    "path": "circle-percentage.svg"
  },
  {
    "name": "circle-plus",
    "label": "Circle Plus",
    "path": "circle-plus.svg"
  },
  {
    "name": "circle-rectangle",
    "label": "Circle Rectangle",
    "path": "circle-rectangle.svg"
  },
  {
    "name": "circle-x",
    "label": "Circle X",
    "path": "circle-x.svg"
  },
  {
    "name": "circles",
    "label": "Circles",
    "path": "circles.svg"
  },
  {
    "name": "clipboard",
    "label": "Clipboard",
    "path": "clipboard.svg"
  },
  {
    "name": "clipboard-check",
    "label": "Clipboard Check",
    "path": "clipboard-check.svg"
  },
  {
    "name": "clipboard-data",
    "label": "Clipboard Data",
    "path": "clipboard-data.svg"
  },
  {
    "name": "clipboard-list",
    "label": "Clipboard List",
    "path": "clipboard-list.svg"
  },
  {
    "name": "clipboard-plus",
    "label": "Clipboard Plus",
    "path": "clipboard-plus.svg"
  },
  {
    "name": "clipboard-smile",
    "label": "Clipboard Smile",
    "path": "clipboard-smile.svg"
  },
  {
    "name": "clipboard-text",
    "label": "Clipboard Text",
    "path": "clipboard-text.svg"
  },
  {
    "name": "clipboard-typography",
    "label": "Clipboard Typography",
    "path": "clipboard-typography.svg"
  },
  {
    "name": "clipboard-x",
    "label": "Clipboard X",
    "path": "clipboard-x.svg"
  },
  {
    "name": "clock",
    "label": "Clock",
    "path": "clock.svg"
  },
  {
    "name": "clock-hour-1",
    "label": "Clock Hour 1",
    "path": "clock-hour-1.svg"
  },
  {
    "name": "clock-hour-10",
    "label": "Clock Hour 10",
    "path": "clock-hour-10.svg"
  },
  {
    "name": "clock-hour-11",
    "label": "Clock Hour 11",
    "path": "clock-hour-11.svg"
  },
  {
    "name": "clock-hour-12",
    "label": "Clock Hour 12",
    "path": "clock-hour-12.svg"
  },
  {
    "name": "clock-hour-2",
    "label": "Clock Hour 2",
    "path": "clock-hour-2.svg"
  },
  {
    "name": "clock-hour-3",
    "label": "Clock Hour 3",
    "path": "clock-hour-3.svg"
  },
  {
    "name": "clock-hour-4",
    "label": "Clock Hour 4",
    "path": "clock-hour-4.svg"
  },
  {
    "name": "clock-hour-5",
    "label": "Clock Hour 5",
    "path": "clock-hour-5.svg"
  },
  {
    "name": "clock-hour-6",
    "label": "Clock Hour 6",
    "path": "clock-hour-6.svg"
  },
  {
    "name": "clock-hour-7",
    "label": "Clock Hour 7",
    "path": "clock-hour-7.svg"
  },
  {
    "name": "clock-hour-8",
    "label": "Clock Hour 8",
    "path": "clock-hour-8.svg"
  },
  {
    "name": "clock-hour-9",
    "label": "Clock Hour 9",
    "path": "clock-hour-9.svg"
  },
  {
    "name": "cloud",
    "label": "Cloud",
    "path": "cloud.svg"
  },
  {
    "name": "cloud-computing",
    "label": "Cloud Computing",
    "path": "cloud-computing.svg"
  },
  {
    "name": "cloud-data-connection",
    "label": "Cloud Data Connection",
    "path": "cloud-data-connection.svg"
  },
  {
    "name": "clover",
    "label": "Clover",
    "path": "clover.svg"
  },
  {
    "name": "clubs",
    "label": "Clubs",
    "path": "clubs.svg"
  },
  {
    "name": "code-circle",
    "label": "Code Circle",
    "path": "code-circle.svg"
  },
  {
    "name": "code-circle-2",
    "label": "Code Circle 2",
    "path": "code-circle-2.svg"
  },
  {
    "name": "coin",
    "label": "Coin",
    "path": "coin.svg"
  },
  {
    "name": "coin-bitcoin",
    "label": "Coin Bitcoin",
    "path": "coin-bitcoin.svg"
  },
  {
    "name": "coin-euro",
    "label": "Coin Euro",
    "path": "coin-euro.svg"
  },
  {
    "name": "coin-monero",
    "label": "Coin Monero",
    "path": "coin-monero.svg"
  },
  {
    "name": "coin-pound",
    "label": "Coin Pound",
    "path": "coin-pound.svg"
  },
  {
    "name": "coin-rupee",
    "label": "Coin Rupee",
    "path": "coin-rupee.svg"
  },
  {
    "name": "coin-taka",
    "label": "Coin Taka",
    "path": "coin-taka.svg"
  },
  {
    "name": "coin-yen",
    "label": "Coin Yen",
    "path": "coin-yen.svg"
  },
  {
    "name": "coin-yuan",
    "label": "Coin Yuan",
    "path": "coin-yuan.svg"
  },
  {
    "name": "columns-1",
    "label": "Columns 1",
    "path": "columns-1.svg"
  },
  {
    "name": "columns-2",
    "label": "Columns 2",
    "path": "columns-2.svg"
  },
  {
    "name": "columns-3",
    "label": "Columns 3",
    "path": "columns-3.svg"
  },
  {
    "name": "compass",
    "label": "Compass",
    "path": "compass.svg"
  },
  {
    "name": "cone",
    "label": "Cone",
    "path": "cone.svg"
  },
  {
    "name": "cone-2",
    "label": "Cone 2",
    "path": "cone-2.svg"
  },
  {
    "name": "confetti",
    "label": "Confetti",
    "path": "confetti.svg"
  },
  {
    "name": "container",
    "label": "Container",
    "path": "container.svg"
  },
  {
    "name": "contrast",
    "label": "Contrast",
    "path": "contrast.svg"
  },
  {
    "name": "contrast-2",
    "label": "Contrast 2",
    "path": "contrast-2.svg"
  },
  {
    "name": "cookie",
    "label": "Cookie",
    "path": "cookie.svg"
  },
  {
    "name": "cookie-man",
    "label": "Cookie Man",
    "path": "cookie-man.svg"
  },
  {
    "name": "copy-check",
    "label": "Copy Check",
    "path": "copy-check.svg"
  },
  {
    "name": "copy-minus",
    "label": "Copy Minus",
    "path": "copy-minus.svg"
  },
  {
    "name": "copy-plus",
    "label": "Copy Plus",
    "path": "copy-plus.svg"
  },
  {
    "name": "copy-x",
    "label": "Copy X",
    "path": "copy-x.svg"
  },
  {
    "name": "copyleft",
    "label": "Copyleft",
    "path": "copyleft.svg"
  },
  {
    "name": "copyright",
    "label": "Copyright",
    "path": "copyright.svg"
  },
  {
    "name": "credit-card",
    "label": "Credit Card",
    "path": "credit-card.svg"
  },
  {
    "name": "crop-1-1",
    "label": "Crop 1 1",
    "path": "crop-1-1.svg"
  },
  {
    "name": "crop-16-9",
    "label": "Crop 16 9",
    "path": "crop-16-9.svg"
  },
  {
    "name": "crop-3-2",
    "label": "Crop 3 2",
    "path": "crop-3-2.svg"
  },
  {
    "name": "crop-5-4",
    "label": "Crop 5 4",
    "path": "crop-5-4.svg"
  },
  {
    "name": "crop-7-5",
    "label": "Crop 7 5",
    "path": "crop-7-5.svg"
  },
  {
    "name": "crop-landscape",
    "label": "Crop Landscape",
    "path": "crop-landscape.svg"
  },
  {
    "name": "crop-portrait",
    "label": "Crop Portrait",
    "path": "crop-portrait.svg"
  },
  {
    "name": "cross",
    "label": "Cross",
    "path": "cross.svg"
  },
  {
    "name": "current-location",
    "label": "Current Location",
    "path": "current-location.svg"
  },
  {
    "name": "dashboard",
    "label": "Dashboard",
    "path": "dashboard.svg"
  },
  {
    "name": "device-cctv",
    "label": "Device Cctv",
    "path": "device-cctv.svg"
  },
  {
    "name": "device-desktop",
    "label": "Device Desktop",
    "path": "device-desktop.svg"
  },
  {
    "name": "device-gamepad",
    "label": "Device Gamepad",
    "path": "device-gamepad.svg"
  },
  {
    "name": "device-gamepad-3",
    "label": "Device Gamepad 3",
    "path": "device-gamepad-3.svg"
  },
  {
    "name": "device-heart-monitor",
    "label": "Device Heart Monitor",
    "path": "device-heart-monitor.svg"
  },
  {
    "name": "device-imac",
    "label": "Device Imac",
    "path": "device-imac.svg"
  },
  {
    "name": "device-ipad",
    "label": "Device Ipad",
    "path": "device-ipad.svg"
  },
  {
    "name": "device-mobile",
    "label": "Device Mobile",
    "path": "device-mobile.svg"
  },
  {
    "name": "device-remote",
    "label": "Device Remote",
    "path": "device-remote.svg"
  },
  {
    "name": "device-speaker",
    "label": "Device Speaker",
    "path": "device-speaker.svg"
  },
  {
    "name": "device-tablet",
    "label": "Device Tablet",
    "path": "device-tablet.svg"
  },
  {
    "name": "device-tv",
    "label": "Device Tv",
    "path": "device-tv.svg"
  },
  {
    "name": "device-tv-old",
    "label": "Device Tv Old",
    "path": "device-tv-old.svg"
  },
  {
    "name": "device-unknown",
    "label": "Device Unknown",
    "path": "device-unknown.svg"
  },
  {
    "name": "device-usb",
    "label": "Device Usb",
    "path": "device-usb.svg"
  },
  {
    "name": "device-vision-pro",
    "label": "Device Vision Pro",
    "path": "device-vision-pro.svg"
  },
  {
    "name": "device-watch",
    "label": "Device Watch",
    "path": "device-watch.svg"
  },
  {
    "name": "dialpad",
    "label": "Dialpad",
    "path": "dialpad.svg"
  },
  {
    "name": "diamond",
    "label": "Diamond",
    "path": "diamond.svg"
  },
  {
    "name": "diamonds",
    "label": "Diamonds",
    "path": "diamonds.svg"
  },
  {
    "name": "dice",
    "label": "Dice",
    "path": "dice.svg"
  },
  {
    "name": "dice-1",
    "label": "Dice 1",
    "path": "dice-1.svg"
  },
  {
    "name": "dice-2",
    "label": "Dice 2",
    "path": "dice-2.svg"
  },
  {
    "name": "dice-3",
    "label": "Dice 3",
    "path": "dice-3.svg"
  },
  {
    "name": "dice-4",
    "label": "Dice 4",
    "path": "dice-4.svg"
  },
  {
    "name": "dice-5",
    "label": "Dice 5",
    "path": "dice-5.svg"
  },
  {
    "name": "dice-6",
    "label": "Dice 6",
    "path": "dice-6.svg"
  },
  {
    "name": "direction-arrows",
    "label": "Direction Arrows",
    "path": "direction-arrows.svg"
  },
  {
    "name": "direction-sign",
    "label": "Direction Sign",
    "path": "direction-sign.svg"
  },
  {
    "name": "directions",
    "label": "Directions",
    "path": "directions.svg"
  },
  {
    "name": "disc",
    "label": "Disc",
    "path": "disc.svg"
  },
  {
    "name": "discount",
    "label": "Discount",
    "path": "discount.svg"
  },
  {
    "name": "drop-circle",
    "label": "Drop Circle",
    "path": "drop-circle.svg"
  },
  {
    "name": "droplet",
    "label": "Droplet",
    "path": "droplet.svg"
  },
  {
    "name": "droplet-half",
    "label": "Droplet Half",
    "path": "droplet-half.svg"
  },
  {
    "name": "droplet-half-2",
    "label": "Droplet Half 2",
    "path": "droplet-half-2.svg"
  },
  {
    "name": "droplets",
    "label": "Droplets",
    "path": "droplets.svg"
  },
  {
    "name": "dual-screen",
    "label": "Dual Screen",
    "path": "dual-screen.svg"
  },
  {
    "name": "dumpling",
    "label": "Dumpling",
    "path": "dumpling.svg"
  },
  {
    "name": "ease-in-control-point",
    "label": "Ease In Control Point",
    "path": "ease-in-control-point.svg"
  },
  {
    "name": "ease-in-out-control-points",
    "label": "Ease In Out Control Points",
    "path": "ease-in-out-control-points.svg"
  },
  {
    "name": "ease-out-control-point",
    "label": "Ease Out Control Point",
    "path": "ease-out-control-point.svg"
  },
  {
    "name": "egg",
    "label": "Egg",
    "path": "egg.svg"
  },
  {
    "name": "egg-cracked",
    "label": "Egg Cracked",
    "path": "egg-cracked.svg"
  },
  {
    "name": "egg-fried",
    "label": "Egg Fried",
    "path": "egg-fried.svg"
  },
  {
    "name": "elevator",
    "label": "Elevator",
    "path": "elevator.svg"
  },
  {
    "name": "engine",
    "label": "Engine",
    "path": "engine.svg"
  },
  {
    "name": "escalator",
    "label": "Escalator",
    "path": "escalator.svg"
  },
  {
    "name": "escalator-down",
    "label": "Escalator Down",
    "path": "escalator-down.svg"
  },
  {
    "name": "escalator-up",
    "label": "Escalator Up",
    "path": "escalator-up.svg"
  },
  {
    "name": "exchange",
    "label": "Exchange",
    "path": "exchange.svg"
  },
  {
    "name": "exclamation-circle",
    "label": "Exclamation Circle",
    "path": "exclamation-circle.svg"
  },
  {
    "name": "explicit",
    "label": "Explicit",
    "path": "explicit.svg"
  },
  {
    "name": "exposure",
    "label": "Exposure",
    "path": "exposure.svg"
  },
  {
    "name": "eye",
    "label": "Eye",
    "path": "eye.svg"
  },
  {
    "name": "eye-table",
    "label": "Eye Table",
    "path": "eye-table.svg"
  },
  {
    "name": "eyeglass",
    "label": "Eyeglass",
    "path": "eyeglass.svg"
  },
  {
    "name": "eyeglass-2",
    "label": "Eyeglass 2",
    "path": "eyeglass-2.svg"
  },
  {
    "name": "face-mask",
    "label": "Face Mask",
    "path": "face-mask.svg"
  },
  {
    "name": "favicon",
    "label": "Favicon",
    "path": "favicon.svg"
  },
  {
    "name": "feather",
    "label": "Feather",
    "path": "feather.svg"
  },
  {
    "name": "fence",
    "label": "Fence",
    "path": "fence.svg"
  },
  {
    "name": "ferry",
    "label": "Ferry",
    "path": "ferry.svg"
  },
  {
    "name": "fidget-spinner",
    "label": "Fidget Spinner",
    "path": "fidget-spinner.svg"
  },
  {
    "name": "file",
    "label": "File",
    "path": "file.svg"
  },
  {
    "name": "file-analytics",
    "label": "File Analytics",
    "path": "file-analytics.svg"
  },
  {
    "name": "file-check",
    "label": "File Check",
    "path": "file-check.svg"
  },
  {
    "name": "file-code",
    "label": "File Code",
    "path": "file-code.svg"
  },
  {
    "name": "file-code-2",
    "label": "File Code 2",
    "path": "file-code-2.svg"
  },
  {
    "name": "file-cv",
    "label": "File Cv",
    "path": "file-cv.svg"
  },
  {
    "name": "file-delta",
    "label": "File Delta",
    "path": "file-delta.svg"
  },
  {
    "name": "file-description",
    "label": "File Description",
    "path": "file-description.svg"
  },
  {
    "name": "file-diff",
    "label": "File Diff",
    "path": "file-diff.svg"
  },
  {
    "name": "file-digit",
    "label": "File Digit",
    "path": "file-digit.svg"
  },
  {
    "name": "file-dollar",
    "label": "File Dollar",
    "path": "file-dollar.svg"
  },
  {
    "name": "file-dots",
    "label": "File Dots",
    "path": "file-dots.svg"
  },
  {
    "name": "file-download",
    "label": "File Download",
    "path": "file-download.svg"
  },
  {
    "name": "file-euro",
    "label": "File Euro",
    "path": "file-euro.svg"
  },
  {
    "name": "file-function",
    "label": "File Function",
    "path": "file-function.svg"
  },
  {
    "name": "file-horizontal",
    "label": "File Horizontal",
    "path": "file-horizontal.svg"
  },
  {
    "name": "file-info",
    "label": "File Info",
    "path": "file-info.svg"
  },
  {
    "name": "file-invoice",
    "label": "File Invoice",
    "path": "file-invoice.svg"
  },
  {
    "name": "file-lambda",
    "label": "File Lambda",
    "path": "file-lambda.svg"
  },
  {
    "name": "file-minus",
    "label": "File Minus",
    "path": "file-minus.svg"
  },
  {
    "name": "file-music",
    "label": "File Music",
    "path": "file-music.svg"
  },
  {
    "name": "file-neutral",
    "label": "File Neutral",
    "path": "file-neutral.svg"
  },
  {
    "name": "file-pencil",
    "label": "File Pencil",
    "path": "file-pencil.svg"
  },
  {
    "name": "file-percent",
    "label": "File Percent",
    "path": "file-percent.svg"
  },
  {
    "name": "file-phone",
    "label": "File Phone",
    "path": "file-phone.svg"
  },
  {
    "name": "file-power",
    "label": "File Power",
    "path": "file-power.svg"
  },
  {
    "name": "file-rss",
    "label": "File Rss",
    "path": "file-rss.svg"
  },
  {
    "name": "file-sad",
    "label": "File Sad",
    "path": "file-sad.svg"
  },
  {
    "name": "file-scissors",
    "label": "File Scissors",
    "path": "file-scissors.svg"
  },
  {
    "name": "file-settings",
    "label": "File Settings",
    "path": "file-settings.svg"
  },
  {
    "name": "file-signal",
    "label": "File Signal",
    "path": "file-signal.svg"
  },
  {
    "name": "file-smile",
    "label": "File Smile",
    "path": "file-smile.svg"
  },
  {
    "name": "file-star",
    "label": "File Star",
    "path": "file-star.svg"
  },
  {
    "name": "file-text",
    "label": "File Text",
    "path": "file-text.svg"
  },
  {
    "name": "file-time",
    "label": "File Time",
    "path": "file-time.svg"
  },
  {
    "name": "file-typography",
    "label": "File Typography",
    "path": "file-typography.svg"
  },
  {
    "name": "file-unknown",
    "label": "File Unknown",
    "path": "file-unknown.svg"
  },
  {
    "name": "file-upload",
    "label": "File Upload",
    "path": "file-upload.svg"
  },
  {
    "name": "file-vector",
    "label": "File Vector",
    "path": "file-vector.svg"
  },
  {
    "name": "file-x",
    "label": "File X",
    "path": "file-x.svg"
  },
  {
    "name": "files",
    "label": "Files",
    "path": "files.svg"
  },
  {
    "name": "filter",
    "label": "Filter",
    "path": "filter.svg"
  },
  {
    "name": "filters",
    "label": "Filters",
    "path": "filters.svg"
  },
  {
    "name": "fish-bone",
    "label": "Fish Bone",
    "path": "fish-bone.svg"
  },
  {
    "name": "flag",
    "label": "Flag",
    "path": "flag.svg"
  },
  {
    "name": "flag-2",
    "label": "Flag 2",
    "path": "flag-2.svg"
  },
  {
    "name": "flag-3",
    "label": "Flag 3",
    "path": "flag-3.svg"
  },
  {
    "name": "flame",
    "label": "Flame",
    "path": "flame.svg"
  },
  {
    "name": "flare",
    "label": "Flare",
    "path": "flare.svg"
  },
  {
    "name": "flask",
    "label": "Flask",
    "path": "flask.svg"
  },
  {
    "name": "flask-2",
    "label": "Flask 2",
    "path": "flask-2.svg"
  },
  {
    "name": "flower",
    "label": "Flower",
    "path": "flower.svg"
  },
  {
    "name": "folder",
    "label": "Folder",
    "path": "folder.svg"
  },
  {
    "name": "folders",
    "label": "Folders",
    "path": "folders.svg"
  },
  {
    "name": "forbid",
    "label": "Forbid",
    "path": "forbid.svg"
  },
  {
    "name": "forbid-2",
    "label": "Forbid 2",
    "path": "forbid-2.svg"
  },
  {
    "name": "fountain",
    "label": "Fountain",
    "path": "fountain.svg"
  },
  {
    "name": "function",
    "label": "Function",
    "path": "function.svg"
  },
  {
    "name": "garden-cart",
    "label": "Garden Cart",
    "path": "garden-cart.svg"
  },
  {
    "name": "gas-station",
    "label": "Gas Station",
    "path": "gas-station.svg"
  },
  {
    "name": "gauge",
    "label": "Gauge",
    "path": "gauge.svg"
  },
  {
    "name": "ghost",
    "label": "Ghost",
    "path": "ghost.svg"
  },
  {
    "name": "ghost-2",
    "label": "Ghost 2",
    "path": "ghost-2.svg"
  },
  {
    "name": "ghost-3",
    "label": "Ghost 3",
    "path": "ghost-3.svg"
  },
  {
    "name": "gift",
    "label": "Gift",
    "path": "gift.svg"
  },
  {
    "name": "gift-card",
    "label": "Gift Card",
    "path": "gift-card.svg"
  },
  {
    "name": "glass",
    "label": "Glass",
    "path": "glass.svg"
  },
  {
    "name": "glass-full",
    "label": "Glass Full",
    "path": "glass-full.svg"
  },
  {
    "name": "globe",
    "label": "Globe",
    "path": "globe.svg"
  },
  {
    "name": "golf",
    "label": "Golf",
    "path": "golf.svg"
  },
  {
    "name": "gps",
    "label": "Gps",
    "path": "gps.svg"
  },
  {
    "name": "graph",
    "label": "Graph",
    "path": "graph.svg"
  },
  {
    "name": "grid-pattern",
    "label": "Grid Pattern",
    "path": "grid-pattern.svg"
  },
  {
    "name": "guitar-pick",
    "label": "Guitar Pick",
    "path": "guitar-pick.svg"
  },
  {
    "name": "hanger-2",
    "label": "Hanger 2",
    "path": "hanger-2.svg"
  },
  {
    "name": "headphones",
    "label": "Headphones",
    "path": "headphones.svg"
  },
  {
    "name": "heart",
    "label": "Heart",
    "path": "heart.svg"
  },
  {
    "name": "heart-broken",
    "label": "Heart Broken",
    "path": "heart-broken.svg"
  },
  {
    "name": "helicopter",
    "label": "Helicopter",
    "path": "helicopter.svg"
  },
  {
    "name": "helicopter-landing",
    "label": "Helicopter Landing",
    "path": "helicopter-landing.svg"
  },
  {
    "name": "help-circle",
    "label": "Help Circle",
    "path": "help-circle.svg"
  },
  {
    "name": "help-hexagon",
    "label": "Help Hexagon",
    "path": "help-hexagon.svg"
  },
  {
    "name": "help-octagon",
    "label": "Help Octagon",
    "path": "help-octagon.svg"
  },
  {
    "name": "help-square",
    "label": "Help Square",
    "path": "help-square.svg"
  },
  {
    "name": "help-square-rounded",
    "label": "Help Square Rounded",
    "path": "help-square-rounded.svg"
  },
  {
    "name": "help-triangle",
    "label": "Help Triangle",
    "path": "help-triangle.svg"
  },
  {
    "name": "hexagon",
    "label": "Hexagon",
    "path": "hexagon.svg"
  },
  {
    "name": "hexagon-letter-a",
    "label": "Hexagon Letter A",
    "path": "hexagon-letter-a.svg"
  },
  {
    "name": "hexagon-letter-b",
    "label": "Hexagon Letter B",
    "path": "hexagon-letter-b.svg"
  },
  {
    "name": "hexagon-letter-c",
    "label": "Hexagon Letter C",
    "path": "hexagon-letter-c.svg"
  },
  {
    "name": "hexagon-letter-d",
    "label": "Hexagon Letter D",
    "path": "hexagon-letter-d.svg"
  },
  {
    "name": "hexagon-letter-e",
    "label": "Hexagon Letter E",
    "path": "hexagon-letter-e.svg"
  },
  {
    "name": "hexagon-letter-f",
    "label": "Hexagon Letter F",
    "path": "hexagon-letter-f.svg"
  },
  {
    "name": "hexagon-letter-g",
    "label": "Hexagon Letter G",
    "path": "hexagon-letter-g.svg"
  },
  {
    "name": "hexagon-letter-h",
    "label": "Hexagon Letter H",
    "path": "hexagon-letter-h.svg"
  },
  {
    "name": "hexagon-letter-i",
    "label": "Hexagon Letter I",
    "path": "hexagon-letter-i.svg"
  },
  {
    "name": "hexagon-letter-j",
    "label": "Hexagon Letter J",
    "path": "hexagon-letter-j.svg"
  },
  {
    "name": "hexagon-letter-k",
    "label": "Hexagon Letter K",
    "path": "hexagon-letter-k.svg"
  },
  {
    "name": "hexagon-letter-l",
    "label": "Hexagon Letter L",
    "path": "hexagon-letter-l.svg"
  },
  {
    "name": "hexagon-letter-m",
    "label": "Hexagon Letter M",
    "path": "hexagon-letter-m.svg"
  },
  {
    "name": "hexagon-letter-n",
    "label": "Hexagon Letter N",
    "path": "hexagon-letter-n.svg"
  },
  {
    "name": "hexagon-letter-o",
    "label": "Hexagon Letter O",
    "path": "hexagon-letter-o.svg"
  },
  {
    "name": "hexagon-letter-p",
    "label": "Hexagon Letter P",
    "path": "hexagon-letter-p.svg"
  },
  {
    "name": "hexagon-letter-q",
    "label": "Hexagon Letter Q",
    "path": "hexagon-letter-q.svg"
  },
  {
    "name": "hexagon-letter-r",
    "label": "Hexagon Letter R",
    "path": "hexagon-letter-r.svg"
  },
  {
    "name": "hexagon-letter-s",
    "label": "Hexagon Letter S",
    "path": "hexagon-letter-s.svg"
  },
  {
    "name": "hexagon-letter-t",
    "label": "Hexagon Letter T",
    "path": "hexagon-letter-t.svg"
  },
  {
    "name": "hexagon-letter-u",
    "label": "Hexagon Letter U",
    "path": "hexagon-letter-u.svg"
  },
  {
    "name": "hexagon-letter-v",
    "label": "Hexagon Letter V",
    "path": "hexagon-letter-v.svg"
  },
  {
    "name": "hexagon-letter-w",
    "label": "Hexagon Letter W",
    "path": "hexagon-letter-w.svg"
  },
  {
    "name": "hexagon-letter-x",
    "label": "Hexagon Letter X",
    "path": "hexagon-letter-x.svg"
  },
  {
    "name": "hexagon-letter-y",
    "label": "Hexagon Letter Y",
    "path": "hexagon-letter-y.svg"
  },
  {
    "name": "hexagon-letter-z",
    "label": "Hexagon Letter Z",
    "path": "hexagon-letter-z.svg"
  },
  {
    "name": "hexagon-minus",
    "label": "Hexagon Minus",
    "path": "hexagon-minus.svg"
  },
  {
    "name": "hexagon-number-0",
    "label": "Hexagon Number 0",
    "path": "hexagon-number-0.svg"
  },
  {
    "name": "hexagon-number-1",
    "label": "Hexagon Number 1",
    "path": "hexagon-number-1.svg"
  },
  {
    "name": "hexagon-number-2",
    "label": "Hexagon Number 2",
    "path": "hexagon-number-2.svg"
  },
  {
    "name": "hexagon-number-3",
    "label": "Hexagon Number 3",
    "path": "hexagon-number-3.svg"
  },
  {
    "name": "hexagon-number-4",
    "label": "Hexagon Number 4",
    "path": "hexagon-number-4.svg"
  },
  {
    "name": "hexagon-number-5",
    "label": "Hexagon Number 5",
    "path": "hexagon-number-5.svg"
  },
  {
    "name": "hexagon-number-6",
    "label": "Hexagon Number 6",
    "path": "hexagon-number-6.svg"
  },
  {
    "name": "hexagon-number-7",
    "label": "Hexagon Number 7",
    "path": "hexagon-number-7.svg"
  },
  {
    "name": "hexagon-number-8",
    "label": "Hexagon Number 8",
    "path": "hexagon-number-8.svg"
  },
  {
    "name": "hexagon-number-9",
    "label": "Hexagon Number 9",
    "path": "hexagon-number-9.svg"
  },
  {
    "name": "hexagon-plus",
    "label": "Hexagon Plus",
    "path": "hexagon-plus.svg"
  },
  {
    "name": "home",
    "label": "Home",
    "path": "home.svg"
  },
  {
    "name": "hospital-circle",
    "label": "Hospital Circle",
    "path": "hospital-circle.svg"
  },
  {
    "name": "hourglass",
    "label": "Hourglass",
    "path": "hourglass.svg"
  },
  {
    "name": "icons",
    "label": "Icons",
    "path": "icons.svg"
  },
  {
    "name": "info-circle",
    "label": "Info Circle",
    "path": "info-circle.svg"
  },
  {
    "name": "info-hexagon",
    "label": "Info Hexagon",
    "path": "info-hexagon.svg"
  },
  {
    "name": "info-octagon",
    "label": "Info Octagon",
    "path": "info-octagon.svg"
  },
  {
    "name": "info-square",
    "label": "Info Square",
    "path": "info-square.svg"
  },
  {
    "name": "info-square-rounded",
    "label": "Info Square Rounded",
    "path": "info-square-rounded.svg"
  },
  {
    "name": "info-triangle",
    "label": "Info Triangle",
    "path": "info-triangle.svg"
  },
  {
    "name": "inner-shadow-bottom",
    "label": "Inner Shadow Bottom",
    "path": "inner-shadow-bottom.svg"
  },
  {
    "name": "inner-shadow-bottom-left",
    "label": "Inner Shadow Bottom Left",
    "path": "inner-shadow-bottom-left.svg"
  },
  {
    "name": "inner-shadow-bottom-right",
    "label": "Inner Shadow Bottom Right",
    "path": "inner-shadow-bottom-right.svg"
  },
  {
    "name": "inner-shadow-left",
    "label": "Inner Shadow Left",
    "path": "inner-shadow-left.svg"
  },
  {
    "name": "inner-shadow-right",
    "label": "Inner Shadow Right",
    "path": "inner-shadow-right.svg"
  },
  {
    "name": "inner-shadow-top",
    "label": "Inner Shadow Top",
    "path": "inner-shadow-top.svg"
  },
  {
    "name": "inner-shadow-top-left",
    "label": "Inner Shadow Top Left",
    "path": "inner-shadow-top-left.svg"
  },
  {
    "name": "inner-shadow-top-right",
    "label": "Inner Shadow Top Right",
    "path": "inner-shadow-top-right.svg"
  },
  {
    "name": "ironing",
    "label": "Ironing",
    "path": "ironing.svg"
  },
  {
    "name": "ironing-1",
    "label": "Ironing 1",
    "path": "ironing-1.svg"
  },
  {
    "name": "ironing-2",
    "label": "Ironing 2",
    "path": "ironing-2.svg"
  },
  {
    "name": "ironing-3",
    "label": "Ironing 3",
    "path": "ironing-3.svg"
  },
  {
    "name": "ironing-steam",
    "label": "Ironing Steam",
    "path": "ironing-steam.svg"
  },
  {
    "name": "jetpack",
    "label": "Jetpack",
    "path": "jetpack.svg"
  },
  {
    "name": "jewish-star",
    "label": "Jewish Star",
    "path": "jewish-star.svg"
  },
  {
    "name": "key",
    "label": "Key",
    "path": "key.svg"
  },
  {
    "name": "keyboard",
    "label": "Keyboard",
    "path": "keyboard.svg"
  },
  {
    "name": "keyframe",
    "label": "Keyframe",
    "path": "keyframe.svg"
  },
  {
    "name": "keyframe-align-center",
    "label": "Keyframe Align Center",
    "path": "keyframe-align-center.svg"
  },
  {
    "name": "keyframe-align-horizontal",
    "label": "Keyframe Align Horizontal",
    "path": "keyframe-align-horizontal.svg"
  },
  {
    "name": "keyframe-align-vertical",
    "label": "Keyframe Align Vertical",
    "path": "keyframe-align-vertical.svg"
  },
  {
    "name": "keyframes",
    "label": "Keyframes",
    "path": "keyframes.svg"
  },
  {
    "name": "label",
    "label": "Label",
    "path": "label.svg"
  },
  {
    "name": "label-important",
    "label": "Label Important",
    "path": "label-important.svg"
  },
  {
    "name": "lasso-polygon",
    "label": "Lasso Polygon",
    "path": "lasso-polygon.svg"
  },
  {
    "name": "laurel-wreath",
    "label": "Laurel Wreath",
    "path": "laurel-wreath.svg"
  },
  {
    "name": "laurel-wreath-1",
    "label": "Laurel Wreath 1",
    "path": "laurel-wreath-1.svg"
  },
  {
    "name": "laurel-wreath-2",
    "label": "Laurel Wreath 2",
    "path": "laurel-wreath-2.svg"
  },
  {
    "name": "laurel-wreath-3",
    "label": "Laurel Wreath 3",
    "path": "laurel-wreath-3.svg"
  },
  {
    "name": "layout",
    "label": "Layout",
    "path": "layout.svg"
  },
  {
    "name": "layout-2",
    "label": "Layout 2",
    "path": "layout-2.svg"
  },
  {
    "name": "layout-align-bottom",
    "label": "Layout Align Bottom",
    "path": "layout-align-bottom.svg"
  },
  {
    "name": "layout-align-center",
    "label": "Layout Align Center",
    "path": "layout-align-center.svg"
  },
  {
    "name": "layout-align-left",
    "label": "Layout Align Left",
    "path": "layout-align-left.svg"
  },
  {
    "name": "layout-align-middle",
    "label": "Layout Align Middle",
    "path": "layout-align-middle.svg"
  },
  {
    "name": "layout-align-right",
    "label": "Layout Align Right",
    "path": "layout-align-right.svg"
  },
  {
    "name": "layout-align-top",
    "label": "Layout Align Top",
    "path": "layout-align-top.svg"
  },
  {
    "name": "layout-board",
    "label": "Layout Board",
    "path": "layout-board.svg"
  },
  {
    "name": "layout-board-split",
    "label": "Layout Board Split",
    "path": "layout-board-split.svg"
  },
  {
    "name": "layout-bottombar",
    "label": "Layout Bottombar",
    "path": "layout-bottombar.svg"
  },
  {
    "name": "layout-bottombar-collapse",
    "label": "Layout Bottombar Collapse",
    "path": "layout-bottombar-collapse.svg"
  },
  {
    "name": "layout-bottombar-expand",
    "label": "Layout Bottombar Expand",
    "path": "layout-bottombar-expand.svg"
  },
  {
    "name": "layout-cards",
    "label": "Layout Cards",
    "path": "layout-cards.svg"
  },
  {
    "name": "layout-dashboard",
    "label": "Layout Dashboard",
    "path": "layout-dashboard.svg"
  },
  {
    "name": "layout-distribute-horizontal",
    "label": "Layout Distribute Horizontal",
    "path": "layout-distribute-horizontal.svg"
  },
  {
    "name": "layout-distribute-vertical",
    "label": "Layout Distribute Vertical",
    "path": "layout-distribute-vertical.svg"
  },
  {
    "name": "layout-grid",
    "label": "Layout Grid",
    "path": "layout-grid.svg"
  },
  {
    "name": "layout-kanban",
    "label": "Layout Kanban",
    "path": "layout-kanban.svg"
  },
  {
    "name": "layout-list",
    "label": "Layout List",
    "path": "layout-list.svg"
  },
  {
    "name": "layout-navbar",
    "label": "Layout Navbar",
    "path": "layout-navbar.svg"
  },
  {
    "name": "layout-navbar-collapse",
    "label": "Layout Navbar Collapse",
    "path": "layout-navbar-collapse.svg"
  },
  {
    "name": "layout-navbar-expand",
    "label": "Layout Navbar Expand",
    "path": "layout-navbar-expand.svg"
  },
  {
    "name": "layout-sidebar",
    "label": "Layout Sidebar",
    "path": "layout-sidebar.svg"
  },
  {
    "name": "layout-sidebar-left-collapse",
    "label": "Layout Sidebar Left Collapse",
    "path": "layout-sidebar-left-collapse.svg"
  },
  {
    "name": "layout-sidebar-left-expand",
    "label": "Layout Sidebar Left Expand",
    "path": "layout-sidebar-left-expand.svg"
  },
  {
    "name": "layout-sidebar-right",
    "label": "Layout Sidebar Right",
    "path": "layout-sidebar-right.svg"
  },
  {
    "name": "layout-sidebar-right-collapse",
    "label": "Layout Sidebar Right Collapse",
    "path": "layout-sidebar-right-collapse.svg"
  },
  {
    "name": "layout-sidebar-right-expand",
    "label": "Layout Sidebar Right Expand",
    "path": "layout-sidebar-right-expand.svg"
  },
  {
    "name": "lego",
    "label": "Lego",
    "path": "lego.svg"
  },
  {
    "name": "lemon-2",
    "label": "Lemon 2",
    "path": "lemon-2.svg"
  },
  {
    "name": "library",
    "label": "Library",
    "path": "library.svg"
  },
  {
    "name": "library-plus",
    "label": "Library Plus",
    "path": "library-plus.svg"
  },
  {
    "name": "lifebuoy",
    "label": "Lifebuoy",
    "path": "lifebuoy.svg"
  },
  {
    "name": "live-photo",
    "label": "Live Photo",
    "path": "live-photo.svg"
  },
  {
    "name": "live-view",
    "label": "Live View",
    "path": "live-view.svg"
  },
  {
    "name": "location",
    "label": "Location",
    "path": "location.svg"
  },
  {
    "name": "lock",
    "label": "Lock",
    "path": "lock.svg"
  },
  {
    "name": "lock-square-rounded",
    "label": "Lock Square Rounded",
    "path": "lock-square-rounded.svg"
  },
  {
    "name": "lungs",
    "label": "Lungs",
    "path": "lungs.svg"
  },
  {
    "name": "macro",
    "label": "Macro",
    "path": "macro.svg"
  },
  {
    "name": "magnet",
    "label": "Magnet",
    "path": "magnet.svg"
  },
  {
    "name": "mail",
    "label": "Mail",
    "path": "mail.svg"
  },
  {
    "name": "mail-opened",
    "label": "Mail Opened",
    "path": "mail-opened.svg"
  },
  {
    "name": "man",
    "label": "Man",
    "path": "man.svg"
  },
  {
    "name": "manual-gearbox",
    "label": "Manual Gearbox",
    "path": "manual-gearbox.svg"
  },
  {
    "name": "map-pin",
    "label": "Map Pin",
    "path": "map-pin.svg"
  },
  {
    "name": "medical-cross",
    "label": "Medical Cross",
    "path": "medical-cross.svg"
  },
  {
    "name": "meeple",
    "label": "Meeple",
    "path": "meeple.svg"
  },
  {
    "name": "melon",
    "label": "Melon",
    "path": "melon.svg"
  },
  {
    "name": "message",
    "label": "Message",
    "path": "message.svg"
  },
  {
    "name": "message-2",
    "label": "Message 2",
    "path": "message-2.svg"
  },
  {
    "name": "message-chatbot",
    "label": "Message Chatbot",
    "path": "message-chatbot.svg"
  },
  {
    "name": "message-circle",
    "label": "Message Circle",
    "path": "message-circle.svg"
  },
  {
    "name": "message-report",
    "label": "Message Report",
    "path": "message-report.svg"
  },
  {
    "name": "meteor",
    "label": "Meteor",
    "path": "meteor.svg"
  },
  {
    "name": "michelin-star",
    "label": "Michelin Star",
    "path": "michelin-star.svg"
  },
  {
    "name": "mickey",
    "label": "Mickey",
    "path": "mickey.svg"
  },
  {
    "name": "microphone",
    "label": "Microphone",
    "path": "microphone.svg"
  },
  {
    "name": "microscope",
    "label": "Microscope",
    "path": "microscope.svg"
  },
  {
    "name": "microwave",
    "label": "Microwave",
    "path": "microwave.svg"
  },
  {
    "name": "military-rank",
    "label": "Military Rank",
    "path": "military-rank.svg"
  },
  {
    "name": "milk",
    "label": "Milk",
    "path": "milk.svg"
  },
  {
    "name": "mood-angry",
    "label": "Mood Angry",
    "path": "mood-angry.svg"
  },
  {
    "name": "mood-confuzed",
    "label": "Mood Confuzed",
    "path": "mood-confuzed.svg"
  },
  {
    "name": "mood-crazy-happy",
    "label": "Mood Crazy Happy",
    "path": "mood-crazy-happy.svg"
  },
  {
    "name": "mood-empty",
    "label": "Mood Empty",
    "path": "mood-empty.svg"
  },
  {
    "name": "mood-happy",
    "label": "Mood Happy",
    "path": "mood-happy.svg"
  },
  {
    "name": "mood-kid",
    "label": "Mood Kid",
    "path": "mood-kid.svg"
  },
  {
    "name": "mood-neutral",
    "label": "Mood Neutral",
    "path": "mood-neutral.svg"
  },
  {
    "name": "mood-sad",
    "label": "Mood Sad",
    "path": "mood-sad.svg"
  },
  {
    "name": "mood-smile",
    "label": "Mood Smile",
    "path": "mood-smile.svg"
  },
  {
    "name": "mood-wrrr",
    "label": "Mood Wrrr",
    "path": "mood-wrrr.svg"
  },
  {
    "name": "moon",
    "label": "Moon",
    "path": "moon.svg"
  },
  {
    "name": "motorbike",
    "label": "Motorbike",
    "path": "motorbike.svg"
  },
  {
    "name": "mountain",
    "label": "Mountain",
    "path": "mountain.svg"
  },
  {
    "name": "mouse",
    "label": "Mouse",
    "path": "mouse.svg"
  },
  {
    "name": "mug",
    "label": "Mug",
    "path": "mug.svg"
  },
  {
    "name": "mushroom",
    "label": "Mushroom",
    "path": "mushroom.svg"
  },
  {
    "name": "navigation",
    "label": "Navigation",
    "path": "navigation.svg"
  },
  {
    "name": "nurse",
    "label": "Nurse",
    "path": "nurse.svg"
  },
  {
    "name": "octagon",
    "label": "Octagon",
    "path": "octagon.svg"
  },
  {
    "name": "octagon-minus",
    "label": "Octagon Minus",
    "path": "octagon-minus.svg"
  },
  {
    "name": "octagon-plus",
    "label": "Octagon Plus",
    "path": "octagon-plus.svg"
  },
  {
    "name": "oval",
    "label": "Oval",
    "path": "oval.svg"
  },
  {
    "name": "oval-vertical",
    "label": "Oval Vertical",
    "path": "oval-vertical.svg"
  },
  {
    "name": "paint",
    "label": "Paint",
    "path": "paint.svg"
  },
  {
    "name": "palette",
    "label": "Palette",
    "path": "palette.svg"
  },
  {
    "name": "panorama-horizontal",
    "label": "Panorama Horizontal",
    "path": "panorama-horizontal.svg"
  },
  {
    "name": "panorama-vertical",
    "label": "Panorama Vertical",
    "path": "panorama-vertical.svg"
  },
  {
    "name": "parking-circle",
    "label": "Parking Circle",
    "path": "parking-circle.svg"
  },
  {
    "name": "paw",
    "label": "Paw",
    "path": "paw.svg"
  },
  {
    "name": "pennant",
    "label": "Pennant",
    "path": "pennant.svg"
  },
  {
    "name": "pennant-2",
    "label": "Pennant 2",
    "path": "pennant-2.svg"
  },
  {
    "name": "pentagon",
    "label": "Pentagon",
    "path": "pentagon.svg"
  },
  {
    "name": "phone",
    "label": "Phone",
    "path": "phone.svg"
  },
  {
    "name": "photo",
    "label": "Photo",
    "path": "photo.svg"
  },
  {
    "name": "picture-in-picture",
    "label": "Picture In Picture",
    "path": "picture-in-picture.svg"
  },
  {
    "name": "picture-in-picture-top",
    "label": "Picture In Picture Top",
    "path": "picture-in-picture-top.svg"
  },
  {
    "name": "pig",
    "label": "Pig",
    "path": "pig.svg"
  },
  {
    "name": "pill",
    "label": "Pill",
    "path": "pill.svg"
  },
  {
    "name": "pin",
    "label": "Pin",
    "path": "pin.svg"
  },
  {
    "name": "pinned",
    "label": "Pinned",
    "path": "pinned.svg"
  },
  {
    "name": "pizza",
    "label": "Pizza",
    "path": "pizza.svg"
  },
  {
    "name": "play-card-1",
    "label": "Play Card 1",
    "path": "play-card-1.svg"
  },
  {
    "name": "play-card-10",
    "label": "Play Card 10",
    "path": "play-card-10.svg"
  },
  {
    "name": "play-card-2",
    "label": "Play Card 2",
    "path": "play-card-2.svg"
  },
  {
    "name": "play-card-3",
    "label": "Play Card 3",
    "path": "play-card-3.svg"
  },
  {
    "name": "play-card-4",
    "label": "Play Card 4",
    "path": "play-card-4.svg"
  },
  {
    "name": "play-card-5",
    "label": "Play Card 5",
    "path": "play-card-5.svg"
  },
  {
    "name": "play-card-6",
    "label": "Play Card 6",
    "path": "play-card-6.svg"
  },
  {
    "name": "play-card-7",
    "label": "Play Card 7",
    "path": "play-card-7.svg"
  },
  {
    "name": "play-card-8",
    "label": "Play Card 8",
    "path": "play-card-8.svg"
  },
  {
    "name": "play-card-9",
    "label": "Play Card 9",
    "path": "play-card-9.svg"
  },
  {
    "name": "play-card-a",
    "label": "Play Card A",
    "path": "play-card-a.svg"
  },
  {
    "name": "play-card-j",
    "label": "Play Card J",
    "path": "play-card-j.svg"
  },
  {
    "name": "play-card-k",
    "label": "Play Card K",
    "path": "play-card-k.svg"
  },
  {
    "name": "play-card-q",
    "label": "Play Card Q",
    "path": "play-card-q.svg"
  },
  {
    "name": "play-card-star",
    "label": "Play Card Star",
    "path": "play-card-star.svg"
  },
  {
    "name": "player-eject",
    "label": "Player Eject",
    "path": "player-eject.svg"
  },
  {
    "name": "player-pause",
    "label": "Player Pause",
    "path": "player-pause.svg"
  },
  {
    "name": "player-play",
    "label": "Player Play",
    "path": "player-play.svg"
  },
  {
    "name": "player-record",
    "label": "Player Record",
    "path": "player-record.svg"
  },
  {
    "name": "player-skip-back",
    "label": "Player Skip Back",
    "path": "player-skip-back.svg"
  },
  {
    "name": "player-skip-forward",
    "label": "Player Skip Forward",
    "path": "player-skip-forward.svg"
  },
  {
    "name": "player-stop",
    "label": "Player Stop",
    "path": "player-stop.svg"
  },
  {
    "name": "player-track-next",
    "label": "Player Track Next",
    "path": "player-track-next.svg"
  },
  {
    "name": "player-track-prev",
    "label": "Player Track Prev",
    "path": "player-track-prev.svg"
  },
  {
    "name": "point",
    "label": "Point",
    "path": "point.svg"
  },
  {
    "name": "pointer",
    "label": "Pointer",
    "path": "pointer.svg"
  },
  {
    "name": "polaroid",
    "label": "Polaroid",
    "path": "polaroid.svg"
  },
  {
    "name": "poo",
    "label": "Poo",
    "path": "poo.svg"
  },
  {
    "name": "presentation",
    "label": "Presentation",
    "path": "presentation.svg"
  },
  {
    "name": "presentation-analytics",
    "label": "Presentation Analytics",
    "path": "presentation-analytics.svg"
  },
  {
    "name": "puzzle",
    "label": "Puzzle",
    "path": "puzzle.svg"
  },
  {
    "name": "quote",
    "label": "Quote",
    "path": "quote.svg"
  },
  {
    "name": "radar",
    "label": "Radar",
    "path": "radar.svg"
  },
  {
    "name": "radioactive",
    "label": "Radioactive",
    "path": "radioactive.svg"
  },
  {
    "name": "receipt",
    "label": "Receipt",
    "path": "receipt.svg"
  },
  {
    "name": "receipt-dollar",
    "label": "Receipt Dollar",
    "path": "receipt-dollar.svg"
  },
  {
    "name": "receipt-euro",
    "label": "Receipt Euro",
    "path": "receipt-euro.svg"
  },
  {
    "name": "receipt-pound",
    "label": "Receipt Pound",
    "path": "receipt-pound.svg"
  },
  {
    "name": "receipt-rupee",
    "label": "Receipt Rupee",
    "path": "receipt-rupee.svg"
  },
  {
    "name": "receipt-yen",
    "label": "Receipt Yen",
    "path": "receipt-yen.svg"
  },
  {
    "name": "receipt-yuan",
    "label": "Receipt Yuan",
    "path": "receipt-yuan.svg"
  },
  {
    "name": "rectangle",
    "label": "Rectangle",
    "path": "rectangle.svg"
  },
  {
    "name": "rectangle-vertical",
    "label": "Rectangle Vertical",
    "path": "rectangle-vertical.svg"
  },
  {
    "name": "registered",
    "label": "Registered",
    "path": "registered.svg"
  },
  {
    "name": "relation-many-to-many",
    "label": "Relation Many To Many",
    "path": "relation-many-to-many.svg"
  },
  {
    "name": "relation-one-to-many",
    "label": "Relation One To Many",
    "path": "relation-one-to-many.svg"
  },
  {
    "name": "relation-one-to-one",
    "label": "Relation One To One",
    "path": "relation-one-to-one.svg"
  },
  {
    "name": "replace",
    "label": "Replace",
    "path": "replace.svg"
  },
  {
    "name": "rollercoaster",
    "label": "Rollercoaster",
    "path": "rollercoaster.svg"
  },
  {
    "name": "rosette",
    "label": "Rosette",
    "path": "rosette.svg"
  },
  {
    "name": "rosette-discount",
    "label": "Rosette Discount",
    "path": "rosette-discount.svg"
  },
  {
    "name": "rosette-discount-check",
    "label": "Rosette Discount Check",
    "path": "rosette-discount-check.svg"
  },
  {
    "name": "salad",
    "label": "Salad",
    "path": "salad.svg"
  },
  {
    "name": "scuba-diving-tank",
    "label": "Scuba Diving Tank",
    "path": "scuba-diving-tank.svg"
  },
  {
    "name": "section",
    "label": "Section",
    "path": "section.svg"
  },
  {
    "name": "seedling",
    "label": "Seedling",
    "path": "seedling.svg"
  },
  {
    "name": "settings",
    "label": "Settings",
    "path": "settings.svg"
  },
  {
    "name": "shield",
    "label": "Shield",
    "path": "shield.svg"
  },
  {
    "name": "shield-check",
    "label": "Shield Check",
    "path": "shield-check.svg"
  },
  {
    "name": "shield-checkered",
    "label": "Shield Checkered",
    "path": "shield-checkered.svg"
  },
  {
    "name": "shield-half",
    "label": "Shield Half",
    "path": "shield-half.svg"
  },
  {
    "name": "shield-lock",
    "label": "Shield Lock",
    "path": "shield-lock.svg"
  },
  {
    "name": "shirt",
    "label": "Shirt",
    "path": "shirt.svg"
  },
  {
    "name": "shopping-cart",
    "label": "Shopping Cart",
    "path": "shopping-cart.svg"
  },
  {
    "name": "sign-left",
    "label": "Sign Left",
    "path": "sign-left.svg"
  },
  {
    "name": "sign-right",
    "label": "Sign Right",
    "path": "sign-right.svg"
  },
  {
    "name": "sitemap",
    "label": "Sitemap",
    "path": "sitemap.svg"
  },
  {
    "name": "sort-ascending-2",
    "label": "Sort Ascending 2",
    "path": "sort-ascending-2.svg"
  },
  {
    "name": "sort-ascending-shapes",
    "label": "Sort Ascending Shapes",
    "path": "sort-ascending-shapes.svg"
  },
  {
    "name": "sort-descending-2",
    "label": "Sort Descending 2",
    "path": "sort-descending-2.svg"
  },
  {
    "name": "sort-descending-shapes",
    "label": "Sort Descending Shapes",
    "path": "sort-descending-shapes.svg"
  },
  {
    "name": "soup",
    "label": "Soup",
    "path": "soup.svg"
  },
  {
    "name": "spade",
    "label": "Spade",
    "path": "spade.svg"
  },
  {
    "name": "speedboat",
    "label": "Speedboat",
    "path": "speedboat.svg"
  },
  {
    "name": "spider",
    "label": "Spider",
    "path": "spider.svg"
  },
  {
    "name": "square",
    "label": "Square",
    "path": "square.svg"
  },
  {
    "name": "square-arrow-down",
    "label": "Square Arrow Down",
    "path": "square-arrow-down.svg"
  },
  {
    "name": "square-arrow-left",
    "label": "Square Arrow Left",
    "path": "square-arrow-left.svg"
  },
  {
    "name": "square-arrow-right",
    "label": "Square Arrow Right",
    "path": "square-arrow-right.svg"
  },
  {
    "name": "square-arrow-up",
    "label": "Square Arrow Up",
    "path": "square-arrow-up.svg"
  },
  {
    "name": "square-asterisk",
    "label": "Square Asterisk",
    "path": "square-asterisk.svg"
  },
  {
    "name": "square-check",
    "label": "Square Check",
    "path": "square-check.svg"
  },
  {
    "name": "square-chevron-down",
    "label": "Square Chevron Down",
    "path": "square-chevron-down.svg"
  },
  {
    "name": "square-chevron-left",
    "label": "Square Chevron Left",
    "path": "square-chevron-left.svg"
  },
  {
    "name": "square-chevron-right",
    "label": "Square Chevron Right",
    "path": "square-chevron-right.svg"
  },
  {
    "name": "square-chevron-up",
    "label": "Square Chevron Up",
    "path": "square-chevron-up.svg"
  },
  {
    "name": "square-chevrons-down",
    "label": "Square Chevrons Down",
    "path": "square-chevrons-down.svg"
  },
  {
    "name": "square-chevrons-left",
    "label": "Square Chevrons Left",
    "path": "square-chevrons-left.svg"
  },
  {
    "name": "square-chevrons-right",
    "label": "Square Chevrons Right",
    "path": "square-chevrons-right.svg"
  },
  {
    "name": "square-chevrons-up",
    "label": "Square Chevrons Up",
    "path": "square-chevrons-up.svg"
  },
  {
    "name": "square-dot",
    "label": "Square Dot",
    "path": "square-dot.svg"
  },
  {
    "name": "square-f0",
    "label": "Square F0",
    "path": "square-f0.svg"
  },
  {
    "name": "square-f1",
    "label": "Square F1",
    "path": "square-f1.svg"
  },
  {
    "name": "square-f2",
    "label": "Square F2",
    "path": "square-f2.svg"
  },
  {
    "name": "square-f3",
    "label": "Square F3",
    "path": "square-f3.svg"
  },
  {
    "name": "square-f4",
    "label": "Square F4",
    "path": "square-f4.svg"
  },
  {
    "name": "square-f5",
    "label": "Square F5",
    "path": "square-f5.svg"
  },
  {
    "name": "square-f6",
    "label": "Square F6",
    "path": "square-f6.svg"
  },
  {
    "name": "square-f7",
    "label": "Square F7",
    "path": "square-f7.svg"
  },
  {
    "name": "square-f8",
    "label": "Square F8",
    "path": "square-f8.svg"
  },
  {
    "name": "square-f9",
    "label": "Square F9",
    "path": "square-f9.svg"
  },
  {
    "name": "square-letter-a",
    "label": "Square Letter A",
    "path": "square-letter-a.svg"
  },
  {
    "name": "square-letter-b",
    "label": "Square Letter B",
    "path": "square-letter-b.svg"
  },
  {
    "name": "square-letter-c",
    "label": "Square Letter C",
    "path": "square-letter-c.svg"
  },
  {
    "name": "square-letter-d",
    "label": "Square Letter D",
    "path": "square-letter-d.svg"
  },
  {
    "name": "square-letter-e",
    "label": "Square Letter E",
    "path": "square-letter-e.svg"
  },
  {
    "name": "square-letter-f",
    "label": "Square Letter F",
    "path": "square-letter-f.svg"
  },
  {
    "name": "square-letter-g",
    "label": "Square Letter G",
    "path": "square-letter-g.svg"
  },
  {
    "name": "square-letter-h",
    "label": "Square Letter H",
    "path": "square-letter-h.svg"
  },
  {
    "name": "square-letter-i",
    "label": "Square Letter I",
    "path": "square-letter-i.svg"
  },
  {
    "name": "square-letter-j",
    "label": "Square Letter J",
    "path": "square-letter-j.svg"
  },
  {
    "name": "square-letter-k",
    "label": "Square Letter K",
    "path": "square-letter-k.svg"
  },
  {
    "name": "square-letter-l",
    "label": "Square Letter L",
    "path": "square-letter-l.svg"
  },
  {
    "name": "square-letter-m",
    "label": "Square Letter M",
    "path": "square-letter-m.svg"
  },
  {
    "name": "square-letter-n",
    "label": "Square Letter N",
    "path": "square-letter-n.svg"
  },
  {
    "name": "square-letter-o",
    "label": "Square Letter O",
    "path": "square-letter-o.svg"
  },
  {
    "name": "square-letter-p",
    "label": "Square Letter P",
    "path": "square-letter-p.svg"
  },
  {
    "name": "square-letter-q",
    "label": "Square Letter Q",
    "path": "square-letter-q.svg"
  },
  {
    "name": "square-letter-r",
    "label": "Square Letter R",
    "path": "square-letter-r.svg"
  },
  {
    "name": "square-letter-s",
    "label": "Square Letter S",
    "path": "square-letter-s.svg"
  },
  {
    "name": "square-letter-t",
    "label": "Square Letter T",
    "path": "square-letter-t.svg"
  },
  {
    "name": "square-letter-u",
    "label": "Square Letter U",
    "path": "square-letter-u.svg"
  },
  {
    "name": "square-letter-v",
    "label": "Square Letter V",
    "path": "square-letter-v.svg"
  },
  {
    "name": "square-letter-w",
    "label": "Square Letter W",
    "path": "square-letter-w.svg"
  },
  {
    "name": "square-letter-x",
    "label": "Square Letter X",
    "path": "square-letter-x.svg"
  },
  {
    "name": "square-letter-y",
    "label": "Square Letter Y",
    "path": "square-letter-y.svg"
  },
  {
    "name": "square-letter-z",
    "label": "Square Letter Z",
    "path": "square-letter-z.svg"
  },
  {
    "name": "square-minus",
    "label": "Square Minus",
    "path": "square-minus.svg"
  },
  {
    "name": "square-number-0",
    "label": "Square Number 0",
    "path": "square-number-0.svg"
  },
  {
    "name": "square-number-1",
    "label": "Square Number 1",
    "path": "square-number-1.svg"
  },
  {
    "name": "square-number-2",
    "label": "Square Number 2",
    "path": "square-number-2.svg"
  },
  {
    "name": "square-number-3",
    "label": "Square Number 3",
    "path": "square-number-3.svg"
  },
  {
    "name": "square-number-4",
    "label": "Square Number 4",
    "path": "square-number-4.svg"
  },
  {
    "name": "square-number-5",
    "label": "Square Number 5",
    "path": "square-number-5.svg"
  },
  {
    "name": "square-number-6",
    "label": "Square Number 6",
    "path": "square-number-6.svg"
  },
  {
    "name": "square-number-7",
    "label": "Square Number 7",
    "path": "square-number-7.svg"
  },
  {
    "name": "square-number-8",
    "label": "Square Number 8",
    "path": "square-number-8.svg"
  },
  {
    "name": "square-number-9",
    "label": "Square Number 9",
    "path": "square-number-9.svg"
  },
  {
    "name": "square-rotated",
    "label": "Square Rotated",
    "path": "square-rotated.svg"
  },
  {
    "name": "square-rounded",
    "label": "Square Rounded",
    "path": "square-rounded.svg"
  },
  {
    "name": "square-rounded-arrow-down",
    "label": "Square Rounded Arrow Down",
    "path": "square-rounded-arrow-down.svg"
  },
  {
    "name": "square-rounded-arrow-left",
    "label": "Square Rounded Arrow Left",
    "path": "square-rounded-arrow-left.svg"
  },
  {
    "name": "square-rounded-arrow-right",
    "label": "Square Rounded Arrow Right",
    "path": "square-rounded-arrow-right.svg"
  },
  {
    "name": "square-rounded-arrow-up",
    "label": "Square Rounded Arrow Up",
    "path": "square-rounded-arrow-up.svg"
  },
  {
    "name": "square-rounded-check",
    "label": "Square Rounded Check",
    "path": "square-rounded-check.svg"
  },
  {
    "name": "square-rounded-chevron-down",
    "label": "Square Rounded Chevron Down",
    "path": "square-rounded-chevron-down.svg"
  },
  {
    "name": "square-rounded-chevron-left",
    "label": "Square Rounded Chevron Left",
    "path": "square-rounded-chevron-left.svg"
  },
  {
    "name": "square-rounded-chevron-right",
    "label": "Square Rounded Chevron Right",
    "path": "square-rounded-chevron-right.svg"
  },
  {
    "name": "square-rounded-chevron-up",
    "label": "Square Rounded Chevron Up",
    "path": "square-rounded-chevron-up.svg"
  },
  {
    "name": "square-rounded-chevrons-down",
    "label": "Square Rounded Chevrons Down",
    "path": "square-rounded-chevrons-down.svg"
  },
  {
    "name": "square-rounded-chevrons-left",
    "label": "Square Rounded Chevrons Left",
    "path": "square-rounded-chevrons-left.svg"
  },
  {
    "name": "square-rounded-chevrons-right",
    "label": "Square Rounded Chevrons Right",
    "path": "square-rounded-chevrons-right.svg"
  },
  {
    "name": "square-rounded-chevrons-up",
    "label": "Square Rounded Chevrons Up",
    "path": "square-rounded-chevrons-up.svg"
  },
  {
    "name": "square-rounded-letter-a",
    "label": "Square Rounded Letter A",
    "path": "square-rounded-letter-a.svg"
  },
  {
    "name": "square-rounded-letter-b",
    "label": "Square Rounded Letter B",
    "path": "square-rounded-letter-b.svg"
  },
  {
    "name": "square-rounded-letter-c",
    "label": "Square Rounded Letter C",
    "path": "square-rounded-letter-c.svg"
  },
  {
    "name": "square-rounded-letter-d",
    "label": "Square Rounded Letter D",
    "path": "square-rounded-letter-d.svg"
  },
  {
    "name": "square-rounded-letter-e",
    "label": "Square Rounded Letter E",
    "path": "square-rounded-letter-e.svg"
  },
  {
    "name": "square-rounded-letter-f",
    "label": "Square Rounded Letter F",
    "path": "square-rounded-letter-f.svg"
  },
  {
    "name": "square-rounded-letter-g",
    "label": "Square Rounded Letter G",
    "path": "square-rounded-letter-g.svg"
  },
  {
    "name": "square-rounded-letter-h",
    "label": "Square Rounded Letter H",
    "path": "square-rounded-letter-h.svg"
  },
  {
    "name": "square-rounded-letter-i",
    "label": "Square Rounded Letter I",
    "path": "square-rounded-letter-i.svg"
  },
  {
    "name": "square-rounded-letter-j",
    "label": "Square Rounded Letter J",
    "path": "square-rounded-letter-j.svg"
  },
  {
    "name": "square-rounded-letter-k",
    "label": "Square Rounded Letter K",
    "path": "square-rounded-letter-k.svg"
  },
  {
    "name": "square-rounded-letter-l",
    "label": "Square Rounded Letter L",
    "path": "square-rounded-letter-l.svg"
  },
  {
    "name": "square-rounded-letter-m",
    "label": "Square Rounded Letter M",
    "path": "square-rounded-letter-m.svg"
  },
  {
    "name": "square-rounded-letter-n",
    "label": "Square Rounded Letter N",
    "path": "square-rounded-letter-n.svg"
  },
  {
    "name": "square-rounded-letter-o",
    "label": "Square Rounded Letter O",
    "path": "square-rounded-letter-o.svg"
  },
  {
    "name": "square-rounded-letter-p",
    "label": "Square Rounded Letter P",
    "path": "square-rounded-letter-p.svg"
  },
  {
    "name": "square-rounded-letter-q",
    "label": "Square Rounded Letter Q",
    "path": "square-rounded-letter-q.svg"
  },
  {
    "name": "square-rounded-letter-r",
    "label": "Square Rounded Letter R",
    "path": "square-rounded-letter-r.svg"
  },
  {
    "name": "square-rounded-letter-s",
    "label": "Square Rounded Letter S",
    "path": "square-rounded-letter-s.svg"
  },
  {
    "name": "square-rounded-letter-t",
    "label": "Square Rounded Letter T",
    "path": "square-rounded-letter-t.svg"
  },
  {
    "name": "square-rounded-letter-u",
    "label": "Square Rounded Letter U",
    "path": "square-rounded-letter-u.svg"
  },
  {
    "name": "square-rounded-letter-v",
    "label": "Square Rounded Letter V",
    "path": "square-rounded-letter-v.svg"
  },
  {
    "name": "square-rounded-letter-w",
    "label": "Square Rounded Letter W",
    "path": "square-rounded-letter-w.svg"
  },
  {
    "name": "square-rounded-letter-x",
    "label": "Square Rounded Letter X",
    "path": "square-rounded-letter-x.svg"
  },
  {
    "name": "square-rounded-letter-y",
    "label": "Square Rounded Letter Y",
    "path": "square-rounded-letter-y.svg"
  },
  {
    "name": "square-rounded-letter-z",
    "label": "Square Rounded Letter Z",
    "path": "square-rounded-letter-z.svg"
  },
  {
    "name": "square-rounded-minus",
    "label": "Square Rounded Minus",
    "path": "square-rounded-minus.svg"
  },
  {
    "name": "square-rounded-number-0",
    "label": "Square Rounded Number 0",
    "path": "square-rounded-number-0.svg"
  },
  {
    "name": "square-rounded-number-1",
    "label": "Square Rounded Number 1",
    "path": "square-rounded-number-1.svg"
  },
  {
    "name": "square-rounded-number-2",
    "label": "Square Rounded Number 2",
    "path": "square-rounded-number-2.svg"
  },
  {
    "name": "square-rounded-number-3",
    "label": "Square Rounded Number 3",
    "path": "square-rounded-number-3.svg"
  },
  {
    "name": "square-rounded-number-4",
    "label": "Square Rounded Number 4",
    "path": "square-rounded-number-4.svg"
  },
  {
    "name": "square-rounded-number-5",
    "label": "Square Rounded Number 5",
    "path": "square-rounded-number-5.svg"
  },
  {
    "name": "square-rounded-number-6",
    "label": "Square Rounded Number 6",
    "path": "square-rounded-number-6.svg"
  },
  {
    "name": "square-rounded-number-7",
    "label": "Square Rounded Number 7",
    "path": "square-rounded-number-7.svg"
  },
  {
    "name": "square-rounded-number-8",
    "label": "Square Rounded Number 8",
    "path": "square-rounded-number-8.svg"
  },
  {
    "name": "square-rounded-number-9",
    "label": "Square Rounded Number 9",
    "path": "square-rounded-number-9.svg"
  },
  {
    "name": "square-rounded-plus",
    "label": "Square Rounded Plus",
    "path": "square-rounded-plus.svg"
  },
  {
    "name": "square-rounded-x",
    "label": "Square Rounded X",
    "path": "square-rounded-x.svg"
  },
  {
    "name": "square-x",
    "label": "Square X",
    "path": "square-x.svg"
  },
  {
    "name": "squares",
    "label": "Squares",
    "path": "squares.svg"
  },
  {
    "name": "stack",
    "label": "Stack",
    "path": "stack.svg"
  },
  {
    "name": "stack-2",
    "label": "Stack 2",
    "path": "stack-2.svg"
  },
  {
    "name": "stack-3",
    "label": "Stack 3",
    "path": "stack-3.svg"
  },
  {
    "name": "star",
    "label": "Star",
    "path": "star.svg"
  },
  {
    "name": "star-half",
    "label": "Star Half",
    "path": "star-half.svg"
  },
  {
    "name": "stars",
    "label": "Stars",
    "path": "stars.svg"
  },
  {
    "name": "steering-wheel",
    "label": "Steering Wheel",
    "path": "steering-wheel.svg"
  },
  {
    "name": "sun",
    "label": "Sun",
    "path": "sun.svg"
  },
  {
    "name": "sun-high",
    "label": "Sun High",
    "path": "sun-high.svg"
  },
  {
    "name": "sun-low",
    "label": "Sun Low",
    "path": "sun-low.svg"
  },
  {
    "name": "sunglasses",
    "label": "Sunglasses",
    "path": "sunglasses.svg"
  },
  {
    "name": "sunrise",
    "label": "Sunrise",
    "path": "sunrise.svg"
  },
  {
    "name": "sunset",
    "label": "Sunset",
    "path": "sunset.svg"
  },
  {
    "name": "sunset-2",
    "label": "Sunset 2",
    "path": "sunset-2.svg"
  },
  {
    "name": "swipe-down",
    "label": "Swipe Down",
    "path": "swipe-down.svg"
  },
  {
    "name": "swipe-left",
    "label": "Swipe Left",
    "path": "swipe-left.svg"
  },
  {
    "name": "swipe-right",
    "label": "Swipe Right",
    "path": "swipe-right.svg"
  },
  {
    "name": "swipe-up",
    "label": "Swipe Up",
    "path": "swipe-up.svg"
  },
  {
    "name": "table",
    "label": "Table",
    "path": "table.svg"
  },
  {
    "name": "tag",
    "label": "Tag",
    "path": "tag.svg"
  },
  {
    "name": "tags",
    "label": "Tags",
    "path": "tags.svg"
  },
  {
    "name": "temperature-minus",
    "label": "Temperature Minus",
    "path": "temperature-minus.svg"
  },
  {
    "name": "temperature-plus",
    "label": "Temperature Plus",
    "path": "temperature-plus.svg"
  },
  {
    "name": "template",
    "label": "Template",
    "path": "template.svg"
  },
  {
    "name": "test-pipe-2",
    "label": "Test Pipe 2",
    "path": "test-pipe-2.svg"
  },
  {
    "name": "thumb-down",
    "label": "Thumb Down",
    "path": "thumb-down.svg"
  },
  {
    "name": "thumb-up",
    "label": "Thumb Up",
    "path": "thumb-up.svg"
  },
  {
    "name": "tilt-shift",
    "label": "Tilt Shift",
    "path": "tilt-shift.svg"
  },
  {
    "name": "timeline-event",
    "label": "Timeline Event",
    "path": "timeline-event.svg"
  },
  {
    "name": "toggle-left",
    "label": "Toggle Left",
    "path": "toggle-left.svg"
  },
  {
    "name": "toggle-right",
    "label": "Toggle Right",
    "path": "toggle-right.svg"
  },
  {
    "name": "train",
    "label": "Train",
    "path": "train.svg"
  },
  {
    "name": "transform",
    "label": "Transform",
    "path": "transform.svg"
  },
  {
    "name": "transition-bottom",
    "label": "Transition Bottom",
    "path": "transition-bottom.svg"
  },
  {
    "name": "transition-left",
    "label": "Transition Left",
    "path": "transition-left.svg"
  },
  {
    "name": "transition-right",
    "label": "Transition Right",
    "path": "transition-right.svg"
  },
  {
    "name": "transition-top",
    "label": "Transition Top",
    "path": "transition-top.svg"
  },
  {
    "name": "trash",
    "label": "Trash",
    "path": "trash.svg"
  },
  {
    "name": "trash-x",
    "label": "Trash X",
    "path": "trash-x.svg"
  },
  {
    "name": "triangle",
    "label": "Triangle",
    "path": "triangle.svg"
  },
  {
    "name": "triangle-inverted",
    "label": "Triangle Inverted",
    "path": "triangle-inverted.svg"
  },
  {
    "name": "triangle-square-circle",
    "label": "Triangle Square Circle",
    "path": "triangle-square-circle.svg"
  },
  {
    "name": "trolley",
    "label": "Trolley",
    "path": "trolley.svg"
  },
  {
    "name": "trophy",
    "label": "Trophy",
    "path": "trophy.svg"
  },
  {
    "name": "truck",
    "label": "Truck",
    "path": "truck.svg"
  },
  {
    "name": "ufo",
    "label": "Ufo",
    "path": "ufo.svg"
  },
  {
    "name": "umbrella",
    "label": "Umbrella",
    "path": "umbrella.svg"
  },
  {
    "name": "user",
    "label": "User",
    "path": "user.svg"
  },
  {
    "name": "versions",
    "label": "Versions",
    "path": "versions.svg"
  },
  {
    "name": "video",
    "label": "Video",
    "path": "video.svg"
  },
  {
    "name": "video-minus",
    "label": "Video Minus",
    "path": "video-minus.svg"
  },
  {
    "name": "video-plus",
    "label": "Video Plus",
    "path": "video-plus.svg"
  },
  {
    "name": "windmill",
    "label": "Windmill",
    "path": "windmill.svg"
  },
  {
    "name": "windsock",
    "label": "Windsock",
    "path": "windsock.svg"
  },
  {
    "name": "woman",
    "label": "Woman",
    "path": "woman.svg"
  },
  {
    "name": "writing",
    "label": "Writing",
    "path": "writing.svg"
  },
  {
    "name": "writing-sign",
    "label": "Writing Sign",
    "path": "writing-sign.svg"
  },
  {
    "name": "xbox-a",
    "label": "Xbox A",
    "path": "xbox-a.svg"
  },
  {
    "name": "xbox-b",
    "label": "Xbox B",
    "path": "xbox-b.svg"
  },
  {
    "name": "xbox-x",
    "label": "Xbox X",
    "path": "xbox-x.svg"
  },
  {
    "name": "xbox-y",
    "label": "Xbox Y",
    "path": "xbox-y.svg"
  },
  {
    "name": "yin-yang",
    "label": "Yin Yang",
    "path": "yin-yang.svg"
  },
  {
    "name": "zeppelin",
    "label": "Zeppelin",
    "path": "zeppelin.svg"
  },
  {
    "name": "zoom",
    "label": "Zoom",
    "path": "zoom.svg"
  },
  {
    "name": "zoom-cancel",
    "label": "Zoom Cancel",
    "path": "zoom-cancel.svg"
  },
  {
    "name": "zoom-check",
    "label": "Zoom Check",
    "path": "zoom-check.svg"
  },
  {
    "name": "zoom-code",
    "label": "Zoom Code",
    "path": "zoom-code.svg"
  },
  {
    "name": "zoom-exclamation",
    "label": "Zoom Exclamation",
    "path": "zoom-exclamation.svg"
  },
  {
    "name": "zoom-in",
    "label": "Zoom In",
    "path": "zoom-in.svg"
  },
  {
    "name": "zoom-in-area",
    "label": "Zoom In Area",
    "path": "zoom-in-area.svg"
  },
  {
    "name": "zoom-money",
    "label": "Zoom Money",
    "path": "zoom-money.svg"
  },
  {
    "name": "zoom-out",
    "label": "Zoom Out",
    "path": "zoom-out.svg"
  },
  {
    "name": "zoom-out-area",
    "label": "Zoom Out Area",
    "path": "zoom-out-area.svg"
  },
  {
    "name": "zoom-pan",
    "label": "Zoom Pan",
    "path": "zoom-pan.svg"
  },
  {
    "name": "zoom-question",
    "label": "Zoom Question",
    "path": "zoom-question.svg"
  },
  {
    "name": "zoom-scan",
    "label": "Zoom Scan",
    "path": "zoom-scan.svg"
  }
];

export const OUTLINE_ICONS = [
  {
    "name": "a-b",
    "label": "A B",
    "path": "a-b.svg"
  },
  {
    "name": "a-b-2",
    "label": "A B 2",
    "path": "a-b-2.svg"
  },
  {
    "name": "a-b-off",
    "label": "A B Off",
    "path": "a-b-off.svg"
  },
  {
    "name": "abacus",
    "label": "Abacus",
    "path": "abacus.svg"
  },
  {
    "name": "abacus-off",
    "label": "Abacus Off",
    "path": "abacus-off.svg"
  },
  {
    "name": "abc",
    "label": "Abc",
    "path": "abc.svg"
  },
  {
    "name": "access-point",
    "label": "Access Point",
    "path": "access-point.svg"
  },
  {
    "name": "access-point-off",
    "label": "Access Point Off",
    "path": "access-point-off.svg"
  },
  {
    "name": "accessible",
    "label": "Accessible",
    "path": "accessible.svg"
  },
  {
    "name": "accessible-off",
    "label": "Accessible Off",
    "path": "accessible-off.svg"
  },
  {
    "name": "activity",
    "label": "Activity",
    "path": "activity.svg"
  },
  {
    "name": "activity-heartbeat",
    "label": "Activity Heartbeat",
    "path": "activity-heartbeat.svg"
  },
  {
    "name": "ad",
    "label": "Ad",
    "path": "ad.svg"
  },
  {
    "name": "ad-2",
    "label": "Ad 2",
    "path": "ad-2.svg"
  },
  {
    "name": "ad-circle",
    "label": "Ad Circle",
    "path": "ad-circle.svg"
  },
  {
    "name": "ad-circle-off",
    "label": "Ad Circle Off",
    "path": "ad-circle-off.svg"
  },
  {
    "name": "ad-off",
    "label": "Ad Off",
    "path": "ad-off.svg"
  },
  {
    "name": "address-book",
    "label": "Address Book",
    "path": "address-book.svg"
  },
  {
    "name": "address-book-off",
    "label": "Address Book Off",
    "path": "address-book-off.svg"
  },
  {
    "name": "adjustments",
    "label": "Adjustments",
    "path": "adjustments.svg"
  },
  {
    "name": "adjustments-alt",
    "label": "Adjustments Alt",
    "path": "adjustments-alt.svg"
  },
  {
    "name": "adjustments-bolt",
    "label": "Adjustments Bolt",
    "path": "adjustments-bolt.svg"
  },
  {
    "name": "adjustments-cancel",
    "label": "Adjustments Cancel",
    "path": "adjustments-cancel.svg"
  },
  {
    "name": "adjustments-check",
    "label": "Adjustments Check",
    "path": "adjustments-check.svg"
  },
  {
    "name": "adjustments-code",
    "label": "Adjustments Code",
    "path": "adjustments-code.svg"
  },
  {
    "name": "adjustments-cog",
    "label": "Adjustments Cog",
    "path": "adjustments-cog.svg"
  },
  {
    "name": "adjustments-dollar",
    "label": "Adjustments Dollar",
    "path": "adjustments-dollar.svg"
  },
  {
    "name": "adjustments-down",
    "label": "Adjustments Down",
    "path": "adjustments-down.svg"
  },
  {
    "name": "adjustments-exclamation",
    "label": "Adjustments Exclamation",
    "path": "adjustments-exclamation.svg"
  },
  {
    "name": "adjustments-heart",
    "label": "Adjustments Heart",
    "path": "adjustments-heart.svg"
  },
  {
    "name": "adjustments-horizontal",
    "label": "Adjustments Horizontal",
    "path": "adjustments-horizontal.svg"
  },
  {
    "name": "adjustments-minus",
    "label": "Adjustments Minus",
    "path": "adjustments-minus.svg"
  },
  {
    "name": "adjustments-off",
    "label": "Adjustments Off",
    "path": "adjustments-off.svg"
  },
  {
    "name": "adjustments-pause",
    "label": "Adjustments Pause",
    "path": "adjustments-pause.svg"
  },
  {
    "name": "adjustments-pin",
    "label": "Adjustments Pin",
    "path": "adjustments-pin.svg"
  },
  {
    "name": "adjustments-plus",
    "label": "Adjustments Plus",
    "path": "adjustments-plus.svg"
  },
  {
    "name": "adjustments-question",
    "label": "Adjustments Question",
    "path": "adjustments-question.svg"
  },
  {
    "name": "adjustments-search",
    "label": "Adjustments Search",
    "path": "adjustments-search.svg"
  },
  {
    "name": "adjustments-share",
    "label": "Adjustments Share",
    "path": "adjustments-share.svg"
  },
  {
    "name": "adjustments-spark",
    "label": "Adjustments Spark",
    "path": "adjustments-spark.svg"
  },
  {
    "name": "adjustments-star",
    "label": "Adjustments Star",
    "path": "adjustments-star.svg"
  },
  {
    "name": "adjustments-up",
    "label": "Adjustments Up",
    "path": "adjustments-up.svg"
  },
  {
    "name": "adjustments-x",
    "label": "Adjustments X",
    "path": "adjustments-x.svg"
  },
  {
    "name": "aerial-lift",
    "label": "Aerial Lift",
    "path": "aerial-lift.svg"
  },
  {
    "name": "affiliate",
    "label": "Affiliate",
    "path": "affiliate.svg"
  },
  {
    "name": "ai",
    "label": "Ai",
    "path": "ai.svg"
  },
  {
    "name": "air-balloon",
    "label": "Air Balloon",
    "path": "air-balloon.svg"
  },
  {
    "name": "air-conditioning",
    "label": "Air Conditioning",
    "path": "air-conditioning.svg"
  },
  {
    "name": "air-conditioning-disabled",
    "label": "Air Conditioning Disabled",
    "path": "air-conditioning-disabled.svg"
  },
  {
    "name": "air-traffic-control",
    "label": "Air Traffic Control",
    "path": "air-traffic-control.svg"
  },
  {
    "name": "alarm",
    "label": "Alarm",
    "path": "alarm.svg"
  },
  {
    "name": "alarm-average",
    "label": "Alarm Average",
    "path": "alarm-average.svg"
  },
  {
    "name": "alarm-minus",
    "label": "Alarm Minus",
    "path": "alarm-minus.svg"
  },
  {
    "name": "alarm-off",
    "label": "Alarm Off",
    "path": "alarm-off.svg"
  },
  {
    "name": "alarm-plus",
    "label": "Alarm Plus",
    "path": "alarm-plus.svg"
  },
  {
    "name": "alarm-smoke",
    "label": "Alarm Smoke",
    "path": "alarm-smoke.svg"
  },
  {
    "name": "alarm-snooze",
    "label": "Alarm Snooze",
    "path": "alarm-snooze.svg"
  },
  {
    "name": "album",
    "label": "Album",
    "path": "album.svg"
  },
  {
    "name": "album-off",
    "label": "Album Off",
    "path": "album-off.svg"
  },
  {
    "name": "alert-circle",
    "label": "Alert Circle",
    "path": "alert-circle.svg"
  },
  {
    "name": "alert-circle-off",
    "label": "Alert Circle Off",
    "path": "alert-circle-off.svg"
  },
  {
    "name": "alert-hexagon",
    "label": "Alert Hexagon",
    "path": "alert-hexagon.svg"
  },
  {
    "name": "alert-hexagon-off",
    "label": "Alert Hexagon Off",
    "path": "alert-hexagon-off.svg"
  },
  {
    "name": "alert-octagon",
    "label": "Alert Octagon",
    "path": "alert-octagon.svg"
  },
  {
    "name": "alert-small",
    "label": "Alert Small",
    "path": "alert-small.svg"
  },
  {
    "name": "alert-small-off",
    "label": "Alert Small Off",
    "path": "alert-small-off.svg"
  },
  {
    "name": "alert-square",
    "label": "Alert Square",
    "path": "alert-square.svg"
  },
  {
    "name": "alert-square-rounded",
    "label": "Alert Square Rounded",
    "path": "alert-square-rounded.svg"
  },
  {
    "name": "alert-square-rounded-off",
    "label": "Alert Square Rounded Off",
    "path": "alert-square-rounded-off.svg"
  },
  {
    "name": "alert-triangle",
    "label": "Alert Triangle",
    "path": "alert-triangle.svg"
  },
  {
    "name": "alert-triangle-off",
    "label": "Alert Triangle Off",
    "path": "alert-triangle-off.svg"
  },
  {
    "name": "alien",
    "label": "Alien",
    "path": "alien.svg"
  },
  {
    "name": "align-box-bottom-center",
    "label": "Align Box Bottom Center",
    "path": "align-box-bottom-center.svg"
  },
  {
    "name": "align-box-bottom-left",
    "label": "Align Box Bottom Left",
    "path": "align-box-bottom-left.svg"
  },
  {
    "name": "align-box-bottom-right",
    "label": "Align Box Bottom Right",
    "path": "align-box-bottom-right.svg"
  },
  {
    "name": "align-box-center-bottom",
    "label": "Align Box Center Bottom",
    "path": "align-box-center-bottom.svg"
  },
  {
    "name": "align-box-center-middle",
    "label": "Align Box Center Middle",
    "path": "align-box-center-middle.svg"
  },
  {
    "name": "align-box-center-stretch",
    "label": "Align Box Center Stretch",
    "path": "align-box-center-stretch.svg"
  },
  {
    "name": "align-box-center-top",
    "label": "Align Box Center Top",
    "path": "align-box-center-top.svg"
  },
  {
    "name": "align-box-left-bottom",
    "label": "Align Box Left Bottom",
    "path": "align-box-left-bottom.svg"
  },
  {
    "name": "align-box-left-middle",
    "label": "Align Box Left Middle",
    "path": "align-box-left-middle.svg"
  },
  {
    "name": "align-box-left-stretch",
    "label": "Align Box Left Stretch",
    "path": "align-box-left-stretch.svg"
  },
  {
    "name": "align-box-left-top",
    "label": "Align Box Left Top",
    "path": "align-box-left-top.svg"
  },
  {
    "name": "align-box-right-bottom",
    "label": "Align Box Right Bottom",
    "path": "align-box-right-bottom.svg"
  },
  {
    "name": "align-box-right-middle",
    "label": "Align Box Right Middle",
    "path": "align-box-right-middle.svg"
  },
  {
    "name": "align-box-right-stretch",
    "label": "Align Box Right Stretch",
    "path": "align-box-right-stretch.svg"
  },
  {
    "name": "align-box-right-top",
    "label": "Align Box Right Top",
    "path": "align-box-right-top.svg"
  },
  {
    "name": "align-box-top-center",
    "label": "Align Box Top Center",
    "path": "align-box-top-center.svg"
  },
  {
    "name": "align-box-top-left",
    "label": "Align Box Top Left",
    "path": "align-box-top-left.svg"
  },
  {
    "name": "align-box-top-right",
    "label": "Align Box Top Right",
    "path": "align-box-top-right.svg"
  },
  {
    "name": "align-center",
    "label": "Align Center",
    "path": "align-center.svg"
  },
  {
    "name": "align-justified",
    "label": "Align Justified",
    "path": "align-justified.svg"
  },
  {
    "name": "align-left",
    "label": "Align Left",
    "path": "align-left.svg"
  },
  {
    "name": "align-left-2",
    "label": "Align Left 2",
    "path": "align-left-2.svg"
  },
  {
    "name": "align-right",
    "label": "Align Right",
    "path": "align-right.svg"
  },
  {
    "name": "align-right-2",
    "label": "Align Right 2",
    "path": "align-right-2.svg"
  },
  {
    "name": "alpha",
    "label": "Alpha",
    "path": "alpha.svg"
  },
  {
    "name": "alphabet-arabic",
    "label": "Alphabet Arabic",
    "path": "alphabet-arabic.svg"
  },
  {
    "name": "alphabet-bangla",
    "label": "Alphabet Bangla",
    "path": "alphabet-bangla.svg"
  },
  {
    "name": "alphabet-cyrillic",
    "label": "Alphabet Cyrillic",
    "path": "alphabet-cyrillic.svg"
  },
  {
    "name": "alphabet-greek",
    "label": "Alphabet Greek",
    "path": "alphabet-greek.svg"
  },
  {
    "name": "alphabet-hebrew",
    "label": "Alphabet Hebrew",
    "path": "alphabet-hebrew.svg"
  },
  {
    "name": "alphabet-korean",
    "label": "Alphabet Korean",
    "path": "alphabet-korean.svg"
  },
  {
    "name": "alphabet-latin",
    "label": "Alphabet Latin",
    "path": "alphabet-latin.svg"
  },
  {
    "name": "alphabet-polish",
    "label": "Alphabet Polish",
    "path": "alphabet-polish.svg"
  },
  {
    "name": "alphabet-runes",
    "label": "Alphabet Runes",
    "path": "alphabet-runes.svg"
  },
  {
    "name": "alphabet-thai",
    "label": "Alphabet Thai",
    "path": "alphabet-thai.svg"
  },
  {
    "name": "alt",
    "label": "Alt",
    "path": "alt.svg"
  },
  {
    "name": "ambulance",
    "label": "Ambulance",
    "path": "ambulance.svg"
  },
  {
    "name": "ampersand",
    "label": "Ampersand",
    "path": "ampersand.svg"
  },
  {
    "name": "analyze",
    "label": "Analyze",
    "path": "analyze.svg"
  },
  {
    "name": "analyze-off",
    "label": "Analyze Off",
    "path": "analyze-off.svg"
  },
  {
    "name": "anchor",
    "label": "Anchor",
    "path": "anchor.svg"
  },
  {
    "name": "anchor-off",
    "label": "Anchor Off",
    "path": "anchor-off.svg"
  },
  {
    "name": "angle",
    "label": "Angle",
    "path": "angle.svg"
  },
  {
    "name": "ankh",
    "label": "Ankh",
    "path": "ankh.svg"
  },
  {
    "name": "antenna",
    "label": "Antenna",
    "path": "antenna.svg"
  },
  {
    "name": "antenna-bars-1",
    "label": "Antenna Bars 1",
    "path": "antenna-bars-1.svg"
  },
  {
    "name": "antenna-bars-2",
    "label": "Antenna Bars 2",
    "path": "antenna-bars-2.svg"
  },
  {
    "name": "antenna-bars-3",
    "label": "Antenna Bars 3",
    "path": "antenna-bars-3.svg"
  },
  {
    "name": "antenna-bars-4",
    "label": "Antenna Bars 4",
    "path": "antenna-bars-4.svg"
  },
  {
    "name": "antenna-bars-5",
    "label": "Antenna Bars 5",
    "path": "antenna-bars-5.svg"
  },
  {
    "name": "antenna-bars-off",
    "label": "Antenna Bars Off",
    "path": "antenna-bars-off.svg"
  },
  {
    "name": "antenna-off",
    "label": "Antenna Off",
    "path": "antenna-off.svg"
  },
  {
    "name": "aperture",
    "label": "Aperture",
    "path": "aperture.svg"
  },
  {
    "name": "aperture-off",
    "label": "Aperture Off",
    "path": "aperture-off.svg"
  },
  {
    "name": "api",
    "label": "Api",
    "path": "api.svg"
  },
  {
    "name": "api-app",
    "label": "Api App",
    "path": "api-app.svg"
  },
  {
    "name": "api-app-off",
    "label": "Api App Off",
    "path": "api-app-off.svg"
  },
  {
    "name": "api-off",
    "label": "Api Off",
    "path": "api-off.svg"
  },
  {
    "name": "app-window",
    "label": "App Window",
    "path": "app-window.svg"
  },
  {
    "name": "apple",
    "label": "Apple",
    "path": "apple.svg"
  },
  {
    "name": "apps",
    "label": "Apps",
    "path": "apps.svg"
  },
  {
    "name": "apps-off",
    "label": "Apps Off",
    "path": "apps-off.svg"
  },
  {
    "name": "archery-arrow",
    "label": "Archery Arrow",
    "path": "archery-arrow.svg"
  },
  {
    "name": "archive",
    "label": "Archive",
    "path": "archive.svg"
  },
  {
    "name": "archive-off",
    "label": "Archive Off",
    "path": "archive-off.svg"
  },
  {
    "name": "armchair",
    "label": "Armchair",
    "path": "armchair.svg"
  },
  {
    "name": "armchair-2",
    "label": "Armchair 2",
    "path": "armchair-2.svg"
  },
  {
    "name": "armchair-2-off",
    "label": "Armchair 2 Off",
    "path": "armchair-2-off.svg"
  },
  {
    "name": "armchair-off",
    "label": "Armchair Off",
    "path": "armchair-off.svg"
  },
  {
    "name": "arrow-autofit-content",
    "label": "Arrow Autofit Content",
    "path": "arrow-autofit-content.svg"
  },
  {
    "name": "arrow-autofit-down",
    "label": "Arrow Autofit Down",
    "path": "arrow-autofit-down.svg"
  },
  {
    "name": "arrow-autofit-height",
    "label": "Arrow Autofit Height",
    "path": "arrow-autofit-height.svg"
  },
  {
    "name": "arrow-autofit-left",
    "label": "Arrow Autofit Left",
    "path": "arrow-autofit-left.svg"
  },
  {
    "name": "arrow-autofit-right",
    "label": "Arrow Autofit Right",
    "path": "arrow-autofit-right.svg"
  },
  {
    "name": "arrow-autofit-up",
    "label": "Arrow Autofit Up",
    "path": "arrow-autofit-up.svg"
  },
  {
    "name": "arrow-autofit-width",
    "label": "Arrow Autofit Width",
    "path": "arrow-autofit-width.svg"
  },
  {
    "name": "arrow-back",
    "label": "Arrow Back",
    "path": "arrow-back.svg"
  },
  {
    "name": "arrow-back-up",
    "label": "Arrow Back Up",
    "path": "arrow-back-up.svg"
  },
  {
    "name": "arrow-back-up-double",
    "label": "Arrow Back Up Double",
    "path": "arrow-back-up-double.svg"
  },
  {
    "name": "arrow-badge-down",
    "label": "Arrow Badge Down",
    "path": "arrow-badge-down.svg"
  },
  {
    "name": "arrow-badge-left",
    "label": "Arrow Badge Left",
    "path": "arrow-badge-left.svg"
  },
  {
    "name": "arrow-badge-right",
    "label": "Arrow Badge Right",
    "path": "arrow-badge-right.svg"
  },
  {
    "name": "arrow-badge-up",
    "label": "Arrow Badge Up",
    "path": "arrow-badge-up.svg"
  },
  {
    "name": "arrow-bar-both",
    "label": "Arrow Bar Both",
    "path": "arrow-bar-both.svg"
  },
  {
    "name": "arrow-bar-down",
    "label": "Arrow Bar Down",
    "path": "arrow-bar-down.svg"
  },
  {
    "name": "arrow-bar-left",
    "label": "Arrow Bar Left",
    "path": "arrow-bar-left.svg"
  },
  {
    "name": "arrow-bar-right",
    "label": "Arrow Bar Right",
    "path": "arrow-bar-right.svg"
  },
  {
    "name": "arrow-bar-to-down",
    "label": "Arrow Bar To Down",
    "path": "arrow-bar-to-down.svg"
  },
  {
    "name": "arrow-bar-to-down-dashed",
    "label": "Arrow Bar To Down Dashed",
    "path": "arrow-bar-to-down-dashed.svg"
  },
  {
    "name": "arrow-bar-to-left",
    "label": "Arrow Bar To Left",
    "path": "arrow-bar-to-left.svg"
  },
  {
    "name": "arrow-bar-to-left-dashed",
    "label": "Arrow Bar To Left Dashed",
    "path": "arrow-bar-to-left-dashed.svg"
  },
  {
    "name": "arrow-bar-to-right",
    "label": "Arrow Bar To Right",
    "path": "arrow-bar-to-right.svg"
  },
  {
    "name": "arrow-bar-to-right-dashed",
    "label": "Arrow Bar To Right Dashed",
    "path": "arrow-bar-to-right-dashed.svg"
  },
  {
    "name": "arrow-bar-to-up",
    "label": "Arrow Bar To Up",
    "path": "arrow-bar-to-up.svg"
  },
  {
    "name": "arrow-bar-to-up-dashed",
    "label": "Arrow Bar To Up Dashed",
    "path": "arrow-bar-to-up-dashed.svg"
  },
  {
    "name": "arrow-bar-up",
    "label": "Arrow Bar Up",
    "path": "arrow-bar-up.svg"
  },
  {
    "name": "arrow-bear-left",
    "label": "Arrow Bear Left",
    "path": "arrow-bear-left.svg"
  },
  {
    "name": "arrow-bear-left-2",
    "label": "Arrow Bear Left 2",
    "path": "arrow-bear-left-2.svg"
  },
  {
    "name": "arrow-bear-right",
    "label": "Arrow Bear Right",
    "path": "arrow-bear-right.svg"
  },
  {
    "name": "arrow-bear-right-2",
    "label": "Arrow Bear Right 2",
    "path": "arrow-bear-right-2.svg"
  },
  {
    "name": "arrow-big-down",
    "label": "Arrow Big Down",
    "path": "arrow-big-down.svg"
  },
  {
    "name": "arrow-big-down-line",
    "label": "Arrow Big Down Line",
    "path": "arrow-big-down-line.svg"
  },
  {
    "name": "arrow-big-down-lines",
    "label": "Arrow Big Down Lines",
    "path": "arrow-big-down-lines.svg"
  },
  {
    "name": "arrow-big-left",
    "label": "Arrow Big Left",
    "path": "arrow-big-left.svg"
  },
  {
    "name": "arrow-big-left-line",
    "label": "Arrow Big Left Line",
    "path": "arrow-big-left-line.svg"
  },
  {
    "name": "arrow-big-left-lines",
    "label": "Arrow Big Left Lines",
    "path": "arrow-big-left-lines.svg"
  },
  {
    "name": "arrow-big-right",
    "label": "Arrow Big Right",
    "path": "arrow-big-right.svg"
  },
  {
    "name": "arrow-big-right-line",
    "label": "Arrow Big Right Line",
    "path": "arrow-big-right-line.svg"
  },
  {
    "name": "arrow-big-right-lines",
    "label": "Arrow Big Right Lines",
    "path": "arrow-big-right-lines.svg"
  },
  {
    "name": "arrow-big-up",
    "label": "Arrow Big Up",
    "path": "arrow-big-up.svg"
  },
  {
    "name": "arrow-big-up-line",
    "label": "Arrow Big Up Line",
    "path": "arrow-big-up-line.svg"
  },
  {
    "name": "arrow-big-up-lines",
    "label": "Arrow Big Up Lines",
    "path": "arrow-big-up-lines.svg"
  },
  {
    "name": "arrow-bounce",
    "label": "Arrow Bounce",
    "path": "arrow-bounce.svg"
  },
  {
    "name": "arrow-capsule",
    "label": "Arrow Capsule",
    "path": "arrow-capsule.svg"
  },
  {
    "name": "arrow-curve-left",
    "label": "Arrow Curve Left",
    "path": "arrow-curve-left.svg"
  },
  {
    "name": "arrow-curve-right",
    "label": "Arrow Curve Right",
    "path": "arrow-curve-right.svg"
  },
  {
    "name": "arrow-down",
    "label": "Arrow Down",
    "path": "arrow-down.svg"
  },
  {
    "name": "arrow-down-bar",
    "label": "Arrow Down Bar",
    "path": "arrow-down-bar.svg"
  },
  {
    "name": "arrow-down-circle",
    "label": "Arrow Down Circle",
    "path": "arrow-down-circle.svg"
  },
  {
    "name": "arrow-down-dashed",
    "label": "Arrow Down Dashed",
    "path": "arrow-down-dashed.svg"
  },
  {
    "name": "arrow-down-from-arc",
    "label": "Arrow Down From Arc",
    "path": "arrow-down-from-arc.svg"
  },
  {
    "name": "arrow-down-left",
    "label": "Arrow Down Left",
    "path": "arrow-down-left.svg"
  },
  {
    "name": "arrow-down-left-circle",
    "label": "Arrow Down Left Circle",
    "path": "arrow-down-left-circle.svg"
  },
  {
    "name": "arrow-down-rhombus",
    "label": "Arrow Down Rhombus",
    "path": "arrow-down-rhombus.svg"
  },
  {
    "name": "arrow-down-right",
    "label": "Arrow Down Right",
    "path": "arrow-down-right.svg"
  },
  {
    "name": "arrow-down-right-circle",
    "label": "Arrow Down Right Circle",
    "path": "arrow-down-right-circle.svg"
  },
  {
    "name": "arrow-down-square",
    "label": "Arrow Down Square",
    "path": "arrow-down-square.svg"
  },
  {
    "name": "arrow-down-tail",
    "label": "Arrow Down Tail",
    "path": "arrow-down-tail.svg"
  },
  {
    "name": "arrow-down-to-arc",
    "label": "Arrow Down To Arc",
    "path": "arrow-down-to-arc.svg"
  },
  {
    "name": "arrow-elbow-left",
    "label": "Arrow Elbow Left",
    "path": "arrow-elbow-left.svg"
  },
  {
    "name": "arrow-elbow-right",
    "label": "Arrow Elbow Right",
    "path": "arrow-elbow-right.svg"
  },
  {
    "name": "arrow-fork",
    "label": "Arrow Fork",
    "path": "arrow-fork.svg"
  },
  {
    "name": "arrow-forward",
    "label": "Arrow Forward",
    "path": "arrow-forward.svg"
  },
  {
    "name": "arrow-forward-up",
    "label": "Arrow Forward Up",
    "path": "arrow-forward-up.svg"
  },
  {
    "name": "arrow-forward-up-double",
    "label": "Arrow Forward Up Double",
    "path": "arrow-forward-up-double.svg"
  },
  {
    "name": "arrow-guide",
    "label": "Arrow Guide",
    "path": "arrow-guide.svg"
  },
  {
    "name": "arrow-iteration",
    "label": "Arrow Iteration",
    "path": "arrow-iteration.svg"
  },
  {
    "name": "arrow-left",
    "label": "Arrow Left",
    "path": "arrow-left.svg"
  },
  {
    "name": "arrow-left-bar",
    "label": "Arrow Left Bar",
    "path": "arrow-left-bar.svg"
  },
  {
    "name": "arrow-left-circle",
    "label": "Arrow Left Circle",
    "path": "arrow-left-circle.svg"
  },
  {
    "name": "arrow-left-dashed",
    "label": "Arrow Left Dashed",
    "path": "arrow-left-dashed.svg"
  },
  {
    "name": "arrow-left-from-arc",
    "label": "Arrow Left From Arc",
    "path": "arrow-left-from-arc.svg"
  },
  {
    "name": "arrow-left-rhombus",
    "label": "Arrow Left Rhombus",
    "path": "arrow-left-rhombus.svg"
  },
  {
    "name": "arrow-left-right",
    "label": "Arrow Left Right",
    "path": "arrow-left-right.svg"
  },
  {
    "name": "arrow-left-square",
    "label": "Arrow Left Square",
    "path": "arrow-left-square.svg"
  },
  {
    "name": "arrow-left-tail",
    "label": "Arrow Left Tail",
    "path": "arrow-left-tail.svg"
  },
  {
    "name": "arrow-left-to-arc",
    "label": "Arrow Left To Arc",
    "path": "arrow-left-to-arc.svg"
  },
  {
    "name": "arrow-loop-left",
    "label": "Arrow Loop Left",
    "path": "arrow-loop-left.svg"
  },
  {
    "name": "arrow-loop-left-2",
    "label": "Arrow Loop Left 2",
    "path": "arrow-loop-left-2.svg"
  },
  {
    "name": "arrow-loop-right",
    "label": "Arrow Loop Right",
    "path": "arrow-loop-right.svg"
  },
  {
    "name": "arrow-loop-right-2",
    "label": "Arrow Loop Right 2",
    "path": "arrow-loop-right-2.svg"
  },
  {
    "name": "arrow-merge",
    "label": "Arrow Merge",
    "path": "arrow-merge.svg"
  },
  {
    "name": "arrow-merge-alt-left",
    "label": "Arrow Merge Alt Left",
    "path": "arrow-merge-alt-left.svg"
  },
  {
    "name": "arrow-merge-alt-right",
    "label": "Arrow Merge Alt Right",
    "path": "arrow-merge-alt-right.svg"
  },
  {
    "name": "arrow-merge-both",
    "label": "Arrow Merge Both",
    "path": "arrow-merge-both.svg"
  },
  {
    "name": "arrow-merge-left",
    "label": "Arrow Merge Left",
    "path": "arrow-merge-left.svg"
  },
  {
    "name": "arrow-merge-right",
    "label": "Arrow Merge Right",
    "path": "arrow-merge-right.svg"
  },
  {
    "name": "arrow-move-down",
    "label": "Arrow Move Down",
    "path": "arrow-move-down.svg"
  },
  {
    "name": "arrow-move-left",
    "label": "Arrow Move Left",
    "path": "arrow-move-left.svg"
  },
  {
    "name": "arrow-move-right",
    "label": "Arrow Move Right",
    "path": "arrow-move-right.svg"
  },
  {
    "name": "arrow-move-up",
    "label": "Arrow Move Up",
    "path": "arrow-move-up.svg"
  },
  {
    "name": "arrow-narrow-down",
    "label": "Arrow Narrow Down",
    "path": "arrow-narrow-down.svg"
  },
  {
    "name": "arrow-narrow-down-dashed",
    "label": "Arrow Narrow Down Dashed",
    "path": "arrow-narrow-down-dashed.svg"
  },
  {
    "name": "arrow-narrow-left",
    "label": "Arrow Narrow Left",
    "path": "arrow-narrow-left.svg"
  },
  {
    "name": "arrow-narrow-left-dashed",
    "label": "Arrow Narrow Left Dashed",
    "path": "arrow-narrow-left-dashed.svg"
  },
  {
    "name": "arrow-narrow-right",
    "label": "Arrow Narrow Right",
    "path": "arrow-narrow-right.svg"
  },
  {
    "name": "arrow-narrow-right-dashed",
    "label": "Arrow Narrow Right Dashed",
    "path": "arrow-narrow-right-dashed.svg"
  },
  {
    "name": "arrow-narrow-up",
    "label": "Arrow Narrow Up",
    "path": "arrow-narrow-up.svg"
  },
  {
    "name": "arrow-narrow-up-dashed",
    "label": "Arrow Narrow Up Dashed",
    "path": "arrow-narrow-up-dashed.svg"
  },
  {
    "name": "arrow-ramp-left",
    "label": "Arrow Ramp Left",
    "path": "arrow-ramp-left.svg"
  },
  {
    "name": "arrow-ramp-left-2",
    "label": "Arrow Ramp Left 2",
    "path": "arrow-ramp-left-2.svg"
  },
  {
    "name": "arrow-ramp-left-3",
    "label": "Arrow Ramp Left 3",
    "path": "arrow-ramp-left-3.svg"
  },
  {
    "name": "arrow-ramp-right",
    "label": "Arrow Ramp Right",
    "path": "arrow-ramp-right.svg"
  },
  {
    "name": "arrow-ramp-right-2",
    "label": "Arrow Ramp Right 2",
    "path": "arrow-ramp-right-2.svg"
  },
  {
    "name": "arrow-ramp-right-3",
    "label": "Arrow Ramp Right 3",
    "path": "arrow-ramp-right-3.svg"
  },
  {
    "name": "arrow-right",
    "label": "Arrow Right",
    "path": "arrow-right.svg"
  },
  {
    "name": "arrow-right-bar",
    "label": "Arrow Right Bar",
    "path": "arrow-right-bar.svg"
  },
  {
    "name": "arrow-right-circle",
    "label": "Arrow Right Circle",
    "path": "arrow-right-circle.svg"
  },
  {
    "name": "arrow-right-dashed",
    "label": "Arrow Right Dashed",
    "path": "arrow-right-dashed.svg"
  },
  {
    "name": "arrow-right-from-arc",
    "label": "Arrow Right From Arc",
    "path": "arrow-right-from-arc.svg"
  },
  {
    "name": "arrow-right-rhombus",
    "label": "Arrow Right Rhombus",
    "path": "arrow-right-rhombus.svg"
  },
  {
    "name": "arrow-right-square",
    "label": "Arrow Right Square",
    "path": "arrow-right-square.svg"
  },
  {
    "name": "arrow-right-tail",
    "label": "Arrow Right Tail",
    "path": "arrow-right-tail.svg"
  },
  {
    "name": "arrow-right-to-arc",
    "label": "Arrow Right To Arc",
    "path": "arrow-right-to-arc.svg"
  },
  {
    "name": "arrow-rotary-first-left",
    "label": "Arrow Rotary First Left",
    "path": "arrow-rotary-first-left.svg"
  },
  {
    "name": "arrow-rotary-first-right",
    "label": "Arrow Rotary First Right",
    "path": "arrow-rotary-first-right.svg"
  },
  {
    "name": "arrow-rotary-last-left",
    "label": "Arrow Rotary Last Left",
    "path": "arrow-rotary-last-left.svg"
  },
  {
    "name": "arrow-rotary-last-right",
    "label": "Arrow Rotary Last Right",
    "path": "arrow-rotary-last-right.svg"
  },
  {
    "name": "arrow-rotary-left",
    "label": "Arrow Rotary Left",
    "path": "arrow-rotary-left.svg"
  },
  {
    "name": "arrow-rotary-right",
    "label": "Arrow Rotary Right",
    "path": "arrow-rotary-right.svg"
  },
  {
    "name": "arrow-rotary-straight",
    "label": "Arrow Rotary Straight",
    "path": "arrow-rotary-straight.svg"
  },
  {
    "name": "arrow-roundabout-left",
    "label": "Arrow Roundabout Left",
    "path": "arrow-roundabout-left.svg"
  },
  {
    "name": "arrow-roundabout-right",
    "label": "Arrow Roundabout Right",
    "path": "arrow-roundabout-right.svg"
  },
  {
    "name": "arrow-sharp-turn-left",
    "label": "Arrow Sharp Turn Left",
    "path": "arrow-sharp-turn-left.svg"
  },
  {
    "name": "arrow-sharp-turn-right",
    "label": "Arrow Sharp Turn Right",
    "path": "arrow-sharp-turn-right.svg"
  },
  {
    "name": "arrow-up",
    "label": "Arrow Up",
    "path": "arrow-up.svg"
  },
  {
    "name": "arrow-up-bar",
    "label": "Arrow Up Bar",
    "path": "arrow-up-bar.svg"
  },
  {
    "name": "arrow-up-circle",
    "label": "Arrow Up Circle",
    "path": "arrow-up-circle.svg"
  },
  {
    "name": "arrow-up-dashed",
    "label": "Arrow Up Dashed",
    "path": "arrow-up-dashed.svg"
  },
  {
    "name": "arrow-up-from-arc",
    "label": "Arrow Up From Arc",
    "path": "arrow-up-from-arc.svg"
  },
  {
    "name": "arrow-up-left",
    "label": "Arrow Up Left",
    "path": "arrow-up-left.svg"
  },
  {
    "name": "arrow-up-left-circle",
    "label": "Arrow Up Left Circle",
    "path": "arrow-up-left-circle.svg"
  },
  {
    "name": "arrow-up-rhombus",
    "label": "Arrow Up Rhombus",
    "path": "arrow-up-rhombus.svg"
  },
  {
    "name": "arrow-up-right",
    "label": "Arrow Up Right",
    "path": "arrow-up-right.svg"
  },
  {
    "name": "arrow-up-right-circle",
    "label": "Arrow Up Right Circle",
    "path": "arrow-up-right-circle.svg"
  },
  {
    "name": "arrow-up-square",
    "label": "Arrow Up Square",
    "path": "arrow-up-square.svg"
  },
  {
    "name": "arrow-up-tail",
    "label": "Arrow Up Tail",
    "path": "arrow-up-tail.svg"
  },
  {
    "name": "arrow-up-to-arc",
    "label": "Arrow Up To Arc",
    "path": "arrow-up-to-arc.svg"
  },
  {
    "name": "arrow-wave-left-down",
    "label": "Arrow Wave Left Down",
    "path": "arrow-wave-left-down.svg"
  },
  {
    "name": "arrow-wave-left-up",
    "label": "Arrow Wave Left Up",
    "path": "arrow-wave-left-up.svg"
  },
  {
    "name": "arrow-wave-right-down",
    "label": "Arrow Wave Right Down",
    "path": "arrow-wave-right-down.svg"
  },
  {
    "name": "arrow-wave-right-up",
    "label": "Arrow Wave Right Up",
    "path": "arrow-wave-right-up.svg"
  },
  {
    "name": "arrow-zig-zag",
    "label": "Arrow Zig Zag",
    "path": "arrow-zig-zag.svg"
  },
  {
    "name": "arrows-cross",
    "label": "Arrows Cross",
    "path": "arrows-cross.svg"
  },
  {
    "name": "arrows-diagonal",
    "label": "Arrows Diagonal",
    "path": "arrows-diagonal.svg"
  },
  {
    "name": "arrows-diagonal-2",
    "label": "Arrows Diagonal 2",
    "path": "arrows-diagonal-2.svg"
  },
  {
    "name": "arrows-diagonal-minimize",
    "label": "Arrows Diagonal Minimize",
    "path": "arrows-diagonal-minimize.svg"
  },
  {
    "name": "arrows-diagonal-minimize-2",
    "label": "Arrows Diagonal Minimize 2",
    "path": "arrows-diagonal-minimize-2.svg"
  },
  {
    "name": "arrows-diff",
    "label": "Arrows Diff",
    "path": "arrows-diff.svg"
  },
  {
    "name": "arrows-double-ne-sw",
    "label": "Arrows Double Ne Sw",
    "path": "arrows-double-ne-sw.svg"
  },
  {
    "name": "arrows-double-nw-se",
    "label": "Arrows Double Nw Se",
    "path": "arrows-double-nw-se.svg"
  },
  {
    "name": "arrows-double-se-nw",
    "label": "Arrows Double Se Nw",
    "path": "arrows-double-se-nw.svg"
  },
  {
    "name": "arrows-double-sw-ne",
    "label": "Arrows Double Sw Ne",
    "path": "arrows-double-sw-ne.svg"
  },
  {
    "name": "arrows-down",
    "label": "Arrows Down",
    "path": "arrows-down.svg"
  },
  {
    "name": "arrows-down-up",
    "label": "Arrows Down Up",
    "path": "arrows-down-up.svg"
  },
  {
    "name": "arrows-exchange",
    "label": "Arrows Exchange",
    "path": "arrows-exchange.svg"
  },
  {
    "name": "arrows-exchange-2",
    "label": "Arrows Exchange 2",
    "path": "arrows-exchange-2.svg"
  },
  {
    "name": "arrows-horizontal",
    "label": "Arrows Horizontal",
    "path": "arrows-horizontal.svg"
  },
  {
    "name": "arrows-join",
    "label": "Arrows Join",
    "path": "arrows-join.svg"
  },
  {
    "name": "arrows-join-2",
    "label": "Arrows Join 2",
    "path": "arrows-join-2.svg"
  },
  {
    "name": "arrows-left",
    "label": "Arrows Left",
    "path": "arrows-left.svg"
  },
  {
    "name": "arrows-left-down",
    "label": "Arrows Left Down",
    "path": "arrows-left-down.svg"
  },
  {
    "name": "arrows-left-right",
    "label": "Arrows Left Right",
    "path": "arrows-left-right.svg"
  },
  {
    "name": "arrows-maximize",
    "label": "Arrows Maximize",
    "path": "arrows-maximize.svg"
  },
  {
    "name": "arrows-minimize",
    "label": "Arrows Minimize",
    "path": "arrows-minimize.svg"
  },
  {
    "name": "arrows-move",
    "label": "Arrows Move",
    "path": "arrows-move.svg"
  },
  {
    "name": "arrows-move-horizontal",
    "label": "Arrows Move Horizontal",
    "path": "arrows-move-horizontal.svg"
  },
  {
    "name": "arrows-move-vertical",
    "label": "Arrows Move Vertical",
    "path": "arrows-move-vertical.svg"
  },
  {
    "name": "arrows-random",
    "label": "Arrows Random",
    "path": "arrows-random.svg"
  },
  {
    "name": "arrows-right",
    "label": "Arrows Right",
    "path": "arrows-right.svg"
  },
  {
    "name": "arrows-right-down",
    "label": "Arrows Right Down",
    "path": "arrows-right-down.svg"
  },
  {
    "name": "arrows-right-left",
    "label": "Arrows Right Left",
    "path": "arrows-right-left.svg"
  },
  {
    "name": "arrows-shuffle",
    "label": "Arrows Shuffle",
    "path": "arrows-shuffle.svg"
  },
  {
    "name": "arrows-shuffle-2",
    "label": "Arrows Shuffle 2",
    "path": "arrows-shuffle-2.svg"
  },
  {
    "name": "arrows-sort",
    "label": "Arrows Sort",
    "path": "arrows-sort.svg"
  },
  {
    "name": "arrows-split",
    "label": "Arrows Split",
    "path": "arrows-split.svg"
  },
  {
    "name": "arrows-split-2",
    "label": "Arrows Split 2",
    "path": "arrows-split-2.svg"
  },
  {
    "name": "arrows-transfer-down",
    "label": "Arrows Transfer Down",
    "path": "arrows-transfer-down.svg"
  },
  {
    "name": "arrows-transfer-up",
    "label": "Arrows Transfer Up",
    "path": "arrows-transfer-up.svg"
  },
  {
    "name": "arrows-transfer-up-down",
    "label": "Arrows Transfer Up Down",
    "path": "arrows-transfer-up-down.svg"
  },
  {
    "name": "arrows-up",
    "label": "Arrows Up",
    "path": "arrows-up.svg"
  },
  {
    "name": "arrows-up-down",
    "label": "Arrows Up Down",
    "path": "arrows-up-down.svg"
  },
  {
    "name": "arrows-up-left",
    "label": "Arrows Up Left",
    "path": "arrows-up-left.svg"
  },
  {
    "name": "arrows-up-right",
    "label": "Arrows Up Right",
    "path": "arrows-up-right.svg"
  },
  {
    "name": "arrows-vertical",
    "label": "Arrows Vertical",
    "path": "arrows-vertical.svg"
  },
  {
    "name": "artboard",
    "label": "Artboard",
    "path": "artboard.svg"
  },
  {
    "name": "artboard-off",
    "label": "Artboard Off",
    "path": "artboard-off.svg"
  },
  {
    "name": "article",
    "label": "Article",
    "path": "article.svg"
  },
  {
    "name": "article-off",
    "label": "Article Off",
    "path": "article-off.svg"
  },
  {
    "name": "aspect-ratio",
    "label": "Aspect Ratio",
    "path": "aspect-ratio.svg"
  },
  {
    "name": "aspect-ratio-off",
    "label": "Aspect Ratio Off",
    "path": "aspect-ratio-off.svg"
  },
  {
    "name": "assembly",
    "label": "Assembly",
    "path": "assembly.svg"
  },
  {
    "name": "assembly-off",
    "label": "Assembly Off",
    "path": "assembly-off.svg"
  },
  {
    "name": "asset",
    "label": "Asset",
    "path": "asset.svg"
  },
  {
    "name": "asterisk",
    "label": "Asterisk",
    "path": "asterisk.svg"
  },
  {
    "name": "asterisk-simple",
    "label": "Asterisk Simple",
    "path": "asterisk-simple.svg"
  },
  {
    "name": "at",
    "label": "At",
    "path": "at.svg"
  },
  {
    "name": "at-off",
    "label": "At Off",
    "path": "at-off.svg"
  },
  {
    "name": "atom",
    "label": "Atom",
    "path": "atom.svg"
  },
  {
    "name": "atom-2",
    "label": "Atom 2",
    "path": "atom-2.svg"
  },
  {
    "name": "atom-off",
    "label": "Atom Off",
    "path": "atom-off.svg"
  },
  {
    "name": "augmented-reality",
    "label": "Augmented Reality",
    "path": "augmented-reality.svg"
  },
  {
    "name": "augmented-reality-2",
    "label": "Augmented Reality 2",
    "path": "augmented-reality-2.svg"
  },
  {
    "name": "augmented-reality-off",
    "label": "Augmented Reality Off",
    "path": "augmented-reality-off.svg"
  },
  {
    "name": "auth-2fa",
    "label": "Auth 2fa",
    "path": "auth-2fa.svg"
  },
  {
    "name": "automatic-gearbox",
    "label": "Automatic Gearbox",
    "path": "automatic-gearbox.svg"
  },
  {
    "name": "automation",
    "label": "Automation",
    "path": "automation.svg"
  },
  {
    "name": "avocado",
    "label": "Avocado",
    "path": "avocado.svg"
  },
  {
    "name": "award",
    "label": "Award",
    "path": "award.svg"
  },
  {
    "name": "award-off",
    "label": "Award Off",
    "path": "award-off.svg"
  },
  {
    "name": "axe",
    "label": "Axe",
    "path": "axe.svg"
  },
  {
    "name": "axis-x",
    "label": "Axis X",
    "path": "axis-x.svg"
  },
  {
    "name": "axis-y",
    "label": "Axis Y",
    "path": "axis-y.svg"
  },
  {
    "name": "baby-bottle",
    "label": "Baby Bottle",
    "path": "baby-bottle.svg"
  },
  {
    "name": "baby-carriage",
    "label": "Baby Carriage",
    "path": "baby-carriage.svg"
  },
  {
    "name": "background",
    "label": "Background",
    "path": "background.svg"
  },
  {
    "name": "backhoe",
    "label": "Backhoe",
    "path": "backhoe.svg"
  },
  {
    "name": "backpack",
    "label": "Backpack",
    "path": "backpack.svg"
  },
  {
    "name": "backpack-off",
    "label": "Backpack Off",
    "path": "backpack-off.svg"
  },
  {
    "name": "backslash",
    "label": "Backslash",
    "path": "backslash.svg"
  },
  {
    "name": "backspace",
    "label": "Backspace",
    "path": "backspace.svg"
  },
  {
    "name": "badge",
    "label": "Badge",
    "path": "badge.svg"
  },
  {
    "name": "badge-2k",
    "label": "Badge 2k",
    "path": "badge-2k.svg"
  },
  {
    "name": "badge-3d",
    "label": "Badge 3d",
    "path": "badge-3d.svg"
  },
  {
    "name": "badge-3k",
    "label": "Badge 3k",
    "path": "badge-3k.svg"
  },
  {
    "name": "badge-4k",
    "label": "Badge 4k",
    "path": "badge-4k.svg"
  },
  {
    "name": "badge-5k",
    "label": "Badge 5k",
    "path": "badge-5k.svg"
  },
  {
    "name": "badge-8k",
    "label": "Badge 8k",
    "path": "badge-8k.svg"
  },
  {
    "name": "badge-ad",
    "label": "Badge Ad",
    "path": "badge-ad.svg"
  },
  {
    "name": "badge-ad-off",
    "label": "Badge Ad Off",
    "path": "badge-ad-off.svg"
  },
  {
    "name": "badge-ar",
    "label": "Badge Ar",
    "path": "badge-ar.svg"
  },
  {
    "name": "badge-cc",
    "label": "Badge Cc",
    "path": "badge-cc.svg"
  },
  {
    "name": "badge-hd",
    "label": "Badge Hd",
    "path": "badge-hd.svg"
  },
  {
    "name": "badge-off",
    "label": "Badge Off",
    "path": "badge-off.svg"
  },
  {
    "name": "badge-sd",
    "label": "Badge Sd",
    "path": "badge-sd.svg"
  },
  {
    "name": "badge-tm",
    "label": "Badge Tm",
    "path": "badge-tm.svg"
  },
  {
    "name": "badge-vo",
    "label": "Badge Vo",
    "path": "badge-vo.svg"
  },
  {
    "name": "badge-vr",
    "label": "Badge Vr",
    "path": "badge-vr.svg"
  },
  {
    "name": "badge-wc",
    "label": "Badge Wc",
    "path": "badge-wc.svg"
  },
  {
    "name": "badges",
    "label": "Badges",
    "path": "badges.svg"
  },
  {
    "name": "badges-off",
    "label": "Badges Off",
    "path": "badges-off.svg"
  },
  {
    "name": "baguette",
    "label": "Baguette",
    "path": "baguette.svg"
  },
  {
    "name": "ball-american-football",
    "label": "Ball American Football",
    "path": "ball-american-football.svg"
  },
  {
    "name": "ball-american-football-off",
    "label": "Ball American Football Off",
    "path": "ball-american-football-off.svg"
  },
  {
    "name": "ball-baseball",
    "label": "Ball Baseball",
    "path": "ball-baseball.svg"
  },
  {
    "name": "ball-basketball",
    "label": "Ball Basketball",
    "path": "ball-basketball.svg"
  },
  {
    "name": "ball-bowling",
    "label": "Ball Bowling",
    "path": "ball-bowling.svg"
  },
  {
    "name": "ball-football",
    "label": "Ball Football",
    "path": "ball-football.svg"
  },
  {
    "name": "ball-football-off",
    "label": "Ball Football Off",
    "path": "ball-football-off.svg"
  },
  {
    "name": "ball-tennis",
    "label": "Ball Tennis",
    "path": "ball-tennis.svg"
  },
  {
    "name": "ball-volleyball",
    "label": "Ball Volleyball",
    "path": "ball-volleyball.svg"
  },
  {
    "name": "balloon",
    "label": "Balloon",
    "path": "balloon.svg"
  },
  {
    "name": "balloon-off",
    "label": "Balloon Off",
    "path": "balloon-off.svg"
  },
  {
    "name": "ballpen",
    "label": "Ballpen",
    "path": "ballpen.svg"
  },
  {
    "name": "ballpen-off",
    "label": "Ballpen Off",
    "path": "ballpen-off.svg"
  },
  {
    "name": "ban",
    "label": "Ban",
    "path": "ban.svg"
  },
  {
    "name": "bandage",
    "label": "Bandage",
    "path": "bandage.svg"
  },
  {
    "name": "bandage-off",
    "label": "Bandage Off",
    "path": "bandage-off.svg"
  },
  {
    "name": "barbell",
    "label": "Barbell",
    "path": "barbell.svg"
  },
  {
    "name": "barbell-off",
    "label": "Barbell Off",
    "path": "barbell-off.svg"
  },
  {
    "name": "barcode",
    "label": "Barcode",
    "path": "barcode.svg"
  },
  {
    "name": "barcode-off",
    "label": "Barcode Off",
    "path": "barcode-off.svg"
  },
  {
    "name": "barrel",
    "label": "Barrel",
    "path": "barrel.svg"
  },
  {
    "name": "barrel-off",
    "label": "Barrel Off",
    "path": "barrel-off.svg"
  },
  {
    "name": "barrier-block",
    "label": "Barrier Block",
    "path": "barrier-block.svg"
  },
  {
    "name": "barrier-block-off",
    "label": "Barrier Block Off",
    "path": "barrier-block-off.svg"
  },
  {
    "name": "baseline",
    "label": "Baseline",
    "path": "baseline.svg"
  },
  {
    "name": "baseline-density-large",
    "label": "Baseline Density Large",
    "path": "baseline-density-large.svg"
  },
  {
    "name": "baseline-density-medium",
    "label": "Baseline Density Medium",
    "path": "baseline-density-medium.svg"
  },
  {
    "name": "baseline-density-small",
    "label": "Baseline Density Small",
    "path": "baseline-density-small.svg"
  },
  {
    "name": "basket",
    "label": "Basket",
    "path": "basket.svg"
  },
  {
    "name": "basket-bolt",
    "label": "Basket Bolt",
    "path": "basket-bolt.svg"
  },
  {
    "name": "basket-cancel",
    "label": "Basket Cancel",
    "path": "basket-cancel.svg"
  },
  {
    "name": "basket-check",
    "label": "Basket Check",
    "path": "basket-check.svg"
  },
  {
    "name": "basket-code",
    "label": "Basket Code",
    "path": "basket-code.svg"
  },
  {
    "name": "basket-cog",
    "label": "Basket Cog",
    "path": "basket-cog.svg"
  },
  {
    "name": "basket-discount",
    "label": "Basket Discount",
    "path": "basket-discount.svg"
  },
  {
    "name": "basket-dollar",
    "label": "Basket Dollar",
    "path": "basket-dollar.svg"
  },
  {
    "name": "basket-down",
    "label": "Basket Down",
    "path": "basket-down.svg"
  },
  {
    "name": "basket-exclamation",
    "label": "Basket Exclamation",
    "path": "basket-exclamation.svg"
  },
  {
    "name": "basket-heart",
    "label": "Basket Heart",
    "path": "basket-heart.svg"
  },
  {
    "name": "basket-minus",
    "label": "Basket Minus",
    "path": "basket-minus.svg"
  },
  {
    "name": "basket-off",
    "label": "Basket Off",
    "path": "basket-off.svg"
  },
  {
    "name": "basket-pause",
    "label": "Basket Pause",
    "path": "basket-pause.svg"
  },
  {
    "name": "basket-pin",
    "label": "Basket Pin",
    "path": "basket-pin.svg"
  },
  {
    "name": "basket-plus",
    "label": "Basket Plus",
    "path": "basket-plus.svg"
  },
  {
    "name": "basket-question",
    "label": "Basket Question",
    "path": "basket-question.svg"
  },
  {
    "name": "basket-search",
    "label": "Basket Search",
    "path": "basket-search.svg"
  },
  {
    "name": "basket-share",
    "label": "Basket Share",
    "path": "basket-share.svg"
  },
  {
    "name": "basket-star",
    "label": "Basket Star",
    "path": "basket-star.svg"
  },
  {
    "name": "basket-up",
    "label": "Basket Up",
    "path": "basket-up.svg"
  },
  {
    "name": "basket-x",
    "label": "Basket X",
    "path": "basket-x.svg"
  },
  {
    "name": "bat",
    "label": "Bat",
    "path": "bat.svg"
  },
  {
    "name": "bath",
    "label": "Bath",
    "path": "bath.svg"
  },
  {
    "name": "bath-off",
    "label": "Bath Off",
    "path": "bath-off.svg"
  },
  {
    "name": "battery",
    "label": "Battery",
    "path": "battery.svg"
  },
  {
    "name": "battery-1",
    "label": "Battery 1",
    "path": "battery-1.svg"
  },
  {
    "name": "battery-2",
    "label": "Battery 2",
    "path": "battery-2.svg"
  },
  {
    "name": "battery-3",
    "label": "Battery 3",
    "path": "battery-3.svg"
  },
  {
    "name": "battery-4",
    "label": "Battery 4",
    "path": "battery-4.svg"
  },
  {
    "name": "battery-automotive",
    "label": "Battery Automotive",
    "path": "battery-automotive.svg"
  },
  {
    "name": "battery-charging",
    "label": "Battery Charging",
    "path": "battery-charging.svg"
  },
  {
    "name": "battery-charging-2",
    "label": "Battery Charging 2",
    "path": "battery-charging-2.svg"
  },
  {
    "name": "battery-eco",
    "label": "Battery Eco",
    "path": "battery-eco.svg"
  },
  {
    "name": "battery-exclamation",
    "label": "Battery Exclamation",
    "path": "battery-exclamation.svg"
  },
  {
    "name": "battery-off",
    "label": "Battery Off",
    "path": "battery-off.svg"
  },
  {
    "name": "battery-spark",
    "label": "Battery Spark",
    "path": "battery-spark.svg"
  },
  {
    "name": "battery-vertical",
    "label": "Battery Vertical",
    "path": "battery-vertical.svg"
  },
  {
    "name": "battery-vertical-1",
    "label": "Battery Vertical 1",
    "path": "battery-vertical-1.svg"
  },
  {
    "name": "battery-vertical-2",
    "label": "Battery Vertical 2",
    "path": "battery-vertical-2.svg"
  },
  {
    "name": "battery-vertical-3",
    "label": "Battery Vertical 3",
    "path": "battery-vertical-3.svg"
  },
  {
    "name": "battery-vertical-4",
    "label": "Battery Vertical 4",
    "path": "battery-vertical-4.svg"
  },
  {
    "name": "battery-vertical-charging",
    "label": "Battery Vertical Charging",
    "path": "battery-vertical-charging.svg"
  },
  {
    "name": "battery-vertical-charging-2",
    "label": "Battery Vertical Charging 2",
    "path": "battery-vertical-charging-2.svg"
  },
  {
    "name": "battery-vertical-eco",
    "label": "Battery Vertical Eco",
    "path": "battery-vertical-eco.svg"
  },
  {
    "name": "battery-vertical-exclamation",
    "label": "Battery Vertical Exclamation",
    "path": "battery-vertical-exclamation.svg"
  },
  {
    "name": "battery-vertical-off",
    "label": "Battery Vertical Off",
    "path": "battery-vertical-off.svg"
  },
  {
    "name": "beach",
    "label": "Beach",
    "path": "beach.svg"
  },
  {
    "name": "beach-off",
    "label": "Beach Off",
    "path": "beach-off.svg"
  },
  {
    "name": "bed",
    "label": "Bed",
    "path": "bed.svg"
  },
  {
    "name": "bed-flat",
    "label": "Bed Flat",
    "path": "bed-flat.svg"
  },
  {
    "name": "bed-off",
    "label": "Bed Off",
    "path": "bed-off.svg"
  },
  {
    "name": "beer",
    "label": "Beer",
    "path": "beer.svg"
  },
  {
    "name": "beer-off",
    "label": "Beer Off",
    "path": "beer-off.svg"
  },
  {
    "name": "bell",
    "label": "Bell",
    "path": "bell.svg"
  },
  {
    "name": "bell-bolt",
    "label": "Bell Bolt",
    "path": "bell-bolt.svg"
  },
  {
    "name": "bell-cancel",
    "label": "Bell Cancel",
    "path": "bell-cancel.svg"
  },
  {
    "name": "bell-check",
    "label": "Bell Check",
    "path": "bell-check.svg"
  },
  {
    "name": "bell-code",
    "label": "Bell Code",
    "path": "bell-code.svg"
  },
  {
    "name": "bell-cog",
    "label": "Bell Cog",
    "path": "bell-cog.svg"
  },
  {
    "name": "bell-dollar",
    "label": "Bell Dollar",
    "path": "bell-dollar.svg"
  },
  {
    "name": "bell-down",
    "label": "Bell Down",
    "path": "bell-down.svg"
  },
  {
    "name": "bell-exclamation",
    "label": "Bell Exclamation",
    "path": "bell-exclamation.svg"
  },
  {
    "name": "bell-heart",
    "label": "Bell Heart",
    "path": "bell-heart.svg"
  },
  {
    "name": "bell-minus",
    "label": "Bell Minus",
    "path": "bell-minus.svg"
  },
  {
    "name": "bell-off",
    "label": "Bell Off",
    "path": "bell-off.svg"
  },
  {
    "name": "bell-pause",
    "label": "Bell Pause",
    "path": "bell-pause.svg"
  },
  {
    "name": "bell-pin",
    "label": "Bell Pin",
    "path": "bell-pin.svg"
  },
  {
    "name": "bell-plus",
    "label": "Bell Plus",
    "path": "bell-plus.svg"
  },
  {
    "name": "bell-question",
    "label": "Bell Question",
    "path": "bell-question.svg"
  },
  {
    "name": "bell-ringing",
    "label": "Bell Ringing",
    "path": "bell-ringing.svg"
  },
  {
    "name": "bell-ringing-2",
    "label": "Bell Ringing 2",
    "path": "bell-ringing-2.svg"
  },
  {
    "name": "bell-school",
    "label": "Bell School",
    "path": "bell-school.svg"
  },
  {
    "name": "bell-search",
    "label": "Bell Search",
    "path": "bell-search.svg"
  },
  {
    "name": "bell-share",
    "label": "Bell Share",
    "path": "bell-share.svg"
  },
  {
    "name": "bell-star",
    "label": "Bell Star",
    "path": "bell-star.svg"
  },
  {
    "name": "bell-up",
    "label": "Bell Up",
    "path": "bell-up.svg"
  },
  {
    "name": "bell-x",
    "label": "Bell X",
    "path": "bell-x.svg"
  },
  {
    "name": "bell-z",
    "label": "Bell Z",
    "path": "bell-z.svg"
  },
  {
    "name": "beta",
    "label": "Beta",
    "path": "beta.svg"
  },
  {
    "name": "bible",
    "label": "Bible",
    "path": "bible.svg"
  },
  {
    "name": "bike",
    "label": "Bike",
    "path": "bike.svg"
  },
  {
    "name": "bike-off",
    "label": "Bike Off",
    "path": "bike-off.svg"
  },
  {
    "name": "binary",
    "label": "Binary",
    "path": "binary.svg"
  },
  {
    "name": "binary-off",
    "label": "Binary Off",
    "path": "binary-off.svg"
  },
  {
    "name": "binary-tree",
    "label": "Binary Tree",
    "path": "binary-tree.svg"
  },
  {
    "name": "binary-tree-2",
    "label": "Binary Tree 2",
    "path": "binary-tree-2.svg"
  },
  {
    "name": "binoculars",
    "label": "Binoculars",
    "path": "binoculars.svg"
  },
  {
    "name": "biohazard",
    "label": "Biohazard",
    "path": "biohazard.svg"
  },
  {
    "name": "biohazard-off",
    "label": "Biohazard Off",
    "path": "biohazard-off.svg"
  },
  {
    "name": "blade",
    "label": "Blade",
    "path": "blade.svg"
  },
  {
    "name": "bleach",
    "label": "Bleach",
    "path": "bleach.svg"
  },
  {
    "name": "bleach-chlorine",
    "label": "Bleach Chlorine",
    "path": "bleach-chlorine.svg"
  },
  {
    "name": "bleach-no-chlorine",
    "label": "Bleach No Chlorine",
    "path": "bleach-no-chlorine.svg"
  },
  {
    "name": "bleach-off",
    "label": "Bleach Off",
    "path": "bleach-off.svg"
  },
  {
    "name": "blend-mode",
    "label": "Blend Mode",
    "path": "blend-mode.svg"
  },
  {
    "name": "blender",
    "label": "Blender",
    "path": "blender.svg"
  },
  {
    "name": "blind",
    "label": "Blind",
    "path": "blind.svg"
  },
  {
    "name": "blob",
    "label": "Blob",
    "path": "blob.svg"
  },
  {
    "name": "blockquote",
    "label": "Blockquote",
    "path": "blockquote.svg"
  },
  {
    "name": "blocks",
    "label": "Blocks",
    "path": "blocks.svg"
  },
  {
    "name": "bluetooth",
    "label": "Bluetooth",
    "path": "bluetooth.svg"
  },
  {
    "name": "bluetooth-connected",
    "label": "Bluetooth Connected",
    "path": "bluetooth-connected.svg"
  },
  {
    "name": "bluetooth-off",
    "label": "Bluetooth Off",
    "path": "bluetooth-off.svg"
  },
  {
    "name": "bluetooth-x",
    "label": "Bluetooth X",
    "path": "bluetooth-x.svg"
  },
  {
    "name": "blur",
    "label": "Blur",
    "path": "blur.svg"
  },
  {
    "name": "blur-off",
    "label": "Blur Off",
    "path": "blur-off.svg"
  },
  {
    "name": "bmp",
    "label": "Bmp",
    "path": "bmp.svg"
  },
  {
    "name": "body-scan",
    "label": "Body Scan",
    "path": "body-scan.svg"
  },
  {
    "name": "bold",
    "label": "Bold",
    "path": "bold.svg"
  },
  {
    "name": "bold-off",
    "label": "Bold Off",
    "path": "bold-off.svg"
  },
  {
    "name": "bolt",
    "label": "Bolt",
    "path": "bolt.svg"
  },
  {
    "name": "bolt-off",
    "label": "Bolt Off",
    "path": "bolt-off.svg"
  },
  {
    "name": "bomb",
    "label": "Bomb",
    "path": "bomb.svg"
  },
  {
    "name": "bone",
    "label": "Bone",
    "path": "bone.svg"
  },
  {
    "name": "bone-off",
    "label": "Bone Off",
    "path": "bone-off.svg"
  },
  {
    "name": "bong",
    "label": "Bong",
    "path": "bong.svg"
  },
  {
    "name": "bong-off",
    "label": "Bong Off",
    "path": "bong-off.svg"
  },
  {
    "name": "book",
    "label": "Book",
    "path": "book.svg"
  },
  {
    "name": "book-2",
    "label": "Book 2",
    "path": "book-2.svg"
  },
  {
    "name": "book-download",
    "label": "Book Download",
    "path": "book-download.svg"
  },
  {
    "name": "book-off",
    "label": "Book Off",
    "path": "book-off.svg"
  },
  {
    "name": "book-upload",
    "label": "Book Upload",
    "path": "book-upload.svg"
  },
  {
    "name": "bookmark",
    "label": "Bookmark",
    "path": "bookmark.svg"
  },
  {
    "name": "bookmark-ai",
    "label": "Bookmark Ai",
    "path": "bookmark-ai.svg"
  },
  {
    "name": "bookmark-edit",
    "label": "Bookmark Edit",
    "path": "bookmark-edit.svg"
  },
  {
    "name": "bookmark-minus",
    "label": "Bookmark Minus",
    "path": "bookmark-minus.svg"
  },
  {
    "name": "bookmark-off",
    "label": "Bookmark Off",
    "path": "bookmark-off.svg"
  },
  {
    "name": "bookmark-plus",
    "label": "Bookmark Plus",
    "path": "bookmark-plus.svg"
  },
  {
    "name": "bookmark-question",
    "label": "Bookmark Question",
    "path": "bookmark-question.svg"
  },
  {
    "name": "bookmarks",
    "label": "Bookmarks",
    "path": "bookmarks.svg"
  },
  {
    "name": "bookmarks-off",
    "label": "Bookmarks Off",
    "path": "bookmarks-off.svg"
  },
  {
    "name": "books",
    "label": "Books",
    "path": "books.svg"
  },
  {
    "name": "books-off",
    "label": "Books Off",
    "path": "books-off.svg"
  },
  {
    "name": "boom",
    "label": "Boom",
    "path": "boom.svg"
  },
  {
    "name": "border-all",
    "label": "Border All",
    "path": "border-all.svg"
  },
  {
    "name": "border-bottom",
    "label": "Border Bottom",
    "path": "border-bottom.svg"
  },
  {
    "name": "border-bottom-plus",
    "label": "Border Bottom Plus",
    "path": "border-bottom-plus.svg"
  },
  {
    "name": "border-corner-ios",
    "label": "Border Corner Ios",
    "path": "border-corner-ios.svg"
  },
  {
    "name": "border-corner-pill",
    "label": "Border Corner Pill",
    "path": "border-corner-pill.svg"
  },
  {
    "name": "border-corner-rounded",
    "label": "Border Corner Rounded",
    "path": "border-corner-rounded.svg"
  },
  {
    "name": "border-corner-square",
    "label": "Border Corner Square",
    "path": "border-corner-square.svg"
  },
  {
    "name": "border-corners",
    "label": "Border Corners",
    "path": "border-corners.svg"
  },
  {
    "name": "border-horizontal",
    "label": "Border Horizontal",
    "path": "border-horizontal.svg"
  },
  {
    "name": "border-inner",
    "label": "Border Inner",
    "path": "border-inner.svg"
  },
  {
    "name": "border-left",
    "label": "Border Left",
    "path": "border-left.svg"
  },
  {
    "name": "border-left-plus",
    "label": "Border Left Plus",
    "path": "border-left-plus.svg"
  },
  {
    "name": "border-none",
    "label": "Border None",
    "path": "border-none.svg"
  },
  {
    "name": "border-outer",
    "label": "Border Outer",
    "path": "border-outer.svg"
  },
  {
    "name": "border-radius",
    "label": "Border Radius",
    "path": "border-radius.svg"
  },
  {
    "name": "border-right",
    "label": "Border Right",
    "path": "border-right.svg"
  },
  {
    "name": "border-right-plus",
    "label": "Border Right Plus",
    "path": "border-right-plus.svg"
  },
  {
    "name": "border-sides",
    "label": "Border Sides",
    "path": "border-sides.svg"
  },
  {
    "name": "border-style",
    "label": "Border Style",
    "path": "border-style.svg"
  },
  {
    "name": "border-style-2",
    "label": "Border Style 2",
    "path": "border-style-2.svg"
  },
  {
    "name": "border-top",
    "label": "Border Top",
    "path": "border-top.svg"
  },
  {
    "name": "border-top-plus",
    "label": "Border Top Plus",
    "path": "border-top-plus.svg"
  },
  {
    "name": "border-vertical",
    "label": "Border Vertical",
    "path": "border-vertical.svg"
  },
  {
    "name": "bottle",
    "label": "Bottle",
    "path": "bottle.svg"
  },
  {
    "name": "bottle-off",
    "label": "Bottle Off",
    "path": "bottle-off.svg"
  },
  {
    "name": "bounce-left",
    "label": "Bounce Left",
    "path": "bounce-left.svg"
  },
  {
    "name": "bounce-right",
    "label": "Bounce Right",
    "path": "bounce-right.svg"
  },
  {
    "name": "bow",
    "label": "Bow",
    "path": "bow.svg"
  },
  {
    "name": "bowl",
    "label": "Bowl",
    "path": "bowl.svg"
  },
  {
    "name": "bowl-chopsticks",
    "label": "Bowl Chopsticks",
    "path": "bowl-chopsticks.svg"
  },
  {
    "name": "bowl-spoon",
    "label": "Bowl Spoon",
    "path": "bowl-spoon.svg"
  },
  {
    "name": "bowling",
    "label": "Bowling",
    "path": "bowling.svg"
  },
  {
    "name": "box",
    "label": "Box",
    "path": "box.svg"
  },
  {
    "name": "box-align-bottom",
    "label": "Box Align Bottom",
    "path": "box-align-bottom.svg"
  },
  {
    "name": "box-align-bottom-left",
    "label": "Box Align Bottom Left",
    "path": "box-align-bottom-left.svg"
  },
  {
    "name": "box-align-bottom-right",
    "label": "Box Align Bottom Right",
    "path": "box-align-bottom-right.svg"
  },
  {
    "name": "box-align-left",
    "label": "Box Align Left",
    "path": "box-align-left.svg"
  },
  {
    "name": "box-align-right",
    "label": "Box Align Right",
    "path": "box-align-right.svg"
  },
  {
    "name": "box-align-top",
    "label": "Box Align Top",
    "path": "box-align-top.svg"
  },
  {
    "name": "box-align-top-left",
    "label": "Box Align Top Left",
    "path": "box-align-top-left.svg"
  },
  {
    "name": "box-align-top-right",
    "label": "Box Align Top Right",
    "path": "box-align-top-right.svg"
  },
  {
    "name": "box-margin",
    "label": "Box Margin",
    "path": "box-margin.svg"
  },
  {
    "name": "box-model",
    "label": "Box Model",
    "path": "box-model.svg"
  },
  {
    "name": "box-model-2",
    "label": "Box Model 2",
    "path": "box-model-2.svg"
  },
  {
    "name": "box-model-2-off",
    "label": "Box Model 2 Off",
    "path": "box-model-2-off.svg"
  },
  {
    "name": "box-model-off",
    "label": "Box Model Off",
    "path": "box-model-off.svg"
  },
  {
    "name": "box-multiple",
    "label": "Box Multiple",
    "path": "box-multiple.svg"
  },
  {
    "name": "box-multiple-0",
    "label": "Box Multiple 0",
    "path": "box-multiple-0.svg"
  },
  {
    "name": "box-multiple-1",
    "label": "Box Multiple 1",
    "path": "box-multiple-1.svg"
  },
  {
    "name": "box-multiple-2",
    "label": "Box Multiple 2",
    "path": "box-multiple-2.svg"
  },
  {
    "name": "box-multiple-3",
    "label": "Box Multiple 3",
    "path": "box-multiple-3.svg"
  },
  {
    "name": "box-multiple-4",
    "label": "Box Multiple 4",
    "path": "box-multiple-4.svg"
  },
  {
    "name": "box-multiple-5",
    "label": "Box Multiple 5",
    "path": "box-multiple-5.svg"
  },
  {
    "name": "box-multiple-6",
    "label": "Box Multiple 6",
    "path": "box-multiple-6.svg"
  },
  {
    "name": "box-multiple-7",
    "label": "Box Multiple 7",
    "path": "box-multiple-7.svg"
  },
  {
    "name": "box-multiple-8",
    "label": "Box Multiple 8",
    "path": "box-multiple-8.svg"
  },
  {
    "name": "box-multiple-9",
    "label": "Box Multiple 9",
    "path": "box-multiple-9.svg"
  },
  {
    "name": "box-off",
    "label": "Box Off",
    "path": "box-off.svg"
  },
  {
    "name": "box-padding",
    "label": "Box Padding",
    "path": "box-padding.svg"
  },
  {
    "name": "braces",
    "label": "Braces",
    "path": "braces.svg"
  },
  {
    "name": "braces-off",
    "label": "Braces Off",
    "path": "braces-off.svg"
  },
  {
    "name": "brackets",
    "label": "Brackets",
    "path": "brackets.svg"
  },
  {
    "name": "brackets-angle",
    "label": "Brackets Angle",
    "path": "brackets-angle.svg"
  },
  {
    "name": "brackets-angle-off",
    "label": "Brackets Angle Off",
    "path": "brackets-angle-off.svg"
  },
  {
    "name": "brackets-contain",
    "label": "Brackets Contain",
    "path": "brackets-contain.svg"
  },
  {
    "name": "brackets-contain-end",
    "label": "Brackets Contain End",
    "path": "brackets-contain-end.svg"
  },
  {
    "name": "brackets-contain-start",
    "label": "Brackets Contain Start",
    "path": "brackets-contain-start.svg"
  },
  {
    "name": "brackets-off",
    "label": "Brackets Off",
    "path": "brackets-off.svg"
  },
  {
    "name": "braille",
    "label": "Braille",
    "path": "braille.svg"
  },
  {
    "name": "brain",
    "label": "Brain",
    "path": "brain.svg"
  },
  {
    "name": "brand-4chan",
    "label": "Brand 4chan",
    "path": "brand-4chan.svg"
  },
  {
    "name": "brand-abstract",
    "label": "Brand Abstract",
    "path": "brand-abstract.svg"
  },
  {
    "name": "brand-adobe",
    "label": "Brand Adobe",
    "path": "brand-adobe.svg"
  },
  {
    "name": "brand-adobe-after-effect",
    "label": "Brand Adobe After Effect",
    "path": "brand-adobe-after-effect.svg"
  },
  {
    "name": "brand-adobe-illustrator",
    "label": "Brand Adobe Illustrator",
    "path": "brand-adobe-illustrator.svg"
  },
  {
    "name": "brand-adobe-indesign",
    "label": "Brand Adobe Indesign",
    "path": "brand-adobe-indesign.svg"
  },
  {
    "name": "brand-adobe-photoshop",
    "label": "Brand Adobe Photoshop",
    "path": "brand-adobe-photoshop.svg"
  },
  {
    "name": "brand-adobe-premier",
    "label": "Brand Adobe Premier",
    "path": "brand-adobe-premier.svg"
  },
  {
    "name": "brand-adobe-xd",
    "label": "Brand Adobe Xd",
    "path": "brand-adobe-xd.svg"
  },
  {
    "name": "brand-adonis-js",
    "label": "Brand Adonis Js",
    "path": "brand-adonis-js.svg"
  },
  {
    "name": "brand-airbnb",
    "label": "Brand Airbnb",
    "path": "brand-airbnb.svg"
  },
  {
    "name": "brand-airtable",
    "label": "Brand Airtable",
    "path": "brand-airtable.svg"
  },
  {
    "name": "brand-algolia",
    "label": "Brand Algolia",
    "path": "brand-algolia.svg"
  },
  {
    "name": "brand-alipay",
    "label": "Brand Alipay",
    "path": "brand-alipay.svg"
  },
  {
    "name": "brand-alpine-js",
    "label": "Brand Alpine Js",
    "path": "brand-alpine-js.svg"
  },
  {
    "name": "brand-amazon",
    "label": "Brand Amazon",
    "path": "brand-amazon.svg"
  },
  {
    "name": "brand-amd",
    "label": "Brand Amd",
    "path": "brand-amd.svg"
  },
  {
    "name": "brand-amie",
    "label": "Brand Amie",
    "path": "brand-amie.svg"
  },
  {
    "name": "brand-amigo",
    "label": "Brand Amigo",
    "path": "brand-amigo.svg"
  },
  {
    "name": "brand-among-us",
    "label": "Brand Among Us",
    "path": "brand-among-us.svg"
  },
  {
    "name": "brand-android",
    "label": "Brand Android",
    "path": "brand-android.svg"
  },
  {
    "name": "brand-angular",
    "label": "Brand Angular",
    "path": "brand-angular.svg"
  },
  {
    "name": "brand-ansible",
    "label": "Brand Ansible",
    "path": "brand-ansible.svg"
  },
  {
    "name": "brand-ao3",
    "label": "Brand Ao3",
    "path": "brand-ao3.svg"
  },
  {
    "name": "brand-appgallery",
    "label": "Brand Appgallery",
    "path": "brand-appgallery.svg"
  },
  {
    "name": "brand-apple",
    "label": "Brand Apple",
    "path": "brand-apple.svg"
  },
  {
    "name": "brand-apple-arcade",
    "label": "Brand Apple Arcade",
    "path": "brand-apple-arcade.svg"
  },
  {
    "name": "brand-apple-news",
    "label": "Brand Apple News",
    "path": "brand-apple-news.svg"
  },
  {
    "name": "brand-apple-podcast",
    "label": "Brand Apple Podcast",
    "path": "brand-apple-podcast.svg"
  },
  {
    "name": "brand-appstore",
    "label": "Brand Appstore",
    "path": "brand-appstore.svg"
  },
  {
    "name": "brand-arc",
    "label": "Brand Arc",
    "path": "brand-arc.svg"
  },
  {
    "name": "brand-asana",
    "label": "Brand Asana",
    "path": "brand-asana.svg"
  },
  {
    "name": "brand-astro",
    "label": "Brand Astro",
    "path": "brand-astro.svg"
  },
  {
    "name": "brand-auth0",
    "label": "Brand Auth0",
    "path": "brand-auth0.svg"
  },
  {
    "name": "brand-aws",
    "label": "Brand Aws",
    "path": "brand-aws.svg"
  },
  {
    "name": "brand-azure",
    "label": "Brand Azure",
    "path": "brand-azure.svg"
  },
  {
    "name": "brand-backbone",
    "label": "Brand Backbone",
    "path": "brand-backbone.svg"
  },
  {
    "name": "brand-badoo",
    "label": "Brand Badoo",
    "path": "brand-badoo.svg"
  },
  {
    "name": "brand-baidu",
    "label": "Brand Baidu",
    "path": "brand-baidu.svg"
  },
  {
    "name": "brand-bandcamp",
    "label": "Brand Bandcamp",
    "path": "brand-bandcamp.svg"
  },
  {
    "name": "brand-bandlab",
    "label": "Brand Bandlab",
    "path": "brand-bandlab.svg"
  },
  {
    "name": "brand-beats",
    "label": "Brand Beats",
    "path": "brand-beats.svg"
  },
  {
    "name": "brand-bebo",
    "label": "Brand Bebo",
    "path": "brand-bebo.svg"
  },
  {
    "name": "brand-behance",
    "label": "Brand Behance",
    "path": "brand-behance.svg"
  },
  {
    "name": "brand-bilibili",
    "label": "Brand Bilibili",
    "path": "brand-bilibili.svg"
  },
  {
    "name": "brand-binance",
    "label": "Brand Binance",
    "path": "brand-binance.svg"
  },
  {
    "name": "brand-bing",
    "label": "Brand Bing",
    "path": "brand-bing.svg"
  },
  {
    "name": "brand-bitbucket",
    "label": "Brand Bitbucket",
    "path": "brand-bitbucket.svg"
  },
  {
    "name": "brand-blackberry",
    "label": "Brand Blackberry",
    "path": "brand-blackberry.svg"
  },
  {
    "name": "brand-blender",
    "label": "Brand Blender",
    "path": "brand-blender.svg"
  },
  {
    "name": "brand-blogger",
    "label": "Brand Blogger",
    "path": "brand-blogger.svg"
  },
  {
    "name": "brand-bluesky",
    "label": "Brand Bluesky",
    "path": "brand-bluesky.svg"
  },
  {
    "name": "brand-booking",
    "label": "Brand Booking",
    "path": "brand-booking.svg"
  },
  {
    "name": "brand-bootstrap",
    "label": "Brand Bootstrap",
    "path": "brand-bootstrap.svg"
  },
  {
    "name": "brand-bulma",
    "label": "Brand Bulma",
    "path": "brand-bulma.svg"
  },
  {
    "name": "brand-bumble",
    "label": "Brand Bumble",
    "path": "brand-bumble.svg"
  },
  {
    "name": "brand-bunpo",
    "label": "Brand Bunpo",
    "path": "brand-bunpo.svg"
  },
  {
    "name": "brand-c-sharp",
    "label": "Brand C Sharp",
    "path": "brand-c-sharp.svg"
  },
  {
    "name": "brand-cake",
    "label": "Brand Cake",
    "path": "brand-cake.svg"
  },
  {
    "name": "brand-cakephp",
    "label": "Brand Cakephp",
    "path": "brand-cakephp.svg"
  },
  {
    "name": "brand-campaignmonitor",
    "label": "Brand Campaignmonitor",
    "path": "brand-campaignmonitor.svg"
  },
  {
    "name": "brand-carbon",
    "label": "Brand Carbon",
    "path": "brand-carbon.svg"
  },
  {
    "name": "brand-cashapp",
    "label": "Brand Cashapp",
    "path": "brand-cashapp.svg"
  },
  {
    "name": "brand-chrome",
    "label": "Brand Chrome",
    "path": "brand-chrome.svg"
  },
  {
    "name": "brand-cinema-4d",
    "label": "Brand Cinema 4d",
    "path": "brand-cinema-4d.svg"
  },
  {
    "name": "brand-citymapper",
    "label": "Brand Citymapper",
    "path": "brand-citymapper.svg"
  },
  {
    "name": "brand-cloudflare",
    "label": "Brand Cloudflare",
    "path": "brand-cloudflare.svg"
  },
  {
    "name": "brand-codecov",
    "label": "Brand Codecov",
    "path": "brand-codecov.svg"
  },
  {
    "name": "brand-codepen",
    "label": "Brand Codepen",
    "path": "brand-codepen.svg"
  },
  {
    "name": "brand-codesandbox",
    "label": "Brand Codesandbox",
    "path": "brand-codesandbox.svg"
  },
  {
    "name": "brand-cohost",
    "label": "Brand Cohost",
    "path": "brand-cohost.svg"
  },
  {
    "name": "brand-coinbase",
    "label": "Brand Coinbase",
    "path": "brand-coinbase.svg"
  },
  {
    "name": "brand-comedy-central",
    "label": "Brand Comedy Central",
    "path": "brand-comedy-central.svg"
  },
  {
    "name": "brand-coreos",
    "label": "Brand Coreos",
    "path": "brand-coreos.svg"
  },
  {
    "name": "brand-couchdb",
    "label": "Brand Couchdb",
    "path": "brand-couchdb.svg"
  },
  {
    "name": "brand-couchsurfing",
    "label": "Brand Couchsurfing",
    "path": "brand-couchsurfing.svg"
  },
  {
    "name": "brand-cpp",
    "label": "Brand Cpp",
    "path": "brand-cpp.svg"
  },
  {
    "name": "brand-craft",
    "label": "Brand Craft",
    "path": "brand-craft.svg"
  },
  {
    "name": "brand-crunchbase",
    "label": "Brand Crunchbase",
    "path": "brand-crunchbase.svg"
  },
  {
    "name": "brand-css3",
    "label": "Brand Css3",
    "path": "brand-css3.svg"
  },
  {
    "name": "brand-ctemplar",
    "label": "Brand Ctemplar",
    "path": "brand-ctemplar.svg"
  },
  {
    "name": "brand-cucumber",
    "label": "Brand Cucumber",
    "path": "brand-cucumber.svg"
  },
  {
    "name": "brand-cupra",
    "label": "Brand Cupra",
    "path": "brand-cupra.svg"
  },
  {
    "name": "brand-cypress",
    "label": "Brand Cypress",
    "path": "brand-cypress.svg"
  },
  {
    "name": "brand-d3",
    "label": "Brand D3",
    "path": "brand-d3.svg"
  },
  {
    "name": "brand-databricks",
    "label": "Brand Databricks",
    "path": "brand-databricks.svg"
  },
  {
    "name": "brand-days-counter",
    "label": "Brand Days Counter",
    "path": "brand-days-counter.svg"
  },
  {
    "name": "brand-dcos",
    "label": "Brand Dcos",
    "path": "brand-dcos.svg"
  },
  {
    "name": "brand-debian",
    "label": "Brand Debian",
    "path": "brand-debian.svg"
  },
  {
    "name": "brand-deezer",
    "label": "Brand Deezer",
    "path": "brand-deezer.svg"
  },
  {
    "name": "brand-deliveroo",
    "label": "Brand Deliveroo",
    "path": "brand-deliveroo.svg"
  },
  {
    "name": "brand-deno",
    "label": "Brand Deno",
    "path": "brand-deno.svg"
  },
  {
    "name": "brand-denodo",
    "label": "Brand Denodo",
    "path": "brand-denodo.svg"
  },
  {
    "name": "brand-deviantart",
    "label": "Brand Deviantart",
    "path": "brand-deviantart.svg"
  },
  {
    "name": "brand-digg",
    "label": "Brand Digg",
    "path": "brand-digg.svg"
  },
  {
    "name": "brand-dingtalk",
    "label": "Brand Dingtalk",
    "path": "brand-dingtalk.svg"
  },
  {
    "name": "brand-discord",
    "label": "Brand Discord",
    "path": "brand-discord.svg"
  },
  {
    "name": "brand-disney",
    "label": "Brand Disney",
    "path": "brand-disney.svg"
  },
  {
    "name": "brand-disqus",
    "label": "Brand Disqus",
    "path": "brand-disqus.svg"
  },
  {
    "name": "brand-django",
    "label": "Brand Django",
    "path": "brand-django.svg"
  },
  {
    "name": "brand-docker",
    "label": "Brand Docker",
    "path": "brand-docker.svg"
  },
  {
    "name": "brand-doctrine",
    "label": "Brand Doctrine",
    "path": "brand-doctrine.svg"
  },
  {
    "name": "brand-dolby-digital",
    "label": "Brand Dolby Digital",
    "path": "brand-dolby-digital.svg"
  },
  {
    "name": "brand-douban",
    "label": "Brand Douban",
    "path": "brand-douban.svg"
  },
  {
    "name": "brand-dribbble",
    "label": "Brand Dribbble",
    "path": "brand-dribbble.svg"
  },
  {
    "name": "brand-dropbox",
    "label": "Brand Dropbox",
    "path": "brand-dropbox.svg"
  },
  {
    "name": "brand-drops",
    "label": "Brand Drops",
    "path": "brand-drops.svg"
  },
  {
    "name": "brand-drupal",
    "label": "Brand Drupal",
    "path": "brand-drupal.svg"
  },
  {
    "name": "brand-edge",
    "label": "Brand Edge",
    "path": "brand-edge.svg"
  },
  {
    "name": "brand-elastic",
    "label": "Brand Elastic",
    "path": "brand-elastic.svg"
  },
  {
    "name": "brand-electronic-arts",
    "label": "Brand Electronic Arts",
    "path": "brand-electronic-arts.svg"
  },
  {
    "name": "brand-ember",
    "label": "Brand Ember",
    "path": "brand-ember.svg"
  },
  {
    "name": "brand-envato",
    "label": "Brand Envato",
    "path": "brand-envato.svg"
  },
  {
    "name": "brand-etsy",
    "label": "Brand Etsy",
    "path": "brand-etsy.svg"
  },
  {
    "name": "brand-evernote",
    "label": "Brand Evernote",
    "path": "brand-evernote.svg"
  },
  {
    "name": "brand-facebook",
    "label": "Brand Facebook",
    "path": "brand-facebook.svg"
  },
  {
    "name": "brand-feedly",
    "label": "Brand Feedly",
    "path": "brand-feedly.svg"
  },
  {
    "name": "brand-figma",
    "label": "Brand Figma",
    "path": "brand-figma.svg"
  },
  {
    "name": "brand-filezilla",
    "label": "Brand Filezilla",
    "path": "brand-filezilla.svg"
  },
  {
    "name": "brand-finder",
    "label": "Brand Finder",
    "path": "brand-finder.svg"
  },
  {
    "name": "brand-firebase",
    "label": "Brand Firebase",
    "path": "brand-firebase.svg"
  },
  {
    "name": "brand-firefox",
    "label": "Brand Firefox",
    "path": "brand-firefox.svg"
  },
  {
    "name": "brand-fiverr",
    "label": "Brand Fiverr",
    "path": "brand-fiverr.svg"
  },
  {
    "name": "brand-flickr",
    "label": "Brand Flickr",
    "path": "brand-flickr.svg"
  },
  {
    "name": "brand-flightradar24",
    "label": "Brand Flightradar24",
    "path": "brand-flightradar24.svg"
  },
  {
    "name": "brand-flipboard",
    "label": "Brand Flipboard",
    "path": "brand-flipboard.svg"
  },
  {
    "name": "brand-flutter",
    "label": "Brand Flutter",
    "path": "brand-flutter.svg"
  },
  {
    "name": "brand-fortnite",
    "label": "Brand Fortnite",
    "path": "brand-fortnite.svg"
  },
  {
    "name": "brand-foursquare",
    "label": "Brand Foursquare",
    "path": "brand-foursquare.svg"
  },
  {
    "name": "brand-framer",
    "label": "Brand Framer",
    "path": "brand-framer.svg"
  },
  {
    "name": "brand-framer-motion",
    "label": "Brand Framer Motion",
    "path": "brand-framer-motion.svg"
  },
  {
    "name": "brand-funimation",
    "label": "Brand Funimation",
    "path": "brand-funimation.svg"
  },
  {
    "name": "brand-gatsby",
    "label": "Brand Gatsby",
    "path": "brand-gatsby.svg"
  },
  {
    "name": "brand-git",
    "label": "Brand Git",
    "path": "brand-git.svg"
  },
  {
    "name": "brand-github",
    "label": "Brand Github",
    "path": "brand-github.svg"
  },
  {
    "name": "brand-github-copilot",
    "label": "Brand Github Copilot",
    "path": "brand-github-copilot.svg"
  },
  {
    "name": "brand-gitlab",
    "label": "Brand Gitlab",
    "path": "brand-gitlab.svg"
  },
  {
    "name": "brand-gmail",
    "label": "Brand Gmail",
    "path": "brand-gmail.svg"
  },
  {
    "name": "brand-golang",
    "label": "Brand Golang",
    "path": "brand-golang.svg"
  },
  {
    "name": "brand-google",
    "label": "Brand Google",
    "path": "brand-google.svg"
  },
  {
    "name": "brand-google-analytics",
    "label": "Brand Google Analytics",
    "path": "brand-google-analytics.svg"
  },
  {
    "name": "brand-google-big-query",
    "label": "Brand Google Big Query",
    "path": "brand-google-big-query.svg"
  },
  {
    "name": "brand-google-drive",
    "label": "Brand Google Drive",
    "path": "brand-google-drive.svg"
  },
  {
    "name": "brand-google-fit",
    "label": "Brand Google Fit",
    "path": "brand-google-fit.svg"
  },
  {
    "name": "brand-google-home",
    "label": "Brand Google Home",
    "path": "brand-google-home.svg"
  },
  {
    "name": "brand-google-maps",
    "label": "Brand Google Maps",
    "path": "brand-google-maps.svg"
  },
  {
    "name": "brand-google-one",
    "label": "Brand Google One",
    "path": "brand-google-one.svg"
  },
  {
    "name": "brand-google-photos",
    "label": "Brand Google Photos",
    "path": "brand-google-photos.svg"
  },
  {
    "name": "brand-google-play",
    "label": "Brand Google Play",
    "path": "brand-google-play.svg"
  },
  {
    "name": "brand-google-podcasts",
    "label": "Brand Google Podcasts",
    "path": "brand-google-podcasts.svg"
  },
  {
    "name": "brand-grammarly",
    "label": "Brand Grammarly",
    "path": "brand-grammarly.svg"
  },
  {
    "name": "brand-graphql",
    "label": "Brand Graphql",
    "path": "brand-graphql.svg"
  },
  {
    "name": "brand-gravatar",
    "label": "Brand Gravatar",
    "path": "brand-gravatar.svg"
  },
  {
    "name": "brand-grindr",
    "label": "Brand Grindr",
    "path": "brand-grindr.svg"
  },
  {
    "name": "brand-guardian",
    "label": "Brand Guardian",
    "path": "brand-guardian.svg"
  },
  {
    "name": "brand-gumroad",
    "label": "Brand Gumroad",
    "path": "brand-gumroad.svg"
  },
  {
    "name": "brand-hackerrank",
    "label": "Brand Hackerrank",
    "path": "brand-hackerrank.svg"
  },
  {
    "name": "brand-hbo",
    "label": "Brand Hbo",
    "path": "brand-hbo.svg"
  },
  {
    "name": "brand-headlessui",
    "label": "Brand Headlessui",
    "path": "brand-headlessui.svg"
  },
  {
    "name": "brand-hexo",
    "label": "Brand Hexo",
    "path": "brand-hexo.svg"
  },
  {
    "name": "brand-hipchat",
    "label": "Brand Hipchat",
    "path": "brand-hipchat.svg"
  },
  {
    "name": "brand-html5",
    "label": "Brand Html5",
    "path": "brand-html5.svg"
  },
  {
    "name": "brand-inertia",
    "label": "Brand Inertia",
    "path": "brand-inertia.svg"
  },
  {
    "name": "brand-instagram",
    "label": "Brand Instagram",
    "path": "brand-instagram.svg"
  },
  {
    "name": "brand-intercom",
    "label": "Brand Intercom",
    "path": "brand-intercom.svg"
  },
  {
    "name": "brand-itch",
    "label": "Brand Itch",
    "path": "brand-itch.svg"
  },
  {
    "name": "brand-javascript",
    "label": "Brand Javascript",
    "path": "brand-javascript.svg"
  },
  {
    "name": "brand-juejin",
    "label": "Brand Juejin",
    "path": "brand-juejin.svg"
  },
  {
    "name": "brand-kako-talk",
    "label": "Brand Kako Talk",
    "path": "brand-kako-talk.svg"
  },
  {
    "name": "brand-kbin",
    "label": "Brand Kbin",
    "path": "brand-kbin.svg"
  },
  {
    "name": "brand-kick",
    "label": "Brand Kick",
    "path": "brand-kick.svg"
  },
  {
    "name": "brand-kickstarter",
    "label": "Brand Kickstarter",
    "path": "brand-kickstarter.svg"
  },
  {
    "name": "brand-kotlin",
    "label": "Brand Kotlin",
    "path": "brand-kotlin.svg"
  },
  {
    "name": "brand-laravel",
    "label": "Brand Laravel",
    "path": "brand-laravel.svg"
  },
  {
    "name": "brand-lastfm",
    "label": "Brand Lastfm",
    "path": "brand-lastfm.svg"
  },
  {
    "name": "brand-leetcode",
    "label": "Brand Leetcode",
    "path": "brand-leetcode.svg"
  },
  {
    "name": "brand-letterboxd",
    "label": "Brand Letterboxd",
    "path": "brand-letterboxd.svg"
  },
  {
    "name": "brand-line",
    "label": "Brand Line",
    "path": "brand-line.svg"
  },
  {
    "name": "brand-linkedin",
    "label": "Brand Linkedin",
    "path": "brand-linkedin.svg"
  },
  {
    "name": "brand-linktree",
    "label": "Brand Linktree",
    "path": "brand-linktree.svg"
  },
  {
    "name": "brand-linqpad",
    "label": "Brand Linqpad",
    "path": "brand-linqpad.svg"
  },
  {
    "name": "brand-livewire",
    "label": "Brand Livewire",
    "path": "brand-livewire.svg"
  },
  {
    "name": "brand-loom",
    "label": "Brand Loom",
    "path": "brand-loom.svg"
  },
  {
    "name": "brand-mailgun",
    "label": "Brand Mailgun",
    "path": "brand-mailgun.svg"
  },
  {
    "name": "brand-mantine",
    "label": "Brand Mantine",
    "path": "brand-mantine.svg"
  },
  {
    "name": "brand-mastercard",
    "label": "Brand Mastercard",
    "path": "brand-mastercard.svg"
  },
  {
    "name": "brand-mastodon",
    "label": "Brand Mastodon",
    "path": "brand-mastodon.svg"
  },
  {
    "name": "brand-matrix",
    "label": "Brand Matrix",
    "path": "brand-matrix.svg"
  },
  {
    "name": "brand-mcdonalds",
    "label": "Brand Mcdonalds",
    "path": "brand-mcdonalds.svg"
  },
  {
    "name": "brand-medium",
    "label": "Brand Medium",
    "path": "brand-medium.svg"
  },
  {
    "name": "brand-meetup",
    "label": "Brand Meetup",
    "path": "brand-meetup.svg"
  },
  {
    "name": "brand-mercedes",
    "label": "Brand Mercedes",
    "path": "brand-mercedes.svg"
  },
  {
    "name": "brand-messenger",
    "label": "Brand Messenger",
    "path": "brand-messenger.svg"
  },
  {
    "name": "brand-meta",
    "label": "Brand Meta",
    "path": "brand-meta.svg"
  },
  {
    "name": "brand-metabrainz",
    "label": "Brand Metabrainz",
    "path": "brand-metabrainz.svg"
  },
  {
    "name": "brand-minecraft",
    "label": "Brand Minecraft",
    "path": "brand-minecraft.svg"
  },
  {
    "name": "brand-miniprogram",
    "label": "Brand Miniprogram",
    "path": "brand-miniprogram.svg"
  },
  {
    "name": "brand-mixpanel",
    "label": "Brand Mixpanel",
    "path": "brand-mixpanel.svg"
  },
  {
    "name": "brand-monday",
    "label": "Brand Monday",
    "path": "brand-monday.svg"
  },
  {
    "name": "brand-mongodb",
    "label": "Brand Mongodb",
    "path": "brand-mongodb.svg"
  },
  {
    "name": "brand-my-oppo",
    "label": "Brand My Oppo",
    "path": "brand-my-oppo.svg"
  },
  {
    "name": "brand-mysql",
    "label": "Brand Mysql",
    "path": "brand-mysql.svg"
  },
  {
    "name": "brand-national-geographic",
    "label": "Brand National Geographic",
    "path": "brand-national-geographic.svg"
  },
  {
    "name": "brand-nem",
    "label": "Brand Nem",
    "path": "brand-nem.svg"
  },
  {
    "name": "brand-netbeans",
    "label": "Brand Netbeans",
    "path": "brand-netbeans.svg"
  },
  {
    "name": "brand-netease-music",
    "label": "Brand Netease Music",
    "path": "brand-netease-music.svg"
  },
  {
    "name": "brand-netflix",
    "label": "Brand Netflix",
    "path": "brand-netflix.svg"
  },
  {
    "name": "brand-nexo",
    "label": "Brand Nexo",
    "path": "brand-nexo.svg"
  },
  {
    "name": "brand-nextcloud",
    "label": "Brand Nextcloud",
    "path": "brand-nextcloud.svg"
  },
  {
    "name": "brand-nextjs",
    "label": "Brand Nextjs",
    "path": "brand-nextjs.svg"
  },
  {
    "name": "brand-nodejs",
    "label": "Brand Nodejs",
    "path": "brand-nodejs.svg"
  },
  {
    "name": "brand-nord-vpn",
    "label": "Brand Nord Vpn",
    "path": "brand-nord-vpn.svg"
  },
  {
    "name": "brand-notion",
    "label": "Brand Notion",
    "path": "brand-notion.svg"
  },
  {
    "name": "brand-npm",
    "label": "Brand Npm",
    "path": "brand-npm.svg"
  },
  {
    "name": "brand-nuxt",
    "label": "Brand Nuxt",
    "path": "brand-nuxt.svg"
  },
  {
    "name": "brand-nytimes",
    "label": "Brand Nytimes",
    "path": "brand-nytimes.svg"
  },
  {
    "name": "brand-oauth",
    "label": "Brand Oauth",
    "path": "brand-oauth.svg"
  },
  {
    "name": "brand-office",
    "label": "Brand Office",
    "path": "brand-office.svg"
  },
  {
    "name": "brand-ok-ru",
    "label": "Brand Ok Ru",
    "path": "brand-ok-ru.svg"
  },
  {
    "name": "brand-onedrive",
    "label": "Brand Onedrive",
    "path": "brand-onedrive.svg"
  },
  {
    "name": "brand-onlyfans",
    "label": "Brand Onlyfans",
    "path": "brand-onlyfans.svg"
  },
  {
    "name": "brand-open-source",
    "label": "Brand Open Source",
    "path": "brand-open-source.svg"
  },
  {
    "name": "brand-openai",
    "label": "Brand Openai",
    "path": "brand-openai.svg"
  },
  {
    "name": "brand-openvpn",
    "label": "Brand Openvpn",
    "path": "brand-openvpn.svg"
  },
  {
    "name": "brand-opera",
    "label": "Brand Opera",
    "path": "brand-opera.svg"
  },
  {
    "name": "brand-pagekit",
    "label": "Brand Pagekit",
    "path": "brand-pagekit.svg"
  },
  {
    "name": "brand-parsinta",
    "label": "Brand Parsinta",
    "path": "brand-parsinta.svg"
  },
  {
    "name": "brand-patreon",
    "label": "Brand Patreon",
    "path": "brand-patreon.svg"
  },
  {
    "name": "brand-paypal",
    "label": "Brand Paypal",
    "path": "brand-paypal.svg"
  },
  {
    "name": "brand-paypay",
    "label": "Brand Paypay",
    "path": "brand-paypay.svg"
  },
  {
    "name": "brand-peanut",
    "label": "Brand Peanut",
    "path": "brand-peanut.svg"
  },
  {
    "name": "brand-pepsi",
    "label": "Brand Pepsi",
    "path": "brand-pepsi.svg"
  },
  {
    "name": "brand-php",
    "label": "Brand Php",
    "path": "brand-php.svg"
  },
  {
    "name": "brand-picsart",
    "label": "Brand Picsart",
    "path": "brand-picsart.svg"
  },
  {
    "name": "brand-pinterest",
    "label": "Brand Pinterest",
    "path": "brand-pinterest.svg"
  },
  {
    "name": "brand-planetscale",
    "label": "Brand Planetscale",
    "path": "brand-planetscale.svg"
  },
  {
    "name": "brand-pnpm",
    "label": "Brand Pnpm",
    "path": "brand-pnpm.svg"
  },
  {
    "name": "brand-pocket",
    "label": "Brand Pocket",
    "path": "brand-pocket.svg"
  },
  {
    "name": "brand-polymer",
    "label": "Brand Polymer",
    "path": "brand-polymer.svg"
  },
  {
    "name": "brand-powershell",
    "label": "Brand Powershell",
    "path": "brand-powershell.svg"
  },
  {
    "name": "brand-printables",
    "label": "Brand Printables",
    "path": "brand-printables.svg"
  },
  {
    "name": "brand-prisma",
    "label": "Brand Prisma",
    "path": "brand-prisma.svg"
  },
  {
    "name": "brand-producthunt",
    "label": "Brand Producthunt",
    "path": "brand-producthunt.svg"
  },
  {
    "name": "brand-pushbullet",
    "label": "Brand Pushbullet",
    "path": "brand-pushbullet.svg"
  },
  {
    "name": "brand-pushover",
    "label": "Brand Pushover",
    "path": "brand-pushover.svg"
  },
  {
    "name": "brand-python",
    "label": "Brand Python",
    "path": "brand-python.svg"
  },
  {
    "name": "brand-qq",
    "label": "Brand Qq",
    "path": "brand-qq.svg"
  },
  {
    "name": "brand-radix-ui",
    "label": "Brand Radix Ui",
    "path": "brand-radix-ui.svg"
  },
  {
    "name": "brand-react",
    "label": "Brand React",
    "path": "brand-react.svg"
  },
  {
    "name": "brand-react-native",
    "label": "Brand React Native",
    "path": "brand-react-native.svg"
  },
  {
    "name": "brand-reason",
    "label": "Brand Reason",
    "path": "brand-reason.svg"
  },
  {
    "name": "brand-reddit",
    "label": "Brand Reddit",
    "path": "brand-reddit.svg"
  },
  {
    "name": "brand-redhat",
    "label": "Brand Redhat",
    "path": "brand-redhat.svg"
  },
  {
    "name": "brand-redux",
    "label": "Brand Redux",
    "path": "brand-redux.svg"
  },
  {
    "name": "brand-revolut",
    "label": "Brand Revolut",
    "path": "brand-revolut.svg"
  },
  {
    "name": "brand-rumble",
    "label": "Brand Rumble",
    "path": "brand-rumble.svg"
  },
  {
    "name": "brand-rust",
    "label": "Brand Rust",
    "path": "brand-rust.svg"
  },
  {
    "name": "brand-safari",
    "label": "Brand Safari",
    "path": "brand-safari.svg"
  },
  {
    "name": "brand-samsungpass",
    "label": "Brand Samsungpass",
    "path": "brand-samsungpass.svg"
  },
  {
    "name": "brand-sass",
    "label": "Brand Sass",
    "path": "brand-sass.svg"
  },
  {
    "name": "brand-sentry",
    "label": "Brand Sentry",
    "path": "brand-sentry.svg"
  },
  {
    "name": "brand-sharik",
    "label": "Brand Sharik",
    "path": "brand-sharik.svg"
  },
  {
    "name": "brand-shazam",
    "label": "Brand Shazam",
    "path": "brand-shazam.svg"
  },
  {
    "name": "brand-shopee",
    "label": "Brand Shopee",
    "path": "brand-shopee.svg"
  },
  {
    "name": "brand-sketch",
    "label": "Brand Sketch",
    "path": "brand-sketch.svg"
  },
  {
    "name": "brand-skype",
    "label": "Brand Skype",
    "path": "brand-skype.svg"
  },
  {
    "name": "brand-slack",
    "label": "Brand Slack",
    "path": "brand-slack.svg"
  },
  {
    "name": "brand-snapchat",
    "label": "Brand Snapchat",
    "path": "brand-snapchat.svg"
  },
  {
    "name": "brand-snapseed",
    "label": "Brand Snapseed",
    "path": "brand-snapseed.svg"
  },
  {
    "name": "brand-snowflake",
    "label": "Brand Snowflake",
    "path": "brand-snowflake.svg"
  },
  {
    "name": "brand-socket-io",
    "label": "Brand Socket Io",
    "path": "brand-socket-io.svg"
  },
  {
    "name": "brand-solidjs",
    "label": "Brand Solidjs",
    "path": "brand-solidjs.svg"
  },
  {
    "name": "brand-soundcloud",
    "label": "Brand Soundcloud",
    "path": "brand-soundcloud.svg"
  },
  {
    "name": "brand-spacehey",
    "label": "Brand Spacehey",
    "path": "brand-spacehey.svg"
  },
  {
    "name": "brand-speedtest",
    "label": "Brand Speedtest",
    "path": "brand-speedtest.svg"
  },
  {
    "name": "brand-spotify",
    "label": "Brand Spotify",
    "path": "brand-spotify.svg"
  },
  {
    "name": "brand-stackoverflow",
    "label": "Brand Stackoverflow",
    "path": "brand-stackoverflow.svg"
  },
  {
    "name": "brand-stackshare",
    "label": "Brand Stackshare",
    "path": "brand-stackshare.svg"
  },
  {
    "name": "brand-steam",
    "label": "Brand Steam",
    "path": "brand-steam.svg"
  },
  {
    "name": "brand-stocktwits",
    "label": "Brand Stocktwits",
    "path": "brand-stocktwits.svg"
  },
  {
    "name": "brand-storj",
    "label": "Brand Storj",
    "path": "brand-storj.svg"
  },
  {
    "name": "brand-storybook",
    "label": "Brand Storybook",
    "path": "brand-storybook.svg"
  },
  {
    "name": "brand-storytel",
    "label": "Brand Storytel",
    "path": "brand-storytel.svg"
  },
  {
    "name": "brand-strava",
    "label": "Brand Strava",
    "path": "brand-strava.svg"
  },
  {
    "name": "brand-stripe",
    "label": "Brand Stripe",
    "path": "brand-stripe.svg"
  },
  {
    "name": "brand-sublime-text",
    "label": "Brand Sublime Text",
    "path": "brand-sublime-text.svg"
  },
  {
    "name": "brand-sugarizer",
    "label": "Brand Sugarizer",
    "path": "brand-sugarizer.svg"
  },
  {
    "name": "brand-supabase",
    "label": "Brand Supabase",
    "path": "brand-supabase.svg"
  },
  {
    "name": "brand-superhuman",
    "label": "Brand Superhuman",
    "path": "brand-superhuman.svg"
  },
  {
    "name": "brand-supernova",
    "label": "Brand Supernova",
    "path": "brand-supernova.svg"
  },
  {
    "name": "brand-surfshark",
    "label": "Brand Surfshark",
    "path": "brand-surfshark.svg"
  },
  {
    "name": "brand-svelte",
    "label": "Brand Svelte",
    "path": "brand-svelte.svg"
  },
  {
    "name": "brand-swift",
    "label": "Brand Swift",
    "path": "brand-swift.svg"
  },
  {
    "name": "brand-symfony",
    "label": "Brand Symfony",
    "path": "brand-symfony.svg"
  },
  {
    "name": "brand-tabler",
    "label": "Brand Tabler",
    "path": "brand-tabler.svg"
  },
  {
    "name": "brand-tabnine",
    "label": "Brand Tabnine",
    "path": "brand-tabnine.svg"
  },
  {
    "name": "brand-tailwind",
    "label": "Brand Tailwind",
    "path": "brand-tailwind.svg"
  },
  {
    "name": "brand-taobao",
    "label": "Brand Taobao",
    "path": "brand-taobao.svg"
  },
  {
    "name": "brand-teams",
    "label": "Brand Teams",
    "path": "brand-teams.svg"
  },
  {
    "name": "brand-ted",
    "label": "Brand Ted",
    "path": "brand-ted.svg"
  },
  {
    "name": "brand-telegram",
    "label": "Brand Telegram",
    "path": "brand-telegram.svg"
  },
  {
    "name": "brand-terraform",
    "label": "Brand Terraform",
    "path": "brand-terraform.svg"
  },
  {
    "name": "brand-tesla",
    "label": "Brand Tesla",
    "path": "brand-tesla.svg"
  },
  {
    "name": "brand-tether",
    "label": "Brand Tether",
    "path": "brand-tether.svg"
  },
  {
    "name": "brand-thingiverse",
    "label": "Brand Thingiverse",
    "path": "brand-thingiverse.svg"
  },
  {
    "name": "brand-threads",
    "label": "Brand Threads",
    "path": "brand-threads.svg"
  },
  {
    "name": "brand-threejs",
    "label": "Brand Threejs",
    "path": "brand-threejs.svg"
  },
  {
    "name": "brand-tidal",
    "label": "Brand Tidal",
    "path": "brand-tidal.svg"
  },
  {
    "name": "brand-tiktok",
    "label": "Brand Tiktok",
    "path": "brand-tiktok.svg"
  },
  {
    "name": "brand-tinder",
    "label": "Brand Tinder",
    "path": "brand-tinder.svg"
  },
  {
    "name": "brand-topbuzz",
    "label": "Brand Topbuzz",
    "path": "brand-topbuzz.svg"
  },
  {
    "name": "brand-torchain",
    "label": "Brand Torchain",
    "path": "brand-torchain.svg"
  },
  {
    "name": "brand-toyota",
    "label": "Brand Toyota",
    "path": "brand-toyota.svg"
  },
  {
    "name": "brand-trello",
    "label": "Brand Trello",
    "path": "brand-trello.svg"
  },
  {
    "name": "brand-tripadvisor",
    "label": "Brand Tripadvisor",
    "path": "brand-tripadvisor.svg"
  },
  {
    "name": "brand-tumblr",
    "label": "Brand Tumblr",
    "path": "brand-tumblr.svg"
  },
  {
    "name": "brand-twilio",
    "label": "Brand Twilio",
    "path": "brand-twilio.svg"
  },
  {
    "name": "brand-twitch",
    "label": "Brand Twitch",
    "path": "brand-twitch.svg"
  },
  {
    "name": "brand-twitter",
    "label": "Brand Twitter",
    "path": "brand-twitter.svg"
  },
  {
    "name": "brand-typescript",
    "label": "Brand Typescript",
    "path": "brand-typescript.svg"
  },
  {
    "name": "brand-uber",
    "label": "Brand Uber",
    "path": "brand-uber.svg"
  },
  {
    "name": "brand-ubuntu",
    "label": "Brand Ubuntu",
    "path": "brand-ubuntu.svg"
  },
  {
    "name": "brand-unity",
    "label": "Brand Unity",
    "path": "brand-unity.svg"
  },
  {
    "name": "brand-unsplash",
    "label": "Brand Unsplash",
    "path": "brand-unsplash.svg"
  },
  {
    "name": "brand-upwork",
    "label": "Brand Upwork",
    "path": "brand-upwork.svg"
  },
  {
    "name": "brand-valorant",
    "label": "Brand Valorant",
    "path": "brand-valorant.svg"
  },
  {
    "name": "brand-vercel",
    "label": "Brand Vercel",
    "path": "brand-vercel.svg"
  },
  {
    "name": "brand-vimeo",
    "label": "Brand Vimeo",
    "path": "brand-vimeo.svg"
  },
  {
    "name": "brand-vinted",
    "label": "Brand Vinted",
    "path": "brand-vinted.svg"
  },
  {
    "name": "brand-visa",
    "label": "Brand Visa",
    "path": "brand-visa.svg"
  },
  {
    "name": "brand-visual-studio",
    "label": "Brand Visual Studio",
    "path": "brand-visual-studio.svg"
  },
  {
    "name": "brand-vite",
    "label": "Brand Vite",
    "path": "brand-vite.svg"
  },
  {
    "name": "brand-vivaldi",
    "label": "Brand Vivaldi",
    "path": "brand-vivaldi.svg"
  },
  {
    "name": "brand-vk",
    "label": "Brand Vk",
    "path": "brand-vk.svg"
  },
  {
    "name": "brand-vlc",
    "label": "Brand Vlc",
    "path": "brand-vlc.svg"
  },
  {
    "name": "brand-volkswagen",
    "label": "Brand Volkswagen",
    "path": "brand-volkswagen.svg"
  },
  {
    "name": "brand-vsco",
    "label": "Brand Vsco",
    "path": "brand-vsco.svg"
  },
  {
    "name": "brand-vscode",
    "label": "Brand Vscode",
    "path": "brand-vscode.svg"
  },
  {
    "name": "brand-vue",
    "label": "Brand Vue",
    "path": "brand-vue.svg"
  },
  {
    "name": "brand-walmart",
    "label": "Brand Walmart",
    "path": "brand-walmart.svg"
  },
  {
    "name": "brand-waze",
    "label": "Brand Waze",
    "path": "brand-waze.svg"
  },
  {
    "name": "brand-webflow",
    "label": "Brand Webflow",
    "path": "brand-webflow.svg"
  },
  {
    "name": "brand-wechat",
    "label": "Brand Wechat",
    "path": "brand-wechat.svg"
  },
  {
    "name": "brand-weibo",
    "label": "Brand Weibo",
    "path": "brand-weibo.svg"
  },
  {
    "name": "brand-whatsapp",
    "label": "Brand Whatsapp",
    "path": "brand-whatsapp.svg"
  },
  {
    "name": "brand-wikipedia",
    "label": "Brand Wikipedia",
    "path": "brand-wikipedia.svg"
  },
  {
    "name": "brand-windows",
    "label": "Brand Windows",
    "path": "brand-windows.svg"
  },
  {
    "name": "brand-windy",
    "label": "Brand Windy",
    "path": "brand-windy.svg"
  },
  {
    "name": "brand-wish",
    "label": "Brand Wish",
    "path": "brand-wish.svg"
  },
  {
    "name": "brand-wix",
    "label": "Brand Wix",
    "path": "brand-wix.svg"
  },
  {
    "name": "brand-wordpress",
    "label": "Brand Wordpress",
    "path": "brand-wordpress.svg"
  },
  {
    "name": "brand-x",
    "label": "Brand X",
    "path": "brand-x.svg"
  },
  {
    "name": "brand-xamarin",
    "label": "Brand Xamarin",
    "path": "brand-xamarin.svg"
  },
  {
    "name": "brand-xbox",
    "label": "Brand Xbox",
    "path": "brand-xbox.svg"
  },
  {
    "name": "brand-xdeep",
    "label": "Brand Xdeep",
    "path": "brand-xdeep.svg"
  },
  {
    "name": "brand-xing",
    "label": "Brand Xing",
    "path": "brand-xing.svg"
  },
  {
    "name": "brand-yahoo",
    "label": "Brand Yahoo",
    "path": "brand-yahoo.svg"
  },
  {
    "name": "brand-yandex",
    "label": "Brand Yandex",
    "path": "brand-yandex.svg"
  },
  {
    "name": "brand-yarn",
    "label": "Brand Yarn",
    "path": "brand-yarn.svg"
  },
  {
    "name": "brand-yatse",
    "label": "Brand Yatse",
    "path": "brand-yatse.svg"
  },
  {
    "name": "brand-ycombinator",
    "label": "Brand Ycombinator",
    "path": "brand-ycombinator.svg"
  },
  {
    "name": "brand-youtube",
    "label": "Brand Youtube",
    "path": "brand-youtube.svg"
  },
  {
    "name": "brand-youtube-kids",
    "label": "Brand Youtube Kids",
    "path": "brand-youtube-kids.svg"
  },
  {
    "name": "brand-zalando",
    "label": "Brand Zalando",
    "path": "brand-zalando.svg"
  },
  {
    "name": "brand-zapier",
    "label": "Brand Zapier",
    "path": "brand-zapier.svg"
  },
  {
    "name": "brand-zeit",
    "label": "Brand Zeit",
    "path": "brand-zeit.svg"
  },
  {
    "name": "brand-zhihu",
    "label": "Brand Zhihu",
    "path": "brand-zhihu.svg"
  },
  {
    "name": "brand-zoom",
    "label": "Brand Zoom",
    "path": "brand-zoom.svg"
  },
  {
    "name": "brand-zulip",
    "label": "Brand Zulip",
    "path": "brand-zulip.svg"
  },
  {
    "name": "brand-zwift",
    "label": "Brand Zwift",
    "path": "brand-zwift.svg"
  },
  {
    "name": "bread",
    "label": "Bread",
    "path": "bread.svg"
  },
  {
    "name": "bread-off",
    "label": "Bread Off",
    "path": "bread-off.svg"
  },
  {
    "name": "briefcase",
    "label": "Briefcase",
    "path": "briefcase.svg"
  },
  {
    "name": "briefcase-2",
    "label": "Briefcase 2",
    "path": "briefcase-2.svg"
  },
  {
    "name": "briefcase-off",
    "label": "Briefcase Off",
    "path": "briefcase-off.svg"
  },
  {
    "name": "brightness",
    "label": "Brightness",
    "path": "brightness.svg"
  },
  {
    "name": "brightness-2",
    "label": "Brightness 2",
    "path": "brightness-2.svg"
  },
  {
    "name": "brightness-auto",
    "label": "Brightness Auto",
    "path": "brightness-auto.svg"
  },
  {
    "name": "brightness-down",
    "label": "Brightness Down",
    "path": "brightness-down.svg"
  },
  {
    "name": "brightness-half",
    "label": "Brightness Half",
    "path": "brightness-half.svg"
  },
  {
    "name": "brightness-off",
    "label": "Brightness Off",
    "path": "brightness-off.svg"
  },
  {
    "name": "brightness-up",
    "label": "Brightness Up",
    "path": "brightness-up.svg"
  },
  {
    "name": "broadcast",
    "label": "Broadcast",
    "path": "broadcast.svg"
  },
  {
    "name": "broadcast-off",
    "label": "Broadcast Off",
    "path": "broadcast-off.svg"
  },
  {
    "name": "browser",
    "label": "Browser",
    "path": "browser.svg"
  },
  {
    "name": "browser-check",
    "label": "Browser Check",
    "path": "browser-check.svg"
  },
  {
    "name": "browser-maximize",
    "label": "Browser Maximize",
    "path": "browser-maximize.svg"
  },
  {
    "name": "browser-minus",
    "label": "Browser Minus",
    "path": "browser-minus.svg"
  },
  {
    "name": "browser-off",
    "label": "Browser Off",
    "path": "browser-off.svg"
  },
  {
    "name": "browser-plus",
    "label": "Browser Plus",
    "path": "browser-plus.svg"
  },
  {
    "name": "browser-share",
    "label": "Browser Share",
    "path": "browser-share.svg"
  },
  {
    "name": "browser-x",
    "label": "Browser X",
    "path": "browser-x.svg"
  },
  {
    "name": "brush",
    "label": "Brush",
    "path": "brush.svg"
  },
  {
    "name": "brush-off",
    "label": "Brush Off",
    "path": "brush-off.svg"
  },
  {
    "name": "bubble",
    "label": "Bubble",
    "path": "bubble.svg"
  },
  {
    "name": "bubble-minus",
    "label": "Bubble Minus",
    "path": "bubble-minus.svg"
  },
  {
    "name": "bubble-plus",
    "label": "Bubble Plus",
    "path": "bubble-plus.svg"
  },
  {
    "name": "bubble-tea",
    "label": "Bubble Tea",
    "path": "bubble-tea.svg"
  },
  {
    "name": "bubble-tea-2",
    "label": "Bubble Tea 2",
    "path": "bubble-tea-2.svg"
  },
  {
    "name": "bubble-text",
    "label": "Bubble Text",
    "path": "bubble-text.svg"
  },
  {
    "name": "bubble-x",
    "label": "Bubble X",
    "path": "bubble-x.svg"
  },
  {
    "name": "bucket",
    "label": "Bucket",
    "path": "bucket.svg"
  },
  {
    "name": "bucket-droplet",
    "label": "Bucket Droplet",
    "path": "bucket-droplet.svg"
  },
  {
    "name": "bucket-off",
    "label": "Bucket Off",
    "path": "bucket-off.svg"
  },
  {
    "name": "bug",
    "label": "Bug",
    "path": "bug.svg"
  },
  {
    "name": "bug-off",
    "label": "Bug Off",
    "path": "bug-off.svg"
  },
  {
    "name": "building",
    "label": "Building",
    "path": "building.svg"
  },
  {
    "name": "building-airport",
    "label": "Building Airport",
    "path": "building-airport.svg"
  },
  {
    "name": "building-arch",
    "label": "Building Arch",
    "path": "building-arch.svg"
  },
  {
    "name": "building-bank",
    "label": "Building Bank",
    "path": "building-bank.svg"
  },
  {
    "name": "building-bridge",
    "label": "Building Bridge",
    "path": "building-bridge.svg"
  },
  {
    "name": "building-bridge-2",
    "label": "Building Bridge 2",
    "path": "building-bridge-2.svg"
  },
  {
    "name": "building-broadcast-tower",
    "label": "Building Broadcast Tower",
    "path": "building-broadcast-tower.svg"
  },
  {
    "name": "building-burj-al-arab",
    "label": "Building Burj Al Arab",
    "path": "building-burj-al-arab.svg"
  },
  {
    "name": "building-carousel",
    "label": "Building Carousel",
    "path": "building-carousel.svg"
  },
  {
    "name": "building-castle",
    "label": "Building Castle",
    "path": "building-castle.svg"
  },
  {
    "name": "building-church",
    "label": "Building Church",
    "path": "building-church.svg"
  },
  {
    "name": "building-circus",
    "label": "Building Circus",
    "path": "building-circus.svg"
  },
  {
    "name": "building-cog",
    "label": "Building Cog",
    "path": "building-cog.svg"
  },
  {
    "name": "building-community",
    "label": "Building Community",
    "path": "building-community.svg"
  },
  {
    "name": "building-cottage",
    "label": "Building Cottage",
    "path": "building-cottage.svg"
  },
  {
    "name": "building-estate",
    "label": "Building Estate",
    "path": "building-estate.svg"
  },
  {
    "name": "building-factory",
    "label": "Building Factory",
    "path": "building-factory.svg"
  },
  {
    "name": "building-factory-2",
    "label": "Building Factory 2",
    "path": "building-factory-2.svg"
  },
  {
    "name": "building-fortress",
    "label": "Building Fortress",
    "path": "building-fortress.svg"
  },
  {
    "name": "building-hospital",
    "label": "Building Hospital",
    "path": "building-hospital.svg"
  },
  {
    "name": "building-lighthouse",
    "label": "Building Lighthouse",
    "path": "building-lighthouse.svg"
  },
  {
    "name": "building-minus",
    "label": "Building Minus",
    "path": "building-minus.svg"
  },
  {
    "name": "building-monument",
    "label": "Building Monument",
    "path": "building-monument.svg"
  },
  {
    "name": "building-mosque",
    "label": "Building Mosque",
    "path": "building-mosque.svg"
  },
  {
    "name": "building-off",
    "label": "Building Off",
    "path": "building-off.svg"
  },
  {
    "name": "building-pavilion",
    "label": "Building Pavilion",
    "path": "building-pavilion.svg"
  },
  {
    "name": "building-plus",
    "label": "Building Plus",
    "path": "building-plus.svg"
  },
  {
    "name": "building-skyscraper",
    "label": "Building Skyscraper",
    "path": "building-skyscraper.svg"
  },
  {
    "name": "building-stadium",
    "label": "Building Stadium",
    "path": "building-stadium.svg"
  },
  {
    "name": "building-store",
    "label": "Building Store",
    "path": "building-store.svg"
  },
  {
    "name": "building-tunnel",
    "label": "Building Tunnel",
    "path": "building-tunnel.svg"
  },
  {
    "name": "building-warehouse",
    "label": "Building Warehouse",
    "path": "building-warehouse.svg"
  },
  {
    "name": "building-wind-turbine",
    "label": "Building Wind Turbine",
    "path": "building-wind-turbine.svg"
  },
  {
    "name": "buildings",
    "label": "Buildings",
    "path": "buildings.svg"
  },
  {
    "name": "bulb",
    "label": "Bulb",
    "path": "bulb.svg"
  },
  {
    "name": "bulb-off",
    "label": "Bulb Off",
    "path": "bulb-off.svg"
  },
  {
    "name": "bulldozer",
    "label": "Bulldozer",
    "path": "bulldozer.svg"
  },
  {
    "name": "burger",
    "label": "Burger",
    "path": "burger.svg"
  },
  {
    "name": "bus",
    "label": "Bus",
    "path": "bus.svg"
  },
  {
    "name": "bus-off",
    "label": "Bus Off",
    "path": "bus-off.svg"
  },
  {
    "name": "bus-stop",
    "label": "Bus Stop",
    "path": "bus-stop.svg"
  },
  {
    "name": "businessplan",
    "label": "Businessplan",
    "path": "businessplan.svg"
  },
  {
    "name": "butterfly",
    "label": "Butterfly",
    "path": "butterfly.svg"
  },
  {
    "name": "cactus",
    "label": "Cactus",
    "path": "cactus.svg"
  },
  {
    "name": "cactus-off",
    "label": "Cactus Off",
    "path": "cactus-off.svg"
  },
  {
    "name": "cake",
    "label": "Cake",
    "path": "cake.svg"
  },
  {
    "name": "cake-off",
    "label": "Cake Off",
    "path": "cake-off.svg"
  },
  {
    "name": "cake-roll",
    "label": "Cake Roll",
    "path": "cake-roll.svg"
  },
  {
    "name": "calculator",
    "label": "Calculator",
    "path": "calculator.svg"
  },
  {
    "name": "calculator-off",
    "label": "Calculator Off",
    "path": "calculator-off.svg"
  },
  {
    "name": "calendar",
    "label": "Calendar",
    "path": "calendar.svg"
  },
  {
    "name": "calendar-bolt",
    "label": "Calendar Bolt",
    "path": "calendar-bolt.svg"
  },
  {
    "name": "calendar-cancel",
    "label": "Calendar Cancel",
    "path": "calendar-cancel.svg"
  },
  {
    "name": "calendar-check",
    "label": "Calendar Check",
    "path": "calendar-check.svg"
  },
  {
    "name": "calendar-clock",
    "label": "Calendar Clock",
    "path": "calendar-clock.svg"
  },
  {
    "name": "calendar-code",
    "label": "Calendar Code",
    "path": "calendar-code.svg"
  },
  {
    "name": "calendar-cog",
    "label": "Calendar Cog",
    "path": "calendar-cog.svg"
  },
  {
    "name": "calendar-dollar",
    "label": "Calendar Dollar",
    "path": "calendar-dollar.svg"
  },
  {
    "name": "calendar-dot",
    "label": "Calendar Dot",
    "path": "calendar-dot.svg"
  },
  {
    "name": "calendar-down",
    "label": "Calendar Down",
    "path": "calendar-down.svg"
  },
  {
    "name": "calendar-due",
    "label": "Calendar Due",
    "path": "calendar-due.svg"
  },
  {
    "name": "calendar-event",
    "label": "Calendar Event",
    "path": "calendar-event.svg"
  },
  {
    "name": "calendar-exclamation",
    "label": "Calendar Exclamation",
    "path": "calendar-exclamation.svg"
  },
  {
    "name": "calendar-heart",
    "label": "Calendar Heart",
    "path": "calendar-heart.svg"
  },
  {
    "name": "calendar-minus",
    "label": "Calendar Minus",
    "path": "calendar-minus.svg"
  },
  {
    "name": "calendar-month",
    "label": "Calendar Month",
    "path": "calendar-month.svg"
  },
  {
    "name": "calendar-off",
    "label": "Calendar Off",
    "path": "calendar-off.svg"
  },
  {
    "name": "calendar-pause",
    "label": "Calendar Pause",
    "path": "calendar-pause.svg"
  },
  {
    "name": "calendar-pin",
    "label": "Calendar Pin",
    "path": "calendar-pin.svg"
  },
  {
    "name": "calendar-plus",
    "label": "Calendar Plus",
    "path": "calendar-plus.svg"
  },
  {
    "name": "calendar-question",
    "label": "Calendar Question",
    "path": "calendar-question.svg"
  },
  {
    "name": "calendar-repeat",
    "label": "Calendar Repeat",
    "path": "calendar-repeat.svg"
  },
  {
    "name": "calendar-sad",
    "label": "Calendar Sad",
    "path": "calendar-sad.svg"
  },
  {
    "name": "calendar-search",
    "label": "Calendar Search",
    "path": "calendar-search.svg"
  },
  {
    "name": "calendar-share",
    "label": "Calendar Share",
    "path": "calendar-share.svg"
  },
  {
    "name": "calendar-smile",
    "label": "Calendar Smile",
    "path": "calendar-smile.svg"
  },
  {
    "name": "calendar-star",
    "label": "Calendar Star",
    "path": "calendar-star.svg"
  },
  {
    "name": "calendar-stats",
    "label": "Calendar Stats",
    "path": "calendar-stats.svg"
  },
  {
    "name": "calendar-time",
    "label": "Calendar Time",
    "path": "calendar-time.svg"
  },
  {
    "name": "calendar-up",
    "label": "Calendar Up",
    "path": "calendar-up.svg"
  },
  {
    "name": "calendar-user",
    "label": "Calendar User",
    "path": "calendar-user.svg"
  },
  {
    "name": "calendar-week",
    "label": "Calendar Week",
    "path": "calendar-week.svg"
  },
  {
    "name": "calendar-x",
    "label": "Calendar X",
    "path": "calendar-x.svg"
  },
  {
    "name": "camera",
    "label": "Camera",
    "path": "camera.svg"
  },
  {
    "name": "camera-ai",
    "label": "Camera Ai",
    "path": "camera-ai.svg"
  },
  {
    "name": "camera-bitcoin",
    "label": "Camera Bitcoin",
    "path": "camera-bitcoin.svg"
  },
  {
    "name": "camera-bolt",
    "label": "Camera Bolt",
    "path": "camera-bolt.svg"
  },
  {
    "name": "camera-cancel",
    "label": "Camera Cancel",
    "path": "camera-cancel.svg"
  },
  {
    "name": "camera-check",
    "label": "Camera Check",
    "path": "camera-check.svg"
  },
  {
    "name": "camera-code",
    "label": "Camera Code",
    "path": "camera-code.svg"
  },
  {
    "name": "camera-cog",
    "label": "Camera Cog",
    "path": "camera-cog.svg"
  },
  {
    "name": "camera-dollar",
    "label": "Camera Dollar",
    "path": "camera-dollar.svg"
  },
  {
    "name": "camera-down",
    "label": "Camera Down",
    "path": "camera-down.svg"
  },
  {
    "name": "camera-exclamation",
    "label": "Camera Exclamation",
    "path": "camera-exclamation.svg"
  },
  {
    "name": "camera-heart",
    "label": "Camera Heart",
    "path": "camera-heart.svg"
  },
  {
    "name": "camera-minus",
    "label": "Camera Minus",
    "path": "camera-minus.svg"
  },
  {
    "name": "camera-moon",
    "label": "Camera Moon",
    "path": "camera-moon.svg"
  },
  {
    "name": "camera-off",
    "label": "Camera Off",
    "path": "camera-off.svg"
  },
  {
    "name": "camera-pause",
    "label": "Camera Pause",
    "path": "camera-pause.svg"
  },
  {
    "name": "camera-pin",
    "label": "Camera Pin",
    "path": "camera-pin.svg"
  },
  {
    "name": "camera-plus",
    "label": "Camera Plus",
    "path": "camera-plus.svg"
  },
  {
    "name": "camera-question",
    "label": "Camera Question",
    "path": "camera-question.svg"
  },
  {
    "name": "camera-rotate",
    "label": "Camera Rotate",
    "path": "camera-rotate.svg"
  },
  {
    "name": "camera-search",
    "label": "Camera Search",
    "path": "camera-search.svg"
  },
  {
    "name": "camera-selfie",
    "label": "Camera Selfie",
    "path": "camera-selfie.svg"
  },
  {
    "name": "camera-share",
    "label": "Camera Share",
    "path": "camera-share.svg"
  },
  {
    "name": "camera-spark",
    "label": "Camera Spark",
    "path": "camera-spark.svg"
  },
  {
    "name": "camera-star",
    "label": "Camera Star",
    "path": "camera-star.svg"
  },
  {
    "name": "camera-up",
    "label": "Camera Up",
    "path": "camera-up.svg"
  },
  {
    "name": "camera-x",
    "label": "Camera X",
    "path": "camera-x.svg"
  },
  {
    "name": "camper",
    "label": "Camper",
    "path": "camper.svg"
  },
  {
    "name": "campfire",
    "label": "Campfire",
    "path": "campfire.svg"
  },
  {
    "name": "cancel",
    "label": "Cancel",
    "path": "cancel.svg"
  },
  {
    "name": "candle",
    "label": "Candle",
    "path": "candle.svg"
  },
  {
    "name": "candy",
    "label": "Candy",
    "path": "candy.svg"
  },
  {
    "name": "candy-off",
    "label": "Candy Off",
    "path": "candy-off.svg"
  },
  {
    "name": "cane",
    "label": "Cane",
    "path": "cane.svg"
  },
  {
    "name": "cannabis",
    "label": "Cannabis",
    "path": "cannabis.svg"
  },
  {
    "name": "cap-projecting",
    "label": "Cap Projecting",
    "path": "cap-projecting.svg"
  },
  {
    "name": "cap-rounded",
    "label": "Cap Rounded",
    "path": "cap-rounded.svg"
  },
  {
    "name": "cap-straight",
    "label": "Cap Straight",
    "path": "cap-straight.svg"
  },
  {
    "name": "capsule",
    "label": "Capsule",
    "path": "capsule.svg"
  },
  {
    "name": "capsule-horizontal",
    "label": "Capsule Horizontal",
    "path": "capsule-horizontal.svg"
  },
  {
    "name": "capture",
    "label": "Capture",
    "path": "capture.svg"
  },
  {
    "name": "capture-off",
    "label": "Capture Off",
    "path": "capture-off.svg"
  },
  {
    "name": "car",
    "label": "Car",
    "path": "car.svg"
  },
  {
    "name": "car-4wd",
    "label": "Car 4wd",
    "path": "car-4wd.svg"
  },
  {
    "name": "car-crane",
    "label": "Car Crane",
    "path": "car-crane.svg"
  },
  {
    "name": "car-crash",
    "label": "Car Crash",
    "path": "car-crash.svg"
  },
  {
    "name": "car-fan",
    "label": "Car Fan",
    "path": "car-fan.svg"
  },
  {
    "name": "car-fan-1",
    "label": "Car Fan 1",
    "path": "car-fan-1.svg"
  },
  {
    "name": "car-fan-2",
    "label": "Car Fan 2",
    "path": "car-fan-2.svg"
  },
  {
    "name": "car-fan-3",
    "label": "Car Fan 3",
    "path": "car-fan-3.svg"
  },
  {
    "name": "car-fan-auto",
    "label": "Car Fan Auto",
    "path": "car-fan-auto.svg"
  },
  {
    "name": "car-garage",
    "label": "Car Garage",
    "path": "car-garage.svg"
  },
  {
    "name": "car-off",
    "label": "Car Off",
    "path": "car-off.svg"
  },
  {
    "name": "car-suv",
    "label": "Car Suv",
    "path": "car-suv.svg"
  },
  {
    "name": "car-turbine",
    "label": "Car Turbine",
    "path": "car-turbine.svg"
  },
  {
    "name": "carambola",
    "label": "Carambola",
    "path": "carambola.svg"
  },
  {
    "name": "caravan",
    "label": "Caravan",
    "path": "caravan.svg"
  },
  {
    "name": "cardboards",
    "label": "Cardboards",
    "path": "cardboards.svg"
  },
  {
    "name": "cardboards-off",
    "label": "Cardboards Off",
    "path": "cardboards-off.svg"
  },
  {
    "name": "cards",
    "label": "Cards",
    "path": "cards.svg"
  },
  {
    "name": "caret-down",
    "label": "Caret Down",
    "path": "caret-down.svg"
  },
  {
    "name": "caret-left",
    "label": "Caret Left",
    "path": "caret-left.svg"
  },
  {
    "name": "caret-left-right",
    "label": "Caret Left Right",
    "path": "caret-left-right.svg"
  },
  {
    "name": "caret-right",
    "label": "Caret Right",
    "path": "caret-right.svg"
  },
  {
    "name": "caret-up",
    "label": "Caret Up",
    "path": "caret-up.svg"
  },
  {
    "name": "caret-up-down",
    "label": "Caret Up Down",
    "path": "caret-up-down.svg"
  },
  {
    "name": "carousel-horizontal",
    "label": "Carousel Horizontal",
    "path": "carousel-horizontal.svg"
  },
  {
    "name": "carousel-vertical",
    "label": "Carousel Vertical",
    "path": "carousel-vertical.svg"
  },
  {
    "name": "carrot",
    "label": "Carrot",
    "path": "carrot.svg"
  },
  {
    "name": "carrot-off",
    "label": "Carrot Off",
    "path": "carrot-off.svg"
  },
  {
    "name": "cash",
    "label": "Cash",
    "path": "cash.svg"
  },
  {
    "name": "cash-banknote",
    "label": "Cash Banknote",
    "path": "cash-banknote.svg"
  },
  {
    "name": "cash-banknote-edit",
    "label": "Cash Banknote Edit",
    "path": "cash-banknote-edit.svg"
  },
  {
    "name": "cash-banknote-heart",
    "label": "Cash Banknote Heart",
    "path": "cash-banknote-heart.svg"
  },
  {
    "name": "cash-banknote-minus",
    "label": "Cash Banknote Minus",
    "path": "cash-banknote-minus.svg"
  },
  {
    "name": "cash-banknote-move",
    "label": "Cash Banknote Move",
    "path": "cash-banknote-move.svg"
  },
  {
    "name": "cash-banknote-move-back",
    "label": "Cash Banknote Move Back",
    "path": "cash-banknote-move-back.svg"
  },
  {
    "name": "cash-banknote-off",
    "label": "Cash Banknote Off",
    "path": "cash-banknote-off.svg"
  },
  {
    "name": "cash-banknote-plus",
    "label": "Cash Banknote Plus",
    "path": "cash-banknote-plus.svg"
  },
  {
    "name": "cash-edit",
    "label": "Cash Edit",
    "path": "cash-edit.svg"
  },
  {
    "name": "cash-heart",
    "label": "Cash Heart",
    "path": "cash-heart.svg"
  },
  {
    "name": "cash-minus",
    "label": "Cash Minus",
    "path": "cash-minus.svg"
  },
  {
    "name": "cash-move",
    "label": "Cash Move",
    "path": "cash-move.svg"
  },
  {
    "name": "cash-move-back",
    "label": "Cash Move Back",
    "path": "cash-move-back.svg"
  },
  {
    "name": "cash-off",
    "label": "Cash Off",
    "path": "cash-off.svg"
  },
  {
    "name": "cash-plus",
    "label": "Cash Plus",
    "path": "cash-plus.svg"
  },
  {
    "name": "cash-register",
    "label": "Cash Register",
    "path": "cash-register.svg"
  },
  {
    "name": "cast",
    "label": "Cast",
    "path": "cast.svg"
  },
  {
    "name": "cast-off",
    "label": "Cast Off",
    "path": "cast-off.svg"
  },
  {
    "name": "cat",
    "label": "Cat",
    "path": "cat.svg"
  },
  {
    "name": "category",
    "label": "Category",
    "path": "category.svg"
  },
  {
    "name": "category-2",
    "label": "Category 2",
    "path": "category-2.svg"
  },
  {
    "name": "category-minus",
    "label": "Category Minus",
    "path": "category-minus.svg"
  },
  {
    "name": "category-plus",
    "label": "Category Plus",
    "path": "category-plus.svg"
  },
  {
    "name": "ce",
    "label": "Ce",
    "path": "ce.svg"
  },
  {
    "name": "ce-off",
    "label": "Ce Off",
    "path": "ce-off.svg"
  },
  {
    "name": "cell",
    "label": "Cell",
    "path": "cell.svg"
  },
  {
    "name": "cell-signal-1",
    "label": "Cell Signal 1",
    "path": "cell-signal-1.svg"
  },
  {
    "name": "cell-signal-2",
    "label": "Cell Signal 2",
    "path": "cell-signal-2.svg"
  },
  {
    "name": "cell-signal-3",
    "label": "Cell Signal 3",
    "path": "cell-signal-3.svg"
  },
  {
    "name": "cell-signal-4",
    "label": "Cell Signal 4",
    "path": "cell-signal-4.svg"
  },
  {
    "name": "cell-signal-5",
    "label": "Cell Signal 5",
    "path": "cell-signal-5.svg"
  },
  {
    "name": "cell-signal-off",
    "label": "Cell Signal Off",
    "path": "cell-signal-off.svg"
  },
  {
    "name": "certificate",
    "label": "Certificate",
    "path": "certificate.svg"
  },
  {
    "name": "certificate-2",
    "label": "Certificate 2",
    "path": "certificate-2.svg"
  },
  {
    "name": "certificate-2-off",
    "label": "Certificate 2 Off",
    "path": "certificate-2-off.svg"
  },
  {
    "name": "certificate-off",
    "label": "Certificate Off",
    "path": "certificate-off.svg"
  },
  {
    "name": "chair-director",
    "label": "Chair Director",
    "path": "chair-director.svg"
  },
  {
    "name": "chalkboard",
    "label": "Chalkboard",
    "path": "chalkboard.svg"
  },
  {
    "name": "chalkboard-off",
    "label": "Chalkboard Off",
    "path": "chalkboard-off.svg"
  },
  {
    "name": "chalkboard-teacher",
    "label": "Chalkboard Teacher",
    "path": "chalkboard-teacher.svg"
  },
  {
    "name": "charging-pile",
    "label": "Charging Pile",
    "path": "charging-pile.svg"
  },
  {
    "name": "chart-arcs",
    "label": "Chart Arcs",
    "path": "chart-arcs.svg"
  },
  {
    "name": "chart-arcs-3",
    "label": "Chart Arcs 3",
    "path": "chart-arcs-3.svg"
  },
  {
    "name": "chart-area",
    "label": "Chart Area",
    "path": "chart-area.svg"
  },
  {
    "name": "chart-area-line",
    "label": "Chart Area Line",
    "path": "chart-area-line.svg"
  },
  {
    "name": "chart-arrows",
    "label": "Chart Arrows",
    "path": "chart-arrows.svg"
  },
  {
    "name": "chart-arrows-vertical",
    "label": "Chart Arrows Vertical",
    "path": "chart-arrows-vertical.svg"
  },
  {
    "name": "chart-bar",
    "label": "Chart Bar",
    "path": "chart-bar.svg"
  },
  {
    "name": "chart-bar-off",
    "label": "Chart Bar Off",
    "path": "chart-bar-off.svg"
  },
  {
    "name": "chart-bar-popular",
    "label": "Chart Bar Popular",
    "path": "chart-bar-popular.svg"
  },
  {
    "name": "chart-bubble",
    "label": "Chart Bubble",
    "path": "chart-bubble.svg"
  },
  {
    "name": "chart-candle",
    "label": "Chart Candle",
    "path": "chart-candle.svg"
  },
  {
    "name": "chart-circles",
    "label": "Chart Circles",
    "path": "chart-circles.svg"
  },
  {
    "name": "chart-cohort",
    "label": "Chart Cohort",
    "path": "chart-cohort.svg"
  },
  {
    "name": "chart-column",
    "label": "Chart Column",
    "path": "chart-column.svg"
  },
  {
    "name": "chart-covariate",
    "label": "Chart Covariate",
    "path": "chart-covariate.svg"
  },
  {
    "name": "chart-donut",
    "label": "Chart Donut",
    "path": "chart-donut.svg"
  },
  {
    "name": "chart-donut-2",
    "label": "Chart Donut 2",
    "path": "chart-donut-2.svg"
  },
  {
    "name": "chart-donut-3",
    "label": "Chart Donut 3",
    "path": "chart-donut-3.svg"
  },
  {
    "name": "chart-donut-4",
    "label": "Chart Donut 4",
    "path": "chart-donut-4.svg"
  },
  {
    "name": "chart-dots",
    "label": "Chart Dots",
    "path": "chart-dots.svg"
  },
  {
    "name": "chart-dots-2",
    "label": "Chart Dots 2",
    "path": "chart-dots-2.svg"
  },
  {
    "name": "chart-dots-3",
    "label": "Chart Dots 3",
    "path": "chart-dots-3.svg"
  },
  {
    "name": "chart-funnel",
    "label": "Chart Funnel",
    "path": "chart-funnel.svg"
  },
  {
    "name": "chart-grid-dots",
    "label": "Chart Grid Dots",
    "path": "chart-grid-dots.svg"
  },
  {
    "name": "chart-histogram",
    "label": "Chart Histogram",
    "path": "chart-histogram.svg"
  },
  {
    "name": "chart-infographic",
    "label": "Chart Infographic",
    "path": "chart-infographic.svg"
  },
  {
    "name": "chart-line",
    "label": "Chart Line",
    "path": "chart-line.svg"
  },
  {
    "name": "chart-pie",
    "label": "Chart Pie",
    "path": "chart-pie.svg"
  },
  {
    "name": "chart-pie-2",
    "label": "Chart Pie 2",
    "path": "chart-pie-2.svg"
  },
  {
    "name": "chart-pie-3",
    "label": "Chart Pie 3",
    "path": "chart-pie-3.svg"
  },
  {
    "name": "chart-pie-4",
    "label": "Chart Pie 4",
    "path": "chart-pie-4.svg"
  },
  {
    "name": "chart-pie-off",
    "label": "Chart Pie Off",
    "path": "chart-pie-off.svg"
  },
  {
    "name": "chart-ppf",
    "label": "Chart Ppf",
    "path": "chart-ppf.svg"
  },
  {
    "name": "chart-radar",
    "label": "Chart Radar",
    "path": "chart-radar.svg"
  },
  {
    "name": "chart-sankey",
    "label": "Chart Sankey",
    "path": "chart-sankey.svg"
  },
  {
    "name": "chart-scatter",
    "label": "Chart Scatter",
    "path": "chart-scatter.svg"
  },
  {
    "name": "chart-scatter-3d",
    "label": "Chart Scatter 3d",
    "path": "chart-scatter-3d.svg"
  },
  {
    "name": "chart-treemap",
    "label": "Chart Treemap",
    "path": "chart-treemap.svg"
  },
  {
    "name": "check",
    "label": "Check",
    "path": "check.svg"
  },
  {
    "name": "checkbox",
    "label": "Checkbox",
    "path": "checkbox.svg"
  },
  {
    "name": "checklist",
    "label": "Checklist",
    "path": "checklist.svg"
  },
  {
    "name": "checks",
    "label": "Checks",
    "path": "checks.svg"
  },
  {
    "name": "checkup-list",
    "label": "Checkup List",
    "path": "checkup-list.svg"
  },
  {
    "name": "cheese",
    "label": "Cheese",
    "path": "cheese.svg"
  },
  {
    "name": "chef-hat",
    "label": "Chef Hat",
    "path": "chef-hat.svg"
  },
  {
    "name": "chef-hat-off",
    "label": "Chef Hat Off",
    "path": "chef-hat-off.svg"
  },
  {
    "name": "cherry",
    "label": "Cherry",
    "path": "cherry.svg"
  },
  {
    "name": "chess",
    "label": "Chess",
    "path": "chess.svg"
  },
  {
    "name": "chess-bishop",
    "label": "Chess Bishop",
    "path": "chess-bishop.svg"
  },
  {
    "name": "chess-king",
    "label": "Chess King",
    "path": "chess-king.svg"
  },
  {
    "name": "chess-knight",
    "label": "Chess Knight",
    "path": "chess-knight.svg"
  },
  {
    "name": "chess-queen",
    "label": "Chess Queen",
    "path": "chess-queen.svg"
  },
  {
    "name": "chess-rook",
    "label": "Chess Rook",
    "path": "chess-rook.svg"
  },
  {
    "name": "chevron-compact-down",
    "label": "Chevron Compact Down",
    "path": "chevron-compact-down.svg"
  },
  {
    "name": "chevron-compact-left",
    "label": "Chevron Compact Left",
    "path": "chevron-compact-left.svg"
  },
  {
    "name": "chevron-compact-right",
    "label": "Chevron Compact Right",
    "path": "chevron-compact-right.svg"
  },
  {
    "name": "chevron-compact-up",
    "label": "Chevron Compact Up",
    "path": "chevron-compact-up.svg"
  },
  {
    "name": "chevron-down",
    "label": "Chevron Down",
    "path": "chevron-down.svg"
  },
  {
    "name": "chevron-down-left",
    "label": "Chevron Down Left",
    "path": "chevron-down-left.svg"
  },
  {
    "name": "chevron-down-right",
    "label": "Chevron Down Right",
    "path": "chevron-down-right.svg"
  },
  {
    "name": "chevron-left",
    "label": "Chevron Left",
    "path": "chevron-left.svg"
  },
  {
    "name": "chevron-left-pipe",
    "label": "Chevron Left Pipe",
    "path": "chevron-left-pipe.svg"
  },
  {
    "name": "chevron-right",
    "label": "Chevron Right",
    "path": "chevron-right.svg"
  },
  {
    "name": "chevron-right-pipe",
    "label": "Chevron Right Pipe",
    "path": "chevron-right-pipe.svg"
  },
  {
    "name": "chevron-up",
    "label": "Chevron Up",
    "path": "chevron-up.svg"
  },
  {
    "name": "chevron-up-left",
    "label": "Chevron Up Left",
    "path": "chevron-up-left.svg"
  },
  {
    "name": "chevron-up-right",
    "label": "Chevron Up Right",
    "path": "chevron-up-right.svg"
  },
  {
    "name": "chevrons-down",
    "label": "Chevrons Down",
    "path": "chevrons-down.svg"
  },
  {
    "name": "chevrons-down-left",
    "label": "Chevrons Down Left",
    "path": "chevrons-down-left.svg"
  },
  {
    "name": "chevrons-down-right",
    "label": "Chevrons Down Right",
    "path": "chevrons-down-right.svg"
  },
  {
    "name": "chevrons-left",
    "label": "Chevrons Left",
    "path": "chevrons-left.svg"
  },
  {
    "name": "chevrons-right",
    "label": "Chevrons Right",
    "path": "chevrons-right.svg"
  },
  {
    "name": "chevrons-up",
    "label": "Chevrons Up",
    "path": "chevrons-up.svg"
  },
  {
    "name": "chevrons-up-left",
    "label": "Chevrons Up Left",
    "path": "chevrons-up-left.svg"
  },
  {
    "name": "chevrons-up-right",
    "label": "Chevrons Up Right",
    "path": "chevrons-up-right.svg"
  },
  {
    "name": "chisel",
    "label": "Chisel",
    "path": "chisel.svg"
  },
  {
    "name": "christmas-ball",
    "label": "Christmas Ball",
    "path": "christmas-ball.svg"
  },
  {
    "name": "christmas-tree",
    "label": "Christmas Tree",
    "path": "christmas-tree.svg"
  },
  {
    "name": "christmas-tree-off",
    "label": "Christmas Tree Off",
    "path": "christmas-tree-off.svg"
  },
  {
    "name": "circle",
    "label": "Circle",
    "path": "circle.svg"
  },
  {
    "name": "circle-arrow-down",
    "label": "Circle Arrow Down",
    "path": "circle-arrow-down.svg"
  },
  {
    "name": "circle-arrow-down-left",
    "label": "Circle Arrow Down Left",
    "path": "circle-arrow-down-left.svg"
  },
  {
    "name": "circle-arrow-down-right",
    "label": "Circle Arrow Down Right",
    "path": "circle-arrow-down-right.svg"
  },
  {
    "name": "circle-arrow-left",
    "label": "Circle Arrow Left",
    "path": "circle-arrow-left.svg"
  },
  {
    "name": "circle-arrow-right",
    "label": "Circle Arrow Right",
    "path": "circle-arrow-right.svg"
  },
  {
    "name": "circle-arrow-up",
    "label": "Circle Arrow Up",
    "path": "circle-arrow-up.svg"
  },
  {
    "name": "circle-arrow-up-left",
    "label": "Circle Arrow Up Left",
    "path": "circle-arrow-up-left.svg"
  },
  {
    "name": "circle-arrow-up-right",
    "label": "Circle Arrow Up Right",
    "path": "circle-arrow-up-right.svg"
  },
  {
    "name": "circle-asterisk",
    "label": "Circle Asterisk",
    "path": "circle-asterisk.svg"
  },
  {
    "name": "circle-caret-down",
    "label": "Circle Caret Down",
    "path": "circle-caret-down.svg"
  },
  {
    "name": "circle-caret-left",
    "label": "Circle Caret Left",
    "path": "circle-caret-left.svg"
  },
  {
    "name": "circle-caret-right",
    "label": "Circle Caret Right",
    "path": "circle-caret-right.svg"
  },
  {
    "name": "circle-caret-up",
    "label": "Circle Caret Up",
    "path": "circle-caret-up.svg"
  },
  {
    "name": "circle-check",
    "label": "Circle Check",
    "path": "circle-check.svg"
  },
  {
    "name": "circle-chevron-down",
    "label": "Circle Chevron Down",
    "path": "circle-chevron-down.svg"
  },
  {
    "name": "circle-chevron-left",
    "label": "Circle Chevron Left",
    "path": "circle-chevron-left.svg"
  },
  {
    "name": "circle-chevron-right",
    "label": "Circle Chevron Right",
    "path": "circle-chevron-right.svg"
  },
  {
    "name": "circle-chevron-up",
    "label": "Circle Chevron Up",
    "path": "circle-chevron-up.svg"
  },
  {
    "name": "circle-chevrons-down",
    "label": "Circle Chevrons Down",
    "path": "circle-chevrons-down.svg"
  },
  {
    "name": "circle-chevrons-left",
    "label": "Circle Chevrons Left",
    "path": "circle-chevrons-left.svg"
  },
  {
    "name": "circle-chevrons-right",
    "label": "Circle Chevrons Right",
    "path": "circle-chevrons-right.svg"
  },
  {
    "name": "circle-chevrons-up",
    "label": "Circle Chevrons Up",
    "path": "circle-chevrons-up.svg"
  },
  {
    "name": "circle-dashed",
    "label": "Circle Dashed",
    "path": "circle-dashed.svg"
  },
  {
    "name": "circle-dashed-check",
    "label": "Circle Dashed Check",
    "path": "circle-dashed-check.svg"
  },
  {
    "name": "circle-dashed-letter-a",
    "label": "Circle Dashed Letter A",
    "path": "circle-dashed-letter-a.svg"
  },
  {
    "name": "circle-dashed-letter-b",
    "label": "Circle Dashed Letter B",
    "path": "circle-dashed-letter-b.svg"
  },
  {
    "name": "circle-dashed-letter-c",
    "label": "Circle Dashed Letter C",
    "path": "circle-dashed-letter-c.svg"
  },
  {
    "name": "circle-dashed-letter-d",
    "label": "Circle Dashed Letter D",
    "path": "circle-dashed-letter-d.svg"
  },
  {
    "name": "circle-dashed-letter-e",
    "label": "Circle Dashed Letter E",
    "path": "circle-dashed-letter-e.svg"
  },
  {
    "name": "circle-dashed-letter-f",
    "label": "Circle Dashed Letter F",
    "path": "circle-dashed-letter-f.svg"
  },
  {
    "name": "circle-dashed-letter-g",
    "label": "Circle Dashed Letter G",
    "path": "circle-dashed-letter-g.svg"
  },
  {
    "name": "circle-dashed-letter-h",
    "label": "Circle Dashed Letter H",
    "path": "circle-dashed-letter-h.svg"
  },
  {
    "name": "circle-dashed-letter-i",
    "label": "Circle Dashed Letter I",
    "path": "circle-dashed-letter-i.svg"
  },
  {
    "name": "circle-dashed-letter-j",
    "label": "Circle Dashed Letter J",
    "path": "circle-dashed-letter-j.svg"
  },
  {
    "name": "circle-dashed-letter-k",
    "label": "Circle Dashed Letter K",
    "path": "circle-dashed-letter-k.svg"
  },
  {
    "name": "circle-dashed-letter-l",
    "label": "Circle Dashed Letter L",
    "path": "circle-dashed-letter-l.svg"
  },
  {
    "name": "circle-dashed-letter-m",
    "label": "Circle Dashed Letter M",
    "path": "circle-dashed-letter-m.svg"
  },
  {
    "name": "circle-dashed-letter-n",
    "label": "Circle Dashed Letter N",
    "path": "circle-dashed-letter-n.svg"
  },
  {
    "name": "circle-dashed-letter-o",
    "label": "Circle Dashed Letter O",
    "path": "circle-dashed-letter-o.svg"
  },
  {
    "name": "circle-dashed-letter-p",
    "label": "Circle Dashed Letter P",
    "path": "circle-dashed-letter-p.svg"
  },
  {
    "name": "circle-dashed-letter-q",
    "label": "Circle Dashed Letter Q",
    "path": "circle-dashed-letter-q.svg"
  },
  {
    "name": "circle-dashed-letter-r",
    "label": "Circle Dashed Letter R",
    "path": "circle-dashed-letter-r.svg"
  },
  {
    "name": "circle-dashed-letter-s",
    "label": "Circle Dashed Letter S",
    "path": "circle-dashed-letter-s.svg"
  },
  {
    "name": "circle-dashed-letter-t",
    "label": "Circle Dashed Letter T",
    "path": "circle-dashed-letter-t.svg"
  },
  {
    "name": "circle-dashed-letter-u",
    "label": "Circle Dashed Letter U",
    "path": "circle-dashed-letter-u.svg"
  },
  {
    "name": "circle-dashed-letter-v",
    "label": "Circle Dashed Letter V",
    "path": "circle-dashed-letter-v.svg"
  },
  {
    "name": "circle-dashed-letter-w",
    "label": "Circle Dashed Letter W",
    "path": "circle-dashed-letter-w.svg"
  },
  {
    "name": "circle-dashed-letter-x",
    "label": "Circle Dashed Letter X",
    "path": "circle-dashed-letter-x.svg"
  },
  {
    "name": "circle-dashed-letter-y",
    "label": "Circle Dashed Letter Y",
    "path": "circle-dashed-letter-y.svg"
  },
  {
    "name": "circle-dashed-letter-z",
    "label": "Circle Dashed Letter Z",
    "path": "circle-dashed-letter-z.svg"
  },
  {
    "name": "circle-dashed-minus",
    "label": "Circle Dashed Minus",
    "path": "circle-dashed-minus.svg"
  },
  {
    "name": "circle-dashed-number-0",
    "label": "Circle Dashed Number 0",
    "path": "circle-dashed-number-0.svg"
  },
  {
    "name": "circle-dashed-number-1",
    "label": "Circle Dashed Number 1",
    "path": "circle-dashed-number-1.svg"
  },
  {
    "name": "circle-dashed-number-2",
    "label": "Circle Dashed Number 2",
    "path": "circle-dashed-number-2.svg"
  },
  {
    "name": "circle-dashed-number-3",
    "label": "Circle Dashed Number 3",
    "path": "circle-dashed-number-3.svg"
  },
  {
    "name": "circle-dashed-number-4",
    "label": "Circle Dashed Number 4",
    "path": "circle-dashed-number-4.svg"
  },
  {
    "name": "circle-dashed-number-5",
    "label": "Circle Dashed Number 5",
    "path": "circle-dashed-number-5.svg"
  },
  {
    "name": "circle-dashed-number-6",
    "label": "Circle Dashed Number 6",
    "path": "circle-dashed-number-6.svg"
  },
  {
    "name": "circle-dashed-number-7",
    "label": "Circle Dashed Number 7",
    "path": "circle-dashed-number-7.svg"
  },
  {
    "name": "circle-dashed-number-8",
    "label": "Circle Dashed Number 8",
    "path": "circle-dashed-number-8.svg"
  },
  {
    "name": "circle-dashed-number-9",
    "label": "Circle Dashed Number 9",
    "path": "circle-dashed-number-9.svg"
  },
  {
    "name": "circle-dashed-percentage",
    "label": "Circle Dashed Percentage",
    "path": "circle-dashed-percentage.svg"
  },
  {
    "name": "circle-dashed-plus",
    "label": "Circle Dashed Plus",
    "path": "circle-dashed-plus.svg"
  },
  {
    "name": "circle-dashed-x",
    "label": "Circle Dashed X",
    "path": "circle-dashed-x.svg"
  },
  {
    "name": "circle-dot",
    "label": "Circle Dot",
    "path": "circle-dot.svg"
  },
  {
    "name": "circle-dotted",
    "label": "Circle Dotted",
    "path": "circle-dotted.svg"
  },
  {
    "name": "circle-dotted-letter-a",
    "label": "Circle Dotted Letter A",
    "path": "circle-dotted-letter-a.svg"
  },
  {
    "name": "circle-dotted-letter-b",
    "label": "Circle Dotted Letter B",
    "path": "circle-dotted-letter-b.svg"
  },
  {
    "name": "circle-dotted-letter-c",
    "label": "Circle Dotted Letter C",
    "path": "circle-dotted-letter-c.svg"
  },
  {
    "name": "circle-dotted-letter-d",
    "label": "Circle Dotted Letter D",
    "path": "circle-dotted-letter-d.svg"
  },
  {
    "name": "circle-dotted-letter-e",
    "label": "Circle Dotted Letter E",
    "path": "circle-dotted-letter-e.svg"
  },
  {
    "name": "circle-dotted-letter-f",
    "label": "Circle Dotted Letter F",
    "path": "circle-dotted-letter-f.svg"
  },
  {
    "name": "circle-dotted-letter-g",
    "label": "Circle Dotted Letter G",
    "path": "circle-dotted-letter-g.svg"
  },
  {
    "name": "circle-dotted-letter-h",
    "label": "Circle Dotted Letter H",
    "path": "circle-dotted-letter-h.svg"
  },
  {
    "name": "circle-dotted-letter-i",
    "label": "Circle Dotted Letter I",
    "path": "circle-dotted-letter-i.svg"
  },
  {
    "name": "circle-dotted-letter-j",
    "label": "Circle Dotted Letter J",
    "path": "circle-dotted-letter-j.svg"
  },
  {
    "name": "circle-dotted-letter-k",
    "label": "Circle Dotted Letter K",
    "path": "circle-dotted-letter-k.svg"
  },
  {
    "name": "circle-dotted-letter-l",
    "label": "Circle Dotted Letter L",
    "path": "circle-dotted-letter-l.svg"
  },
  {
    "name": "circle-dotted-letter-m",
    "label": "Circle Dotted Letter M",
    "path": "circle-dotted-letter-m.svg"
  },
  {
    "name": "circle-dotted-letter-n",
    "label": "Circle Dotted Letter N",
    "path": "circle-dotted-letter-n.svg"
  },
  {
    "name": "circle-dotted-letter-o",
    "label": "Circle Dotted Letter O",
    "path": "circle-dotted-letter-o.svg"
  },
  {
    "name": "circle-dotted-letter-p",
    "label": "Circle Dotted Letter P",
    "path": "circle-dotted-letter-p.svg"
  },
  {
    "name": "circle-dotted-letter-q",
    "label": "Circle Dotted Letter Q",
    "path": "circle-dotted-letter-q.svg"
  },
  {
    "name": "circle-dotted-letter-r",
    "label": "Circle Dotted Letter R",
    "path": "circle-dotted-letter-r.svg"
  },
  {
    "name": "circle-dotted-letter-s",
    "label": "Circle Dotted Letter S",
    "path": "circle-dotted-letter-s.svg"
  },
  {
    "name": "circle-dotted-letter-t",
    "label": "Circle Dotted Letter T",
    "path": "circle-dotted-letter-t.svg"
  },
  {
    "name": "circle-dotted-letter-u",
    "label": "Circle Dotted Letter U",
    "path": "circle-dotted-letter-u.svg"
  },
  {
    "name": "circle-dotted-letter-v",
    "label": "Circle Dotted Letter V",
    "path": "circle-dotted-letter-v.svg"
  },
  {
    "name": "circle-dotted-letter-w",
    "label": "Circle Dotted Letter W",
    "path": "circle-dotted-letter-w.svg"
  },
  {
    "name": "circle-dotted-letter-x",
    "label": "Circle Dotted Letter X",
    "path": "circle-dotted-letter-x.svg"
  },
  {
    "name": "circle-dotted-letter-y",
    "label": "Circle Dotted Letter Y",
    "path": "circle-dotted-letter-y.svg"
  },
  {
    "name": "circle-dotted-letter-z",
    "label": "Circle Dotted Letter Z",
    "path": "circle-dotted-letter-z.svg"
  },
  {
    "name": "circle-half",
    "label": "Circle Half",
    "path": "circle-half.svg"
  },
  {
    "name": "circle-half-2",
    "label": "Circle Half 2",
    "path": "circle-half-2.svg"
  },
  {
    "name": "circle-half-vertical",
    "label": "Circle Half Vertical",
    "path": "circle-half-vertical.svg"
  },
  {
    "name": "circle-key",
    "label": "Circle Key",
    "path": "circle-key.svg"
  },
  {
    "name": "circle-letter-a",
    "label": "Circle Letter A",
    "path": "circle-letter-a.svg"
  },
  {
    "name": "circle-letter-b",
    "label": "Circle Letter B",
    "path": "circle-letter-b.svg"
  },
  {
    "name": "circle-letter-c",
    "label": "Circle Letter C",
    "path": "circle-letter-c.svg"
  },
  {
    "name": "circle-letter-d",
    "label": "Circle Letter D",
    "path": "circle-letter-d.svg"
  },
  {
    "name": "circle-letter-e",
    "label": "Circle Letter E",
    "path": "circle-letter-e.svg"
  },
  {
    "name": "circle-letter-f",
    "label": "Circle Letter F",
    "path": "circle-letter-f.svg"
  },
  {
    "name": "circle-letter-g",
    "label": "Circle Letter G",
    "path": "circle-letter-g.svg"
  },
  {
    "name": "circle-letter-h",
    "label": "Circle Letter H",
    "path": "circle-letter-h.svg"
  },
  {
    "name": "circle-letter-i",
    "label": "Circle Letter I",
    "path": "circle-letter-i.svg"
  },
  {
    "name": "circle-letter-j",
    "label": "Circle Letter J",
    "path": "circle-letter-j.svg"
  },
  {
    "name": "circle-letter-k",
    "label": "Circle Letter K",
    "path": "circle-letter-k.svg"
  },
  {
    "name": "circle-letter-l",
    "label": "Circle Letter L",
    "path": "circle-letter-l.svg"
  },
  {
    "name": "circle-letter-m",
    "label": "Circle Letter M",
    "path": "circle-letter-m.svg"
  },
  {
    "name": "circle-letter-n",
    "label": "Circle Letter N",
    "path": "circle-letter-n.svg"
  },
  {
    "name": "circle-letter-o",
    "label": "Circle Letter O",
    "path": "circle-letter-o.svg"
  },
  {
    "name": "circle-letter-p",
    "label": "Circle Letter P",
    "path": "circle-letter-p.svg"
  },
  {
    "name": "circle-letter-q",
    "label": "Circle Letter Q",
    "path": "circle-letter-q.svg"
  },
  {
    "name": "circle-letter-r",
    "label": "Circle Letter R",
    "path": "circle-letter-r.svg"
  },
  {
    "name": "circle-letter-s",
    "label": "Circle Letter S",
    "path": "circle-letter-s.svg"
  },
  {
    "name": "circle-letter-t",
    "label": "Circle Letter T",
    "path": "circle-letter-t.svg"
  },
  {
    "name": "circle-letter-u",
    "label": "Circle Letter U",
    "path": "circle-letter-u.svg"
  },
  {
    "name": "circle-letter-v",
    "label": "Circle Letter V",
    "path": "circle-letter-v.svg"
  },
  {
    "name": "circle-letter-w",
    "label": "Circle Letter W",
    "path": "circle-letter-w.svg"
  },
  {
    "name": "circle-letter-x",
    "label": "Circle Letter X",
    "path": "circle-letter-x.svg"
  },
  {
    "name": "circle-letter-y",
    "label": "Circle Letter Y",
    "path": "circle-letter-y.svg"
  },
  {
    "name": "circle-letter-z",
    "label": "Circle Letter Z",
    "path": "circle-letter-z.svg"
  },
  {
    "name": "circle-minus",
    "label": "Circle Minus",
    "path": "circle-minus.svg"
  },
  {
    "name": "circle-minus-2",
    "label": "Circle Minus 2",
    "path": "circle-minus-2.svg"
  },
  {
    "name": "circle-number-0",
    "label": "Circle Number 0",
    "path": "circle-number-0.svg"
  },
  {
    "name": "circle-number-1",
    "label": "Circle Number 1",
    "path": "circle-number-1.svg"
  },
  {
    "name": "circle-number-2",
    "label": "Circle Number 2",
    "path": "circle-number-2.svg"
  },
  {
    "name": "circle-number-3",
    "label": "Circle Number 3",
    "path": "circle-number-3.svg"
  },
  {
    "name": "circle-number-4",
    "label": "Circle Number 4",
    "path": "circle-number-4.svg"
  },
  {
    "name": "circle-number-5",
    "label": "Circle Number 5",
    "path": "circle-number-5.svg"
  },
  {
    "name": "circle-number-6",
    "label": "Circle Number 6",
    "path": "circle-number-6.svg"
  },
  {
    "name": "circle-number-7",
    "label": "Circle Number 7",
    "path": "circle-number-7.svg"
  },
  {
    "name": "circle-number-8",
    "label": "Circle Number 8",
    "path": "circle-number-8.svg"
  },
  {
    "name": "circle-number-9",
    "label": "Circle Number 9",
    "path": "circle-number-9.svg"
  },
  {
    "name": "circle-off",
    "label": "Circle Off",
    "path": "circle-off.svg"
  },
  {
    "name": "circle-percentage",
    "label": "Circle Percentage",
    "path": "circle-percentage.svg"
  },
  {
    "name": "circle-plus",
    "label": "Circle Plus",
    "path": "circle-plus.svg"
  },
  {
    "name": "circle-plus-2",
    "label": "Circle Plus 2",
    "path": "circle-plus-2.svg"
  },
  {
    "name": "circle-rectangle",
    "label": "Circle Rectangle",
    "path": "circle-rectangle.svg"
  },
  {
    "name": "circle-rectangle-off",
    "label": "Circle Rectangle Off",
    "path": "circle-rectangle-off.svg"
  },
  {
    "name": "circle-square",
    "label": "Circle Square",
    "path": "circle-square.svg"
  },
  {
    "name": "circle-triangle",
    "label": "Circle Triangle",
    "path": "circle-triangle.svg"
  },
  {
    "name": "circle-x",
    "label": "Circle X",
    "path": "circle-x.svg"
  },
  {
    "name": "circles",
    "label": "Circles",
    "path": "circles.svg"
  },
  {
    "name": "circles-relation",
    "label": "Circles Relation",
    "path": "circles-relation.svg"
  },
  {
    "name": "circuit-ammeter",
    "label": "Circuit Ammeter",
    "path": "circuit-ammeter.svg"
  },
  {
    "name": "circuit-battery",
    "label": "Circuit Battery",
    "path": "circuit-battery.svg"
  },
  {
    "name": "circuit-bulb",
    "label": "Circuit Bulb",
    "path": "circuit-bulb.svg"
  },
  {
    "name": "circuit-capacitor",
    "label": "Circuit Capacitor",
    "path": "circuit-capacitor.svg"
  },
  {
    "name": "circuit-capacitor-polarized",
    "label": "Circuit Capacitor Polarized",
    "path": "circuit-capacitor-polarized.svg"
  },
  {
    "name": "circuit-cell",
    "label": "Circuit Cell",
    "path": "circuit-cell.svg"
  },
  {
    "name": "circuit-cell-plus",
    "label": "Circuit Cell Plus",
    "path": "circuit-cell-plus.svg"
  },
  {
    "name": "circuit-changeover",
    "label": "Circuit Changeover",
    "path": "circuit-changeover.svg"
  },
  {
    "name": "circuit-diode",
    "label": "Circuit Diode",
    "path": "circuit-diode.svg"
  },
  {
    "name": "circuit-diode-zener",
    "label": "Circuit Diode Zener",
    "path": "circuit-diode-zener.svg"
  },
  {
    "name": "circuit-ground",
    "label": "Circuit Ground",
    "path": "circuit-ground.svg"
  },
  {
    "name": "circuit-ground-digital",
    "label": "Circuit Ground Digital",
    "path": "circuit-ground-digital.svg"
  },
  {
    "name": "circuit-inductor",
    "label": "Circuit Inductor",
    "path": "circuit-inductor.svg"
  },
  {
    "name": "circuit-motor",
    "label": "Circuit Motor",
    "path": "circuit-motor.svg"
  },
  {
    "name": "circuit-pushbutton",
    "label": "Circuit Pushbutton",
    "path": "circuit-pushbutton.svg"
  },
  {
    "name": "circuit-resistor",
    "label": "Circuit Resistor",
    "path": "circuit-resistor.svg"
  },
  {
    "name": "circuit-switch-closed",
    "label": "Circuit Switch Closed",
    "path": "circuit-switch-closed.svg"
  },
  {
    "name": "circuit-switch-open",
    "label": "Circuit Switch Open",
    "path": "circuit-switch-open.svg"
  },
  {
    "name": "circuit-voltmeter",
    "label": "Circuit Voltmeter",
    "path": "circuit-voltmeter.svg"
  },
  {
    "name": "clear-all",
    "label": "Clear All",
    "path": "clear-all.svg"
  },
  {
    "name": "clear-formatting",
    "label": "Clear Formatting",
    "path": "clear-formatting.svg"
  },
  {
    "name": "click",
    "label": "Click",
    "path": "click.svg"
  },
  {
    "name": "cliff-jumping",
    "label": "Cliff Jumping",
    "path": "cliff-jumping.svg"
  },
  {
    "name": "clipboard",
    "label": "Clipboard",
    "path": "clipboard.svg"
  },
  {
    "name": "clipboard-check",
    "label": "Clipboard Check",
    "path": "clipboard-check.svg"
  },
  {
    "name": "clipboard-copy",
    "label": "Clipboard Copy",
    "path": "clipboard-copy.svg"
  },
  {
    "name": "clipboard-data",
    "label": "Clipboard Data",
    "path": "clipboard-data.svg"
  },
  {
    "name": "clipboard-heart",
    "label": "Clipboard Heart",
    "path": "clipboard-heart.svg"
  },
  {
    "name": "clipboard-list",
    "label": "Clipboard List",
    "path": "clipboard-list.svg"
  },
  {
    "name": "clipboard-off",
    "label": "Clipboard Off",
    "path": "clipboard-off.svg"
  },
  {
    "name": "clipboard-plus",
    "label": "Clipboard Plus",
    "path": "clipboard-plus.svg"
  },
  {
    "name": "clipboard-search",
    "label": "Clipboard Search",
    "path": "clipboard-search.svg"
  },
  {
    "name": "clipboard-smile",
    "label": "Clipboard Smile",
    "path": "clipboard-smile.svg"
  },
  {
    "name": "clipboard-text",
    "label": "Clipboard Text",
    "path": "clipboard-text.svg"
  },
  {
    "name": "clipboard-typography",
    "label": "Clipboard Typography",
    "path": "clipboard-typography.svg"
  },
  {
    "name": "clipboard-x",
    "label": "Clipboard X",
    "path": "clipboard-x.svg"
  },
  {
    "name": "clock",
    "label": "Clock",
    "path": "clock.svg"
  },
  {
    "name": "clock-12",
    "label": "Clock 12",
    "path": "clock-12.svg"
  },
  {
    "name": "clock-2",
    "label": "Clock 2",
    "path": "clock-2.svg"
  },
  {
    "name": "clock-24",
    "label": "Clock 24",
    "path": "clock-24.svg"
  },
  {
    "name": "clock-bitcoin",
    "label": "Clock Bitcoin",
    "path": "clock-bitcoin.svg"
  },
  {
    "name": "clock-bolt",
    "label": "Clock Bolt",
    "path": "clock-bolt.svg"
  },
  {
    "name": "clock-cancel",
    "label": "Clock Cancel",
    "path": "clock-cancel.svg"
  },
  {
    "name": "clock-check",
    "label": "Clock Check",
    "path": "clock-check.svg"
  },
  {
    "name": "clock-code",
    "label": "Clock Code",
    "path": "clock-code.svg"
  },
  {
    "name": "clock-cog",
    "label": "Clock Cog",
    "path": "clock-cog.svg"
  },
  {
    "name": "clock-dollar",
    "label": "Clock Dollar",
    "path": "clock-dollar.svg"
  },
  {
    "name": "clock-down",
    "label": "Clock Down",
    "path": "clock-down.svg"
  },
  {
    "name": "clock-edit",
    "label": "Clock Edit",
    "path": "clock-edit.svg"
  },
  {
    "name": "clock-exclamation",
    "label": "Clock Exclamation",
    "path": "clock-exclamation.svg"
  },
  {
    "name": "clock-heart",
    "label": "Clock Heart",
    "path": "clock-heart.svg"
  },
  {
    "name": "clock-hour-1",
    "label": "Clock Hour 1",
    "path": "clock-hour-1.svg"
  },
  {
    "name": "clock-hour-10",
    "label": "Clock Hour 10",
    "path": "clock-hour-10.svg"
  },
  {
    "name": "clock-hour-11",
    "label": "Clock Hour 11",
    "path": "clock-hour-11.svg"
  },
  {
    "name": "clock-hour-12",
    "label": "Clock Hour 12",
    "path": "clock-hour-12.svg"
  },
  {
    "name": "clock-hour-2",
    "label": "Clock Hour 2",
    "path": "clock-hour-2.svg"
  },
  {
    "name": "clock-hour-3",
    "label": "Clock Hour 3",
    "path": "clock-hour-3.svg"
  },
  {
    "name": "clock-hour-4",
    "label": "Clock Hour 4",
    "path": "clock-hour-4.svg"
  },
  {
    "name": "clock-hour-5",
    "label": "Clock Hour 5",
    "path": "clock-hour-5.svg"
  },
  {
    "name": "clock-hour-6",
    "label": "Clock Hour 6",
    "path": "clock-hour-6.svg"
  },
  {
    "name": "clock-hour-7",
    "label": "Clock Hour 7",
    "path": "clock-hour-7.svg"
  },
  {
    "name": "clock-hour-8",
    "label": "Clock Hour 8",
    "path": "clock-hour-8.svg"
  },
  {
    "name": "clock-hour-9",
    "label": "Clock Hour 9",
    "path": "clock-hour-9.svg"
  },
  {
    "name": "clock-minus",
    "label": "Clock Minus",
    "path": "clock-minus.svg"
  },
  {
    "name": "clock-off",
    "label": "Clock Off",
    "path": "clock-off.svg"
  },
  {
    "name": "clock-pause",
    "label": "Clock Pause",
    "path": "clock-pause.svg"
  },
  {
    "name": "clock-pin",
    "label": "Clock Pin",
    "path": "clock-pin.svg"
  },
  {
    "name": "clock-play",
    "label": "Clock Play",
    "path": "clock-play.svg"
  },
  {
    "name": "clock-plus",
    "label": "Clock Plus",
    "path": "clock-plus.svg"
  },
  {
    "name": "clock-question",
    "label": "Clock Question",
    "path": "clock-question.svg"
  },
  {
    "name": "clock-record",
    "label": "Clock Record",
    "path": "clock-record.svg"
  },
  {
    "name": "clock-search",
    "label": "Clock Search",
    "path": "clock-search.svg"
  },
  {
    "name": "clock-share",
    "label": "Clock Share",
    "path": "clock-share.svg"
  },
  {
    "name": "clock-shield",
    "label": "Clock Shield",
    "path": "clock-shield.svg"
  },
  {
    "name": "clock-star",
    "label": "Clock Star",
    "path": "clock-star.svg"
  },
  {
    "name": "clock-stop",
    "label": "Clock Stop",
    "path": "clock-stop.svg"
  },
  {
    "name": "clock-up",
    "label": "Clock Up",
    "path": "clock-up.svg"
  },
  {
    "name": "clock-x",
    "label": "Clock X",
    "path": "clock-x.svg"
  },
  {
    "name": "clothes-rack",
    "label": "Clothes Rack",
    "path": "clothes-rack.svg"
  },
  {
    "name": "clothes-rack-off",
    "label": "Clothes Rack Off",
    "path": "clothes-rack-off.svg"
  },
  {
    "name": "cloud",
    "label": "Cloud",
    "path": "cloud.svg"
  },
  {
    "name": "cloud-bitcoin",
    "label": "Cloud Bitcoin",
    "path": "cloud-bitcoin.svg"
  },
  {
    "name": "cloud-bolt",
    "label": "Cloud Bolt",
    "path": "cloud-bolt.svg"
  },
  {
    "name": "cloud-cancel",
    "label": "Cloud Cancel",
    "path": "cloud-cancel.svg"
  },
  {
    "name": "cloud-check",
    "label": "Cloud Check",
    "path": "cloud-check.svg"
  },
  {
    "name": "cloud-code",
    "label": "Cloud Code",
    "path": "cloud-code.svg"
  },
  {
    "name": "cloud-cog",
    "label": "Cloud Cog",
    "path": "cloud-cog.svg"
  },
  {
    "name": "cloud-computing",
    "label": "Cloud Computing",
    "path": "cloud-computing.svg"
  },
  {
    "name": "cloud-data-connection",
    "label": "Cloud Data Connection",
    "path": "cloud-data-connection.svg"
  },
  {
    "name": "cloud-dollar",
    "label": "Cloud Dollar",
    "path": "cloud-dollar.svg"
  },
  {
    "name": "cloud-down",
    "label": "Cloud Down",
    "path": "cloud-down.svg"
  },
  {
    "name": "cloud-download",
    "label": "Cloud Download",
    "path": "cloud-download.svg"
  },
  {
    "name": "cloud-exclamation",
    "label": "Cloud Exclamation",
    "path": "cloud-exclamation.svg"
  },
  {
    "name": "cloud-fog",
    "label": "Cloud Fog",
    "path": "cloud-fog.svg"
  },
  {
    "name": "cloud-heart",
    "label": "Cloud Heart",
    "path": "cloud-heart.svg"
  },
  {
    "name": "cloud-lock",
    "label": "Cloud Lock",
    "path": "cloud-lock.svg"
  },
  {
    "name": "cloud-lock-open",
    "label": "Cloud Lock Open",
    "path": "cloud-lock-open.svg"
  },
  {
    "name": "cloud-minus",
    "label": "Cloud Minus",
    "path": "cloud-minus.svg"
  },
  {
    "name": "cloud-network",
    "label": "Cloud Network",
    "path": "cloud-network.svg"
  },
  {
    "name": "cloud-off",
    "label": "Cloud Off",
    "path": "cloud-off.svg"
  },
  {
    "name": "cloud-pause",
    "label": "Cloud Pause",
    "path": "cloud-pause.svg"
  },
  {
    "name": "cloud-pin",
    "label": "Cloud Pin",
    "path": "cloud-pin.svg"
  },
  {
    "name": "cloud-plus",
    "label": "Cloud Plus",
    "path": "cloud-plus.svg"
  },
  {
    "name": "cloud-question",
    "label": "Cloud Question",
    "path": "cloud-question.svg"
  },
  {
    "name": "cloud-rain",
    "label": "Cloud Rain",
    "path": "cloud-rain.svg"
  },
  {
    "name": "cloud-search",
    "label": "Cloud Search",
    "path": "cloud-search.svg"
  },
  {
    "name": "cloud-share",
    "label": "Cloud Share",
    "path": "cloud-share.svg"
  },
  {
    "name": "cloud-snow",
    "label": "Cloud Snow",
    "path": "cloud-snow.svg"
  },
  {
    "name": "cloud-star",
    "label": "Cloud Star",
    "path": "cloud-star.svg"
  },
  {
    "name": "cloud-storm",
    "label": "Cloud Storm",
    "path": "cloud-storm.svg"
  },
  {
    "name": "cloud-up",
    "label": "Cloud Up",
    "path": "cloud-up.svg"
  },
  {
    "name": "cloud-upload",
    "label": "Cloud Upload",
    "path": "cloud-upload.svg"
  },
  {
    "name": "cloud-x",
    "label": "Cloud X",
    "path": "cloud-x.svg"
  },
  {
    "name": "clover",
    "label": "Clover",
    "path": "clover.svg"
  },
  {
    "name": "clover-2",
    "label": "Clover 2",
    "path": "clover-2.svg"
  },
  {
    "name": "clubs",
    "label": "Clubs",
    "path": "clubs.svg"
  },
  {
    "name": "code",
    "label": "Code",
    "path": "code.svg"
  },
  {
    "name": "code-asterisk",
    "label": "Code Asterisk",
    "path": "code-asterisk.svg"
  },
  {
    "name": "code-circle",
    "label": "Code Circle",
    "path": "code-circle.svg"
  },
  {
    "name": "code-circle-2",
    "label": "Code Circle 2",
    "path": "code-circle-2.svg"
  },
  {
    "name": "code-dots",
    "label": "Code Dots",
    "path": "code-dots.svg"
  },
  {
    "name": "code-minus",
    "label": "Code Minus",
    "path": "code-minus.svg"
  },
  {
    "name": "code-off",
    "label": "Code Off",
    "path": "code-off.svg"
  },
  {
    "name": "code-plus",
    "label": "Code Plus",
    "path": "code-plus.svg"
  },
  {
    "name": "code-variable",
    "label": "Code Variable",
    "path": "code-variable.svg"
  },
  {
    "name": "code-variable-minus",
    "label": "Code Variable Minus",
    "path": "code-variable-minus.svg"
  },
  {
    "name": "code-variable-plus",
    "label": "Code Variable Plus",
    "path": "code-variable-plus.svg"
  },
  {
    "name": "coffee",
    "label": "Coffee",
    "path": "coffee.svg"
  },
  {
    "name": "coffee-off",
    "label": "Coffee Off",
    "path": "coffee-off.svg"
  },
  {
    "name": "coffin",
    "label": "Coffin",
    "path": "coffin.svg"
  },
  {
    "name": "coin",
    "label": "Coin",
    "path": "coin.svg"
  },
  {
    "name": "coin-bitcoin",
    "label": "Coin Bitcoin",
    "path": "coin-bitcoin.svg"
  },
  {
    "name": "coin-euro",
    "label": "Coin Euro",
    "path": "coin-euro.svg"
  },
  {
    "name": "coin-monero",
    "label": "Coin Monero",
    "path": "coin-monero.svg"
  },
  {
    "name": "coin-off",
    "label": "Coin Off",
    "path": "coin-off.svg"
  },
  {
    "name": "coin-pound",
    "label": "Coin Pound",
    "path": "coin-pound.svg"
  },
  {
    "name": "coin-rupee",
    "label": "Coin Rupee",
    "path": "coin-rupee.svg"
  },
  {
    "name": "coin-taka",
    "label": "Coin Taka",
    "path": "coin-taka.svg"
  },
  {
    "name": "coin-yen",
    "label": "Coin Yen",
    "path": "coin-yen.svg"
  },
  {
    "name": "coin-yuan",
    "label": "Coin Yuan",
    "path": "coin-yuan.svg"
  },
  {
    "name": "coins",
    "label": "Coins",
    "path": "coins.svg"
  },
  {
    "name": "color-filter",
    "label": "Color Filter",
    "path": "color-filter.svg"
  },
  {
    "name": "color-picker",
    "label": "Color Picker",
    "path": "color-picker.svg"
  },
  {
    "name": "color-picker-off",
    "label": "Color Picker Off",
    "path": "color-picker-off.svg"
  },
  {
    "name": "color-swatch",
    "label": "Color Swatch",
    "path": "color-swatch.svg"
  },
  {
    "name": "color-swatch-off",
    "label": "Color Swatch Off",
    "path": "color-swatch-off.svg"
  },
  {
    "name": "column-insert-left",
    "label": "Column Insert Left",
    "path": "column-insert-left.svg"
  },
  {
    "name": "column-insert-right",
    "label": "Column Insert Right",
    "path": "column-insert-right.svg"
  },
  {
    "name": "column-remove",
    "label": "Column Remove",
    "path": "column-remove.svg"
  },
  {
    "name": "columns",
    "label": "Columns",
    "path": "columns.svg"
  },
  {
    "name": "columns-1",
    "label": "Columns 1",
    "path": "columns-1.svg"
  },
  {
    "name": "columns-2",
    "label": "Columns 2",
    "path": "columns-2.svg"
  },
  {
    "name": "columns-3",
    "label": "Columns 3",
    "path": "columns-3.svg"
  },
  {
    "name": "columns-off",
    "label": "Columns Off",
    "path": "columns-off.svg"
  },
  {
    "name": "comet",
    "label": "Comet",
    "path": "comet.svg"
  },
  {
    "name": "command",
    "label": "Command",
    "path": "command.svg"
  },
  {
    "name": "command-off",
    "label": "Command Off",
    "path": "command-off.svg"
  },
  {
    "name": "compass",
    "label": "Compass",
    "path": "compass.svg"
  },
  {
    "name": "compass-off",
    "label": "Compass Off",
    "path": "compass-off.svg"
  },
  {
    "name": "components",
    "label": "Components",
    "path": "components.svg"
  },
  {
    "name": "components-off",
    "label": "Components Off",
    "path": "components-off.svg"
  },
  {
    "name": "cone",
    "label": "Cone",
    "path": "cone.svg"
  },
  {
    "name": "cone-2",
    "label": "Cone 2",
    "path": "cone-2.svg"
  },
  {
    "name": "cone-off",
    "label": "Cone Off",
    "path": "cone-off.svg"
  },
  {
    "name": "cone-plus",
    "label": "Cone Plus",
    "path": "cone-plus.svg"
  },
  {
    "name": "confetti",
    "label": "Confetti",
    "path": "confetti.svg"
  },
  {
    "name": "confetti-off",
    "label": "Confetti Off",
    "path": "confetti-off.svg"
  },
  {
    "name": "confucius",
    "label": "Confucius",
    "path": "confucius.svg"
  },
  {
    "name": "congruent-to",
    "label": "Congruent To",
    "path": "congruent-to.svg"
  },
  {
    "name": "container",
    "label": "Container",
    "path": "container.svg"
  },
  {
    "name": "container-off",
    "label": "Container Off",
    "path": "container-off.svg"
  },
  {
    "name": "contract",
    "label": "Contract",
    "path": "contract.svg"
  },
  {
    "name": "contrast",
    "label": "Contrast",
    "path": "contrast.svg"
  },
  {
    "name": "contrast-2",
    "label": "Contrast 2",
    "path": "contrast-2.svg"
  },
  {
    "name": "contrast-2-off",
    "label": "Contrast 2 Off",
    "path": "contrast-2-off.svg"
  },
  {
    "name": "contrast-off",
    "label": "Contrast Off",
    "path": "contrast-off.svg"
  },
  {
    "name": "cooker",
    "label": "Cooker",
    "path": "cooker.svg"
  },
  {
    "name": "cookie",
    "label": "Cookie",
    "path": "cookie.svg"
  },
  {
    "name": "cookie-man",
    "label": "Cookie Man",
    "path": "cookie-man.svg"
  },
  {
    "name": "cookie-off",
    "label": "Cookie Off",
    "path": "cookie-off.svg"
  },
  {
    "name": "copy",
    "label": "Copy",
    "path": "copy.svg"
  },
  {
    "name": "copy-check",
    "label": "Copy Check",
    "path": "copy-check.svg"
  },
  {
    "name": "copy-minus",
    "label": "Copy Minus",
    "path": "copy-minus.svg"
  },
  {
    "name": "copy-off",
    "label": "Copy Off",
    "path": "copy-off.svg"
  },
  {
    "name": "copy-plus",
    "label": "Copy Plus",
    "path": "copy-plus.svg"
  },
  {
    "name": "copy-x",
    "label": "Copy X",
    "path": "copy-x.svg"
  },
  {
    "name": "copyleft",
    "label": "Copyleft",
    "path": "copyleft.svg"
  },
  {
    "name": "copyleft-off",
    "label": "Copyleft Off",
    "path": "copyleft-off.svg"
  },
  {
    "name": "copyright",
    "label": "Copyright",
    "path": "copyright.svg"
  },
  {
    "name": "copyright-off",
    "label": "Copyright Off",
    "path": "copyright-off.svg"
  },
  {
    "name": "corner-down-left",
    "label": "Corner Down Left",
    "path": "corner-down-left.svg"
  },
  {
    "name": "corner-down-left-double",
    "label": "Corner Down Left Double",
    "path": "corner-down-left-double.svg"
  },
  {
    "name": "corner-down-right",
    "label": "Corner Down Right",
    "path": "corner-down-right.svg"
  },
  {
    "name": "corner-down-right-double",
    "label": "Corner Down Right Double",
    "path": "corner-down-right-double.svg"
  },
  {
    "name": "corner-left-down",
    "label": "Corner Left Down",
    "path": "corner-left-down.svg"
  },
  {
    "name": "corner-left-down-double",
    "label": "Corner Left Down Double",
    "path": "corner-left-down-double.svg"
  },
  {
    "name": "corner-left-up",
    "label": "Corner Left Up",
    "path": "corner-left-up.svg"
  },
  {
    "name": "corner-left-up-double",
    "label": "Corner Left Up Double",
    "path": "corner-left-up-double.svg"
  },
  {
    "name": "corner-right-down",
    "label": "Corner Right Down",
    "path": "corner-right-down.svg"
  },
  {
    "name": "corner-right-down-double",
    "label": "Corner Right Down Double",
    "path": "corner-right-down-double.svg"
  },
  {
    "name": "corner-right-up",
    "label": "Corner Right Up",
    "path": "corner-right-up.svg"
  },
  {
    "name": "corner-right-up-double",
    "label": "Corner Right Up Double",
    "path": "corner-right-up-double.svg"
  },
  {
    "name": "corner-up-left",
    "label": "Corner Up Left",
    "path": "corner-up-left.svg"
  },
  {
    "name": "corner-up-left-double",
    "label": "Corner Up Left Double",
    "path": "corner-up-left-double.svg"
  },
  {
    "name": "corner-up-right",
    "label": "Corner Up Right",
    "path": "corner-up-right.svg"
  },
  {
    "name": "corner-up-right-double",
    "label": "Corner Up Right Double",
    "path": "corner-up-right-double.svg"
  },
  {
    "name": "cpu",
    "label": "Cpu",
    "path": "cpu.svg"
  },
  {
    "name": "cpu-2",
    "label": "Cpu 2",
    "path": "cpu-2.svg"
  },
  {
    "name": "cpu-off",
    "label": "Cpu Off",
    "path": "cpu-off.svg"
  },
  {
    "name": "crane",
    "label": "Crane",
    "path": "crane.svg"
  },
  {
    "name": "crane-off",
    "label": "Crane Off",
    "path": "crane-off.svg"
  },
  {
    "name": "creative-commons",
    "label": "Creative Commons",
    "path": "creative-commons.svg"
  },
  {
    "name": "creative-commons-by",
    "label": "Creative Commons By",
    "path": "creative-commons-by.svg"
  },
  {
    "name": "creative-commons-nc",
    "label": "Creative Commons Nc",
    "path": "creative-commons-nc.svg"
  },
  {
    "name": "creative-commons-nd",
    "label": "Creative Commons Nd",
    "path": "creative-commons-nd.svg"
  },
  {
    "name": "creative-commons-off",
    "label": "Creative Commons Off",
    "path": "creative-commons-off.svg"
  },
  {
    "name": "creative-commons-sa",
    "label": "Creative Commons Sa",
    "path": "creative-commons-sa.svg"
  },
  {
    "name": "creative-commons-zero",
    "label": "Creative Commons Zero",
    "path": "creative-commons-zero.svg"
  },
  {
    "name": "credit-card",
    "label": "Credit Card",
    "path": "credit-card.svg"
  },
  {
    "name": "credit-card-off",
    "label": "Credit Card Off",
    "path": "credit-card-off.svg"
  },
  {
    "name": "credit-card-pay",
    "label": "Credit Card Pay",
    "path": "credit-card-pay.svg"
  },
  {
    "name": "credit-card-refund",
    "label": "Credit Card Refund",
    "path": "credit-card-refund.svg"
  },
  {
    "name": "cricket",
    "label": "Cricket",
    "path": "cricket.svg"
  },
  {
    "name": "crop",
    "label": "Crop",
    "path": "crop.svg"
  },
  {
    "name": "crop-1-1",
    "label": "Crop 1 1",
    "path": "crop-1-1.svg"
  },
  {
    "name": "crop-16-9",
    "label": "Crop 16 9",
    "path": "crop-16-9.svg"
  },
  {
    "name": "crop-3-2",
    "label": "Crop 3 2",
    "path": "crop-3-2.svg"
  },
  {
    "name": "crop-5-4",
    "label": "Crop 5 4",
    "path": "crop-5-4.svg"
  },
  {
    "name": "crop-7-5",
    "label": "Crop 7 5",
    "path": "crop-7-5.svg"
  },
  {
    "name": "crop-landscape",
    "label": "Crop Landscape",
    "path": "crop-landscape.svg"
  },
  {
    "name": "crop-portrait",
    "label": "Crop Portrait",
    "path": "crop-portrait.svg"
  },
  {
    "name": "cross",
    "label": "Cross",
    "path": "cross.svg"
  },
  {
    "name": "cross-off",
    "label": "Cross Off",
    "path": "cross-off.svg"
  },
  {
    "name": "crosshair",
    "label": "Crosshair",
    "path": "crosshair.svg"
  },
  {
    "name": "crown",
    "label": "Crown",
    "path": "crown.svg"
  },
  {
    "name": "crown-off",
    "label": "Crown Off",
    "path": "crown-off.svg"
  },
  {
    "name": "crutches",
    "label": "Crutches",
    "path": "crutches.svg"
  },
  {
    "name": "crutches-off",
    "label": "Crutches Off",
    "path": "crutches-off.svg"
  },
  {
    "name": "crystal-ball",
    "label": "Crystal Ball",
    "path": "crystal-ball.svg"
  },
  {
    "name": "csv",
    "label": "Csv",
    "path": "csv.svg"
  },
  {
    "name": "cube",
    "label": "Cube",
    "path": "cube.svg"
  },
  {
    "name": "cube-3d-sphere",
    "label": "Cube 3d Sphere",
    "path": "cube-3d-sphere.svg"
  },
  {
    "name": "cube-3d-sphere-off",
    "label": "Cube 3d Sphere Off",
    "path": "cube-3d-sphere-off.svg"
  },
  {
    "name": "cube-off",
    "label": "Cube Off",
    "path": "cube-off.svg"
  },
  {
    "name": "cube-plus",
    "label": "Cube Plus",
    "path": "cube-plus.svg"
  },
  {
    "name": "cube-send",
    "label": "Cube Send",
    "path": "cube-send.svg"
  },
  {
    "name": "cube-spark",
    "label": "Cube Spark",
    "path": "cube-spark.svg"
  },
  {
    "name": "cube-unfolded",
    "label": "Cube Unfolded",
    "path": "cube-unfolded.svg"
  },
  {
    "name": "cup",
    "label": "Cup",
    "path": "cup.svg"
  },
  {
    "name": "cup-off",
    "label": "Cup Off",
    "path": "cup-off.svg"
  },
  {
    "name": "curling",
    "label": "Curling",
    "path": "curling.svg"
  },
  {
    "name": "curly-loop",
    "label": "Curly Loop",
    "path": "curly-loop.svg"
  },
  {
    "name": "currency",
    "label": "Currency",
    "path": "currency.svg"
  },
  {
    "name": "currency-afghani",
    "label": "Currency Afghani",
    "path": "currency-afghani.svg"
  },
  {
    "name": "currency-bahraini",
    "label": "Currency Bahraini",
    "path": "currency-bahraini.svg"
  },
  {
    "name": "currency-baht",
    "label": "Currency Baht",
    "path": "currency-baht.svg"
  },
  {
    "name": "currency-bitcoin",
    "label": "Currency Bitcoin",
    "path": "currency-bitcoin.svg"
  },
  {
    "name": "currency-cent",
    "label": "Currency Cent",
    "path": "currency-cent.svg"
  },
  {
    "name": "currency-dinar",
    "label": "Currency Dinar",
    "path": "currency-dinar.svg"
  },
  {
    "name": "currency-dirham",
    "label": "Currency Dirham",
    "path": "currency-dirham.svg"
  },
  {
    "name": "currency-dogecoin",
    "label": "Currency Dogecoin",
    "path": "currency-dogecoin.svg"
  },
  {
    "name": "currency-dollar",
    "label": "Currency Dollar",
    "path": "currency-dollar.svg"
  },
  {
    "name": "currency-dollar-australian",
    "label": "Currency Dollar Australian",
    "path": "currency-dollar-australian.svg"
  },
  {
    "name": "currency-dollar-brunei",
    "label": "Currency Dollar Brunei",
    "path": "currency-dollar-brunei.svg"
  },
  {
    "name": "currency-dollar-canadian",
    "label": "Currency Dollar Canadian",
    "path": "currency-dollar-canadian.svg"
  },
  {
    "name": "currency-dollar-guyanese",
    "label": "Currency Dollar Guyanese",
    "path": "currency-dollar-guyanese.svg"
  },
  {
    "name": "currency-dollar-off",
    "label": "Currency Dollar Off",
    "path": "currency-dollar-off.svg"
  },
  {
    "name": "currency-dollar-singapore",
    "label": "Currency Dollar Singapore",
    "path": "currency-dollar-singapore.svg"
  },
  {
    "name": "currency-dollar-zimbabwean",
    "label": "Currency Dollar Zimbabwean",
    "path": "currency-dollar-zimbabwean.svg"
  },
  {
    "name": "currency-dong",
    "label": "Currency Dong",
    "path": "currency-dong.svg"
  },
  {
    "name": "currency-dram",
    "label": "Currency Dram",
    "path": "currency-dram.svg"
  },
  {
    "name": "currency-ethereum",
    "label": "Currency Ethereum",
    "path": "currency-ethereum.svg"
  },
  {
    "name": "currency-euro",
    "label": "Currency Euro",
    "path": "currency-euro.svg"
  },
  {
    "name": "currency-euro-off",
    "label": "Currency Euro Off",
    "path": "currency-euro-off.svg"
  },
  {
    "name": "currency-florin",
    "label": "Currency Florin",
    "path": "currency-florin.svg"
  },
  {
    "name": "currency-forint",
    "label": "Currency Forint",
    "path": "currency-forint.svg"
  },
  {
    "name": "currency-frank",
    "label": "Currency Frank",
    "path": "currency-frank.svg"
  },
  {
    "name": "currency-guarani",
    "label": "Currency Guarani",
    "path": "currency-guarani.svg"
  },
  {
    "name": "currency-hryvnia",
    "label": "Currency Hryvnia",
    "path": "currency-hryvnia.svg"
  },
  {
    "name": "currency-iranian-rial",
    "label": "Currency Iranian Rial",
    "path": "currency-iranian-rial.svg"
  },
  {
    "name": "currency-kip",
    "label": "Currency Kip",
    "path": "currency-kip.svg"
  },
  {
    "name": "currency-krone-czech",
    "label": "Currency Krone Czech",
    "path": "currency-krone-czech.svg"
  },
  {
    "name": "currency-krone-danish",
    "label": "Currency Krone Danish",
    "path": "currency-krone-danish.svg"
  },
  {
    "name": "currency-krone-swedish",
    "label": "Currency Krone Swedish",
    "path": "currency-krone-swedish.svg"
  },
  {
    "name": "currency-lari",
    "label": "Currency Lari",
    "path": "currency-lari.svg"
  },
  {
    "name": "currency-leu",
    "label": "Currency Leu",
    "path": "currency-leu.svg"
  },
  {
    "name": "currency-lira",
    "label": "Currency Lira",
    "path": "currency-lira.svg"
  },
  {
    "name": "currency-litecoin",
    "label": "Currency Litecoin",
    "path": "currency-litecoin.svg"
  },
  {
    "name": "currency-lyd",
    "label": "Currency Lyd",
    "path": "currency-lyd.svg"
  },
  {
    "name": "currency-manat",
    "label": "Currency Manat",
    "path": "currency-manat.svg"
  },
  {
    "name": "currency-monero",
    "label": "Currency Monero",
    "path": "currency-monero.svg"
  },
  {
    "name": "currency-naira",
    "label": "Currency Naira",
    "path": "currency-naira.svg"
  },
  {
    "name": "currency-nano",
    "label": "Currency Nano",
    "path": "currency-nano.svg"
  },
  {
    "name": "currency-off",
    "label": "Currency Off",
    "path": "currency-off.svg"
  },
  {
    "name": "currency-paanga",
    "label": "Currency Paanga",
    "path": "currency-paanga.svg"
  },
  {
    "name": "currency-peso",
    "label": "Currency Peso",
    "path": "currency-peso.svg"
  },
  {
    "name": "currency-pound",
    "label": "Currency Pound",
    "path": "currency-pound.svg"
  },
  {
    "name": "currency-pound-off",
    "label": "Currency Pound Off",
    "path": "currency-pound-off.svg"
  },
  {
    "name": "currency-quetzal",
    "label": "Currency Quetzal",
    "path": "currency-quetzal.svg"
  },
  {
    "name": "currency-real",
    "label": "Currency Real",
    "path": "currency-real.svg"
  },
  {
    "name": "currency-renminbi",
    "label": "Currency Renminbi",
    "path": "currency-renminbi.svg"
  },
  {
    "name": "currency-ripple",
    "label": "Currency Ripple",
    "path": "currency-ripple.svg"
  },
  {
    "name": "currency-riyal",
    "label": "Currency Riyal",
    "path": "currency-riyal.svg"
  },
  {
    "name": "currency-rubel",
    "label": "Currency Rubel",
    "path": "currency-rubel.svg"
  },
  {
    "name": "currency-rufiyaa",
    "label": "Currency Rufiyaa",
    "path": "currency-rufiyaa.svg"
  },
  {
    "name": "currency-rupee",
    "label": "Currency Rupee",
    "path": "currency-rupee.svg"
  },
  {
    "name": "currency-rupee-nepalese",
    "label": "Currency Rupee Nepalese",
    "path": "currency-rupee-nepalese.svg"
  },
  {
    "name": "currency-shekel",
    "label": "Currency Shekel",
    "path": "currency-shekel.svg"
  },
  {
    "name": "currency-solana",
    "label": "Currency Solana",
    "path": "currency-solana.svg"
  },
  {
    "name": "currency-som",
    "label": "Currency Som",
    "path": "currency-som.svg"
  },
  {
    "name": "currency-taka",
    "label": "Currency Taka",
    "path": "currency-taka.svg"
  },
  {
    "name": "currency-tenge",
    "label": "Currency Tenge",
    "path": "currency-tenge.svg"
  },
  {
    "name": "currency-tugrik",
    "label": "Currency Tugrik",
    "path": "currency-tugrik.svg"
  },
  {
    "name": "currency-won",
    "label": "Currency Won",
    "path": "currency-won.svg"
  },
  {
    "name": "currency-xrp",
    "label": "Currency Xrp",
    "path": "currency-xrp.svg"
  },
  {
    "name": "currency-yen",
    "label": "Currency Yen",
    "path": "currency-yen.svg"
  },
  {
    "name": "currency-yen-off",
    "label": "Currency Yen Off",
    "path": "currency-yen-off.svg"
  },
  {
    "name": "currency-yuan",
    "label": "Currency Yuan",
    "path": "currency-yuan.svg"
  },
  {
    "name": "currency-zloty",
    "label": "Currency Zloty",
    "path": "currency-zloty.svg"
  },
  {
    "name": "current-location",
    "label": "Current Location",
    "path": "current-location.svg"
  },
  {
    "name": "current-location-off",
    "label": "Current Location Off",
    "path": "current-location-off.svg"
  },
  {
    "name": "cursor-off",
    "label": "Cursor Off",
    "path": "cursor-off.svg"
  },
  {
    "name": "cursor-text",
    "label": "Cursor Text",
    "path": "cursor-text.svg"
  },
  {
    "name": "cut",
    "label": "Cut",
    "path": "cut.svg"
  },
  {
    "name": "cylinder",
    "label": "Cylinder",
    "path": "cylinder.svg"
  },
  {
    "name": "cylinder-off",
    "label": "Cylinder Off",
    "path": "cylinder-off.svg"
  },
  {
    "name": "cylinder-plus",
    "label": "Cylinder Plus",
    "path": "cylinder-plus.svg"
  },
  {
    "name": "dashboard",
    "label": "Dashboard",
    "path": "dashboard.svg"
  },
  {
    "name": "dashboard-off",
    "label": "Dashboard Off",
    "path": "dashboard-off.svg"
  },
  {
    "name": "database",
    "label": "Database",
    "path": "database.svg"
  },
  {
    "name": "database-cog",
    "label": "Database Cog",
    "path": "database-cog.svg"
  },
  {
    "name": "database-dollar",
    "label": "Database Dollar",
    "path": "database-dollar.svg"
  },
  {
    "name": "database-edit",
    "label": "Database Edit",
    "path": "database-edit.svg"
  },
  {
    "name": "database-exclamation",
    "label": "Database Exclamation",
    "path": "database-exclamation.svg"
  },
  {
    "name": "database-export",
    "label": "Database Export",
    "path": "database-export.svg"
  },
  {
    "name": "database-heart",
    "label": "Database Heart",
    "path": "database-heart.svg"
  },
  {
    "name": "database-import",
    "label": "Database Import",
    "path": "database-import.svg"
  },
  {
    "name": "database-leak",
    "label": "Database Leak",
    "path": "database-leak.svg"
  },
  {
    "name": "database-minus",
    "label": "Database Minus",
    "path": "database-minus.svg"
  },
  {
    "name": "database-off",
    "label": "Database Off",
    "path": "database-off.svg"
  },
  {
    "name": "database-plus",
    "label": "Database Plus",
    "path": "database-plus.svg"
  },
  {
    "name": "database-search",
    "label": "Database Search",
    "path": "database-search.svg"
  },
  {
    "name": "database-share",
    "label": "Database Share",
    "path": "database-share.svg"
  },
  {
    "name": "database-smile",
    "label": "Database Smile",
    "path": "database-smile.svg"
  },
  {
    "name": "database-star",
    "label": "Database Star",
    "path": "database-star.svg"
  },
  {
    "name": "database-x",
    "label": "Database X",
    "path": "database-x.svg"
  },
  {
    "name": "deaf",
    "label": "Deaf",
    "path": "deaf.svg"
  },
  {
    "name": "decimal",
    "label": "Decimal",
    "path": "decimal.svg"
  },
  {
    "name": "deer",
    "label": "Deer",
    "path": "deer.svg"
  },
  {
    "name": "delta",
    "label": "Delta",
    "path": "delta.svg"
  },
  {
    "name": "dental",
    "label": "Dental",
    "path": "dental.svg"
  },
  {
    "name": "dental-broken",
    "label": "Dental Broken",
    "path": "dental-broken.svg"
  },
  {
    "name": "dental-off",
    "label": "Dental Off",
    "path": "dental-off.svg"
  },
  {
    "name": "deselect",
    "label": "Deselect",
    "path": "deselect.svg"
  },
  {
    "name": "desk",
    "label": "Desk",
    "path": "desk.svg"
  },
  {
    "name": "details",
    "label": "Details",
    "path": "details.svg"
  },
  {
    "name": "details-off",
    "label": "Details Off",
    "path": "details-off.svg"
  },
  {
    "name": "device-airpods",
    "label": "Device Airpods",
    "path": "device-airpods.svg"
  },
  {
    "name": "device-airpods-case",
    "label": "Device Airpods Case",
    "path": "device-airpods-case.svg"
  },
  {
    "name": "device-airtag",
    "label": "Device Airtag",
    "path": "device-airtag.svg"
  },
  {
    "name": "device-analytics",
    "label": "Device Analytics",
    "path": "device-analytics.svg"
  },
  {
    "name": "device-audio-tape",
    "label": "Device Audio Tape",
    "path": "device-audio-tape.svg"
  },
  {
    "name": "device-camera-phone",
    "label": "Device Camera Phone",
    "path": "device-camera-phone.svg"
  },
  {
    "name": "device-cctv",
    "label": "Device Cctv",
    "path": "device-cctv.svg"
  },
  {
    "name": "device-cctv-off",
    "label": "Device Cctv Off",
    "path": "device-cctv-off.svg"
  },
  {
    "name": "device-computer-camera",
    "label": "Device Computer Camera",
    "path": "device-computer-camera.svg"
  },
  {
    "name": "device-computer-camera-off",
    "label": "Device Computer Camera Off",
    "path": "device-computer-camera-off.svg"
  },
  {
    "name": "device-desktop",
    "label": "Device Desktop",
    "path": "device-desktop.svg"
  },
  {
    "name": "device-desktop-analytics",
    "label": "Device Desktop Analytics",
    "path": "device-desktop-analytics.svg"
  },
  {
    "name": "device-desktop-bolt",
    "label": "Device Desktop Bolt",
    "path": "device-desktop-bolt.svg"
  },
  {
    "name": "device-desktop-cancel",
    "label": "Device Desktop Cancel",
    "path": "device-desktop-cancel.svg"
  },
  {
    "name": "device-desktop-check",
    "label": "Device Desktop Check",
    "path": "device-desktop-check.svg"
  },
  {
    "name": "device-desktop-code",
    "label": "Device Desktop Code",
    "path": "device-desktop-code.svg"
  },
  {
    "name": "device-desktop-cog",
    "label": "Device Desktop Cog",
    "path": "device-desktop-cog.svg"
  },
  {
    "name": "device-desktop-dollar",
    "label": "Device Desktop Dollar",
    "path": "device-desktop-dollar.svg"
  },
  {
    "name": "device-desktop-down",
    "label": "Device Desktop Down",
    "path": "device-desktop-down.svg"
  },
  {
    "name": "device-desktop-exclamation",
    "label": "Device Desktop Exclamation",
    "path": "device-desktop-exclamation.svg"
  },
  {
    "name": "device-desktop-heart",
    "label": "Device Desktop Heart",
    "path": "device-desktop-heart.svg"
  },
  {
    "name": "device-desktop-minus",
    "label": "Device Desktop Minus",
    "path": "device-desktop-minus.svg"
  },
  {
    "name": "device-desktop-off",
    "label": "Device Desktop Off",
    "path": "device-desktop-off.svg"
  },
  {
    "name": "device-desktop-pause",
    "label": "Device Desktop Pause",
    "path": "device-desktop-pause.svg"
  },
  {
    "name": "device-desktop-pin",
    "label": "Device Desktop Pin",
    "path": "device-desktop-pin.svg"
  },
  {
    "name": "device-desktop-plus",
    "label": "Device Desktop Plus",
    "path": "device-desktop-plus.svg"
  },
  {
    "name": "device-desktop-question",
    "label": "Device Desktop Question",
    "path": "device-desktop-question.svg"
  },
  {
    "name": "device-desktop-search",
    "label": "Device Desktop Search",
    "path": "device-desktop-search.svg"
  },
  {
    "name": "device-desktop-share",
    "label": "Device Desktop Share",
    "path": "device-desktop-share.svg"
  },
  {
    "name": "device-desktop-star",
    "label": "Device Desktop Star",
    "path": "device-desktop-star.svg"
  },
  {
    "name": "device-desktop-up",
    "label": "Device Desktop Up",
    "path": "device-desktop-up.svg"
  },
  {
    "name": "device-desktop-x",
    "label": "Device Desktop X",
    "path": "device-desktop-x.svg"
  },
  {
    "name": "device-floppy",
    "label": "Device Floppy",
    "path": "device-floppy.svg"
  },
  {
    "name": "device-gamepad",
    "label": "Device Gamepad",
    "path": "device-gamepad.svg"
  },
  {
    "name": "device-gamepad-2",
    "label": "Device Gamepad 2",
    "path": "device-gamepad-2.svg"
  },
  {
    "name": "device-gamepad-3",
    "label": "Device Gamepad 3",
    "path": "device-gamepad-3.svg"
  },
  {
    "name": "device-heart-monitor",
    "label": "Device Heart Monitor",
    "path": "device-heart-monitor.svg"
  },
  {
    "name": "device-imac",
    "label": "Device Imac",
    "path": "device-imac.svg"
  },
  {
    "name": "device-imac-bolt",
    "label": "Device Imac Bolt",
    "path": "device-imac-bolt.svg"
  },
  {
    "name": "device-imac-cancel",
    "label": "Device Imac Cancel",
    "path": "device-imac-cancel.svg"
  },
  {
    "name": "device-imac-check",
    "label": "Device Imac Check",
    "path": "device-imac-check.svg"
  },
  {
    "name": "device-imac-code",
    "label": "Device Imac Code",
    "path": "device-imac-code.svg"
  },
  {
    "name": "device-imac-cog",
    "label": "Device Imac Cog",
    "path": "device-imac-cog.svg"
  },
  {
    "name": "device-imac-dollar",
    "label": "Device Imac Dollar",
    "path": "device-imac-dollar.svg"
  },
  {
    "name": "device-imac-down",
    "label": "Device Imac Down",
    "path": "device-imac-down.svg"
  },
  {
    "name": "device-imac-exclamation",
    "label": "Device Imac Exclamation",
    "path": "device-imac-exclamation.svg"
  },
  {
    "name": "device-imac-heart",
    "label": "Device Imac Heart",
    "path": "device-imac-heart.svg"
  },
  {
    "name": "device-imac-minus",
    "label": "Device Imac Minus",
    "path": "device-imac-minus.svg"
  },
  {
    "name": "device-imac-off",
    "label": "Device Imac Off",
    "path": "device-imac-off.svg"
  },
  {
    "name": "device-imac-pause",
    "label": "Device Imac Pause",
    "path": "device-imac-pause.svg"
  },
  {
    "name": "device-imac-pin",
    "label": "Device Imac Pin",
    "path": "device-imac-pin.svg"
  },
  {
    "name": "device-imac-plus",
    "label": "Device Imac Plus",
    "path": "device-imac-plus.svg"
  },
  {
    "name": "device-imac-question",
    "label": "Device Imac Question",
    "path": "device-imac-question.svg"
  },
  {
    "name": "device-imac-search",
    "label": "Device Imac Search",
    "path": "device-imac-search.svg"
  },
  {
    "name": "device-imac-share",
    "label": "Device Imac Share",
    "path": "device-imac-share.svg"
  },
  {
    "name": "device-imac-star",
    "label": "Device Imac Star",
    "path": "device-imac-star.svg"
  },
  {
    "name": "device-imac-up",
    "label": "Device Imac Up",
    "path": "device-imac-up.svg"
  },
  {
    "name": "device-imac-x",
    "label": "Device Imac X",
    "path": "device-imac-x.svg"
  },
  {
    "name": "device-ipad",
    "label": "Device Ipad",
    "path": "device-ipad.svg"
  },
  {
    "name": "device-ipad-bolt",
    "label": "Device Ipad Bolt",
    "path": "device-ipad-bolt.svg"
  },
  {
    "name": "device-ipad-cancel",
    "label": "Device Ipad Cancel",
    "path": "device-ipad-cancel.svg"
  },
  {
    "name": "device-ipad-check",
    "label": "Device Ipad Check",
    "path": "device-ipad-check.svg"
  },
  {
    "name": "device-ipad-code",
    "label": "Device Ipad Code",
    "path": "device-ipad-code.svg"
  },
  {
    "name": "device-ipad-cog",
    "label": "Device Ipad Cog",
    "path": "device-ipad-cog.svg"
  },
  {
    "name": "device-ipad-dollar",
    "label": "Device Ipad Dollar",
    "path": "device-ipad-dollar.svg"
  },
  {
    "name": "device-ipad-down",
    "label": "Device Ipad Down",
    "path": "device-ipad-down.svg"
  },
  {
    "name": "device-ipad-exclamation",
    "label": "Device Ipad Exclamation",
    "path": "device-ipad-exclamation.svg"
  },
  {
    "name": "device-ipad-heart",
    "label": "Device Ipad Heart",
    "path": "device-ipad-heart.svg"
  },
  {
    "name": "device-ipad-horizontal",
    "label": "Device Ipad Horizontal",
    "path": "device-ipad-horizontal.svg"
  },
  {
    "name": "device-ipad-horizontal-bolt",
    "label": "Device Ipad Horizontal Bolt",
    "path": "device-ipad-horizontal-bolt.svg"
  },
  {
    "name": "device-ipad-horizontal-cancel",
    "label": "Device Ipad Horizontal Cancel",
    "path": "device-ipad-horizontal-cancel.svg"
  },
  {
    "name": "device-ipad-horizontal-check",
    "label": "Device Ipad Horizontal Check",
    "path": "device-ipad-horizontal-check.svg"
  },
  {
    "name": "device-ipad-horizontal-code",
    "label": "Device Ipad Horizontal Code",
    "path": "device-ipad-horizontal-code.svg"
  },
  {
    "name": "device-ipad-horizontal-cog",
    "label": "Device Ipad Horizontal Cog",
    "path": "device-ipad-horizontal-cog.svg"
  },
  {
    "name": "device-ipad-horizontal-dollar",
    "label": "Device Ipad Horizontal Dollar",
    "path": "device-ipad-horizontal-dollar.svg"
  },
  {
    "name": "device-ipad-horizontal-down",
    "label": "Device Ipad Horizontal Down",
    "path": "device-ipad-horizontal-down.svg"
  },
  {
    "name": "device-ipad-horizontal-exclamation",
    "label": "Device Ipad Horizontal Exclamation",
    "path": "device-ipad-horizontal-exclamation.svg"
  },
  {
    "name": "device-ipad-horizontal-heart",
    "label": "Device Ipad Horizontal Heart",
    "path": "device-ipad-horizontal-heart.svg"
  },
  {
    "name": "device-ipad-horizontal-minus",
    "label": "Device Ipad Horizontal Minus",
    "path": "device-ipad-horizontal-minus.svg"
  },
  {
    "name": "device-ipad-horizontal-off",
    "label": "Device Ipad Horizontal Off",
    "path": "device-ipad-horizontal-off.svg"
  },
  {
    "name": "device-ipad-horizontal-pause",
    "label": "Device Ipad Horizontal Pause",
    "path": "device-ipad-horizontal-pause.svg"
  },
  {
    "name": "device-ipad-horizontal-pin",
    "label": "Device Ipad Horizontal Pin",
    "path": "device-ipad-horizontal-pin.svg"
  },
  {
    "name": "device-ipad-horizontal-plus",
    "label": "Device Ipad Horizontal Plus",
    "path": "device-ipad-horizontal-plus.svg"
  },
  {
    "name": "device-ipad-horizontal-question",
    "label": "Device Ipad Horizontal Question",
    "path": "device-ipad-horizontal-question.svg"
  },
  {
    "name": "device-ipad-horizontal-search",
    "label": "Device Ipad Horizontal Search",
    "path": "device-ipad-horizontal-search.svg"
  },
  {
    "name": "device-ipad-horizontal-share",
    "label": "Device Ipad Horizontal Share",
    "path": "device-ipad-horizontal-share.svg"
  },
  {
    "name": "device-ipad-horizontal-star",
    "label": "Device Ipad Horizontal Star",
    "path": "device-ipad-horizontal-star.svg"
  },
  {
    "name": "device-ipad-horizontal-up",
    "label": "Device Ipad Horizontal Up",
    "path": "device-ipad-horizontal-up.svg"
  },
  {
    "name": "device-ipad-horizontal-x",
    "label": "Device Ipad Horizontal X",
    "path": "device-ipad-horizontal-x.svg"
  },
  {
    "name": "device-ipad-minus",
    "label": "Device Ipad Minus",
    "path": "device-ipad-minus.svg"
  },
  {
    "name": "device-ipad-off",
    "label": "Device Ipad Off",
    "path": "device-ipad-off.svg"
  },
  {
    "name": "device-ipad-pause",
    "label": "Device Ipad Pause",
    "path": "device-ipad-pause.svg"
  },
  {
    "name": "device-ipad-pin",
    "label": "Device Ipad Pin",
    "path": "device-ipad-pin.svg"
  },
  {
    "name": "device-ipad-plus",
    "label": "Device Ipad Plus",
    "path": "device-ipad-plus.svg"
  },
  {
    "name": "device-ipad-question",
    "label": "Device Ipad Question",
    "path": "device-ipad-question.svg"
  },
  {
    "name": "device-ipad-search",
    "label": "Device Ipad Search",
    "path": "device-ipad-search.svg"
  },
  {
    "name": "device-ipad-share",
    "label": "Device Ipad Share",
    "path": "device-ipad-share.svg"
  },
  {
    "name": "device-ipad-star",
    "label": "Device Ipad Star",
    "path": "device-ipad-star.svg"
  },
  {
    "name": "device-ipad-up",
    "label": "Device Ipad Up",
    "path": "device-ipad-up.svg"
  },
  {
    "name": "device-ipad-x",
    "label": "Device Ipad X",
    "path": "device-ipad-x.svg"
  },
  {
    "name": "device-landline-phone",
    "label": "Device Landline Phone",
    "path": "device-landline-phone.svg"
  },
  {
    "name": "device-laptop",
    "label": "Device Laptop",
    "path": "device-laptop.svg"
  },
  {
    "name": "device-laptop-off",
    "label": "Device Laptop Off",
    "path": "device-laptop-off.svg"
  },
  {
    "name": "device-mobile",
    "label": "Device Mobile",
    "path": "device-mobile.svg"
  },
  {
    "name": "device-mobile-bolt",
    "label": "Device Mobile Bolt",
    "path": "device-mobile-bolt.svg"
  },
  {
    "name": "device-mobile-cancel",
    "label": "Device Mobile Cancel",
    "path": "device-mobile-cancel.svg"
  },
  {
    "name": "device-mobile-charging",
    "label": "Device Mobile Charging",
    "path": "device-mobile-charging.svg"
  },
  {
    "name": "device-mobile-check",
    "label": "Device Mobile Check",
    "path": "device-mobile-check.svg"
  },
  {
    "name": "device-mobile-code",
    "label": "Device Mobile Code",
    "path": "device-mobile-code.svg"
  },
  {
    "name": "device-mobile-cog",
    "label": "Device Mobile Cog",
    "path": "device-mobile-cog.svg"
  },
  {
    "name": "device-mobile-dollar",
    "label": "Device Mobile Dollar",
    "path": "device-mobile-dollar.svg"
  },
  {
    "name": "device-mobile-down",
    "label": "Device Mobile Down",
    "path": "device-mobile-down.svg"
  },
  {
    "name": "device-mobile-exclamation",
    "label": "Device Mobile Exclamation",
    "path": "device-mobile-exclamation.svg"
  },
  {
    "name": "device-mobile-heart",
    "label": "Device Mobile Heart",
    "path": "device-mobile-heart.svg"
  },
  {
    "name": "device-mobile-message",
    "label": "Device Mobile Message",
    "path": "device-mobile-message.svg"
  },
  {
    "name": "device-mobile-minus",
    "label": "Device Mobile Minus",
    "path": "device-mobile-minus.svg"
  },
  {
    "name": "device-mobile-off",
    "label": "Device Mobile Off",
    "path": "device-mobile-off.svg"
  },
  {
    "name": "device-mobile-pause",
    "label": "Device Mobile Pause",
    "path": "device-mobile-pause.svg"
  },
  {
    "name": "device-mobile-pin",
    "label": "Device Mobile Pin",
    "path": "device-mobile-pin.svg"
  },
  {
    "name": "device-mobile-plus",
    "label": "Device Mobile Plus",
    "path": "device-mobile-plus.svg"
  },
  {
    "name": "device-mobile-question",
    "label": "Device Mobile Question",
    "path": "device-mobile-question.svg"
  },
  {
    "name": "device-mobile-rotated",
    "label": "Device Mobile Rotated",
    "path": "device-mobile-rotated.svg"
  },
  {
    "name": "device-mobile-search",
    "label": "Device Mobile Search",
    "path": "device-mobile-search.svg"
  },
  {
    "name": "device-mobile-share",
    "label": "Device Mobile Share",
    "path": "device-mobile-share.svg"
  },
  {
    "name": "device-mobile-star",
    "label": "Device Mobile Star",
    "path": "device-mobile-star.svg"
  },
  {
    "name": "device-mobile-up",
    "label": "Device Mobile Up",
    "path": "device-mobile-up.svg"
  },
  {
    "name": "device-mobile-vibration",
    "label": "Device Mobile Vibration",
    "path": "device-mobile-vibration.svg"
  },
  {
    "name": "device-mobile-x",
    "label": "Device Mobile X",
    "path": "device-mobile-x.svg"
  },
  {
    "name": "device-nintendo",
    "label": "Device Nintendo",
    "path": "device-nintendo.svg"
  },
  {
    "name": "device-nintendo-off",
    "label": "Device Nintendo Off",
    "path": "device-nintendo-off.svg"
  },
  {
    "name": "device-projector",
    "label": "Device Projector",
    "path": "device-projector.svg"
  },
  {
    "name": "device-remote",
    "label": "Device Remote",
    "path": "device-remote.svg"
  },
  {
    "name": "device-sd-card",
    "label": "Device Sd Card",
    "path": "device-sd-card.svg"
  },
  {
    "name": "device-sim",
    "label": "Device Sim",
    "path": "device-sim.svg"
  },
  {
    "name": "device-sim-1",
    "label": "Device Sim 1",
    "path": "device-sim-1.svg"
  },
  {
    "name": "device-sim-2",
    "label": "Device Sim 2",
    "path": "device-sim-2.svg"
  },
  {
    "name": "device-sim-3",
    "label": "Device Sim 3",
    "path": "device-sim-3.svg"
  },
  {
    "name": "device-speaker",
    "label": "Device Speaker",
    "path": "device-speaker.svg"
  },
  {
    "name": "device-speaker-off",
    "label": "Device Speaker Off",
    "path": "device-speaker-off.svg"
  },
  {
    "name": "device-tablet",
    "label": "Device Tablet",
    "path": "device-tablet.svg"
  },
  {
    "name": "device-tablet-bolt",
    "label": "Device Tablet Bolt",
    "path": "device-tablet-bolt.svg"
  },
  {
    "name": "device-tablet-cancel",
    "label": "Device Tablet Cancel",
    "path": "device-tablet-cancel.svg"
  },
  {
    "name": "device-tablet-check",
    "label": "Device Tablet Check",
    "path": "device-tablet-check.svg"
  },
  {
    "name": "device-tablet-code",
    "label": "Device Tablet Code",
    "path": "device-tablet-code.svg"
  },
  {
    "name": "device-tablet-cog",
    "label": "Device Tablet Cog",
    "path": "device-tablet-cog.svg"
  },
  {
    "name": "device-tablet-dollar",
    "label": "Device Tablet Dollar",
    "path": "device-tablet-dollar.svg"
  },
  {
    "name": "device-tablet-down",
    "label": "Device Tablet Down",
    "path": "device-tablet-down.svg"
  },
  {
    "name": "device-tablet-exclamation",
    "label": "Device Tablet Exclamation",
    "path": "device-tablet-exclamation.svg"
  },
  {
    "name": "device-tablet-heart",
    "label": "Device Tablet Heart",
    "path": "device-tablet-heart.svg"
  },
  {
    "name": "device-tablet-minus",
    "label": "Device Tablet Minus",
    "path": "device-tablet-minus.svg"
  },
  {
    "name": "device-tablet-off",
    "label": "Device Tablet Off",
    "path": "device-tablet-off.svg"
  },
  {
    "name": "device-tablet-pause",
    "label": "Device Tablet Pause",
    "path": "device-tablet-pause.svg"
  },
  {
    "name": "device-tablet-pin",
    "label": "Device Tablet Pin",
    "path": "device-tablet-pin.svg"
  },
  {
    "name": "device-tablet-plus",
    "label": "Device Tablet Plus",
    "path": "device-tablet-plus.svg"
  },
  {
    "name": "device-tablet-question",
    "label": "Device Tablet Question",
    "path": "device-tablet-question.svg"
  },
  {
    "name": "device-tablet-search",
    "label": "Device Tablet Search",
    "path": "device-tablet-search.svg"
  },
  {
    "name": "device-tablet-share",
    "label": "Device Tablet Share",
    "path": "device-tablet-share.svg"
  },
  {
    "name": "device-tablet-star",
    "label": "Device Tablet Star",
    "path": "device-tablet-star.svg"
  },
  {
    "name": "device-tablet-up",
    "label": "Device Tablet Up",
    "path": "device-tablet-up.svg"
  },
  {
    "name": "device-tablet-x",
    "label": "Device Tablet X",
    "path": "device-tablet-x.svg"
  },
  {
    "name": "device-tv",
    "label": "Device Tv",
    "path": "device-tv.svg"
  },
  {
    "name": "device-tv-off",
    "label": "Device Tv Off",
    "path": "device-tv-off.svg"
  },
  {
    "name": "device-tv-old",
    "label": "Device Tv Old",
    "path": "device-tv-old.svg"
  },
  {
    "name": "device-unknown",
    "label": "Device Unknown",
    "path": "device-unknown.svg"
  },
  {
    "name": "device-usb",
    "label": "Device Usb",
    "path": "device-usb.svg"
  },
  {
    "name": "device-vision-pro",
    "label": "Device Vision Pro",
    "path": "device-vision-pro.svg"
  },
  {
    "name": "device-watch",
    "label": "Device Watch",
    "path": "device-watch.svg"
  },
  {
    "name": "device-watch-bolt",
    "label": "Device Watch Bolt",
    "path": "device-watch-bolt.svg"
  },
  {
    "name": "device-watch-cancel",
    "label": "Device Watch Cancel",
    "path": "device-watch-cancel.svg"
  },
  {
    "name": "device-watch-check",
    "label": "Device Watch Check",
    "path": "device-watch-check.svg"
  },
  {
    "name": "device-watch-code",
    "label": "Device Watch Code",
    "path": "device-watch-code.svg"
  },
  {
    "name": "device-watch-cog",
    "label": "Device Watch Cog",
    "path": "device-watch-cog.svg"
  },
  {
    "name": "device-watch-dollar",
    "label": "Device Watch Dollar",
    "path": "device-watch-dollar.svg"
  },
  {
    "name": "device-watch-down",
    "label": "Device Watch Down",
    "path": "device-watch-down.svg"
  },
  {
    "name": "device-watch-exclamation",
    "label": "Device Watch Exclamation",
    "path": "device-watch-exclamation.svg"
  },
  {
    "name": "device-watch-heart",
    "label": "Device Watch Heart",
    "path": "device-watch-heart.svg"
  },
  {
    "name": "device-watch-minus",
    "label": "Device Watch Minus",
    "path": "device-watch-minus.svg"
  },
  {
    "name": "device-watch-off",
    "label": "Device Watch Off",
    "path": "device-watch-off.svg"
  },
  {
    "name": "device-watch-pause",
    "label": "Device Watch Pause",
    "path": "device-watch-pause.svg"
  },
  {
    "name": "device-watch-pin",
    "label": "Device Watch Pin",
    "path": "device-watch-pin.svg"
  },
  {
    "name": "device-watch-plus",
    "label": "Device Watch Plus",
    "path": "device-watch-plus.svg"
  },
  {
    "name": "device-watch-question",
    "label": "Device Watch Question",
    "path": "device-watch-question.svg"
  },
  {
    "name": "device-watch-search",
    "label": "Device Watch Search",
    "path": "device-watch-search.svg"
  },
  {
    "name": "device-watch-share",
    "label": "Device Watch Share",
    "path": "device-watch-share.svg"
  },
  {
    "name": "device-watch-star",
    "label": "Device Watch Star",
    "path": "device-watch-star.svg"
  },
  {
    "name": "device-watch-stats",
    "label": "Device Watch Stats",
    "path": "device-watch-stats.svg"
  },
  {
    "name": "device-watch-stats-2",
    "label": "Device Watch Stats 2",
    "path": "device-watch-stats-2.svg"
  },
  {
    "name": "device-watch-up",
    "label": "Device Watch Up",
    "path": "device-watch-up.svg"
  },
  {
    "name": "device-watch-x",
    "label": "Device Watch X",
    "path": "device-watch-x.svg"
  },
  {
    "name": "devices",
    "label": "Devices",
    "path": "devices.svg"
  },
  {
    "name": "devices-2",
    "label": "Devices 2",
    "path": "devices-2.svg"
  },
  {
    "name": "devices-bolt",
    "label": "Devices Bolt",
    "path": "devices-bolt.svg"
  },
  {
    "name": "devices-cancel",
    "label": "Devices Cancel",
    "path": "devices-cancel.svg"
  },
  {
    "name": "devices-check",
    "label": "Devices Check",
    "path": "devices-check.svg"
  },
  {
    "name": "devices-code",
    "label": "Devices Code",
    "path": "devices-code.svg"
  },
  {
    "name": "devices-cog",
    "label": "Devices Cog",
    "path": "devices-cog.svg"
  },
  {
    "name": "devices-dollar",
    "label": "Devices Dollar",
    "path": "devices-dollar.svg"
  },
  {
    "name": "devices-down",
    "label": "Devices Down",
    "path": "devices-down.svg"
  },
  {
    "name": "devices-exclamation",
    "label": "Devices Exclamation",
    "path": "devices-exclamation.svg"
  },
  {
    "name": "devices-heart",
    "label": "Devices Heart",
    "path": "devices-heart.svg"
  },
  {
    "name": "devices-minus",
    "label": "Devices Minus",
    "path": "devices-minus.svg"
  },
  {
    "name": "devices-off",
    "label": "Devices Off",
    "path": "devices-off.svg"
  },
  {
    "name": "devices-pause",
    "label": "Devices Pause",
    "path": "devices-pause.svg"
  },
  {
    "name": "devices-pc",
    "label": "Devices Pc",
    "path": "devices-pc.svg"
  },
  {
    "name": "devices-pc-off",
    "label": "Devices Pc Off",
    "path": "devices-pc-off.svg"
  },
  {
    "name": "devices-pin",
    "label": "Devices Pin",
    "path": "devices-pin.svg"
  },
  {
    "name": "devices-plus",
    "label": "Devices Plus",
    "path": "devices-plus.svg"
  },
  {
    "name": "devices-question",
    "label": "Devices Question",
    "path": "devices-question.svg"
  },
  {
    "name": "devices-search",
    "label": "Devices Search",
    "path": "devices-search.svg"
  },
  {
    "name": "devices-share",
    "label": "Devices Share",
    "path": "devices-share.svg"
  },
  {
    "name": "devices-star",
    "label": "Devices Star",
    "path": "devices-star.svg"
  },
  {
    "name": "devices-up",
    "label": "Devices Up",
    "path": "devices-up.svg"
  },
  {
    "name": "devices-x",
    "label": "Devices X",
    "path": "devices-x.svg"
  },
  {
    "name": "diabolo",
    "label": "Diabolo",
    "path": "diabolo.svg"
  },
  {
    "name": "diabolo-off",
    "label": "Diabolo Off",
    "path": "diabolo-off.svg"
  },
  {
    "name": "diabolo-plus",
    "label": "Diabolo Plus",
    "path": "diabolo-plus.svg"
  },
  {
    "name": "dialpad",
    "label": "Dialpad",
    "path": "dialpad.svg"
  },
  {
    "name": "dialpad-off",
    "label": "Dialpad Off",
    "path": "dialpad-off.svg"
  },
  {
    "name": "diamond",
    "label": "Diamond",
    "path": "diamond.svg"
  },
  {
    "name": "diamond-off",
    "label": "Diamond Off",
    "path": "diamond-off.svg"
  },
  {
    "name": "diamonds",
    "label": "Diamonds",
    "path": "diamonds.svg"
  },
  {
    "name": "diaper",
    "label": "Diaper",
    "path": "diaper.svg"
  },
  {
    "name": "dice",
    "label": "Dice",
    "path": "dice.svg"
  },
  {
    "name": "dice-1",
    "label": "Dice 1",
    "path": "dice-1.svg"
  },
  {
    "name": "dice-2",
    "label": "Dice 2",
    "path": "dice-2.svg"
  },
  {
    "name": "dice-3",
    "label": "Dice 3",
    "path": "dice-3.svg"
  },
  {
    "name": "dice-4",
    "label": "Dice 4",
    "path": "dice-4.svg"
  },
  {
    "name": "dice-5",
    "label": "Dice 5",
    "path": "dice-5.svg"
  },
  {
    "name": "dice-6",
    "label": "Dice 6",
    "path": "dice-6.svg"
  },
  {
    "name": "dimensions",
    "label": "Dimensions",
    "path": "dimensions.svg"
  },
  {
    "name": "direction",
    "label": "Direction",
    "path": "direction.svg"
  },
  {
    "name": "direction-arrows",
    "label": "Direction Arrows",
    "path": "direction-arrows.svg"
  },
  {
    "name": "direction-horizontal",
    "label": "Direction Horizontal",
    "path": "direction-horizontal.svg"
  },
  {
    "name": "direction-sign",
    "label": "Direction Sign",
    "path": "direction-sign.svg"
  },
  {
    "name": "direction-sign-off",
    "label": "Direction Sign Off",
    "path": "direction-sign-off.svg"
  },
  {
    "name": "directions",
    "label": "Directions",
    "path": "directions.svg"
  },
  {
    "name": "directions-off",
    "label": "Directions Off",
    "path": "directions-off.svg"
  },
  {
    "name": "disabled",
    "label": "Disabled",
    "path": "disabled.svg"
  },
  {
    "name": "disabled-2",
    "label": "Disabled 2",
    "path": "disabled-2.svg"
  },
  {
    "name": "disabled-off",
    "label": "Disabled Off",
    "path": "disabled-off.svg"
  },
  {
    "name": "disc",
    "label": "Disc",
    "path": "disc.svg"
  },
  {
    "name": "disc-golf",
    "label": "Disc Golf",
    "path": "disc-golf.svg"
  },
  {
    "name": "disc-off",
    "label": "Disc Off",
    "path": "disc-off.svg"
  },
  {
    "name": "discount",
    "label": "Discount",
    "path": "discount.svg"
  },
  {
    "name": "discount-off",
    "label": "Discount Off",
    "path": "discount-off.svg"
  },
  {
    "name": "divide",
    "label": "Divide",
    "path": "divide.svg"
  },
  {
    "name": "dna",
    "label": "Dna",
    "path": "dna.svg"
  },
  {
    "name": "dna-2",
    "label": "Dna 2",
    "path": "dna-2.svg"
  },
  {
    "name": "dna-2-off",
    "label": "Dna 2 Off",
    "path": "dna-2-off.svg"
  },
  {
    "name": "dna-off",
    "label": "Dna Off",
    "path": "dna-off.svg"
  },
  {
    "name": "dog",
    "label": "Dog",
    "path": "dog.svg"
  },
  {
    "name": "dog-bowl",
    "label": "Dog Bowl",
    "path": "dog-bowl.svg"
  },
  {
    "name": "door",
    "label": "Door",
    "path": "door.svg"
  },
  {
    "name": "door-enter",
    "label": "Door Enter",
    "path": "door-enter.svg"
  },
  {
    "name": "door-exit",
    "label": "Door Exit",
    "path": "door-exit.svg"
  },
  {
    "name": "door-off",
    "label": "Door Off",
    "path": "door-off.svg"
  },
  {
    "name": "dots",
    "label": "Dots",
    "path": "dots.svg"
  },
  {
    "name": "dots-circle-horizontal",
    "label": "Dots Circle Horizontal",
    "path": "dots-circle-horizontal.svg"
  },
  {
    "name": "dots-diagonal",
    "label": "Dots Diagonal",
    "path": "dots-diagonal.svg"
  },
  {
    "name": "dots-diagonal-2",
    "label": "Dots Diagonal 2",
    "path": "dots-diagonal-2.svg"
  },
  {
    "name": "dots-vertical",
    "label": "Dots Vertical",
    "path": "dots-vertical.svg"
  },
  {
    "name": "download",
    "label": "Download",
    "path": "download.svg"
  },
  {
    "name": "download-off",
    "label": "Download Off",
    "path": "download-off.svg"
  },
  {
    "name": "drag-drop",
    "label": "Drag Drop",
    "path": "drag-drop.svg"
  },
  {
    "name": "drag-drop-2",
    "label": "Drag Drop 2",
    "path": "drag-drop-2.svg"
  },
  {
    "name": "drone",
    "label": "Drone",
    "path": "drone.svg"
  },
  {
    "name": "drone-off",
    "label": "Drone Off",
    "path": "drone-off.svg"
  },
  {
    "name": "drop-circle",
    "label": "Drop Circle",
    "path": "drop-circle.svg"
  },
  {
    "name": "droplet",
    "label": "Droplet",
    "path": "droplet.svg"
  },
  {
    "name": "droplet-bolt",
    "label": "Droplet Bolt",
    "path": "droplet-bolt.svg"
  },
  {
    "name": "droplet-cancel",
    "label": "Droplet Cancel",
    "path": "droplet-cancel.svg"
  },
  {
    "name": "droplet-check",
    "label": "Droplet Check",
    "path": "droplet-check.svg"
  },
  {
    "name": "droplet-code",
    "label": "Droplet Code",
    "path": "droplet-code.svg"
  },
  {
    "name": "droplet-cog",
    "label": "Droplet Cog",
    "path": "droplet-cog.svg"
  },
  {
    "name": "droplet-dollar",
    "label": "Droplet Dollar",
    "path": "droplet-dollar.svg"
  },
  {
    "name": "droplet-down",
    "label": "Droplet Down",
    "path": "droplet-down.svg"
  },
  {
    "name": "droplet-exclamation",
    "label": "Droplet Exclamation",
    "path": "droplet-exclamation.svg"
  },
  {
    "name": "droplet-half",
    "label": "Droplet Half",
    "path": "droplet-half.svg"
  },
  {
    "name": "droplet-half-2",
    "label": "Droplet Half 2",
    "path": "droplet-half-2.svg"
  },
  {
    "name": "droplet-heart",
    "label": "Droplet Heart",
    "path": "droplet-heart.svg"
  },
  {
    "name": "droplet-minus",
    "label": "Droplet Minus",
    "path": "droplet-minus.svg"
  },
  {
    "name": "droplet-off",
    "label": "Droplet Off",
    "path": "droplet-off.svg"
  },
  {
    "name": "droplet-pause",
    "label": "Droplet Pause",
    "path": "droplet-pause.svg"
  },
  {
    "name": "droplet-pin",
    "label": "Droplet Pin",
    "path": "droplet-pin.svg"
  },
  {
    "name": "droplet-plus",
    "label": "Droplet Plus",
    "path": "droplet-plus.svg"
  },
  {
    "name": "droplet-question",
    "label": "Droplet Question",
    "path": "droplet-question.svg"
  },
  {
    "name": "droplet-search",
    "label": "Droplet Search",
    "path": "droplet-search.svg"
  },
  {
    "name": "droplet-share",
    "label": "Droplet Share",
    "path": "droplet-share.svg"
  },
  {
    "name": "droplet-star",
    "label": "Droplet Star",
    "path": "droplet-star.svg"
  },
  {
    "name": "droplet-up",
    "label": "Droplet Up",
    "path": "droplet-up.svg"
  },
  {
    "name": "droplet-x",
    "label": "Droplet X",
    "path": "droplet-x.svg"
  },
  {
    "name": "droplets",
    "label": "Droplets",
    "path": "droplets.svg"
  },
  {
    "name": "dual-screen",
    "label": "Dual Screen",
    "path": "dual-screen.svg"
  },
  {
    "name": "dumpling",
    "label": "Dumpling",
    "path": "dumpling.svg"
  },
  {
    "name": "e-passport",
    "label": "E Passport",
    "path": "e-passport.svg"
  },
  {
    "name": "ear",
    "label": "Ear",
    "path": "ear.svg"
  },
  {
    "name": "ear-off",
    "label": "Ear Off",
    "path": "ear-off.svg"
  },
  {
    "name": "ear-scan",
    "label": "Ear Scan",
    "path": "ear-scan.svg"
  },
  {
    "name": "ease-in",
    "label": "Ease In",
    "path": "ease-in.svg"
  },
  {
    "name": "ease-in-control-point",
    "label": "Ease In Control Point",
    "path": "ease-in-control-point.svg"
  },
  {
    "name": "ease-in-out",
    "label": "Ease In Out",
    "path": "ease-in-out.svg"
  },
  {
    "name": "ease-in-out-control-points",
    "label": "Ease In Out Control Points",
    "path": "ease-in-out-control-points.svg"
  },
  {
    "name": "ease-out",
    "label": "Ease Out",
    "path": "ease-out.svg"
  },
  {
    "name": "ease-out-control-point",
    "label": "Ease Out Control Point",
    "path": "ease-out-control-point.svg"
  },
  {
    "name": "edit",
    "label": "Edit",
    "path": "edit.svg"
  },
  {
    "name": "edit-circle",
    "label": "Edit Circle",
    "path": "edit-circle.svg"
  },
  {
    "name": "edit-circle-off",
    "label": "Edit Circle Off",
    "path": "edit-circle-off.svg"
  },
  {
    "name": "edit-off",
    "label": "Edit Off",
    "path": "edit-off.svg"
  },
  {
    "name": "egg",
    "label": "Egg",
    "path": "egg.svg"
  },
  {
    "name": "egg-cracked",
    "label": "Egg Cracked",
    "path": "egg-cracked.svg"
  },
  {
    "name": "egg-fried",
    "label": "Egg Fried",
    "path": "egg-fried.svg"
  },
  {
    "name": "egg-off",
    "label": "Egg Off",
    "path": "egg-off.svg"
  },
  {
    "name": "eggs",
    "label": "Eggs",
    "path": "eggs.svg"
  },
  {
    "name": "elevator",
    "label": "Elevator",
    "path": "elevator.svg"
  },
  {
    "name": "elevator-off",
    "label": "Elevator Off",
    "path": "elevator-off.svg"
  },
  {
    "name": "emergency-bed",
    "label": "Emergency Bed",
    "path": "emergency-bed.svg"
  },
  {
    "name": "empathize",
    "label": "Empathize",
    "path": "empathize.svg"
  },
  {
    "name": "empathize-off",
    "label": "Empathize Off",
    "path": "empathize-off.svg"
  },
  {
    "name": "emphasis",
    "label": "Emphasis",
    "path": "emphasis.svg"
  },
  {
    "name": "engine",
    "label": "Engine",
    "path": "engine.svg"
  },
  {
    "name": "engine-off",
    "label": "Engine Off",
    "path": "engine-off.svg"
  },
  {
    "name": "equal",
    "label": "Equal",
    "path": "equal.svg"
  },
  {
    "name": "equal-double",
    "label": "Equal Double",
    "path": "equal-double.svg"
  },
  {
    "name": "equal-not",
    "label": "Equal Not",
    "path": "equal-not.svg"
  },
  {
    "name": "eraser",
    "label": "Eraser",
    "path": "eraser.svg"
  },
  {
    "name": "eraser-off",
    "label": "Eraser Off",
    "path": "eraser-off.svg"
  },
  {
    "name": "error-404",
    "label": "Error 404",
    "path": "error-404.svg"
  },
  {
    "name": "error-404-off",
    "label": "Error 404 Off",
    "path": "error-404-off.svg"
  },
  {
    "name": "escalator",
    "label": "Escalator",
    "path": "escalator.svg"
  },
  {
    "name": "escalator-down",
    "label": "Escalator Down",
    "path": "escalator-down.svg"
  },
  {
    "name": "escalator-up",
    "label": "Escalator Up",
    "path": "escalator-up.svg"
  },
  {
    "name": "exchange",
    "label": "Exchange",
    "path": "exchange.svg"
  },
  {
    "name": "exchange-off",
    "label": "Exchange Off",
    "path": "exchange-off.svg"
  },
  {
    "name": "exclamation-circle",
    "label": "Exclamation Circle",
    "path": "exclamation-circle.svg"
  },
  {
    "name": "exclamation-mark",
    "label": "Exclamation Mark",
    "path": "exclamation-mark.svg"
  },
  {
    "name": "exclamation-mark-off",
    "label": "Exclamation Mark Off",
    "path": "exclamation-mark-off.svg"
  },
  {
    "name": "explicit",
    "label": "Explicit",
    "path": "explicit.svg"
  },
  {
    "name": "explicit-off",
    "label": "Explicit Off",
    "path": "explicit-off.svg"
  },
  {
    "name": "exposure",
    "label": "Exposure",
    "path": "exposure.svg"
  },
  {
    "name": "exposure-0",
    "label": "Exposure 0",
    "path": "exposure-0.svg"
  },
  {
    "name": "exposure-minus-1",
    "label": "Exposure Minus 1",
    "path": "exposure-minus-1.svg"
  },
  {
    "name": "exposure-minus-2",
    "label": "Exposure Minus 2",
    "path": "exposure-minus-2.svg"
  },
  {
    "name": "exposure-off",
    "label": "Exposure Off",
    "path": "exposure-off.svg"
  },
  {
    "name": "exposure-plus-1",
    "label": "Exposure Plus 1",
    "path": "exposure-plus-1.svg"
  },
  {
    "name": "exposure-plus-2",
    "label": "Exposure Plus 2",
    "path": "exposure-plus-2.svg"
  },
  {
    "name": "external-link",
    "label": "External Link",
    "path": "external-link.svg"
  },
  {
    "name": "external-link-off",
    "label": "External Link Off",
    "path": "external-link-off.svg"
  },
  {
    "name": "eye",
    "label": "Eye",
    "path": "eye.svg"
  },
  {
    "name": "eye-bitcoin",
    "label": "Eye Bitcoin",
    "path": "eye-bitcoin.svg"
  },
  {
    "name": "eye-bolt",
    "label": "Eye Bolt",
    "path": "eye-bolt.svg"
  },
  {
    "name": "eye-cancel",
    "label": "Eye Cancel",
    "path": "eye-cancel.svg"
  },
  {
    "name": "eye-check",
    "label": "Eye Check",
    "path": "eye-check.svg"
  },
  {
    "name": "eye-closed",
    "label": "Eye Closed",
    "path": "eye-closed.svg"
  },
  {
    "name": "eye-code",
    "label": "Eye Code",
    "path": "eye-code.svg"
  },
  {
    "name": "eye-cog",
    "label": "Eye Cog",
    "path": "eye-cog.svg"
  },
  {
    "name": "eye-discount",
    "label": "Eye Discount",
    "path": "eye-discount.svg"
  },
  {
    "name": "eye-dollar",
    "label": "Eye Dollar",
    "path": "eye-dollar.svg"
  },
  {
    "name": "eye-dotted",
    "label": "Eye Dotted",
    "path": "eye-dotted.svg"
  },
  {
    "name": "eye-down",
    "label": "Eye Down",
    "path": "eye-down.svg"
  },
  {
    "name": "eye-edit",
    "label": "Eye Edit",
    "path": "eye-edit.svg"
  },
  {
    "name": "eye-exclamation",
    "label": "Eye Exclamation",
    "path": "eye-exclamation.svg"
  },
  {
    "name": "eye-heart",
    "label": "Eye Heart",
    "path": "eye-heart.svg"
  },
  {
    "name": "eye-minus",
    "label": "Eye Minus",
    "path": "eye-minus.svg"
  },
  {
    "name": "eye-off",
    "label": "Eye Off",
    "path": "eye-off.svg"
  },
  {
    "name": "eye-pause",
    "label": "Eye Pause",
    "path": "eye-pause.svg"
  },
  {
    "name": "eye-pin",
    "label": "Eye Pin",
    "path": "eye-pin.svg"
  },
  {
    "name": "eye-plus",
    "label": "Eye Plus",
    "path": "eye-plus.svg"
  },
  {
    "name": "eye-question",
    "label": "Eye Question",
    "path": "eye-question.svg"
  },
  {
    "name": "eye-search",
    "label": "Eye Search",
    "path": "eye-search.svg"
  },
  {
    "name": "eye-share",
    "label": "Eye Share",
    "path": "eye-share.svg"
  },
  {
    "name": "eye-spark",
    "label": "Eye Spark",
    "path": "eye-spark.svg"
  },
  {
    "name": "eye-star",
    "label": "Eye Star",
    "path": "eye-star.svg"
  },
  {
    "name": "eye-table",
    "label": "Eye Table",
    "path": "eye-table.svg"
  },
  {
    "name": "eye-up",
    "label": "Eye Up",
    "path": "eye-up.svg"
  },
  {
    "name": "eye-x",
    "label": "Eye X",
    "path": "eye-x.svg"
  },
  {
    "name": "eyeglass",
    "label": "Eyeglass",
    "path": "eyeglass.svg"
  },
  {
    "name": "eyeglass-2",
    "label": "Eyeglass 2",
    "path": "eyeglass-2.svg"
  },
  {
    "name": "eyeglass-off",
    "label": "Eyeglass Off",
    "path": "eyeglass-off.svg"
  },
  {
    "name": "face-id",
    "label": "Face Id",
    "path": "face-id.svg"
  },
  {
    "name": "face-id-error",
    "label": "Face Id Error",
    "path": "face-id-error.svg"
  },
  {
    "name": "face-mask",
    "label": "Face Mask",
    "path": "face-mask.svg"
  },
  {
    "name": "face-mask-off",
    "label": "Face Mask Off",
    "path": "face-mask-off.svg"
  },
  {
    "name": "fall",
    "label": "Fall",
    "path": "fall.svg"
  },
  {
    "name": "favicon",
    "label": "Favicon",
    "path": "favicon.svg"
  },
  {
    "name": "feather",
    "label": "Feather",
    "path": "feather.svg"
  },
  {
    "name": "feather-off",
    "label": "Feather Off",
    "path": "feather-off.svg"
  },
  {
    "name": "fence",
    "label": "Fence",
    "path": "fence.svg"
  },
  {
    "name": "fence-off",
    "label": "Fence Off",
    "path": "fence-off.svg"
  },
  {
    "name": "ferry",
    "label": "Ferry",
    "path": "ferry.svg"
  },
  {
    "name": "fidget-spinner",
    "label": "Fidget Spinner",
    "path": "fidget-spinner.svg"
  },
  {
    "name": "file",
    "label": "File",
    "path": "file.svg"
  },
  {
    "name": "file-3d",
    "label": "File 3d",
    "path": "file-3d.svg"
  },
  {
    "name": "file-ai",
    "label": "File Ai",
    "path": "file-ai.svg"
  },
  {
    "name": "file-alert",
    "label": "File Alert",
    "path": "file-alert.svg"
  },
  {
    "name": "file-analytics",
    "label": "File Analytics",
    "path": "file-analytics.svg"
  },
  {
    "name": "file-arrow-left",
    "label": "File Arrow Left",
    "path": "file-arrow-left.svg"
  },
  {
    "name": "file-arrow-right",
    "label": "File Arrow Right",
    "path": "file-arrow-right.svg"
  },
  {
    "name": "file-barcode",
    "label": "File Barcode",
    "path": "file-barcode.svg"
  },
  {
    "name": "file-bitcoin",
    "label": "File Bitcoin",
    "path": "file-bitcoin.svg"
  },
  {
    "name": "file-broken",
    "label": "File Broken",
    "path": "file-broken.svg"
  },
  {
    "name": "file-certificate",
    "label": "File Certificate",
    "path": "file-certificate.svg"
  },
  {
    "name": "file-chart",
    "label": "File Chart",
    "path": "file-chart.svg"
  },
  {
    "name": "file-check",
    "label": "File Check",
    "path": "file-check.svg"
  },
  {
    "name": "file-code",
    "label": "File Code",
    "path": "file-code.svg"
  },
  {
    "name": "file-code-2",
    "label": "File Code 2",
    "path": "file-code-2.svg"
  },
  {
    "name": "file-cv",
    "label": "File Cv",
    "path": "file-cv.svg"
  },
  {
    "name": "file-database",
    "label": "File Database",
    "path": "file-database.svg"
  },
  {
    "name": "file-delta",
    "label": "File Delta",
    "path": "file-delta.svg"
  },
  {
    "name": "file-description",
    "label": "File Description",
    "path": "file-description.svg"
  },
  {
    "name": "file-diff",
    "label": "File Diff",
    "path": "file-diff.svg"
  },
  {
    "name": "file-digit",
    "label": "File Digit",
    "path": "file-digit.svg"
  },
  {
    "name": "file-dislike",
    "label": "File Dislike",
    "path": "file-dislike.svg"
  },
  {
    "name": "file-dollar",
    "label": "File Dollar",
    "path": "file-dollar.svg"
  },
  {
    "name": "file-dots",
    "label": "File Dots",
    "path": "file-dots.svg"
  },
  {
    "name": "file-download",
    "label": "File Download",
    "path": "file-download.svg"
  },
  {
    "name": "file-euro",
    "label": "File Euro",
    "path": "file-euro.svg"
  },
  {
    "name": "file-excel",
    "label": "File Excel",
    "path": "file-excel.svg"
  },
  {
    "name": "file-export",
    "label": "File Export",
    "path": "file-export.svg"
  },
  {
    "name": "file-function",
    "label": "File Function",
    "path": "file-function.svg"
  },
  {
    "name": "file-horizontal",
    "label": "File Horizontal",
    "path": "file-horizontal.svg"
  },
  {
    "name": "file-import",
    "label": "File Import",
    "path": "file-import.svg"
  },
  {
    "name": "file-infinity",
    "label": "File Infinity",
    "path": "file-infinity.svg"
  },
  {
    "name": "file-info",
    "label": "File Info",
    "path": "file-info.svg"
  },
  {
    "name": "file-invoice",
    "label": "File Invoice",
    "path": "file-invoice.svg"
  },
  {
    "name": "file-isr",
    "label": "File Isr",
    "path": "file-isr.svg"
  },
  {
    "name": "file-lambda",
    "label": "File Lambda",
    "path": "file-lambda.svg"
  },
  {
    "name": "file-like",
    "label": "File Like",
    "path": "file-like.svg"
  },
  {
    "name": "file-minus",
    "label": "File Minus",
    "path": "file-minus.svg"
  },
  {
    "name": "file-music",
    "label": "File Music",
    "path": "file-music.svg"
  },
  {
    "name": "file-neutral",
    "label": "File Neutral",
    "path": "file-neutral.svg"
  },
  {
    "name": "file-off",
    "label": "File Off",
    "path": "file-off.svg"
  },
  {
    "name": "file-orientation",
    "label": "File Orientation",
    "path": "file-orientation.svg"
  },
  {
    "name": "file-pencil",
    "label": "File Pencil",
    "path": "file-pencil.svg"
  },
  {
    "name": "file-percent",
    "label": "File Percent",
    "path": "file-percent.svg"
  },
  {
    "name": "file-phone",
    "label": "File Phone",
    "path": "file-phone.svg"
  },
  {
    "name": "file-plus",
    "label": "File Plus",
    "path": "file-plus.svg"
  },
  {
    "name": "file-power",
    "label": "File Power",
    "path": "file-power.svg"
  },
  {
    "name": "file-report",
    "label": "File Report",
    "path": "file-report.svg"
  },
  {
    "name": "file-rss",
    "label": "File Rss",
    "path": "file-rss.svg"
  },
  {
    "name": "file-sad",
    "label": "File Sad",
    "path": "file-sad.svg"
  },
  {
    "name": "file-scissors",
    "label": "File Scissors",
    "path": "file-scissors.svg"
  },
  {
    "name": "file-search",
    "label": "File Search",
    "path": "file-search.svg"
  },
  {
    "name": "file-settings",
    "label": "File Settings",
    "path": "file-settings.svg"
  },
  {
    "name": "file-shredder",
    "label": "File Shredder",
    "path": "file-shredder.svg"
  },
  {
    "name": "file-signal",
    "label": "File Signal",
    "path": "file-signal.svg"
  },
  {
    "name": "file-smile",
    "label": "File Smile",
    "path": "file-smile.svg"
  },
  {
    "name": "file-spark",
    "label": "File Spark",
    "path": "file-spark.svg"
  },
  {
    "name": "file-spreadsheet",
    "label": "File Spreadsheet",
    "path": "file-spreadsheet.svg"
  },
  {
    "name": "file-stack",
    "label": "File Stack",
    "path": "file-stack.svg"
  },
  {
    "name": "file-star",
    "label": "File Star",
    "path": "file-star.svg"
  },
  {
    "name": "file-symlink",
    "label": "File Symlink",
    "path": "file-symlink.svg"
  },
  {
    "name": "file-text",
    "label": "File Text",
    "path": "file-text.svg"
  },
  {
    "name": "file-text-ai",
    "label": "File Text Ai",
    "path": "file-text-ai.svg"
  },
  {
    "name": "file-text-shield",
    "label": "File Text Shield",
    "path": "file-text-shield.svg"
  },
  {
    "name": "file-text-spark",
    "label": "File Text Spark",
    "path": "file-text-spark.svg"
  },
  {
    "name": "file-time",
    "label": "File Time",
    "path": "file-time.svg"
  },
  {
    "name": "file-type-bmp",
    "label": "File Type Bmp",
    "path": "file-type-bmp.svg"
  },
  {
    "name": "file-type-css",
    "label": "File Type Css",
    "path": "file-type-css.svg"
  },
  {
    "name": "file-type-csv",
    "label": "File Type Csv",
    "path": "file-type-csv.svg"
  },
  {
    "name": "file-type-doc",
    "label": "File Type Doc",
    "path": "file-type-doc.svg"
  },
  {
    "name": "file-type-docx",
    "label": "File Type Docx",
    "path": "file-type-docx.svg"
  },
  {
    "name": "file-type-html",
    "label": "File Type Html",
    "path": "file-type-html.svg"
  },
  {
    "name": "file-type-jpg",
    "label": "File Type Jpg",
    "path": "file-type-jpg.svg"
  },
  {
    "name": "file-type-js",
    "label": "File Type Js",
    "path": "file-type-js.svg"
  },
  {
    "name": "file-type-jsx",
    "label": "File Type Jsx",
    "path": "file-type-jsx.svg"
  },
  {
    "name": "file-type-pdf",
    "label": "File Type Pdf",
    "path": "file-type-pdf.svg"
  },
  {
    "name": "file-type-php",
    "label": "File Type Php",
    "path": "file-type-php.svg"
  },
  {
    "name": "file-type-png",
    "label": "File Type Png",
    "path": "file-type-png.svg"
  },
  {
    "name": "file-type-ppt",
    "label": "File Type Ppt",
    "path": "file-type-ppt.svg"
  },
  {
    "name": "file-type-rs",
    "label": "File Type Rs",
    "path": "file-type-rs.svg"
  },
  {
    "name": "file-type-sql",
    "label": "File Type Sql",
    "path": "file-type-sql.svg"
  },
  {
    "name": "file-type-svg",
    "label": "File Type Svg",
    "path": "file-type-svg.svg"
  },
  {
    "name": "file-type-ts",
    "label": "File Type Ts",
    "path": "file-type-ts.svg"
  },
  {
    "name": "file-type-tsx",
    "label": "File Type Tsx",
    "path": "file-type-tsx.svg"
  },
  {
    "name": "file-type-txt",
    "label": "File Type Txt",
    "path": "file-type-txt.svg"
  },
  {
    "name": "file-type-vue",
    "label": "File Type Vue",
    "path": "file-type-vue.svg"
  },
  {
    "name": "file-type-xls",
    "label": "File Type Xls",
    "path": "file-type-xls.svg"
  },
  {
    "name": "file-type-xml",
    "label": "File Type Xml",
    "path": "file-type-xml.svg"
  },
  {
    "name": "file-type-zip",
    "label": "File Type Zip",
    "path": "file-type-zip.svg"
  },
  {
    "name": "file-typography",
    "label": "File Typography",
    "path": "file-typography.svg"
  },
  {
    "name": "file-unknown",
    "label": "File Unknown",
    "path": "file-unknown.svg"
  },
  {
    "name": "file-upload",
    "label": "File Upload",
    "path": "file-upload.svg"
  },
  {
    "name": "file-vector",
    "label": "File Vector",
    "path": "file-vector.svg"
  },
  {
    "name": "file-word",
    "label": "File Word",
    "path": "file-word.svg"
  },
  {
    "name": "file-x",
    "label": "File X",
    "path": "file-x.svg"
  },
  {
    "name": "file-zip",
    "label": "File Zip",
    "path": "file-zip.svg"
  },
  {
    "name": "files",
    "label": "Files",
    "path": "files.svg"
  },
  {
    "name": "files-off",
    "label": "Files Off",
    "path": "files-off.svg"
  },
  {
    "name": "filter",
    "label": "Filter",
    "path": "filter.svg"
  },
  {
    "name": "filter-2",
    "label": "Filter 2",
    "path": "filter-2.svg"
  },
  {
    "name": "filter-2-bolt",
    "label": "Filter 2 Bolt",
    "path": "filter-2-bolt.svg"
  },
  {
    "name": "filter-2-cancel",
    "label": "Filter 2 Cancel",
    "path": "filter-2-cancel.svg"
  },
  {
    "name": "filter-2-check",
    "label": "Filter 2 Check",
    "path": "filter-2-check.svg"
  },
  {
    "name": "filter-2-code",
    "label": "Filter 2 Code",
    "path": "filter-2-code.svg"
  },
  {
    "name": "filter-2-cog",
    "label": "Filter 2 Cog",
    "path": "filter-2-cog.svg"
  },
  {
    "name": "filter-2-discount",
    "label": "Filter 2 Discount",
    "path": "filter-2-discount.svg"
  },
  {
    "name": "filter-2-dollar",
    "label": "Filter 2 Dollar",
    "path": "filter-2-dollar.svg"
  },
  {
    "name": "filter-2-down",
    "label": "Filter 2 Down",
    "path": "filter-2-down.svg"
  },
  {
    "name": "filter-2-edit",
    "label": "Filter 2 Edit",
    "path": "filter-2-edit.svg"
  },
  {
    "name": "filter-2-exclamation",
    "label": "Filter 2 Exclamation",
    "path": "filter-2-exclamation.svg"
  },
  {
    "name": "filter-2-minus",
    "label": "Filter 2 Minus",
    "path": "filter-2-minus.svg"
  },
  {
    "name": "filter-2-pause",
    "label": "Filter 2 Pause",
    "path": "filter-2-pause.svg"
  },
  {
    "name": "filter-2-pin",
    "label": "Filter 2 Pin",
    "path": "filter-2-pin.svg"
  },
  {
    "name": "filter-2-plus",
    "label": "Filter 2 Plus",
    "path": "filter-2-plus.svg"
  },
  {
    "name": "filter-2-question",
    "label": "Filter 2 Question",
    "path": "filter-2-question.svg"
  },
  {
    "name": "filter-2-search",
    "label": "Filter 2 Search",
    "path": "filter-2-search.svg"
  },
  {
    "name": "filter-2-share",
    "label": "Filter 2 Share",
    "path": "filter-2-share.svg"
  },
  {
    "name": "filter-2-spark",
    "label": "Filter 2 Spark",
    "path": "filter-2-spark.svg"
  },
  {
    "name": "filter-2-up",
    "label": "Filter 2 Up",
    "path": "filter-2-up.svg"
  },
  {
    "name": "filter-2-x",
    "label": "Filter 2 X",
    "path": "filter-2-x.svg"
  },
  {
    "name": "filter-bolt",
    "label": "Filter Bolt",
    "path": "filter-bolt.svg"
  },
  {
    "name": "filter-cancel",
    "label": "Filter Cancel",
    "path": "filter-cancel.svg"
  },
  {
    "name": "filter-check",
    "label": "Filter Check",
    "path": "filter-check.svg"
  },
  {
    "name": "filter-code",
    "label": "Filter Code",
    "path": "filter-code.svg"
  },
  {
    "name": "filter-cog",
    "label": "Filter Cog",
    "path": "filter-cog.svg"
  },
  {
    "name": "filter-discount",
    "label": "Filter Discount",
    "path": "filter-discount.svg"
  },
  {
    "name": "filter-dollar",
    "label": "Filter Dollar",
    "path": "filter-dollar.svg"
  },
  {
    "name": "filter-down",
    "label": "Filter Down",
    "path": "filter-down.svg"
  },
  {
    "name": "filter-edit",
    "label": "Filter Edit",
    "path": "filter-edit.svg"
  },
  {
    "name": "filter-exclamation",
    "label": "Filter Exclamation",
    "path": "filter-exclamation.svg"
  },
  {
    "name": "filter-heart",
    "label": "Filter Heart",
    "path": "filter-heart.svg"
  },
  {
    "name": "filter-minus",
    "label": "Filter Minus",
    "path": "filter-minus.svg"
  },
  {
    "name": "filter-off",
    "label": "Filter Off",
    "path": "filter-off.svg"
  },
  {
    "name": "filter-pause",
    "label": "Filter Pause",
    "path": "filter-pause.svg"
  },
  {
    "name": "filter-pin",
    "label": "Filter Pin",
    "path": "filter-pin.svg"
  },
  {
    "name": "filter-plus",
    "label": "Filter Plus",
    "path": "filter-plus.svg"
  },
  {
    "name": "filter-question",
    "label": "Filter Question",
    "path": "filter-question.svg"
  },
  {
    "name": "filter-search",
    "label": "Filter Search",
    "path": "filter-search.svg"
  },
  {
    "name": "filter-share",
    "label": "Filter Share",
    "path": "filter-share.svg"
  },
  {
    "name": "filter-spark",
    "label": "Filter Spark",
    "path": "filter-spark.svg"
  },
  {
    "name": "filter-star",
    "label": "Filter Star",
    "path": "filter-star.svg"
  },
  {
    "name": "filter-up",
    "label": "Filter Up",
    "path": "filter-up.svg"
  },
  {
    "name": "filter-x",
    "label": "Filter X",
    "path": "filter-x.svg"
  },
  {
    "name": "filters",
    "label": "Filters",
    "path": "filters.svg"
  },
  {
    "name": "fingerprint",
    "label": "Fingerprint",
    "path": "fingerprint.svg"
  },
  {
    "name": "fingerprint-off",
    "label": "Fingerprint Off",
    "path": "fingerprint-off.svg"
  },
  {
    "name": "fingerprint-scan",
    "label": "Fingerprint Scan",
    "path": "fingerprint-scan.svg"
  },
  {
    "name": "fire-extinguisher",
    "label": "Fire Extinguisher",
    "path": "fire-extinguisher.svg"
  },
  {
    "name": "fire-hydrant",
    "label": "Fire Hydrant",
    "path": "fire-hydrant.svg"
  },
  {
    "name": "fire-hydrant-off",
    "label": "Fire Hydrant Off",
    "path": "fire-hydrant-off.svg"
  },
  {
    "name": "firetruck",
    "label": "Firetruck",
    "path": "firetruck.svg"
  },
  {
    "name": "first-aid-kit",
    "label": "First Aid Kit",
    "path": "first-aid-kit.svg"
  },
  {
    "name": "first-aid-kit-off",
    "label": "First Aid Kit Off",
    "path": "first-aid-kit-off.svg"
  },
  {
    "name": "fish",
    "label": "Fish",
    "path": "fish.svg"
  },
  {
    "name": "fish-bone",
    "label": "Fish Bone",
    "path": "fish-bone.svg"
  },
  {
    "name": "fish-christianity",
    "label": "Fish Christianity",
    "path": "fish-christianity.svg"
  },
  {
    "name": "fish-hook",
    "label": "Fish Hook",
    "path": "fish-hook.svg"
  },
  {
    "name": "fish-hook-off",
    "label": "Fish Hook Off",
    "path": "fish-hook-off.svg"
  },
  {
    "name": "fish-off",
    "label": "Fish Off",
    "path": "fish-off.svg"
  },
  {
    "name": "flag",
    "label": "Flag",
    "path": "flag.svg"
  },
  {
    "name": "flag-2",
    "label": "Flag 2",
    "path": "flag-2.svg"
  },
  {
    "name": "flag-2-off",
    "label": "Flag 2 Off",
    "path": "flag-2-off.svg"
  },
  {
    "name": "flag-3",
    "label": "Flag 3",
    "path": "flag-3.svg"
  },
  {
    "name": "flag-bitcoin",
    "label": "Flag Bitcoin",
    "path": "flag-bitcoin.svg"
  },
  {
    "name": "flag-bolt",
    "label": "Flag Bolt",
    "path": "flag-bolt.svg"
  },
  {
    "name": "flag-cancel",
    "label": "Flag Cancel",
    "path": "flag-cancel.svg"
  },
  {
    "name": "flag-check",
    "label": "Flag Check",
    "path": "flag-check.svg"
  },
  {
    "name": "flag-code",
    "label": "Flag Code",
    "path": "flag-code.svg"
  },
  {
    "name": "flag-cog",
    "label": "Flag Cog",
    "path": "flag-cog.svg"
  },
  {
    "name": "flag-discount",
    "label": "Flag Discount",
    "path": "flag-discount.svg"
  },
  {
    "name": "flag-dollar",
    "label": "Flag Dollar",
    "path": "flag-dollar.svg"
  },
  {
    "name": "flag-down",
    "label": "Flag Down",
    "path": "flag-down.svg"
  },
  {
    "name": "flag-exclamation",
    "label": "Flag Exclamation",
    "path": "flag-exclamation.svg"
  },
  {
    "name": "flag-heart",
    "label": "Flag Heart",
    "path": "flag-heart.svg"
  },
  {
    "name": "flag-minus",
    "label": "Flag Minus",
    "path": "flag-minus.svg"
  },
  {
    "name": "flag-off",
    "label": "Flag Off",
    "path": "flag-off.svg"
  },
  {
    "name": "flag-pause",
    "label": "Flag Pause",
    "path": "flag-pause.svg"
  },
  {
    "name": "flag-pin",
    "label": "Flag Pin",
    "path": "flag-pin.svg"
  },
  {
    "name": "flag-plus",
    "label": "Flag Plus",
    "path": "flag-plus.svg"
  },
  {
    "name": "flag-question",
    "label": "Flag Question",
    "path": "flag-question.svg"
  },
  {
    "name": "flag-search",
    "label": "Flag Search",
    "path": "flag-search.svg"
  },
  {
    "name": "flag-share",
    "label": "Flag Share",
    "path": "flag-share.svg"
  },
  {
    "name": "flag-spark",
    "label": "Flag Spark",
    "path": "flag-spark.svg"
  },
  {
    "name": "flag-star",
    "label": "Flag Star",
    "path": "flag-star.svg"
  },
  {
    "name": "flag-up",
    "label": "Flag Up",
    "path": "flag-up.svg"
  },
  {
    "name": "flag-x",
    "label": "Flag X",
    "path": "flag-x.svg"
  },
  {
    "name": "flame",
    "label": "Flame",
    "path": "flame.svg"
  },
  {
    "name": "flame-off",
    "label": "Flame Off",
    "path": "flame-off.svg"
  },
  {
    "name": "flare",
    "label": "Flare",
    "path": "flare.svg"
  },
  {
    "name": "flask",
    "label": "Flask",
    "path": "flask.svg"
  },
  {
    "name": "flask-2",
    "label": "Flask 2",
    "path": "flask-2.svg"
  },
  {
    "name": "flask-2-off",
    "label": "Flask 2 Off",
    "path": "flask-2-off.svg"
  },
  {
    "name": "flask-off",
    "label": "Flask Off",
    "path": "flask-off.svg"
  },
  {
    "name": "flip-flops",
    "label": "Flip Flops",
    "path": "flip-flops.svg"
  },
  {
    "name": "flip-horizontal",
    "label": "Flip Horizontal",
    "path": "flip-horizontal.svg"
  },
  {
    "name": "flip-vertical",
    "label": "Flip Vertical",
    "path": "flip-vertical.svg"
  },
  {
    "name": "float-center",
    "label": "Float Center",
    "path": "float-center.svg"
  },
  {
    "name": "float-left",
    "label": "Float Left",
    "path": "float-left.svg"
  },
  {
    "name": "float-none",
    "label": "Float None",
    "path": "float-none.svg"
  },
  {
    "name": "float-right",
    "label": "Float Right",
    "path": "float-right.svg"
  },
  {
    "name": "flower",
    "label": "Flower",
    "path": "flower.svg"
  },
  {
    "name": "flower-off",
    "label": "Flower Off",
    "path": "flower-off.svg"
  },
  {
    "name": "focus",
    "label": "Focus",
    "path": "focus.svg"
  },
  {
    "name": "focus-2",
    "label": "Focus 2",
    "path": "focus-2.svg"
  },
  {
    "name": "focus-auto",
    "label": "Focus Auto",
    "path": "focus-auto.svg"
  },
  {
    "name": "focus-centered",
    "label": "Focus Centered",
    "path": "focus-centered.svg"
  },
  {
    "name": "fold",
    "label": "Fold",
    "path": "fold.svg"
  },
  {
    "name": "fold-down",
    "label": "Fold Down",
    "path": "fold-down.svg"
  },
  {
    "name": "fold-up",
    "label": "Fold Up",
    "path": "fold-up.svg"
  },
  {
    "name": "folder",
    "label": "Folder",
    "path": "folder.svg"
  },
  {
    "name": "folder-bolt",
    "label": "Folder Bolt",
    "path": "folder-bolt.svg"
  },
  {
    "name": "folder-cancel",
    "label": "Folder Cancel",
    "path": "folder-cancel.svg"
  },
  {
    "name": "folder-check",
    "label": "Folder Check",
    "path": "folder-check.svg"
  },
  {
    "name": "folder-code",
    "label": "Folder Code",
    "path": "folder-code.svg"
  },
  {
    "name": "folder-cog",
    "label": "Folder Cog",
    "path": "folder-cog.svg"
  },
  {
    "name": "folder-dollar",
    "label": "Folder Dollar",
    "path": "folder-dollar.svg"
  },
  {
    "name": "folder-down",
    "label": "Folder Down",
    "path": "folder-down.svg"
  },
  {
    "name": "folder-exclamation",
    "label": "Folder Exclamation",
    "path": "folder-exclamation.svg"
  },
  {
    "name": "folder-heart",
    "label": "Folder Heart",
    "path": "folder-heart.svg"
  },
  {
    "name": "folder-minus",
    "label": "Folder Minus",
    "path": "folder-minus.svg"
  },
  {
    "name": "folder-off",
    "label": "Folder Off",
    "path": "folder-off.svg"
  },
  {
    "name": "folder-open",
    "label": "Folder Open",
    "path": "folder-open.svg"
  },
  {
    "name": "folder-pause",
    "label": "Folder Pause",
    "path": "folder-pause.svg"
  },
  {
    "name": "folder-pin",
    "label": "Folder Pin",
    "path": "folder-pin.svg"
  },
  {
    "name": "folder-plus",
    "label": "Folder Plus",
    "path": "folder-plus.svg"
  },
  {
    "name": "folder-question",
    "label": "Folder Question",
    "path": "folder-question.svg"
  },
  {
    "name": "folder-root",
    "label": "Folder Root",
    "path": "folder-root.svg"
  },
  {
    "name": "folder-search",
    "label": "Folder Search",
    "path": "folder-search.svg"
  },
  {
    "name": "folder-share",
    "label": "Folder Share",
    "path": "folder-share.svg"
  },
  {
    "name": "folder-star",
    "label": "Folder Star",
    "path": "folder-star.svg"
  },
  {
    "name": "folder-symlink",
    "label": "Folder Symlink",
    "path": "folder-symlink.svg"
  },
  {
    "name": "folder-up",
    "label": "Folder Up",
    "path": "folder-up.svg"
  },
  {
    "name": "folder-x",
    "label": "Folder X",
    "path": "folder-x.svg"
  },
  {
    "name": "folders",
    "label": "Folders",
    "path": "folders.svg"
  },
  {
    "name": "folders-off",
    "label": "Folders Off",
    "path": "folders-off.svg"
  },
  {
    "name": "forbid",
    "label": "Forbid",
    "path": "forbid.svg"
  },
  {
    "name": "forbid-2",
    "label": "Forbid 2",
    "path": "forbid-2.svg"
  },
  {
    "name": "forklift",
    "label": "Forklift",
    "path": "forklift.svg"
  },
  {
    "name": "forms",
    "label": "Forms",
    "path": "forms.svg"
  },
  {
    "name": "fountain",
    "label": "Fountain",
    "path": "fountain.svg"
  },
  {
    "name": "fountain-off",
    "label": "Fountain Off",
    "path": "fountain-off.svg"
  },
  {
    "name": "frame",
    "label": "Frame",
    "path": "frame.svg"
  },
  {
    "name": "frame-off",
    "label": "Frame Off",
    "path": "frame-off.svg"
  },
  {
    "name": "free-rights",
    "label": "Free Rights",
    "path": "free-rights.svg"
  },
  {
    "name": "freeze-column",
    "label": "Freeze Column",
    "path": "freeze-column.svg"
  },
  {
    "name": "freeze-row",
    "label": "Freeze Row",
    "path": "freeze-row.svg"
  },
  {
    "name": "freeze-row-column",
    "label": "Freeze Row Column",
    "path": "freeze-row-column.svg"
  },
  {
    "name": "fridge",
    "label": "Fridge",
    "path": "fridge.svg"
  },
  {
    "name": "fridge-off",
    "label": "Fridge Off",
    "path": "fridge-off.svg"
  },
  {
    "name": "friends",
    "label": "Friends",
    "path": "friends.svg"
  },
  {
    "name": "friends-off",
    "label": "Friends Off",
    "path": "friends-off.svg"
  },
  {
    "name": "frustum",
    "label": "Frustum",
    "path": "frustum.svg"
  },
  {
    "name": "frustum-off",
    "label": "Frustum Off",
    "path": "frustum-off.svg"
  },
  {
    "name": "frustum-plus",
    "label": "Frustum Plus",
    "path": "frustum-plus.svg"
  },
  {
    "name": "function",
    "label": "Function",
    "path": "function.svg"
  },
  {
    "name": "function-off",
    "label": "Function Off",
    "path": "function-off.svg"
  },
  {
    "name": "galaxy",
    "label": "Galaxy",
    "path": "galaxy.svg"
  },
  {
    "name": "garden-cart",
    "label": "Garden Cart",
    "path": "garden-cart.svg"
  },
  {
    "name": "garden-cart-off",
    "label": "Garden Cart Off",
    "path": "garden-cart-off.svg"
  },
  {
    "name": "gas-station",
    "label": "Gas Station",
    "path": "gas-station.svg"
  },
  {
    "name": "gas-station-off",
    "label": "Gas Station Off",
    "path": "gas-station-off.svg"
  },
  {
    "name": "gauge",
    "label": "Gauge",
    "path": "gauge.svg"
  },
  {
    "name": "gauge-off",
    "label": "Gauge Off",
    "path": "gauge-off.svg"
  },
  {
    "name": "gavel",
    "label": "Gavel",
    "path": "gavel.svg"
  },
  {
    "name": "gender-agender",
    "label": "Gender Agender",
    "path": "gender-agender.svg"
  },
  {
    "name": "gender-androgyne",
    "label": "Gender Androgyne",
    "path": "gender-androgyne.svg"
  },
  {
    "name": "gender-bigender",
    "label": "Gender Bigender",
    "path": "gender-bigender.svg"
  },
  {
    "name": "gender-demiboy",
    "label": "Gender Demiboy",
    "path": "gender-demiboy.svg"
  },
  {
    "name": "gender-demigirl",
    "label": "Gender Demigirl",
    "path": "gender-demigirl.svg"
  },
  {
    "name": "gender-epicene",
    "label": "Gender Epicene",
    "path": "gender-epicene.svg"
  },
  {
    "name": "gender-female",
    "label": "Gender Female",
    "path": "gender-female.svg"
  },
  {
    "name": "gender-femme",
    "label": "Gender Femme",
    "path": "gender-femme.svg"
  },
  {
    "name": "gender-genderfluid",
    "label": "Gender Genderfluid",
    "path": "gender-genderfluid.svg"
  },
  {
    "name": "gender-genderless",
    "label": "Gender Genderless",
    "path": "gender-genderless.svg"
  },
  {
    "name": "gender-genderqueer",
    "label": "Gender Genderqueer",
    "path": "gender-genderqueer.svg"
  },
  {
    "name": "gender-hermaphrodite",
    "label": "Gender Hermaphrodite",
    "path": "gender-hermaphrodite.svg"
  },
  {
    "name": "gender-intergender",
    "label": "Gender Intergender",
    "path": "gender-intergender.svg"
  },
  {
    "name": "gender-male",
    "label": "Gender Male",
    "path": "gender-male.svg"
  },
  {
    "name": "gender-neutrois",
    "label": "Gender Neutrois",
    "path": "gender-neutrois.svg"
  },
  {
    "name": "gender-third",
    "label": "Gender Third",
    "path": "gender-third.svg"
  },
  {
    "name": "gender-transgender",
    "label": "Gender Transgender",
    "path": "gender-transgender.svg"
  },
  {
    "name": "gender-trasvesti",
    "label": "Gender Trasvesti",
    "path": "gender-trasvesti.svg"
  },
  {
    "name": "geometry",
    "label": "Geometry",
    "path": "geometry.svg"
  },
  {
    "name": "ghost",
    "label": "Ghost",
    "path": "ghost.svg"
  },
  {
    "name": "ghost-2",
    "label": "Ghost 2",
    "path": "ghost-2.svg"
  },
  {
    "name": "ghost-3",
    "label": "Ghost 3",
    "path": "ghost-3.svg"
  },
  {
    "name": "ghost-off",
    "label": "Ghost Off",
    "path": "ghost-off.svg"
  },
  {
    "name": "gif",
    "label": "Gif",
    "path": "gif.svg"
  },
  {
    "name": "gift",
    "label": "Gift",
    "path": "gift.svg"
  },
  {
    "name": "gift-card",
    "label": "Gift Card",
    "path": "gift-card.svg"
  },
  {
    "name": "gift-off",
    "label": "Gift Off",
    "path": "gift-off.svg"
  },
  {
    "name": "git-branch",
    "label": "Git Branch",
    "path": "git-branch.svg"
  },
  {
    "name": "git-branch-deleted",
    "label": "Git Branch Deleted",
    "path": "git-branch-deleted.svg"
  },
  {
    "name": "git-cherry-pick",
    "label": "Git Cherry Pick",
    "path": "git-cherry-pick.svg"
  },
  {
    "name": "git-commit",
    "label": "Git Commit",
    "path": "git-commit.svg"
  },
  {
    "name": "git-compare",
    "label": "Git Compare",
    "path": "git-compare.svg"
  },
  {
    "name": "git-fork",
    "label": "Git Fork",
    "path": "git-fork.svg"
  },
  {
    "name": "git-merge",
    "label": "Git Merge",
    "path": "git-merge.svg"
  },
  {
    "name": "git-pull-request",
    "label": "Git Pull Request",
    "path": "git-pull-request.svg"
  },
  {
    "name": "git-pull-request-closed",
    "label": "Git Pull Request Closed",
    "path": "git-pull-request-closed.svg"
  },
  {
    "name": "git-pull-request-draft",
    "label": "Git Pull Request Draft",
    "path": "git-pull-request-draft.svg"
  },
  {
    "name": "gizmo",
    "label": "Gizmo",
    "path": "gizmo.svg"
  },
  {
    "name": "glass",
    "label": "Glass",
    "path": "glass.svg"
  },
  {
    "name": "glass-champagne",
    "label": "Glass Champagne",
    "path": "glass-champagne.svg"
  },
  {
    "name": "glass-cocktail",
    "label": "Glass Cocktail",
    "path": "glass-cocktail.svg"
  },
  {
    "name": "glass-full",
    "label": "Glass Full",
    "path": "glass-full.svg"
  },
  {
    "name": "glass-gin",
    "label": "Glass Gin",
    "path": "glass-gin.svg"
  },
  {
    "name": "glass-off",
    "label": "Glass Off",
    "path": "glass-off.svg"
  },
  {
    "name": "globe",
    "label": "Globe",
    "path": "globe.svg"
  },
  {
    "name": "globe-off",
    "label": "Globe Off",
    "path": "globe-off.svg"
  },
  {
    "name": "go-game",
    "label": "Go Game",
    "path": "go-game.svg"
  },
  {
    "name": "golf",
    "label": "Golf",
    "path": "golf.svg"
  },
  {
    "name": "golf-off",
    "label": "Golf Off",
    "path": "golf-off.svg"
  },
  {
    "name": "gps",
    "label": "Gps",
    "path": "gps.svg"
  },
  {
    "name": "gradienter",
    "label": "Gradienter",
    "path": "gradienter.svg"
  },
  {
    "name": "grain",
    "label": "Grain",
    "path": "grain.svg"
  },
  {
    "name": "graph",
    "label": "Graph",
    "path": "graph.svg"
  },
  {
    "name": "graph-off",
    "label": "Graph Off",
    "path": "graph-off.svg"
  },
  {
    "name": "grave",
    "label": "Grave",
    "path": "grave.svg"
  },
  {
    "name": "grave-2",
    "label": "Grave 2",
    "path": "grave-2.svg"
  },
  {
    "name": "grid-3x3",
    "label": "Grid 3x3",
    "path": "grid-3x3.svg"
  },
  {
    "name": "grid-4x4",
    "label": "Grid 4x4",
    "path": "grid-4x4.svg"
  },
  {
    "name": "grid-dots",
    "label": "Grid Dots",
    "path": "grid-dots.svg"
  },
  {
    "name": "grid-goldenratio",
    "label": "Grid Goldenratio",
    "path": "grid-goldenratio.svg"
  },
  {
    "name": "grid-pattern",
    "label": "Grid Pattern",
    "path": "grid-pattern.svg"
  },
  {
    "name": "grid-scan",
    "label": "Grid Scan",
    "path": "grid-scan.svg"
  },
  {
    "name": "grill",
    "label": "Grill",
    "path": "grill.svg"
  },
  {
    "name": "grill-fork",
    "label": "Grill Fork",
    "path": "grill-fork.svg"
  },
  {
    "name": "grill-off",
    "label": "Grill Off",
    "path": "grill-off.svg"
  },
  {
    "name": "grill-spatula",
    "label": "Grill Spatula",
    "path": "grill-spatula.svg"
  },
  {
    "name": "grip-horizontal",
    "label": "Grip Horizontal",
    "path": "grip-horizontal.svg"
  },
  {
    "name": "grip-vertical",
    "label": "Grip Vertical",
    "path": "grip-vertical.svg"
  },
  {
    "name": "growth",
    "label": "Growth",
    "path": "growth.svg"
  },
  {
    "name": "guitar-pick",
    "label": "Guitar Pick",
    "path": "guitar-pick.svg"
  },
  {
    "name": "gymnastics",
    "label": "Gymnastics",
    "path": "gymnastics.svg"
  },
  {
    "name": "h-1",
    "label": "H 1",
    "path": "h-1.svg"
  },
  {
    "name": "h-2",
    "label": "H 2",
    "path": "h-2.svg"
  },
  {
    "name": "h-3",
    "label": "H 3",
    "path": "h-3.svg"
  },
  {
    "name": "h-4",
    "label": "H 4",
    "path": "h-4.svg"
  },
  {
    "name": "h-5",
    "label": "H 5",
    "path": "h-5.svg"
  },
  {
    "name": "h-6",
    "label": "H 6",
    "path": "h-6.svg"
  },
  {
    "name": "hammer",
    "label": "Hammer",
    "path": "hammer.svg"
  },
  {
    "name": "hammer-off",
    "label": "Hammer Off",
    "path": "hammer-off.svg"
  },
  {
    "name": "hand-click",
    "label": "Hand Click",
    "path": "hand-click.svg"
  },
  {
    "name": "hand-click-off",
    "label": "Hand Click Off",
    "path": "hand-click-off.svg"
  },
  {
    "name": "hand-finger",
    "label": "Hand Finger",
    "path": "hand-finger.svg"
  },
  {
    "name": "hand-finger-down",
    "label": "Hand Finger Down",
    "path": "hand-finger-down.svg"
  },
  {
    "name": "hand-finger-left",
    "label": "Hand Finger Left",
    "path": "hand-finger-left.svg"
  },
  {
    "name": "hand-finger-off",
    "label": "Hand Finger Off",
    "path": "hand-finger-off.svg"
  },
  {
    "name": "hand-finger-right",
    "label": "Hand Finger Right",
    "path": "hand-finger-right.svg"
  },
  {
    "name": "hand-grab",
    "label": "Hand Grab",
    "path": "hand-grab.svg"
  },
  {
    "name": "hand-little-finger",
    "label": "Hand Little Finger",
    "path": "hand-little-finger.svg"
  },
  {
    "name": "hand-love-you",
    "label": "Hand Love You",
    "path": "hand-love-you.svg"
  },
  {
    "name": "hand-middle-finger",
    "label": "Hand Middle Finger",
    "path": "hand-middle-finger.svg"
  },
  {
    "name": "hand-move",
    "label": "Hand Move",
    "path": "hand-move.svg"
  },
  {
    "name": "hand-off",
    "label": "Hand Off",
    "path": "hand-off.svg"
  },
  {
    "name": "hand-ring-finger",
    "label": "Hand Ring Finger",
    "path": "hand-ring-finger.svg"
  },
  {
    "name": "hand-sanitizer",
    "label": "Hand Sanitizer",
    "path": "hand-sanitizer.svg"
  },
  {
    "name": "hand-stop",
    "label": "Hand Stop",
    "path": "hand-stop.svg"
  },
  {
    "name": "hand-three-fingers",
    "label": "Hand Three Fingers",
    "path": "hand-three-fingers.svg"
  },
  {
    "name": "hand-two-fingers",
    "label": "Hand Two Fingers",
    "path": "hand-two-fingers.svg"
  },
  {
    "name": "hanger",
    "label": "Hanger",
    "path": "hanger.svg"
  },
  {
    "name": "hanger-2",
    "label": "Hanger 2",
    "path": "hanger-2.svg"
  },
  {
    "name": "hanger-off",
    "label": "Hanger Off",
    "path": "hanger-off.svg"
  },
  {
    "name": "hash",
    "label": "Hash",
    "path": "hash.svg"
  },
  {
    "name": "haze",
    "label": "Haze",
    "path": "haze.svg"
  },
  {
    "name": "haze-moon",
    "label": "Haze Moon",
    "path": "haze-moon.svg"
  },
  {
    "name": "hdr",
    "label": "Hdr",
    "path": "hdr.svg"
  },
  {
    "name": "heading",
    "label": "Heading",
    "path": "heading.svg"
  },
  {
    "name": "heading-off",
    "label": "Heading Off",
    "path": "heading-off.svg"
  },
  {
    "name": "headphones",
    "label": "Headphones",
    "path": "headphones.svg"
  },
  {
    "name": "headphones-off",
    "label": "Headphones Off",
    "path": "headphones-off.svg"
  },
  {
    "name": "headset",
    "label": "Headset",
    "path": "headset.svg"
  },
  {
    "name": "headset-off",
    "label": "Headset Off",
    "path": "headset-off.svg"
  },
  {
    "name": "health-recognition",
    "label": "Health Recognition",
    "path": "health-recognition.svg"
  },
  {
    "name": "heart",
    "label": "Heart",
    "path": "heart.svg"
  },
  {
    "name": "heart-bitcoin",
    "label": "Heart Bitcoin",
    "path": "heart-bitcoin.svg"
  },
  {
    "name": "heart-bolt",
    "label": "Heart Bolt",
    "path": "heart-bolt.svg"
  },
  {
    "name": "heart-broken",
    "label": "Heart Broken",
    "path": "heart-broken.svg"
  },
  {
    "name": "heart-cancel",
    "label": "Heart Cancel",
    "path": "heart-cancel.svg"
  },
  {
    "name": "heart-check",
    "label": "Heart Check",
    "path": "heart-check.svg"
  },
  {
    "name": "heart-code",
    "label": "Heart Code",
    "path": "heart-code.svg"
  },
  {
    "name": "heart-cog",
    "label": "Heart Cog",
    "path": "heart-cog.svg"
  },
  {
    "name": "heart-discount",
    "label": "Heart Discount",
    "path": "heart-discount.svg"
  },
  {
    "name": "heart-dollar",
    "label": "Heart Dollar",
    "path": "heart-dollar.svg"
  },
  {
    "name": "heart-down",
    "label": "Heart Down",
    "path": "heart-down.svg"
  },
  {
    "name": "heart-exclamation",
    "label": "Heart Exclamation",
    "path": "heart-exclamation.svg"
  },
  {
    "name": "heart-handshake",
    "label": "Heart Handshake",
    "path": "heart-handshake.svg"
  },
  {
    "name": "heart-minus",
    "label": "Heart Minus",
    "path": "heart-minus.svg"
  },
  {
    "name": "heart-off",
    "label": "Heart Off",
    "path": "heart-off.svg"
  },
  {
    "name": "heart-pause",
    "label": "Heart Pause",
    "path": "heart-pause.svg"
  },
  {
    "name": "heart-pin",
    "label": "Heart Pin",
    "path": "heart-pin.svg"
  },
  {
    "name": "heart-plus",
    "label": "Heart Plus",
    "path": "heart-plus.svg"
  },
  {
    "name": "heart-question",
    "label": "Heart Question",
    "path": "heart-question.svg"
  },
  {
    "name": "heart-rate-monitor",
    "label": "Heart Rate Monitor",
    "path": "heart-rate-monitor.svg"
  },
  {
    "name": "heart-search",
    "label": "Heart Search",
    "path": "heart-search.svg"
  },
  {
    "name": "heart-share",
    "label": "Heart Share",
    "path": "heart-share.svg"
  },
  {
    "name": "heart-spark",
    "label": "Heart Spark",
    "path": "heart-spark.svg"
  },
  {
    "name": "heart-star",
    "label": "Heart Star",
    "path": "heart-star.svg"
  },
  {
    "name": "heart-up",
    "label": "Heart Up",
    "path": "heart-up.svg"
  },
  {
    "name": "heart-x",
    "label": "Heart X",
    "path": "heart-x.svg"
  },
  {
    "name": "heartbeat",
    "label": "Heartbeat",
    "path": "heartbeat.svg"
  },
  {
    "name": "hearts",
    "label": "Hearts",
    "path": "hearts.svg"
  },
  {
    "name": "hearts-off",
    "label": "Hearts Off",
    "path": "hearts-off.svg"
  },
  {
    "name": "helicopter",
    "label": "Helicopter",
    "path": "helicopter.svg"
  },
  {
    "name": "helicopter-landing",
    "label": "Helicopter Landing",
    "path": "helicopter-landing.svg"
  },
  {
    "name": "helmet",
    "label": "Helmet",
    "path": "helmet.svg"
  },
  {
    "name": "helmet-off",
    "label": "Helmet Off",
    "path": "helmet-off.svg"
  },
  {
    "name": "help",
    "label": "Help",
    "path": "help.svg"
  },
  {
    "name": "help-circle",
    "label": "Help Circle",
    "path": "help-circle.svg"
  },
  {
    "name": "help-hexagon",
    "label": "Help Hexagon",
    "path": "help-hexagon.svg"
  },
  {
    "name": "help-octagon",
    "label": "Help Octagon",
    "path": "help-octagon.svg"
  },
  {
    "name": "help-off",
    "label": "Help Off",
    "path": "help-off.svg"
  },
  {
    "name": "help-small",
    "label": "Help Small",
    "path": "help-small.svg"
  },
  {
    "name": "help-square",
    "label": "Help Square",
    "path": "help-square.svg"
  },
  {
    "name": "help-square-rounded",
    "label": "Help Square Rounded",
    "path": "help-square-rounded.svg"
  },
  {
    "name": "help-triangle",
    "label": "Help Triangle",
    "path": "help-triangle.svg"
  },
  {
    "name": "hemisphere",
    "label": "Hemisphere",
    "path": "hemisphere.svg"
  },
  {
    "name": "hemisphere-off",
    "label": "Hemisphere Off",
    "path": "hemisphere-off.svg"
  },
  {
    "name": "hemisphere-plus",
    "label": "Hemisphere Plus",
    "path": "hemisphere-plus.svg"
  },
  {
    "name": "hexagon",
    "label": "Hexagon",
    "path": "hexagon.svg"
  },
  {
    "name": "hexagon-3d",
    "label": "Hexagon 3d",
    "path": "hexagon-3d.svg"
  },
  {
    "name": "hexagon-asterisk",
    "label": "Hexagon Asterisk",
    "path": "hexagon-asterisk.svg"
  },
  {
    "name": "hexagon-letter-a",
    "label": "Hexagon Letter A",
    "path": "hexagon-letter-a.svg"
  },
  {
    "name": "hexagon-letter-b",
    "label": "Hexagon Letter B",
    "path": "hexagon-letter-b.svg"
  },
  {
    "name": "hexagon-letter-c",
    "label": "Hexagon Letter C",
    "path": "hexagon-letter-c.svg"
  },
  {
    "name": "hexagon-letter-d",
    "label": "Hexagon Letter D",
    "path": "hexagon-letter-d.svg"
  },
  {
    "name": "hexagon-letter-e",
    "label": "Hexagon Letter E",
    "path": "hexagon-letter-e.svg"
  },
  {
    "name": "hexagon-letter-f",
    "label": "Hexagon Letter F",
    "path": "hexagon-letter-f.svg"
  },
  {
    "name": "hexagon-letter-g",
    "label": "Hexagon Letter G",
    "path": "hexagon-letter-g.svg"
  },
  {
    "name": "hexagon-letter-h",
    "label": "Hexagon Letter H",
    "path": "hexagon-letter-h.svg"
  },
  {
    "name": "hexagon-letter-i",
    "label": "Hexagon Letter I",
    "path": "hexagon-letter-i.svg"
  },
  {
    "name": "hexagon-letter-j",
    "label": "Hexagon Letter J",
    "path": "hexagon-letter-j.svg"
  },
  {
    "name": "hexagon-letter-k",
    "label": "Hexagon Letter K",
    "path": "hexagon-letter-k.svg"
  },
  {
    "name": "hexagon-letter-l",
    "label": "Hexagon Letter L",
    "path": "hexagon-letter-l.svg"
  },
  {
    "name": "hexagon-letter-m",
    "label": "Hexagon Letter M",
    "path": "hexagon-letter-m.svg"
  },
  {
    "name": "hexagon-letter-n",
    "label": "Hexagon Letter N",
    "path": "hexagon-letter-n.svg"
  },
  {
    "name": "hexagon-letter-o",
    "label": "Hexagon Letter O",
    "path": "hexagon-letter-o.svg"
  },
  {
    "name": "hexagon-letter-p",
    "label": "Hexagon Letter P",
    "path": "hexagon-letter-p.svg"
  },
  {
    "name": "hexagon-letter-q",
    "label": "Hexagon Letter Q",
    "path": "hexagon-letter-q.svg"
  },
  {
    "name": "hexagon-letter-r",
    "label": "Hexagon Letter R",
    "path": "hexagon-letter-r.svg"
  },
  {
    "name": "hexagon-letter-s",
    "label": "Hexagon Letter S",
    "path": "hexagon-letter-s.svg"
  },
  {
    "name": "hexagon-letter-t",
    "label": "Hexagon Letter T",
    "path": "hexagon-letter-t.svg"
  },
  {
    "name": "hexagon-letter-u",
    "label": "Hexagon Letter U",
    "path": "hexagon-letter-u.svg"
  },
  {
    "name": "hexagon-letter-v",
    "label": "Hexagon Letter V",
    "path": "hexagon-letter-v.svg"
  },
  {
    "name": "hexagon-letter-w",
    "label": "Hexagon Letter W",
    "path": "hexagon-letter-w.svg"
  },
  {
    "name": "hexagon-letter-x",
    "label": "Hexagon Letter X",
    "path": "hexagon-letter-x.svg"
  },
  {
    "name": "hexagon-letter-y",
    "label": "Hexagon Letter Y",
    "path": "hexagon-letter-y.svg"
  },
  {
    "name": "hexagon-letter-z",
    "label": "Hexagon Letter Z",
    "path": "hexagon-letter-z.svg"
  },
  {
    "name": "hexagon-minus",
    "label": "Hexagon Minus",
    "path": "hexagon-minus.svg"
  },
  {
    "name": "hexagon-minus-2",
    "label": "Hexagon Minus 2",
    "path": "hexagon-minus-2.svg"
  },
  {
    "name": "hexagon-number-0",
    "label": "Hexagon Number 0",
    "path": "hexagon-number-0.svg"
  },
  {
    "name": "hexagon-number-1",
    "label": "Hexagon Number 1",
    "path": "hexagon-number-1.svg"
  },
  {
    "name": "hexagon-number-2",
    "label": "Hexagon Number 2",
    "path": "hexagon-number-2.svg"
  },
  {
    "name": "hexagon-number-3",
    "label": "Hexagon Number 3",
    "path": "hexagon-number-3.svg"
  },
  {
    "name": "hexagon-number-4",
    "label": "Hexagon Number 4",
    "path": "hexagon-number-4.svg"
  },
  {
    "name": "hexagon-number-5",
    "label": "Hexagon Number 5",
    "path": "hexagon-number-5.svg"
  },
  {
    "name": "hexagon-number-6",
    "label": "Hexagon Number 6",
    "path": "hexagon-number-6.svg"
  },
  {
    "name": "hexagon-number-7",
    "label": "Hexagon Number 7",
    "path": "hexagon-number-7.svg"
  },
  {
    "name": "hexagon-number-8",
    "label": "Hexagon Number 8",
    "path": "hexagon-number-8.svg"
  },
  {
    "name": "hexagon-number-9",
    "label": "Hexagon Number 9",
    "path": "hexagon-number-9.svg"
  },
  {
    "name": "hexagon-off",
    "label": "Hexagon Off",
    "path": "hexagon-off.svg"
  },
  {
    "name": "hexagon-plus",
    "label": "Hexagon Plus",
    "path": "hexagon-plus.svg"
  },
  {
    "name": "hexagon-plus-2",
    "label": "Hexagon Plus 2",
    "path": "hexagon-plus-2.svg"
  },
  {
    "name": "hexagonal-prism",
    "label": "Hexagonal Prism",
    "path": "hexagonal-prism.svg"
  },
  {
    "name": "hexagonal-prism-off",
    "label": "Hexagonal Prism Off",
    "path": "hexagonal-prism-off.svg"
  },
  {
    "name": "hexagonal-prism-plus",
    "label": "Hexagonal Prism Plus",
    "path": "hexagonal-prism-plus.svg"
  },
  {
    "name": "hexagonal-pyramid",
    "label": "Hexagonal Pyramid",
    "path": "hexagonal-pyramid.svg"
  },
  {
    "name": "hexagonal-pyramid-off",
    "label": "Hexagonal Pyramid Off",
    "path": "hexagonal-pyramid-off.svg"
  },
  {
    "name": "hexagonal-pyramid-plus",
    "label": "Hexagonal Pyramid Plus",
    "path": "hexagonal-pyramid-plus.svg"
  },
  {
    "name": "hexagons",
    "label": "Hexagons",
    "path": "hexagons.svg"
  },
  {
    "name": "hexagons-off",
    "label": "Hexagons Off",
    "path": "hexagons-off.svg"
  },
  {
    "name": "hierarchy",
    "label": "Hierarchy",
    "path": "hierarchy.svg"
  },
  {
    "name": "hierarchy-2",
    "label": "Hierarchy 2",
    "path": "hierarchy-2.svg"
  },
  {
    "name": "hierarchy-3",
    "label": "Hierarchy 3",
    "path": "hierarchy-3.svg"
  },
  {
    "name": "hierarchy-off",
    "label": "Hierarchy Off",
    "path": "hierarchy-off.svg"
  },
  {
    "name": "highlight",
    "label": "Highlight",
    "path": "highlight.svg"
  },
  {
    "name": "highlight-off",
    "label": "Highlight Off",
    "path": "highlight-off.svg"
  },
  {
    "name": "history",
    "label": "History",
    "path": "history.svg"
  },
  {
    "name": "history-off",
    "label": "History Off",
    "path": "history-off.svg"
  },
  {
    "name": "history-toggle",
    "label": "History Toggle",
    "path": "history-toggle.svg"
  },
  {
    "name": "home",
    "label": "Home",
    "path": "home.svg"
  },
  {
    "name": "home-2",
    "label": "Home 2",
    "path": "home-2.svg"
  },
  {
    "name": "home-bitcoin",
    "label": "Home Bitcoin",
    "path": "home-bitcoin.svg"
  },
  {
    "name": "home-bolt",
    "label": "Home Bolt",
    "path": "home-bolt.svg"
  },
  {
    "name": "home-cancel",
    "label": "Home Cancel",
    "path": "home-cancel.svg"
  },
  {
    "name": "home-check",
    "label": "Home Check",
    "path": "home-check.svg"
  },
  {
    "name": "home-cog",
    "label": "Home Cog",
    "path": "home-cog.svg"
  },
  {
    "name": "home-dollar",
    "label": "Home Dollar",
    "path": "home-dollar.svg"
  },
  {
    "name": "home-dot",
    "label": "Home Dot",
    "path": "home-dot.svg"
  },
  {
    "name": "home-down",
    "label": "Home Down",
    "path": "home-down.svg"
  },
  {
    "name": "home-eco",
    "label": "Home Eco",
    "path": "home-eco.svg"
  },
  {
    "name": "home-edit",
    "label": "Home Edit",
    "path": "home-edit.svg"
  },
  {
    "name": "home-exclamation",
    "label": "Home Exclamation",
    "path": "home-exclamation.svg"
  },
  {
    "name": "home-hand",
    "label": "Home Hand",
    "path": "home-hand.svg"
  },
  {
    "name": "home-heart",
    "label": "Home Heart",
    "path": "home-heart.svg"
  },
  {
    "name": "home-infinity",
    "label": "Home Infinity",
    "path": "home-infinity.svg"
  },
  {
    "name": "home-link",
    "label": "Home Link",
    "path": "home-link.svg"
  },
  {
    "name": "home-minus",
    "label": "Home Minus",
    "path": "home-minus.svg"
  },
  {
    "name": "home-move",
    "label": "Home Move",
    "path": "home-move.svg"
  },
  {
    "name": "home-off",
    "label": "Home Off",
    "path": "home-off.svg"
  },
  {
    "name": "home-plus",
    "label": "Home Plus",
    "path": "home-plus.svg"
  },
  {
    "name": "home-question",
    "label": "Home Question",
    "path": "home-question.svg"
  },
  {
    "name": "home-ribbon",
    "label": "Home Ribbon",
    "path": "home-ribbon.svg"
  },
  {
    "name": "home-search",
    "label": "Home Search",
    "path": "home-search.svg"
  },
  {
    "name": "home-share",
    "label": "Home Share",
    "path": "home-share.svg"
  },
  {
    "name": "home-shield",
    "label": "Home Shield",
    "path": "home-shield.svg"
  },
  {
    "name": "home-signal",
    "label": "Home Signal",
    "path": "home-signal.svg"
  },
  {
    "name": "home-spark",
    "label": "Home Spark",
    "path": "home-spark.svg"
  },
  {
    "name": "home-star",
    "label": "Home Star",
    "path": "home-star.svg"
  },
  {
    "name": "home-stats",
    "label": "Home Stats",
    "path": "home-stats.svg"
  },
  {
    "name": "home-up",
    "label": "Home Up",
    "path": "home-up.svg"
  },
  {
    "name": "home-x",
    "label": "Home X",
    "path": "home-x.svg"
  },
  {
    "name": "horse",
    "label": "Horse",
    "path": "horse.svg"
  },
  {
    "name": "horse-toy",
    "label": "Horse Toy",
    "path": "horse-toy.svg"
  },
  {
    "name": "horseshoe",
    "label": "Horseshoe",
    "path": "horseshoe.svg"
  },
  {
    "name": "hospital",
    "label": "Hospital",
    "path": "hospital.svg"
  },
  {
    "name": "hospital-circle",
    "label": "Hospital Circle",
    "path": "hospital-circle.svg"
  },
  {
    "name": "hotel-service",
    "label": "Hotel Service",
    "path": "hotel-service.svg"
  },
  {
    "name": "hourglass",
    "label": "Hourglass",
    "path": "hourglass.svg"
  },
  {
    "name": "hourglass-empty",
    "label": "Hourglass Empty",
    "path": "hourglass-empty.svg"
  },
  {
    "name": "hourglass-high",
    "label": "Hourglass High",
    "path": "hourglass-high.svg"
  },
  {
    "name": "hourglass-low",
    "label": "Hourglass Low",
    "path": "hourglass-low.svg"
  },
  {
    "name": "hourglass-off",
    "label": "Hourglass Off",
    "path": "hourglass-off.svg"
  },
  {
    "name": "hours-12",
    "label": "Hours 12",
    "path": "hours-12.svg"
  },
  {
    "name": "hours-24",
    "label": "Hours 24",
    "path": "hours-24.svg"
  },
  {
    "name": "html",
    "label": "Html",
    "path": "html.svg"
  },
  {
    "name": "http-connect",
    "label": "Http Connect",
    "path": "http-connect.svg"
  },
  {
    "name": "http-connect-off",
    "label": "Http Connect Off",
    "path": "http-connect-off.svg"
  },
  {
    "name": "http-delete",
    "label": "Http Delete",
    "path": "http-delete.svg"
  },
  {
    "name": "http-delete-off",
    "label": "Http Delete Off",
    "path": "http-delete-off.svg"
  },
  {
    "name": "http-get",
    "label": "Http Get",
    "path": "http-get.svg"
  },
  {
    "name": "http-get-off",
    "label": "Http Get Off",
    "path": "http-get-off.svg"
  },
  {
    "name": "http-head",
    "label": "Http Head",
    "path": "http-head.svg"
  },
  {
    "name": "http-head-off",
    "label": "Http Head Off",
    "path": "http-head-off.svg"
  },
  {
    "name": "http-options",
    "label": "Http Options",
    "path": "http-options.svg"
  },
  {
    "name": "http-options-off",
    "label": "Http Options Off",
    "path": "http-options-off.svg"
  },
  {
    "name": "http-patch",
    "label": "Http Patch",
    "path": "http-patch.svg"
  },
  {
    "name": "http-patch-off",
    "label": "Http Patch Off",
    "path": "http-patch-off.svg"
  },
  {
    "name": "http-post",
    "label": "Http Post",
    "path": "http-post.svg"
  },
  {
    "name": "http-post-off",
    "label": "Http Post Off",
    "path": "http-post-off.svg"
  },
  {
    "name": "http-put",
    "label": "Http Put",
    "path": "http-put.svg"
  },
  {
    "name": "http-put-off",
    "label": "Http Put Off",
    "path": "http-put-off.svg"
  },
  {
    "name": "http-que",
    "label": "Http Que",
    "path": "http-que.svg"
  },
  {
    "name": "http-que-off",
    "label": "Http Que Off",
    "path": "http-que-off.svg"
  },
  {
    "name": "http-trace",
    "label": "Http Trace",
    "path": "http-trace.svg"
  },
  {
    "name": "http-trace-off",
    "label": "Http Trace Off",
    "path": "http-trace-off.svg"
  },
  {
    "name": "ice-cream",
    "label": "Ice Cream",
    "path": "ice-cream.svg"
  },
  {
    "name": "ice-cream-2",
    "label": "Ice Cream 2",
    "path": "ice-cream-2.svg"
  },
  {
    "name": "ice-cream-off",
    "label": "Ice Cream Off",
    "path": "ice-cream-off.svg"
  },
  {
    "name": "ice-skating",
    "label": "Ice Skating",
    "path": "ice-skating.svg"
  },
  {
    "name": "icons",
    "label": "Icons",
    "path": "icons.svg"
  },
  {
    "name": "icons-off",
    "label": "Icons Off",
    "path": "icons-off.svg"
  },
  {
    "name": "id",
    "label": "Id",
    "path": "id.svg"
  },
  {
    "name": "id-badge",
    "label": "Id Badge",
    "path": "id-badge.svg"
  },
  {
    "name": "id-badge-2",
    "label": "Id Badge 2",
    "path": "id-badge-2.svg"
  },
  {
    "name": "id-badge-off",
    "label": "Id Badge Off",
    "path": "id-badge-off.svg"
  },
  {
    "name": "id-off",
    "label": "Id Off",
    "path": "id-off.svg"
  },
  {
    "name": "ikosaedr",
    "label": "Ikosaedr",
    "path": "ikosaedr.svg"
  },
  {
    "name": "image-in-picture",
    "label": "Image In Picture",
    "path": "image-in-picture.svg"
  },
  {
    "name": "inbox",
    "label": "Inbox",
    "path": "inbox.svg"
  },
  {
    "name": "inbox-off",
    "label": "Inbox Off",
    "path": "inbox-off.svg"
  },
  {
    "name": "indent-decrease",
    "label": "Indent Decrease",
    "path": "indent-decrease.svg"
  },
  {
    "name": "indent-increase",
    "label": "Indent Increase",
    "path": "indent-increase.svg"
  },
  {
    "name": "infinity",
    "label": "Infinity",
    "path": "infinity.svg"
  },
  {
    "name": "infinity-off",
    "label": "Infinity Off",
    "path": "infinity-off.svg"
  },
  {
    "name": "info-circle",
    "label": "Info Circle",
    "path": "info-circle.svg"
  },
  {
    "name": "info-hexagon",
    "label": "Info Hexagon",
    "path": "info-hexagon.svg"
  },
  {
    "name": "info-octagon",
    "label": "Info Octagon",
    "path": "info-octagon.svg"
  },
  {
    "name": "info-small",
    "label": "Info Small",
    "path": "info-small.svg"
  },
  {
    "name": "info-square",
    "label": "Info Square",
    "path": "info-square.svg"
  },
  {
    "name": "info-square-rounded",
    "label": "Info Square Rounded",
    "path": "info-square-rounded.svg"
  },
  {
    "name": "info-triangle",
    "label": "Info Triangle",
    "path": "info-triangle.svg"
  },
  {
    "name": "inner-shadow-bottom",
    "label": "Inner Shadow Bottom",
    "path": "inner-shadow-bottom.svg"
  },
  {
    "name": "inner-shadow-bottom-left",
    "label": "Inner Shadow Bottom Left",
    "path": "inner-shadow-bottom-left.svg"
  },
  {
    "name": "inner-shadow-bottom-right",
    "label": "Inner Shadow Bottom Right",
    "path": "inner-shadow-bottom-right.svg"
  },
  {
    "name": "inner-shadow-left",
    "label": "Inner Shadow Left",
    "path": "inner-shadow-left.svg"
  },
  {
    "name": "inner-shadow-right",
    "label": "Inner Shadow Right",
    "path": "inner-shadow-right.svg"
  },
  {
    "name": "inner-shadow-top",
    "label": "Inner Shadow Top",
    "path": "inner-shadow-top.svg"
  },
  {
    "name": "inner-shadow-top-left",
    "label": "Inner Shadow Top Left",
    "path": "inner-shadow-top-left.svg"
  },
  {
    "name": "inner-shadow-top-right",
    "label": "Inner Shadow Top Right",
    "path": "inner-shadow-top-right.svg"
  },
  {
    "name": "input-ai",
    "label": "Input Ai",
    "path": "input-ai.svg"
  },
  {
    "name": "input-check",
    "label": "Input Check",
    "path": "input-check.svg"
  },
  {
    "name": "input-search",
    "label": "Input Search",
    "path": "input-search.svg"
  },
  {
    "name": "input-spark",
    "label": "Input Spark",
    "path": "input-spark.svg"
  },
  {
    "name": "input-x",
    "label": "Input X",
    "path": "input-x.svg"
  },
  {
    "name": "invoice",
    "label": "Invoice",
    "path": "invoice.svg"
  },
  {
    "name": "ironing",
    "label": "Ironing",
    "path": "ironing.svg"
  },
  {
    "name": "ironing-1",
    "label": "Ironing 1",
    "path": "ironing-1.svg"
  },
  {
    "name": "ironing-2",
    "label": "Ironing 2",
    "path": "ironing-2.svg"
  },
  {
    "name": "ironing-3",
    "label": "Ironing 3",
    "path": "ironing-3.svg"
  },
  {
    "name": "ironing-off",
    "label": "Ironing Off",
    "path": "ironing-off.svg"
  },
  {
    "name": "ironing-steam",
    "label": "Ironing Steam",
    "path": "ironing-steam.svg"
  },
  {
    "name": "ironing-steam-off",
    "label": "Ironing Steam Off",
    "path": "ironing-steam-off.svg"
  },
  {
    "name": "irregular-polyhedron",
    "label": "Irregular Polyhedron",
    "path": "irregular-polyhedron.svg"
  },
  {
    "name": "irregular-polyhedron-off",
    "label": "Irregular Polyhedron Off",
    "path": "irregular-polyhedron-off.svg"
  },
  {
    "name": "irregular-polyhedron-plus",
    "label": "Irregular Polyhedron Plus",
    "path": "irregular-polyhedron-plus.svg"
  },
  {
    "name": "italic",
    "label": "Italic",
    "path": "italic.svg"
  },
  {
    "name": "jacket",
    "label": "Jacket",
    "path": "jacket.svg"
  },
  {
    "name": "jetpack",
    "label": "Jetpack",
    "path": "jetpack.svg"
  },
  {
    "name": "jewish-star",
    "label": "Jewish Star",
    "path": "jewish-star.svg"
  },
  {
    "name": "join-bevel",
    "label": "Join Bevel",
    "path": "join-bevel.svg"
  },
  {
    "name": "join-round",
    "label": "Join Round",
    "path": "join-round.svg"
  },
  {
    "name": "join-straight",
    "label": "Join Straight",
    "path": "join-straight.svg"
  },
  {
    "name": "joker",
    "label": "Joker",
    "path": "joker.svg"
  },
  {
    "name": "jpg",
    "label": "Jpg",
    "path": "jpg.svg"
  },
  {
    "name": "json",
    "label": "Json",
    "path": "json.svg"
  },
  {
    "name": "jump-rope",
    "label": "Jump Rope",
    "path": "jump-rope.svg"
  },
  {
    "name": "karate",
    "label": "Karate",
    "path": "karate.svg"
  },
  {
    "name": "kayak",
    "label": "Kayak",
    "path": "kayak.svg"
  },
  {
    "name": "kerning",
    "label": "Kerning",
    "path": "kerning.svg"
  },
  {
    "name": "key",
    "label": "Key",
    "path": "key.svg"
  },
  {
    "name": "key-off",
    "label": "Key Off",
    "path": "key-off.svg"
  },
  {
    "name": "keyboard",
    "label": "Keyboard",
    "path": "keyboard.svg"
  },
  {
    "name": "keyboard-hide",
    "label": "Keyboard Hide",
    "path": "keyboard-hide.svg"
  },
  {
    "name": "keyboard-off",
    "label": "Keyboard Off",
    "path": "keyboard-off.svg"
  },
  {
    "name": "keyboard-show",
    "label": "Keyboard Show",
    "path": "keyboard-show.svg"
  },
  {
    "name": "keyframe",
    "label": "Keyframe",
    "path": "keyframe.svg"
  },
  {
    "name": "keyframe-align-center",
    "label": "Keyframe Align Center",
    "path": "keyframe-align-center.svg"
  },
  {
    "name": "keyframe-align-horizontal",
    "label": "Keyframe Align Horizontal",
    "path": "keyframe-align-horizontal.svg"
  },
  {
    "name": "keyframe-align-vertical",
    "label": "Keyframe Align Vertical",
    "path": "keyframe-align-vertical.svg"
  },
  {
    "name": "keyframes",
    "label": "Keyframes",
    "path": "keyframes.svg"
  },
  {
    "name": "label",
    "label": "Label",
    "path": "label.svg"
  },
  {
    "name": "label-important",
    "label": "Label Important",
    "path": "label-important.svg"
  },
  {
    "name": "label-off",
    "label": "Label Off",
    "path": "label-off.svg"
  },
  {
    "name": "ladder",
    "label": "Ladder",
    "path": "ladder.svg"
  },
  {
    "name": "ladder-off",
    "label": "Ladder Off",
    "path": "ladder-off.svg"
  },
  {
    "name": "ladle",
    "label": "Ladle",
    "path": "ladle.svg"
  },
  {
    "name": "lambda",
    "label": "Lambda",
    "path": "lambda.svg"
  },
  {
    "name": "lamp",
    "label": "Lamp",
    "path": "lamp.svg"
  },
  {
    "name": "lamp-2",
    "label": "Lamp 2",
    "path": "lamp-2.svg"
  },
  {
    "name": "lamp-off",
    "label": "Lamp Off",
    "path": "lamp-off.svg"
  },
  {
    "name": "lane",
    "label": "Lane",
    "path": "lane.svg"
  },
  {
    "name": "language",
    "label": "Language",
    "path": "language.svg"
  },
  {
    "name": "language-hiragana",
    "label": "Language Hiragana",
    "path": "language-hiragana.svg"
  },
  {
    "name": "language-katakana",
    "label": "Language Katakana",
    "path": "language-katakana.svg"
  },
  {
    "name": "language-off",
    "label": "Language Off",
    "path": "language-off.svg"
  },
  {
    "name": "lasso",
    "label": "Lasso",
    "path": "lasso.svg"
  },
  {
    "name": "lasso-off",
    "label": "Lasso Off",
    "path": "lasso-off.svg"
  },
  {
    "name": "lasso-polygon",
    "label": "Lasso Polygon",
    "path": "lasso-polygon.svg"
  },
  {
    "name": "laurel-wreath",
    "label": "Laurel Wreath",
    "path": "laurel-wreath.svg"
  },
  {
    "name": "laurel-wreath-1",
    "label": "Laurel Wreath 1",
    "path": "laurel-wreath-1.svg"
  },
  {
    "name": "laurel-wreath-2",
    "label": "Laurel Wreath 2",
    "path": "laurel-wreath-2.svg"
  },
  {
    "name": "laurel-wreath-3",
    "label": "Laurel Wreath 3",
    "path": "laurel-wreath-3.svg"
  },
  {
    "name": "layers-difference",
    "label": "Layers Difference",
    "path": "layers-difference.svg"
  },
  {
    "name": "layers-intersect",
    "label": "Layers Intersect",
    "path": "layers-intersect.svg"
  },
  {
    "name": "layers-intersect-2",
    "label": "Layers Intersect 2",
    "path": "layers-intersect-2.svg"
  },
  {
    "name": "layers-linked",
    "label": "Layers Linked",
    "path": "layers-linked.svg"
  },
  {
    "name": "layers-off",
    "label": "Layers Off",
    "path": "layers-off.svg"
  },
  {
    "name": "layers-selected",
    "label": "Layers Selected",
    "path": "layers-selected.svg"
  },
  {
    "name": "layers-selected-bottom",
    "label": "Layers Selected Bottom",
    "path": "layers-selected-bottom.svg"
  },
  {
    "name": "layers-subtract",
    "label": "Layers Subtract",
    "path": "layers-subtract.svg"
  },
  {
    "name": "layers-union",
    "label": "Layers Union",
    "path": "layers-union.svg"
  },
  {
    "name": "layout",
    "label": "Layout",
    "path": "layout.svg"
  },
  {
    "name": "layout-2",
    "label": "Layout 2",
    "path": "layout-2.svg"
  },
  {
    "name": "layout-align-bottom",
    "label": "Layout Align Bottom",
    "path": "layout-align-bottom.svg"
  },
  {
    "name": "layout-align-center",
    "label": "Layout Align Center",
    "path": "layout-align-center.svg"
  },
  {
    "name": "layout-align-left",
    "label": "Layout Align Left",
    "path": "layout-align-left.svg"
  },
  {
    "name": "layout-align-middle",
    "label": "Layout Align Middle",
    "path": "layout-align-middle.svg"
  },
  {
    "name": "layout-align-right",
    "label": "Layout Align Right",
    "path": "layout-align-right.svg"
  },
  {
    "name": "layout-align-top",
    "label": "Layout Align Top",
    "path": "layout-align-top.svg"
  },
  {
    "name": "layout-board",
    "label": "Layout Board",
    "path": "layout-board.svg"
  },
  {
    "name": "layout-board-split",
    "label": "Layout Board Split",
    "path": "layout-board-split.svg"
  },
  {
    "name": "layout-bottombar",
    "label": "Layout Bottombar",
    "path": "layout-bottombar.svg"
  },
  {
    "name": "layout-bottombar-collapse",
    "label": "Layout Bottombar Collapse",
    "path": "layout-bottombar-collapse.svg"
  },
  {
    "name": "layout-bottombar-expand",
    "label": "Layout Bottombar Expand",
    "path": "layout-bottombar-expand.svg"
  },
  {
    "name": "layout-bottombar-inactive",
    "label": "Layout Bottombar Inactive",
    "path": "layout-bottombar-inactive.svg"
  },
  {
    "name": "layout-cards",
    "label": "Layout Cards",
    "path": "layout-cards.svg"
  },
  {
    "name": "layout-collage",
    "label": "Layout Collage",
    "path": "layout-collage.svg"
  },
  {
    "name": "layout-columns",
    "label": "Layout Columns",
    "path": "layout-columns.svg"
  },
  {
    "name": "layout-dashboard",
    "label": "Layout Dashboard",
    "path": "layout-dashboard.svg"
  },
  {
    "name": "layout-distribute-horizontal",
    "label": "Layout Distribute Horizontal",
    "path": "layout-distribute-horizontal.svg"
  },
  {
    "name": "layout-distribute-vertical",
    "label": "Layout Distribute Vertical",
    "path": "layout-distribute-vertical.svg"
  },
  {
    "name": "layout-grid",
    "label": "Layout Grid",
    "path": "layout-grid.svg"
  },
  {
    "name": "layout-grid-add",
    "label": "Layout Grid Add",
    "path": "layout-grid-add.svg"
  },
  {
    "name": "layout-grid-remove",
    "label": "Layout Grid Remove",
    "path": "layout-grid-remove.svg"
  },
  {
    "name": "layout-kanban",
    "label": "Layout Kanban",
    "path": "layout-kanban.svg"
  },
  {
    "name": "layout-list",
    "label": "Layout List",
    "path": "layout-list.svg"
  },
  {
    "name": "layout-navbar",
    "label": "Layout Navbar",
    "path": "layout-navbar.svg"
  },
  {
    "name": "layout-navbar-collapse",
    "label": "Layout Navbar Collapse",
    "path": "layout-navbar-collapse.svg"
  },
  {
    "name": "layout-navbar-expand",
    "label": "Layout Navbar Expand",
    "path": "layout-navbar-expand.svg"
  },
  {
    "name": "layout-navbar-inactive",
    "label": "Layout Navbar Inactive",
    "path": "layout-navbar-inactive.svg"
  },
  {
    "name": "layout-off",
    "label": "Layout Off",
    "path": "layout-off.svg"
  },
  {
    "name": "layout-rows",
    "label": "Layout Rows",
    "path": "layout-rows.svg"
  },
  {
    "name": "layout-sidebar",
    "label": "Layout Sidebar",
    "path": "layout-sidebar.svg"
  },
  {
    "name": "layout-sidebar-inactive",
    "label": "Layout Sidebar Inactive",
    "path": "layout-sidebar-inactive.svg"
  },
  {
    "name": "layout-sidebar-left-collapse",
    "label": "Layout Sidebar Left Collapse",
    "path": "layout-sidebar-left-collapse.svg"
  },
  {
    "name": "layout-sidebar-left-expand",
    "label": "Layout Sidebar Left Expand",
    "path": "layout-sidebar-left-expand.svg"
  },
  {
    "name": "layout-sidebar-right",
    "label": "Layout Sidebar Right",
    "path": "layout-sidebar-right.svg"
  },
  {
    "name": "layout-sidebar-right-collapse",
    "label": "Layout Sidebar Right Collapse",
    "path": "layout-sidebar-right-collapse.svg"
  },
  {
    "name": "layout-sidebar-right-expand",
    "label": "Layout Sidebar Right Expand",
    "path": "layout-sidebar-right-expand.svg"
  },
  {
    "name": "layout-sidebar-right-inactive",
    "label": "Layout Sidebar Right Inactive",
    "path": "layout-sidebar-right-inactive.svg"
  },
  {
    "name": "leaf",
    "label": "Leaf",
    "path": "leaf.svg"
  },
  {
    "name": "leaf-2",
    "label": "Leaf 2",
    "path": "leaf-2.svg"
  },
  {
    "name": "leaf-off",
    "label": "Leaf Off",
    "path": "leaf-off.svg"
  },
  {
    "name": "lego",
    "label": "Lego",
    "path": "lego.svg"
  },
  {
    "name": "lego-off",
    "label": "Lego Off",
    "path": "lego-off.svg"
  },
  {
    "name": "lemon",
    "label": "Lemon",
    "path": "lemon.svg"
  },
  {
    "name": "lemon-2",
    "label": "Lemon 2",
    "path": "lemon-2.svg"
  },
  {
    "name": "letter-a",
    "label": "Letter A",
    "path": "letter-a.svg"
  },
  {
    "name": "letter-a-small",
    "label": "Letter A Small",
    "path": "letter-a-small.svg"
  },
  {
    "name": "letter-b",
    "label": "Letter B",
    "path": "letter-b.svg"
  },
  {
    "name": "letter-b-small",
    "label": "Letter B Small",
    "path": "letter-b-small.svg"
  },
  {
    "name": "letter-c",
    "label": "Letter C",
    "path": "letter-c.svg"
  },
  {
    "name": "letter-c-small",
    "label": "Letter C Small",
    "path": "letter-c-small.svg"
  },
  {
    "name": "letter-case",
    "label": "Letter Case",
    "path": "letter-case.svg"
  },
  {
    "name": "letter-case-lower",
    "label": "Letter Case Lower",
    "path": "letter-case-lower.svg"
  },
  {
    "name": "letter-case-toggle",
    "label": "Letter Case Toggle",
    "path": "letter-case-toggle.svg"
  },
  {
    "name": "letter-case-upper",
    "label": "Letter Case Upper",
    "path": "letter-case-upper.svg"
  },
  {
    "name": "letter-d",
    "label": "Letter D",
    "path": "letter-d.svg"
  },
  {
    "name": "letter-d-small",
    "label": "Letter D Small",
    "path": "letter-d-small.svg"
  },
  {
    "name": "letter-e",
    "label": "Letter E",
    "path": "letter-e.svg"
  },
  {
    "name": "letter-e-small",
    "label": "Letter E Small",
    "path": "letter-e-small.svg"
  },
  {
    "name": "letter-f",
    "label": "Letter F",
    "path": "letter-f.svg"
  },
  {
    "name": "letter-f-small",
    "label": "Letter F Small",
    "path": "letter-f-small.svg"
  },
  {
    "name": "letter-g",
    "label": "Letter G",
    "path": "letter-g.svg"
  },
  {
    "name": "letter-g-small",
    "label": "Letter G Small",
    "path": "letter-g-small.svg"
  },
  {
    "name": "letter-h",
    "label": "Letter H",
    "path": "letter-h.svg"
  },
  {
    "name": "letter-h-small",
    "label": "Letter H Small",
    "path": "letter-h-small.svg"
  },
  {
    "name": "letter-i",
    "label": "Letter I",
    "path": "letter-i.svg"
  },
  {
    "name": "letter-i-small",
    "label": "Letter I Small",
    "path": "letter-i-small.svg"
  },
  {
    "name": "letter-j",
    "label": "Letter J",
    "path": "letter-j.svg"
  },
  {
    "name": "letter-j-small",
    "label": "Letter J Small",
    "path": "letter-j-small.svg"
  },
  {
    "name": "letter-k",
    "label": "Letter K",
    "path": "letter-k.svg"
  },
  {
    "name": "letter-k-small",
    "label": "Letter K Small",
    "path": "letter-k-small.svg"
  },
  {
    "name": "letter-l",
    "label": "Letter L",
    "path": "letter-l.svg"
  },
  {
    "name": "letter-l-small",
    "label": "Letter L Small",
    "path": "letter-l-small.svg"
  },
  {
    "name": "letter-m",
    "label": "Letter M",
    "path": "letter-m.svg"
  },
  {
    "name": "letter-m-small",
    "label": "Letter M Small",
    "path": "letter-m-small.svg"
  },
  {
    "name": "letter-n",
    "label": "Letter N",
    "path": "letter-n.svg"
  },
  {
    "name": "letter-n-small",
    "label": "Letter N Small",
    "path": "letter-n-small.svg"
  },
  {
    "name": "letter-o",
    "label": "Letter O",
    "path": "letter-o.svg"
  },
  {
    "name": "letter-o-small",
    "label": "Letter O Small",
    "path": "letter-o-small.svg"
  },
  {
    "name": "letter-p",
    "label": "Letter P",
    "path": "letter-p.svg"
  },
  {
    "name": "letter-p-small",
    "label": "Letter P Small",
    "path": "letter-p-small.svg"
  },
  {
    "name": "letter-q",
    "label": "Letter Q",
    "path": "letter-q.svg"
  },
  {
    "name": "letter-q-small",
    "label": "Letter Q Small",
    "path": "letter-q-small.svg"
  },
  {
    "name": "letter-r",
    "label": "Letter R",
    "path": "letter-r.svg"
  },
  {
    "name": "letter-r-small",
    "label": "Letter R Small",
    "path": "letter-r-small.svg"
  },
  {
    "name": "letter-s",
    "label": "Letter S",
    "path": "letter-s.svg"
  },
  {
    "name": "letter-s-small",
    "label": "Letter S Small",
    "path": "letter-s-small.svg"
  },
  {
    "name": "letter-spacing",
    "label": "Letter Spacing",
    "path": "letter-spacing.svg"
  },
  {
    "name": "letter-t",
    "label": "Letter T",
    "path": "letter-t.svg"
  },
  {
    "name": "letter-t-small",
    "label": "Letter T Small",
    "path": "letter-t-small.svg"
  },
  {
    "name": "letter-u",
    "label": "Letter U",
    "path": "letter-u.svg"
  },
  {
    "name": "letter-u-small",
    "label": "Letter U Small",
    "path": "letter-u-small.svg"
  },
  {
    "name": "letter-v",
    "label": "Letter V",
    "path": "letter-v.svg"
  },
  {
    "name": "letter-v-small",
    "label": "Letter V Small",
    "path": "letter-v-small.svg"
  },
  {
    "name": "letter-w",
    "label": "Letter W",
    "path": "letter-w.svg"
  },
  {
    "name": "letter-w-small",
    "label": "Letter W Small",
    "path": "letter-w-small.svg"
  },
  {
    "name": "letter-x",
    "label": "Letter X",
    "path": "letter-x.svg"
  },
  {
    "name": "letter-x-small",
    "label": "Letter X Small",
    "path": "letter-x-small.svg"
  },
  {
    "name": "letter-y",
    "label": "Letter Y",
    "path": "letter-y.svg"
  },
  {
    "name": "letter-y-small",
    "label": "Letter Y Small",
    "path": "letter-y-small.svg"
  },
  {
    "name": "letter-z",
    "label": "Letter Z",
    "path": "letter-z.svg"
  },
  {
    "name": "letter-z-small",
    "label": "Letter Z Small",
    "path": "letter-z-small.svg"
  },
  {
    "name": "library",
    "label": "Library",
    "path": "library.svg"
  },
  {
    "name": "library-minus",
    "label": "Library Minus",
    "path": "library-minus.svg"
  },
  {
    "name": "library-photo",
    "label": "Library Photo",
    "path": "library-photo.svg"
  },
  {
    "name": "library-plus",
    "label": "Library Plus",
    "path": "library-plus.svg"
  },
  {
    "name": "license",
    "label": "License",
    "path": "license.svg"
  },
  {
    "name": "license-off",
    "label": "License Off",
    "path": "license-off.svg"
  },
  {
    "name": "lifebuoy",
    "label": "Lifebuoy",
    "path": "lifebuoy.svg"
  },
  {
    "name": "lifebuoy-off",
    "label": "Lifebuoy Off",
    "path": "lifebuoy-off.svg"
  },
  {
    "name": "lighter",
    "label": "Lighter",
    "path": "lighter.svg"
  },
  {
    "name": "line",
    "label": "Line",
    "path": "line.svg"
  },
  {
    "name": "line-dashed",
    "label": "Line Dashed",
    "path": "line-dashed.svg"
  },
  {
    "name": "line-dotted",
    "label": "Line Dotted",
    "path": "line-dotted.svg"
  },
  {
    "name": "line-height",
    "label": "Line Height",
    "path": "line-height.svg"
  },
  {
    "name": "line-scan",
    "label": "Line Scan",
    "path": "line-scan.svg"
  },
  {
    "name": "link",
    "label": "Link",
    "path": "link.svg"
  },
  {
    "name": "link-minus",
    "label": "Link Minus",
    "path": "link-minus.svg"
  },
  {
    "name": "link-off",
    "label": "Link Off",
    "path": "link-off.svg"
  },
  {
    "name": "link-plus",
    "label": "Link Plus",
    "path": "link-plus.svg"
  },
  {
    "name": "list",
    "label": "List",
    "path": "list.svg"
  },
  {
    "name": "list-check",
    "label": "List Check",
    "path": "list-check.svg"
  },
  {
    "name": "list-details",
    "label": "List Details",
    "path": "list-details.svg"
  },
  {
    "name": "list-letters",
    "label": "List Letters",
    "path": "list-letters.svg"
  },
  {
    "name": "list-numbers",
    "label": "List Numbers",
    "path": "list-numbers.svg"
  },
  {
    "name": "list-search",
    "label": "List Search",
    "path": "list-search.svg"
  },
  {
    "name": "list-tree",
    "label": "List Tree",
    "path": "list-tree.svg"
  },
  {
    "name": "live-photo",
    "label": "Live Photo",
    "path": "live-photo.svg"
  },
  {
    "name": "live-photo-off",
    "label": "Live Photo Off",
    "path": "live-photo-off.svg"
  },
  {
    "name": "live-view",
    "label": "Live View",
    "path": "live-view.svg"
  },
  {
    "name": "load-balancer",
    "label": "Load Balancer",
    "path": "load-balancer.svg"
  },
  {
    "name": "loader",
    "label": "Loader",
    "path": "loader.svg"
  },
  {
    "name": "loader-2",
    "label": "Loader 2",
    "path": "loader-2.svg"
  },
  {
    "name": "loader-3",
    "label": "Loader 3",
    "path": "loader-3.svg"
  },
  {
    "name": "loader-quarter",
    "label": "Loader Quarter",
    "path": "loader-quarter.svg"
  },
  {
    "name": "location",
    "label": "Location",
    "path": "location.svg"
  },
  {
    "name": "location-bolt",
    "label": "Location Bolt",
    "path": "location-bolt.svg"
  },
  {
    "name": "location-broken",
    "label": "Location Broken",
    "path": "location-broken.svg"
  },
  {
    "name": "location-cancel",
    "label": "Location Cancel",
    "path": "location-cancel.svg"
  },
  {
    "name": "location-check",
    "label": "Location Check",
    "path": "location-check.svg"
  },
  {
    "name": "location-code",
    "label": "Location Code",
    "path": "location-code.svg"
  },
  {
    "name": "location-cog",
    "label": "Location Cog",
    "path": "location-cog.svg"
  },
  {
    "name": "location-discount",
    "label": "Location Discount",
    "path": "location-discount.svg"
  },
  {
    "name": "location-dollar",
    "label": "Location Dollar",
    "path": "location-dollar.svg"
  },
  {
    "name": "location-down",
    "label": "Location Down",
    "path": "location-down.svg"
  },
  {
    "name": "location-exclamation",
    "label": "Location Exclamation",
    "path": "location-exclamation.svg"
  },
  {
    "name": "location-heart",
    "label": "Location Heart",
    "path": "location-heart.svg"
  },
  {
    "name": "location-minus",
    "label": "Location Minus",
    "path": "location-minus.svg"
  },
  {
    "name": "location-off",
    "label": "Location Off",
    "path": "location-off.svg"
  },
  {
    "name": "location-pause",
    "label": "Location Pause",
    "path": "location-pause.svg"
  },
  {
    "name": "location-pin",
    "label": "Location Pin",
    "path": "location-pin.svg"
  },
  {
    "name": "location-plus",
    "label": "Location Plus",
    "path": "location-plus.svg"
  },
  {
    "name": "location-question",
    "label": "Location Question",
    "path": "location-question.svg"
  },
  {
    "name": "location-search",
    "label": "Location Search",
    "path": "location-search.svg"
  },
  {
    "name": "location-share",
    "label": "Location Share",
    "path": "location-share.svg"
  },
  {
    "name": "location-star",
    "label": "Location Star",
    "path": "location-star.svg"
  },
  {
    "name": "location-up",
    "label": "Location Up",
    "path": "location-up.svg"
  },
  {
    "name": "location-x",
    "label": "Location X",
    "path": "location-x.svg"
  },
  {
    "name": "lock",
    "label": "Lock",
    "path": "lock.svg"
  },
  {
    "name": "lock-access",
    "label": "Lock Access",
    "path": "lock-access.svg"
  },
  {
    "name": "lock-access-off",
    "label": "Lock Access Off",
    "path": "lock-access-off.svg"
  },
  {
    "name": "lock-bitcoin",
    "label": "Lock Bitcoin",
    "path": "lock-bitcoin.svg"
  },
  {
    "name": "lock-bolt",
    "label": "Lock Bolt",
    "path": "lock-bolt.svg"
  },
  {
    "name": "lock-cancel",
    "label": "Lock Cancel",
    "path": "lock-cancel.svg"
  },
  {
    "name": "lock-check",
    "label": "Lock Check",
    "path": "lock-check.svg"
  },
  {
    "name": "lock-code",
    "label": "Lock Code",
    "path": "lock-code.svg"
  },
  {
    "name": "lock-cog",
    "label": "Lock Cog",
    "path": "lock-cog.svg"
  },
  {
    "name": "lock-dollar",
    "label": "Lock Dollar",
    "path": "lock-dollar.svg"
  },
  {
    "name": "lock-down",
    "label": "Lock Down",
    "path": "lock-down.svg"
  },
  {
    "name": "lock-exclamation",
    "label": "Lock Exclamation",
    "path": "lock-exclamation.svg"
  },
  {
    "name": "lock-heart",
    "label": "Lock Heart",
    "path": "lock-heart.svg"
  },
  {
    "name": "lock-minus",
    "label": "Lock Minus",
    "path": "lock-minus.svg"
  },
  {
    "name": "lock-off",
    "label": "Lock Off",
    "path": "lock-off.svg"
  },
  {
    "name": "lock-open",
    "label": "Lock Open",
    "path": "lock-open.svg"
  },
  {
    "name": "lock-open-2",
    "label": "Lock Open 2",
    "path": "lock-open-2.svg"
  },
  {
    "name": "lock-open-off",
    "label": "Lock Open Off",
    "path": "lock-open-off.svg"
  },
  {
    "name": "lock-password",
    "label": "Lock Password",
    "path": "lock-password.svg"
  },
  {
    "name": "lock-pause",
    "label": "Lock Pause",
    "path": "lock-pause.svg"
  },
  {
    "name": "lock-pin",
    "label": "Lock Pin",
    "path": "lock-pin.svg"
  },
  {
    "name": "lock-plus",
    "label": "Lock Plus",
    "path": "lock-plus.svg"
  },
  {
    "name": "lock-question",
    "label": "Lock Question",
    "path": "lock-question.svg"
  },
  {
    "name": "lock-search",
    "label": "Lock Search",
    "path": "lock-search.svg"
  },
  {
    "name": "lock-share",
    "label": "Lock Share",
    "path": "lock-share.svg"
  },
  {
    "name": "lock-square",
    "label": "Lock Square",
    "path": "lock-square.svg"
  },
  {
    "name": "lock-square-rounded",
    "label": "Lock Square Rounded",
    "path": "lock-square-rounded.svg"
  },
  {
    "name": "lock-star",
    "label": "Lock Star",
    "path": "lock-star.svg"
  },
  {
    "name": "lock-up",
    "label": "Lock Up",
    "path": "lock-up.svg"
  },
  {
    "name": "lock-x",
    "label": "Lock X",
    "path": "lock-x.svg"
  },
  {
    "name": "logic-and",
    "label": "Logic And",
    "path": "logic-and.svg"
  },
  {
    "name": "logic-buffer",
    "label": "Logic Buffer",
    "path": "logic-buffer.svg"
  },
  {
    "name": "logic-nand",
    "label": "Logic Nand",
    "path": "logic-nand.svg"
  },
  {
    "name": "logic-nor",
    "label": "Logic Nor",
    "path": "logic-nor.svg"
  },
  {
    "name": "logic-not",
    "label": "Logic Not",
    "path": "logic-not.svg"
  },
  {
    "name": "logic-or",
    "label": "Logic Or",
    "path": "logic-or.svg"
  },
  {
    "name": "logic-xnor",
    "label": "Logic Xnor",
    "path": "logic-xnor.svg"
  },
  {
    "name": "logic-xor",
    "label": "Logic Xor",
    "path": "logic-xor.svg"
  },
  {
    "name": "login",
    "label": "Login",
    "path": "login.svg"
  },
  {
    "name": "login-2",
    "label": "Login 2",
    "path": "login-2.svg"
  },
  {
    "name": "logout",
    "label": "Logout",
    "path": "logout.svg"
  },
  {
    "name": "logout-2",
    "label": "Logout 2",
    "path": "logout-2.svg"
  },
  {
    "name": "logs",
    "label": "Logs",
    "path": "logs.svg"
  },
  {
    "name": "lollipop",
    "label": "Lollipop",
    "path": "lollipop.svg"
  },
  {
    "name": "lollipop-off",
    "label": "Lollipop Off",
    "path": "lollipop-off.svg"
  },
  {
    "name": "luggage",
    "label": "Luggage",
    "path": "luggage.svg"
  },
  {
    "name": "luggage-off",
    "label": "Luggage Off",
    "path": "luggage-off.svg"
  },
  {
    "name": "lungs",
    "label": "Lungs",
    "path": "lungs.svg"
  },
  {
    "name": "lungs-off",
    "label": "Lungs Off",
    "path": "lungs-off.svg"
  },
  {
    "name": "macro",
    "label": "Macro",
    "path": "macro.svg"
  },
  {
    "name": "macro-off",
    "label": "Macro Off",
    "path": "macro-off.svg"
  },
  {
    "name": "magnet",
    "label": "Magnet",
    "path": "magnet.svg"
  },
  {
    "name": "magnet-off",
    "label": "Magnet Off",
    "path": "magnet-off.svg"
  },
  {
    "name": "magnetic",
    "label": "Magnetic",
    "path": "magnetic.svg"
  },
  {
    "name": "mail",
    "label": "Mail",
    "path": "mail.svg"
  },
  {
    "name": "mail-ai",
    "label": "Mail Ai",
    "path": "mail-ai.svg"
  },
  {
    "name": "mail-bitcoin",
    "label": "Mail Bitcoin",
    "path": "mail-bitcoin.svg"
  },
  {
    "name": "mail-bolt",
    "label": "Mail Bolt",
    "path": "mail-bolt.svg"
  },
  {
    "name": "mail-cancel",
    "label": "Mail Cancel",
    "path": "mail-cancel.svg"
  },
  {
    "name": "mail-check",
    "label": "Mail Check",
    "path": "mail-check.svg"
  },
  {
    "name": "mail-code",
    "label": "Mail Code",
    "path": "mail-code.svg"
  },
  {
    "name": "mail-cog",
    "label": "Mail Cog",
    "path": "mail-cog.svg"
  },
  {
    "name": "mail-dollar",
    "label": "Mail Dollar",
    "path": "mail-dollar.svg"
  },
  {
    "name": "mail-down",
    "label": "Mail Down",
    "path": "mail-down.svg"
  },
  {
    "name": "mail-exclamation",
    "label": "Mail Exclamation",
    "path": "mail-exclamation.svg"
  },
  {
    "name": "mail-fast",
    "label": "Mail Fast",
    "path": "mail-fast.svg"
  },
  {
    "name": "mail-forward",
    "label": "Mail Forward",
    "path": "mail-forward.svg"
  },
  {
    "name": "mail-heart",
    "label": "Mail Heart",
    "path": "mail-heart.svg"
  },
  {
    "name": "mail-minus",
    "label": "Mail Minus",
    "path": "mail-minus.svg"
  },
  {
    "name": "mail-off",
    "label": "Mail Off",
    "path": "mail-off.svg"
  },
  {
    "name": "mail-opened",
    "label": "Mail Opened",
    "path": "mail-opened.svg"
  },
  {
    "name": "mail-pause",
    "label": "Mail Pause",
    "path": "mail-pause.svg"
  },
  {
    "name": "mail-pin",
    "label": "Mail Pin",
    "path": "mail-pin.svg"
  },
  {
    "name": "mail-plus",
    "label": "Mail Plus",
    "path": "mail-plus.svg"
  },
  {
    "name": "mail-question",
    "label": "Mail Question",
    "path": "mail-question.svg"
  },
  {
    "name": "mail-search",
    "label": "Mail Search",
    "path": "mail-search.svg"
  },
  {
    "name": "mail-share",
    "label": "Mail Share",
    "path": "mail-share.svg"
  },
  {
    "name": "mail-spark",
    "label": "Mail Spark",
    "path": "mail-spark.svg"
  },
  {
    "name": "mail-star",
    "label": "Mail Star",
    "path": "mail-star.svg"
  },
  {
    "name": "mail-up",
    "label": "Mail Up",
    "path": "mail-up.svg"
  },
  {
    "name": "mail-x",
    "label": "Mail X",
    "path": "mail-x.svg"
  },
  {
    "name": "mailbox",
    "label": "Mailbox",
    "path": "mailbox.svg"
  },
  {
    "name": "mailbox-off",
    "label": "Mailbox Off",
    "path": "mailbox-off.svg"
  },
  {
    "name": "man",
    "label": "Man",
    "path": "man.svg"
  },
  {
    "name": "manual-gearbox",
    "label": "Manual Gearbox",
    "path": "manual-gearbox.svg"
  },
  {
    "name": "map",
    "label": "Map",
    "path": "map.svg"
  },
  {
    "name": "map-2",
    "label": "Map 2",
    "path": "map-2.svg"
  },
  {
    "name": "map-bolt",
    "label": "Map Bolt",
    "path": "map-bolt.svg"
  },
  {
    "name": "map-cancel",
    "label": "Map Cancel",
    "path": "map-cancel.svg"
  },
  {
    "name": "map-check",
    "label": "Map Check",
    "path": "map-check.svg"
  },
  {
    "name": "map-code",
    "label": "Map Code",
    "path": "map-code.svg"
  },
  {
    "name": "map-cog",
    "label": "Map Cog",
    "path": "map-cog.svg"
  },
  {
    "name": "map-discount",
    "label": "Map Discount",
    "path": "map-discount.svg"
  },
  {
    "name": "map-dollar",
    "label": "Map Dollar",
    "path": "map-dollar.svg"
  },
  {
    "name": "map-down",
    "label": "Map Down",
    "path": "map-down.svg"
  },
  {
    "name": "map-east",
    "label": "Map East",
    "path": "map-east.svg"
  },
  {
    "name": "map-exclamation",
    "label": "Map Exclamation",
    "path": "map-exclamation.svg"
  },
  {
    "name": "map-heart",
    "label": "Map Heart",
    "path": "map-heart.svg"
  },
  {
    "name": "map-minus",
    "label": "Map Minus",
    "path": "map-minus.svg"
  },
  {
    "name": "map-north",
    "label": "Map North",
    "path": "map-north.svg"
  },
  {
    "name": "map-off",
    "label": "Map Off",
    "path": "map-off.svg"
  },
  {
    "name": "map-pause",
    "label": "Map Pause",
    "path": "map-pause.svg"
  },
  {
    "name": "map-pin",
    "label": "Map Pin",
    "path": "map-pin.svg"
  },
  {
    "name": "map-pin-2",
    "label": "Map Pin 2",
    "path": "map-pin-2.svg"
  },
  {
    "name": "map-pin-bolt",
    "label": "Map Pin Bolt",
    "path": "map-pin-bolt.svg"
  },
  {
    "name": "map-pin-cancel",
    "label": "Map Pin Cancel",
    "path": "map-pin-cancel.svg"
  },
  {
    "name": "map-pin-check",
    "label": "Map Pin Check",
    "path": "map-pin-check.svg"
  },
  {
    "name": "map-pin-code",
    "label": "Map Pin Code",
    "path": "map-pin-code.svg"
  },
  {
    "name": "map-pin-cog",
    "label": "Map Pin Cog",
    "path": "map-pin-cog.svg"
  },
  {
    "name": "map-pin-dollar",
    "label": "Map Pin Dollar",
    "path": "map-pin-dollar.svg"
  },
  {
    "name": "map-pin-down",
    "label": "Map Pin Down",
    "path": "map-pin-down.svg"
  },
  {
    "name": "map-pin-exclamation",
    "label": "Map Pin Exclamation",
    "path": "map-pin-exclamation.svg"
  },
  {
    "name": "map-pin-heart",
    "label": "Map Pin Heart",
    "path": "map-pin-heart.svg"
  },
  {
    "name": "map-pin-minus",
    "label": "Map Pin Minus",
    "path": "map-pin-minus.svg"
  },
  {
    "name": "map-pin-off",
    "label": "Map Pin Off",
    "path": "map-pin-off.svg"
  },
  {
    "name": "map-pin-pause",
    "label": "Map Pin Pause",
    "path": "map-pin-pause.svg"
  },
  {
    "name": "map-pin-pin",
    "label": "Map Pin Pin",
    "path": "map-pin-pin.svg"
  },
  {
    "name": "map-pin-plus",
    "label": "Map Pin Plus",
    "path": "map-pin-plus.svg"
  },
  {
    "name": "map-pin-question",
    "label": "Map Pin Question",
    "path": "map-pin-question.svg"
  },
  {
    "name": "map-pin-search",
    "label": "Map Pin Search",
    "path": "map-pin-search.svg"
  },
  {
    "name": "map-pin-share",
    "label": "Map Pin Share",
    "path": "map-pin-share.svg"
  },
  {
    "name": "map-pin-star",
    "label": "Map Pin Star",
    "path": "map-pin-star.svg"
  },
  {
    "name": "map-pin-up",
    "label": "Map Pin Up",
    "path": "map-pin-up.svg"
  },
  {
    "name": "map-pin-x",
    "label": "Map Pin X",
    "path": "map-pin-x.svg"
  },
  {
    "name": "map-pins",
    "label": "Map Pins",
    "path": "map-pins.svg"
  },
  {
    "name": "map-plus",
    "label": "Map Plus",
    "path": "map-plus.svg"
  },
  {
    "name": "map-question",
    "label": "Map Question",
    "path": "map-question.svg"
  },
  {
    "name": "map-route",
    "label": "Map Route",
    "path": "map-route.svg"
  },
  {
    "name": "map-search",
    "label": "Map Search",
    "path": "map-search.svg"
  },
  {
    "name": "map-share",
    "label": "Map Share",
    "path": "map-share.svg"
  },
  {
    "name": "map-south",
    "label": "Map South",
    "path": "map-south.svg"
  },
  {
    "name": "map-star",
    "label": "Map Star",
    "path": "map-star.svg"
  },
  {
    "name": "map-up",
    "label": "Map Up",
    "path": "map-up.svg"
  },
  {
    "name": "map-west",
    "label": "Map West",
    "path": "map-west.svg"
  },
  {
    "name": "map-x",
    "label": "Map X",
    "path": "map-x.svg"
  },
  {
    "name": "markdown",
    "label": "Markdown",
    "path": "markdown.svg"
  },
  {
    "name": "markdown-off",
    "label": "Markdown Off",
    "path": "markdown-off.svg"
  },
  {
    "name": "marquee",
    "label": "Marquee",
    "path": "marquee.svg"
  },
  {
    "name": "marquee-2",
    "label": "Marquee 2",
    "path": "marquee-2.svg"
  },
  {
    "name": "marquee-off",
    "label": "Marquee Off",
    "path": "marquee-off.svg"
  },
  {
    "name": "mars",
    "label": "Mars",
    "path": "mars.svg"
  },
  {
    "name": "mask",
    "label": "Mask",
    "path": "mask.svg"
  },
  {
    "name": "mask-off",
    "label": "Mask Off",
    "path": "mask-off.svg"
  },
  {
    "name": "masks-theater",
    "label": "Masks Theater",
    "path": "masks-theater.svg"
  },
  {
    "name": "masks-theater-off",
    "label": "Masks Theater Off",
    "path": "masks-theater-off.svg"
  },
  {
    "name": "massage",
    "label": "Massage",
    "path": "massage.svg"
  },
  {
    "name": "matchstick",
    "label": "Matchstick",
    "path": "matchstick.svg"
  },
  {
    "name": "math",
    "label": "Math",
    "path": "math.svg"
  },
  {
    "name": "math-1-divide-2",
    "label": "Math 1 Divide 2",
    "path": "math-1-divide-2.svg"
  },
  {
    "name": "math-1-divide-3",
    "label": "Math 1 Divide 3",
    "path": "math-1-divide-3.svg"
  },
  {
    "name": "math-avg",
    "label": "Math Avg",
    "path": "math-avg.svg"
  },
  {
    "name": "math-cos",
    "label": "Math Cos",
    "path": "math-cos.svg"
  },
  {
    "name": "math-ctg",
    "label": "Math Ctg",
    "path": "math-ctg.svg"
  },
  {
    "name": "math-equal-greater",
    "label": "Math Equal Greater",
    "path": "math-equal-greater.svg"
  },
  {
    "name": "math-equal-lower",
    "label": "Math Equal Lower",
    "path": "math-equal-lower.svg"
  },
  {
    "name": "math-function",
    "label": "Math Function",
    "path": "math-function.svg"
  },
  {
    "name": "math-function-off",
    "label": "Math Function Off",
    "path": "math-function-off.svg"
  },
  {
    "name": "math-function-y",
    "label": "Math Function Y",
    "path": "math-function-y.svg"
  },
  {
    "name": "math-greater",
    "label": "Math Greater",
    "path": "math-greater.svg"
  },
  {
    "name": "math-integral",
    "label": "Math Integral",
    "path": "math-integral.svg"
  },
  {
    "name": "math-integral-x",
    "label": "Math Integral X",
    "path": "math-integral-x.svg"
  },
  {
    "name": "math-integrals",
    "label": "Math Integrals",
    "path": "math-integrals.svg"
  },
  {
    "name": "math-lower",
    "label": "Math Lower",
    "path": "math-lower.svg"
  },
  {
    "name": "math-max",
    "label": "Math Max",
    "path": "math-max.svg"
  },
  {
    "name": "math-max-min",
    "label": "Math Max Min",
    "path": "math-max-min.svg"
  },
  {
    "name": "math-min",
    "label": "Math Min",
    "path": "math-min.svg"
  },
  {
    "name": "math-not",
    "label": "Math Not",
    "path": "math-not.svg"
  },
  {
    "name": "math-off",
    "label": "Math Off",
    "path": "math-off.svg"
  },
  {
    "name": "math-pi",
    "label": "Math Pi",
    "path": "math-pi.svg"
  },
  {
    "name": "math-pi-divide-2",
    "label": "Math Pi Divide 2",
    "path": "math-pi-divide-2.svg"
  },
  {
    "name": "math-sec",
    "label": "Math Sec",
    "path": "math-sec.svg"
  },
  {
    "name": "math-sin",
    "label": "Math Sin",
    "path": "math-sin.svg"
  },
  {
    "name": "math-symbols",
    "label": "Math Symbols",
    "path": "math-symbols.svg"
  },
  {
    "name": "math-tg",
    "label": "Math Tg",
    "path": "math-tg.svg"
  },
  {
    "name": "math-x-divide-2",
    "label": "Math X Divide 2",
    "path": "math-x-divide-2.svg"
  },
  {
    "name": "math-x-divide-y",
    "label": "Math X Divide Y",
    "path": "math-x-divide-y.svg"
  },
  {
    "name": "math-x-divide-y-2",
    "label": "Math X Divide Y 2",
    "path": "math-x-divide-y-2.svg"
  },
  {
    "name": "math-x-floor-divide-y",
    "label": "Math X Floor Divide Y",
    "path": "math-x-floor-divide-y.svg"
  },
  {
    "name": "math-x-minus-x",
    "label": "Math X Minus X",
    "path": "math-x-minus-x.svg"
  },
  {
    "name": "math-x-minus-y",
    "label": "Math X Minus Y",
    "path": "math-x-minus-y.svg"
  },
  {
    "name": "math-x-plus-x",
    "label": "Math X Plus X",
    "path": "math-x-plus-x.svg"
  },
  {
    "name": "math-x-plus-y",
    "label": "Math X Plus Y",
    "path": "math-x-plus-y.svg"
  },
  {
    "name": "math-xy",
    "label": "Math Xy",
    "path": "math-xy.svg"
  },
  {
    "name": "math-y-minus-y",
    "label": "Math Y Minus Y",
    "path": "math-y-minus-y.svg"
  },
  {
    "name": "math-y-plus-y",
    "label": "Math Y Plus Y",
    "path": "math-y-plus-y.svg"
  },
  {
    "name": "matrix",
    "label": "Matrix",
    "path": "matrix.svg"
  },
  {
    "name": "maximize",
    "label": "Maximize",
    "path": "maximize.svg"
  },
  {
    "name": "maximize-off",
    "label": "Maximize Off",
    "path": "maximize-off.svg"
  },
  {
    "name": "meat",
    "label": "Meat",
    "path": "meat.svg"
  },
  {
    "name": "meat-off",
    "label": "Meat Off",
    "path": "meat-off.svg"
  },
  {
    "name": "medal",
    "label": "Medal",
    "path": "medal.svg"
  },
  {
    "name": "medal-2",
    "label": "Medal 2",
    "path": "medal-2.svg"
  },
  {
    "name": "medical-cross",
    "label": "Medical Cross",
    "path": "medical-cross.svg"
  },
  {
    "name": "medical-cross-circle",
    "label": "Medical Cross Circle",
    "path": "medical-cross-circle.svg"
  },
  {
    "name": "medical-cross-off",
    "label": "Medical Cross Off",
    "path": "medical-cross-off.svg"
  },
  {
    "name": "medicine-syrup",
    "label": "Medicine Syrup",
    "path": "medicine-syrup.svg"
  },
  {
    "name": "meeple",
    "label": "Meeple",
    "path": "meeple.svg"
  },
  {
    "name": "melon",
    "label": "Melon",
    "path": "melon.svg"
  },
  {
    "name": "menorah",
    "label": "Menorah",
    "path": "menorah.svg"
  },
  {
    "name": "menu",
    "label": "Menu",
    "path": "menu.svg"
  },
  {
    "name": "menu-2",
    "label": "Menu 2",
    "path": "menu-2.svg"
  },
  {
    "name": "menu-3",
    "label": "Menu 3",
    "path": "menu-3.svg"
  },
  {
    "name": "menu-4",
    "label": "Menu 4",
    "path": "menu-4.svg"
  },
  {
    "name": "menu-deep",
    "label": "Menu Deep",
    "path": "menu-deep.svg"
  },
  {
    "name": "menu-order",
    "label": "Menu Order",
    "path": "menu-order.svg"
  },
  {
    "name": "message",
    "label": "Message",
    "path": "message.svg"
  },
  {
    "name": "message-2",
    "label": "Message 2",
    "path": "message-2.svg"
  },
  {
    "name": "message-2-bolt",
    "label": "Message 2 Bolt",
    "path": "message-2-bolt.svg"
  },
  {
    "name": "message-2-cancel",
    "label": "Message 2 Cancel",
    "path": "message-2-cancel.svg"
  },
  {
    "name": "message-2-check",
    "label": "Message 2 Check",
    "path": "message-2-check.svg"
  },
  {
    "name": "message-2-code",
    "label": "Message 2 Code",
    "path": "message-2-code.svg"
  },
  {
    "name": "message-2-cog",
    "label": "Message 2 Cog",
    "path": "message-2-cog.svg"
  },
  {
    "name": "message-2-dollar",
    "label": "Message 2 Dollar",
    "path": "message-2-dollar.svg"
  },
  {
    "name": "message-2-down",
    "label": "Message 2 Down",
    "path": "message-2-down.svg"
  },
  {
    "name": "message-2-exclamation",
    "label": "Message 2 Exclamation",
    "path": "message-2-exclamation.svg"
  },
  {
    "name": "message-2-heart",
    "label": "Message 2 Heart",
    "path": "message-2-heart.svg"
  },
  {
    "name": "message-2-minus",
    "label": "Message 2 Minus",
    "path": "message-2-minus.svg"
  },
  {
    "name": "message-2-off",
    "label": "Message 2 Off",
    "path": "message-2-off.svg"
  },
  {
    "name": "message-2-pause",
    "label": "Message 2 Pause",
    "path": "message-2-pause.svg"
  },
  {
    "name": "message-2-pin",
    "label": "Message 2 Pin",
    "path": "message-2-pin.svg"
  },
  {
    "name": "message-2-plus",
    "label": "Message 2 Plus",
    "path": "message-2-plus.svg"
  },
  {
    "name": "message-2-question",
    "label": "Message 2 Question",
    "path": "message-2-question.svg"
  },
  {
    "name": "message-2-search",
    "label": "Message 2 Search",
    "path": "message-2-search.svg"
  },
  {
    "name": "message-2-share",
    "label": "Message 2 Share",
    "path": "message-2-share.svg"
  },
  {
    "name": "message-2-star",
    "label": "Message 2 Star",
    "path": "message-2-star.svg"
  },
  {
    "name": "message-2-up",
    "label": "Message 2 Up",
    "path": "message-2-up.svg"
  },
  {
    "name": "message-2-x",
    "label": "Message 2 X",
    "path": "message-2-x.svg"
  },
  {
    "name": "message-bolt",
    "label": "Message Bolt",
    "path": "message-bolt.svg"
  },
  {
    "name": "message-cancel",
    "label": "Message Cancel",
    "path": "message-cancel.svg"
  },
  {
    "name": "message-chatbot",
    "label": "Message Chatbot",
    "path": "message-chatbot.svg"
  },
  {
    "name": "message-check",
    "label": "Message Check",
    "path": "message-check.svg"
  },
  {
    "name": "message-circle",
    "label": "Message Circle",
    "path": "message-circle.svg"
  },
  {
    "name": "message-circle-bolt",
    "label": "Message Circle Bolt",
    "path": "message-circle-bolt.svg"
  },
  {
    "name": "message-circle-cancel",
    "label": "Message Circle Cancel",
    "path": "message-circle-cancel.svg"
  },
  {
    "name": "message-circle-check",
    "label": "Message Circle Check",
    "path": "message-circle-check.svg"
  },
  {
    "name": "message-circle-code",
    "label": "Message Circle Code",
    "path": "message-circle-code.svg"
  },
  {
    "name": "message-circle-cog",
    "label": "Message Circle Cog",
    "path": "message-circle-cog.svg"
  },
  {
    "name": "message-circle-dollar",
    "label": "Message Circle Dollar",
    "path": "message-circle-dollar.svg"
  },
  {
    "name": "message-circle-down",
    "label": "Message Circle Down",
    "path": "message-circle-down.svg"
  },
  {
    "name": "message-circle-exclamation",
    "label": "Message Circle Exclamation",
    "path": "message-circle-exclamation.svg"
  },
  {
    "name": "message-circle-heart",
    "label": "Message Circle Heart",
    "path": "message-circle-heart.svg"
  },
  {
    "name": "message-circle-minus",
    "label": "Message Circle Minus",
    "path": "message-circle-minus.svg"
  },
  {
    "name": "message-circle-off",
    "label": "Message Circle Off",
    "path": "message-circle-off.svg"
  },
  {
    "name": "message-circle-pause",
    "label": "Message Circle Pause",
    "path": "message-circle-pause.svg"
  },
  {
    "name": "message-circle-pin",
    "label": "Message Circle Pin",
    "path": "message-circle-pin.svg"
  },
  {
    "name": "message-circle-plus",
    "label": "Message Circle Plus",
    "path": "message-circle-plus.svg"
  },
  {
    "name": "message-circle-question",
    "label": "Message Circle Question",
    "path": "message-circle-question.svg"
  },
  {
    "name": "message-circle-search",
    "label": "Message Circle Search",
    "path": "message-circle-search.svg"
  },
  {
    "name": "message-circle-share",
    "label": "Message Circle Share",
    "path": "message-circle-share.svg"
  },
  {
    "name": "message-circle-star",
    "label": "Message Circle Star",
    "path": "message-circle-star.svg"
  },
  {
    "name": "message-circle-up",
    "label": "Message Circle Up",
    "path": "message-circle-up.svg"
  },
  {
    "name": "message-circle-user",
    "label": "Message Circle User",
    "path": "message-circle-user.svg"
  },
  {
    "name": "message-circle-x",
    "label": "Message Circle X",
    "path": "message-circle-x.svg"
  },
  {
    "name": "message-code",
    "label": "Message Code",
    "path": "message-code.svg"
  },
  {
    "name": "message-cog",
    "label": "Message Cog",
    "path": "message-cog.svg"
  },
  {
    "name": "message-dollar",
    "label": "Message Dollar",
    "path": "message-dollar.svg"
  },
  {
    "name": "message-dots",
    "label": "Message Dots",
    "path": "message-dots.svg"
  },
  {
    "name": "message-down",
    "label": "Message Down",
    "path": "message-down.svg"
  },
  {
    "name": "message-exclamation",
    "label": "Message Exclamation",
    "path": "message-exclamation.svg"
  },
  {
    "name": "message-forward",
    "label": "Message Forward",
    "path": "message-forward.svg"
  },
  {
    "name": "message-heart",
    "label": "Message Heart",
    "path": "message-heart.svg"
  },
  {
    "name": "message-language",
    "label": "Message Language",
    "path": "message-language.svg"
  },
  {
    "name": "message-minus",
    "label": "Message Minus",
    "path": "message-minus.svg"
  },
  {
    "name": "message-off",
    "label": "Message Off",
    "path": "message-off.svg"
  },
  {
    "name": "message-pause",
    "label": "Message Pause",
    "path": "message-pause.svg"
  },
  {
    "name": "message-pin",
    "label": "Message Pin",
    "path": "message-pin.svg"
  },
  {
    "name": "message-plus",
    "label": "Message Plus",
    "path": "message-plus.svg"
  },
  {
    "name": "message-question",
    "label": "Message Question",
    "path": "message-question.svg"
  },
  {
    "name": "message-reply",
    "label": "Message Reply",
    "path": "message-reply.svg"
  },
  {
    "name": "message-report",
    "label": "Message Report",
    "path": "message-report.svg"
  },
  {
    "name": "message-search",
    "label": "Message Search",
    "path": "message-search.svg"
  },
  {
    "name": "message-share",
    "label": "Message Share",
    "path": "message-share.svg"
  },
  {
    "name": "message-star",
    "label": "Message Star",
    "path": "message-star.svg"
  },
  {
    "name": "message-up",
    "label": "Message Up",
    "path": "message-up.svg"
  },
  {
    "name": "message-user",
    "label": "Message User",
    "path": "message-user.svg"
  },
  {
    "name": "message-x",
    "label": "Message X",
    "path": "message-x.svg"
  },
  {
    "name": "messages",
    "label": "Messages",
    "path": "messages.svg"
  },
  {
    "name": "messages-off",
    "label": "Messages Off",
    "path": "messages-off.svg"
  },
  {
    "name": "meteor",
    "label": "Meteor",
    "path": "meteor.svg"
  },
  {
    "name": "meteor-off",
    "label": "Meteor Off",
    "path": "meteor-off.svg"
  },
  {
    "name": "meter-cube",
    "label": "Meter Cube",
    "path": "meter-cube.svg"
  },
  {
    "name": "meter-square",
    "label": "Meter Square",
    "path": "meter-square.svg"
  },
  {
    "name": "metronome",
    "label": "Metronome",
    "path": "metronome.svg"
  },
  {
    "name": "michelin-bib-gourmand",
    "label": "Michelin Bib Gourmand",
    "path": "michelin-bib-gourmand.svg"
  },
  {
    "name": "michelin-star",
    "label": "Michelin Star",
    "path": "michelin-star.svg"
  },
  {
    "name": "michelin-star-green",
    "label": "Michelin Star Green",
    "path": "michelin-star-green.svg"
  },
  {
    "name": "mickey",
    "label": "Mickey",
    "path": "mickey.svg"
  },
  {
    "name": "microphone",
    "label": "Microphone",
    "path": "microphone.svg"
  },
  {
    "name": "microphone-2",
    "label": "Microphone 2",
    "path": "microphone-2.svg"
  },
  {
    "name": "microphone-2-off",
    "label": "Microphone 2 Off",
    "path": "microphone-2-off.svg"
  },
  {
    "name": "microphone-off",
    "label": "Microphone Off",
    "path": "microphone-off.svg"
  },
  {
    "name": "microscope",
    "label": "Microscope",
    "path": "microscope.svg"
  },
  {
    "name": "microscope-off",
    "label": "Microscope Off",
    "path": "microscope-off.svg"
  },
  {
    "name": "microwave",
    "label": "Microwave",
    "path": "microwave.svg"
  },
  {
    "name": "microwave-off",
    "label": "Microwave Off",
    "path": "microwave-off.svg"
  },
  {
    "name": "military-award",
    "label": "Military Award",
    "path": "military-award.svg"
  },
  {
    "name": "military-rank",
    "label": "Military Rank",
    "path": "military-rank.svg"
  },
  {
    "name": "milk",
    "label": "Milk",
    "path": "milk.svg"
  },
  {
    "name": "milk-off",
    "label": "Milk Off",
    "path": "milk-off.svg"
  },
  {
    "name": "milkshake",
    "label": "Milkshake",
    "path": "milkshake.svg"
  },
  {
    "name": "minimize",
    "label": "Minimize",
    "path": "minimize.svg"
  },
  {
    "name": "minus",
    "label": "Minus",
    "path": "minus.svg"
  },
  {
    "name": "minus-vertical",
    "label": "Minus Vertical",
    "path": "minus-vertical.svg"
  },
  {
    "name": "mist",
    "label": "Mist",
    "path": "mist.svg"
  },
  {
    "name": "mist-off",
    "label": "Mist Off",
    "path": "mist-off.svg"
  },
  {
    "name": "mobiledata",
    "label": "Mobiledata",
    "path": "mobiledata.svg"
  },
  {
    "name": "mobiledata-off",
    "label": "Mobiledata Off",
    "path": "mobiledata-off.svg"
  },
  {
    "name": "moneybag",
    "label": "Moneybag",
    "path": "moneybag.svg"
  },
  {
    "name": "moneybag-edit",
    "label": "Moneybag Edit",
    "path": "moneybag-edit.svg"
  },
  {
    "name": "moneybag-heart",
    "label": "Moneybag Heart",
    "path": "moneybag-heart.svg"
  },
  {
    "name": "moneybag-minus",
    "label": "Moneybag Minus",
    "path": "moneybag-minus.svg"
  },
  {
    "name": "moneybag-move",
    "label": "Moneybag Move",
    "path": "moneybag-move.svg"
  },
  {
    "name": "moneybag-move-back",
    "label": "Moneybag Move Back",
    "path": "moneybag-move-back.svg"
  },
  {
    "name": "moneybag-plus",
    "label": "Moneybag Plus",
    "path": "moneybag-plus.svg"
  },
  {
    "name": "monkeybar",
    "label": "Monkeybar",
    "path": "monkeybar.svg"
  },
  {
    "name": "mood-angry",
    "label": "Mood Angry",
    "path": "mood-angry.svg"
  },
  {
    "name": "mood-annoyed",
    "label": "Mood Annoyed",
    "path": "mood-annoyed.svg"
  },
  {
    "name": "mood-annoyed-2",
    "label": "Mood Annoyed 2",
    "path": "mood-annoyed-2.svg"
  },
  {
    "name": "mood-bitcoin",
    "label": "Mood Bitcoin",
    "path": "mood-bitcoin.svg"
  },
  {
    "name": "mood-boy",
    "label": "Mood Boy",
    "path": "mood-boy.svg"
  },
  {
    "name": "mood-check",
    "label": "Mood Check",
    "path": "mood-check.svg"
  },
  {
    "name": "mood-cog",
    "label": "Mood Cog",
    "path": "mood-cog.svg"
  },
  {
    "name": "mood-confuzed",
    "label": "Mood Confuzed",
    "path": "mood-confuzed.svg"
  },
  {
    "name": "mood-crazy-happy",
    "label": "Mood Crazy Happy",
    "path": "mood-crazy-happy.svg"
  },
  {
    "name": "mood-cry",
    "label": "Mood Cry",
    "path": "mood-cry.svg"
  },
  {
    "name": "mood-dollar",
    "label": "Mood Dollar",
    "path": "mood-dollar.svg"
  },
  {
    "name": "mood-edit",
    "label": "Mood Edit",
    "path": "mood-edit.svg"
  },
  {
    "name": "mood-empty",
    "label": "Mood Empty",
    "path": "mood-empty.svg"
  },
  {
    "name": "mood-happy",
    "label": "Mood Happy",
    "path": "mood-happy.svg"
  },
  {
    "name": "mood-heart",
    "label": "Mood Heart",
    "path": "mood-heart.svg"
  },
  {
    "name": "mood-kid",
    "label": "Mood Kid",
    "path": "mood-kid.svg"
  },
  {
    "name": "mood-look-down",
    "label": "Mood Look Down",
    "path": "mood-look-down.svg"
  },
  {
    "name": "mood-look-left",
    "label": "Mood Look Left",
    "path": "mood-look-left.svg"
  },
  {
    "name": "mood-look-right",
    "label": "Mood Look Right",
    "path": "mood-look-right.svg"
  },
  {
    "name": "mood-look-up",
    "label": "Mood Look Up",
    "path": "mood-look-up.svg"
  },
  {
    "name": "mood-minus",
    "label": "Mood Minus",
    "path": "mood-minus.svg"
  },
  {
    "name": "mood-nerd",
    "label": "Mood Nerd",
    "path": "mood-nerd.svg"
  },
  {
    "name": "mood-nervous",
    "label": "Mood Nervous",
    "path": "mood-nervous.svg"
  },
  {
    "name": "mood-neutral",
    "label": "Mood Neutral",
    "path": "mood-neutral.svg"
  },
  {
    "name": "mood-off",
    "label": "Mood Off",
    "path": "mood-off.svg"
  },
  {
    "name": "mood-pin",
    "label": "Mood Pin",
    "path": "mood-pin.svg"
  },
  {
    "name": "mood-plus",
    "label": "Mood Plus",
    "path": "mood-plus.svg"
  },
  {
    "name": "mood-puzzled",
    "label": "Mood Puzzled",
    "path": "mood-puzzled.svg"
  },
  {
    "name": "mood-sad",
    "label": "Mood Sad",
    "path": "mood-sad.svg"
  },
  {
    "name": "mood-sad-2",
    "label": "Mood Sad 2",
    "path": "mood-sad-2.svg"
  },
  {
    "name": "mood-sad-dizzy",
    "label": "Mood Sad Dizzy",
    "path": "mood-sad-dizzy.svg"
  },
  {
    "name": "mood-sad-squint",
    "label": "Mood Sad Squint",
    "path": "mood-sad-squint.svg"
  },
  {
    "name": "mood-search",
    "label": "Mood Search",
    "path": "mood-search.svg"
  },
  {
    "name": "mood-share",
    "label": "Mood Share",
    "path": "mood-share.svg"
  },
  {
    "name": "mood-sick",
    "label": "Mood Sick",
    "path": "mood-sick.svg"
  },
  {
    "name": "mood-silence",
    "label": "Mood Silence",
    "path": "mood-silence.svg"
  },
  {
    "name": "mood-sing",
    "label": "Mood Sing",
    "path": "mood-sing.svg"
  },
  {
    "name": "mood-smile",
    "label": "Mood Smile",
    "path": "mood-smile.svg"
  },
  {
    "name": "mood-smile-beam",
    "label": "Mood Smile Beam",
    "path": "mood-smile-beam.svg"
  },
  {
    "name": "mood-smile-dizzy",
    "label": "Mood Smile Dizzy",
    "path": "mood-smile-dizzy.svg"
  },
  {
    "name": "mood-spark",
    "label": "Mood Spark",
    "path": "mood-spark.svg"
  },
  {
    "name": "mood-surprised",
    "label": "Mood Surprised",
    "path": "mood-surprised.svg"
  },
  {
    "name": "mood-tongue",
    "label": "Mood Tongue",
    "path": "mood-tongue.svg"
  },
  {
    "name": "mood-tongue-wink",
    "label": "Mood Tongue Wink",
    "path": "mood-tongue-wink.svg"
  },
  {
    "name": "mood-tongue-wink-2",
    "label": "Mood Tongue Wink 2",
    "path": "mood-tongue-wink-2.svg"
  },
  {
    "name": "mood-unamused",
    "label": "Mood Unamused",
    "path": "mood-unamused.svg"
  },
  {
    "name": "mood-up",
    "label": "Mood Up",
    "path": "mood-up.svg"
  },
  {
    "name": "mood-wink",
    "label": "Mood Wink",
    "path": "mood-wink.svg"
  },
  {
    "name": "mood-wink-2",
    "label": "Mood Wink 2",
    "path": "mood-wink-2.svg"
  },
  {
    "name": "mood-wrrr",
    "label": "Mood Wrrr",
    "path": "mood-wrrr.svg"
  },
  {
    "name": "mood-x",
    "label": "Mood X",
    "path": "mood-x.svg"
  },
  {
    "name": "mood-xd",
    "label": "Mood Xd",
    "path": "mood-xd.svg"
  },
  {
    "name": "moon",
    "label": "Moon",
    "path": "moon.svg"
  },
  {
    "name": "moon-2",
    "label": "Moon 2",
    "path": "moon-2.svg"
  },
  {
    "name": "moon-off",
    "label": "Moon Off",
    "path": "moon-off.svg"
  },
  {
    "name": "moon-stars",
    "label": "Moon Stars",
    "path": "moon-stars.svg"
  },
  {
    "name": "moped",
    "label": "Moped",
    "path": "moped.svg"
  },
  {
    "name": "motorbike",
    "label": "Motorbike",
    "path": "motorbike.svg"
  },
  {
    "name": "mountain",
    "label": "Mountain",
    "path": "mountain.svg"
  },
  {
    "name": "mountain-off",
    "label": "Mountain Off",
    "path": "mountain-off.svg"
  },
  {
    "name": "mouse",
    "label": "Mouse",
    "path": "mouse.svg"
  },
  {
    "name": "mouse-2",
    "label": "Mouse 2",
    "path": "mouse-2.svg"
  },
  {
    "name": "mouse-off",
    "label": "Mouse Off",
    "path": "mouse-off.svg"
  },
  {
    "name": "moustache",
    "label": "Moustache",
    "path": "moustache.svg"
  },
  {
    "name": "movie",
    "label": "Movie",
    "path": "movie.svg"
  },
  {
    "name": "movie-off",
    "label": "Movie Off",
    "path": "movie-off.svg"
  },
  {
    "name": "mug",
    "label": "Mug",
    "path": "mug.svg"
  },
  {
    "name": "mug-off",
    "label": "Mug Off",
    "path": "mug-off.svg"
  },
  {
    "name": "multiplier-0-5x",
    "label": "Multiplier 0 5x",
    "path": "multiplier-0-5x.svg"
  },
  {
    "name": "multiplier-1-5x",
    "label": "Multiplier 1 5x",
    "path": "multiplier-1-5x.svg"
  },
  {
    "name": "multiplier-1x",
    "label": "Multiplier 1x",
    "path": "multiplier-1x.svg"
  },
  {
    "name": "multiplier-2x",
    "label": "Multiplier 2x",
    "path": "multiplier-2x.svg"
  },
  {
    "name": "mushroom",
    "label": "Mushroom",
    "path": "mushroom.svg"
  },
  {
    "name": "mushroom-off",
    "label": "Mushroom Off",
    "path": "mushroom-off.svg"
  },
  {
    "name": "music",
    "label": "Music",
    "path": "music.svg"
  },
  {
    "name": "music-bolt",
    "label": "Music Bolt",
    "path": "music-bolt.svg"
  },
  {
    "name": "music-cancel",
    "label": "Music Cancel",
    "path": "music-cancel.svg"
  },
  {
    "name": "music-check",
    "label": "Music Check",
    "path": "music-check.svg"
  },
  {
    "name": "music-code",
    "label": "Music Code",
    "path": "music-code.svg"
  },
  {
    "name": "music-cog",
    "label": "Music Cog",
    "path": "music-cog.svg"
  },
  {
    "name": "music-discount",
    "label": "Music Discount",
    "path": "music-discount.svg"
  },
  {
    "name": "music-dollar",
    "label": "Music Dollar",
    "path": "music-dollar.svg"
  },
  {
    "name": "music-down",
    "label": "Music Down",
    "path": "music-down.svg"
  },
  {
    "name": "music-exclamation",
    "label": "Music Exclamation",
    "path": "music-exclamation.svg"
  },
  {
    "name": "music-heart",
    "label": "Music Heart",
    "path": "music-heart.svg"
  },
  {
    "name": "music-minus",
    "label": "Music Minus",
    "path": "music-minus.svg"
  },
  {
    "name": "music-off",
    "label": "Music Off",
    "path": "music-off.svg"
  },
  {
    "name": "music-pause",
    "label": "Music Pause",
    "path": "music-pause.svg"
  },
  {
    "name": "music-pin",
    "label": "Music Pin",
    "path": "music-pin.svg"
  },
  {
    "name": "music-plus",
    "label": "Music Plus",
    "path": "music-plus.svg"
  },
  {
    "name": "music-question",
    "label": "Music Question",
    "path": "music-question.svg"
  },
  {
    "name": "music-search",
    "label": "Music Search",
    "path": "music-search.svg"
  },
  {
    "name": "music-share",
    "label": "Music Share",
    "path": "music-share.svg"
  },
  {
    "name": "music-star",
    "label": "Music Star",
    "path": "music-star.svg"
  },
  {
    "name": "music-up",
    "label": "Music Up",
    "path": "music-up.svg"
  },
  {
    "name": "music-x",
    "label": "Music X",
    "path": "music-x.svg"
  },
  {
    "name": "navigation",
    "label": "Navigation",
    "path": "navigation.svg"
  },
  {
    "name": "navigation-bolt",
    "label": "Navigation Bolt",
    "path": "navigation-bolt.svg"
  },
  {
    "name": "navigation-cancel",
    "label": "Navigation Cancel",
    "path": "navigation-cancel.svg"
  },
  {
    "name": "navigation-check",
    "label": "Navigation Check",
    "path": "navigation-check.svg"
  },
  {
    "name": "navigation-code",
    "label": "Navigation Code",
    "path": "navigation-code.svg"
  },
  {
    "name": "navigation-cog",
    "label": "Navigation Cog",
    "path": "navigation-cog.svg"
  },
  {
    "name": "navigation-discount",
    "label": "Navigation Discount",
    "path": "navigation-discount.svg"
  },
  {
    "name": "navigation-dollar",
    "label": "Navigation Dollar",
    "path": "navigation-dollar.svg"
  },
  {
    "name": "navigation-down",
    "label": "Navigation Down",
    "path": "navigation-down.svg"
  },
  {
    "name": "navigation-east",
    "label": "Navigation East",
    "path": "navigation-east.svg"
  },
  {
    "name": "navigation-exclamation",
    "label": "Navigation Exclamation",
    "path": "navigation-exclamation.svg"
  },
  {
    "name": "navigation-heart",
    "label": "Navigation Heart",
    "path": "navigation-heart.svg"
  },
  {
    "name": "navigation-minus",
    "label": "Navigation Minus",
    "path": "navigation-minus.svg"
  },
  {
    "name": "navigation-north",
    "label": "Navigation North",
    "path": "navigation-north.svg"
  },
  {
    "name": "navigation-off",
    "label": "Navigation Off",
    "path": "navigation-off.svg"
  },
  {
    "name": "navigation-pause",
    "label": "Navigation Pause",
    "path": "navigation-pause.svg"
  },
  {
    "name": "navigation-pin",
    "label": "Navigation Pin",
    "path": "navigation-pin.svg"
  },
  {
    "name": "navigation-plus",
    "label": "Navigation Plus",
    "path": "navigation-plus.svg"
  },
  {
    "name": "navigation-question",
    "label": "Navigation Question",
    "path": "navigation-question.svg"
  },
  {
    "name": "navigation-search",
    "label": "Navigation Search",
    "path": "navigation-search.svg"
  },
  {
    "name": "navigation-share",
    "label": "Navigation Share",
    "path": "navigation-share.svg"
  },
  {
    "name": "navigation-south",
    "label": "Navigation South",
    "path": "navigation-south.svg"
  },
  {
    "name": "navigation-star",
    "label": "Navigation Star",
    "path": "navigation-star.svg"
  },
  {
    "name": "navigation-top",
    "label": "Navigation Top",
    "path": "navigation-top.svg"
  },
  {
    "name": "navigation-up",
    "label": "Navigation Up",
    "path": "navigation-up.svg"
  },
  {
    "name": "navigation-west",
    "label": "Navigation West",
    "path": "navigation-west.svg"
  },
  {
    "name": "navigation-x",
    "label": "Navigation X",
    "path": "navigation-x.svg"
  },
  {
    "name": "needle",
    "label": "Needle",
    "path": "needle.svg"
  },
  {
    "name": "needle-thread",
    "label": "Needle Thread",
    "path": "needle-thread.svg"
  },
  {
    "name": "network",
    "label": "Network",
    "path": "network.svg"
  },
  {
    "name": "network-off",
    "label": "Network Off",
    "path": "network-off.svg"
  },
  {
    "name": "new-section",
    "label": "New Section",
    "path": "new-section.svg"
  },
  {
    "name": "news",
    "label": "News",
    "path": "news.svg"
  },
  {
    "name": "news-off",
    "label": "News Off",
    "path": "news-off.svg"
  },
  {
    "name": "nfc",
    "label": "Nfc",
    "path": "nfc.svg"
  },
  {
    "name": "nfc-off",
    "label": "Nfc Off",
    "path": "nfc-off.svg"
  },
  {
    "name": "no-copyright",
    "label": "No Copyright",
    "path": "no-copyright.svg"
  },
  {
    "name": "no-creative-commons",
    "label": "No Creative Commons",
    "path": "no-creative-commons.svg"
  },
  {
    "name": "no-derivatives",
    "label": "No Derivatives",
    "path": "no-derivatives.svg"
  },
  {
    "name": "north-star",
    "label": "North Star",
    "path": "north-star.svg"
  },
  {
    "name": "note",
    "label": "Note",
    "path": "note.svg"
  },
  {
    "name": "note-off",
    "label": "Note Off",
    "path": "note-off.svg"
  },
  {
    "name": "notebook",
    "label": "Notebook",
    "path": "notebook.svg"
  },
  {
    "name": "notebook-off",
    "label": "Notebook Off",
    "path": "notebook-off.svg"
  },
  {
    "name": "notes",
    "label": "Notes",
    "path": "notes.svg"
  },
  {
    "name": "notes-off",
    "label": "Notes Off",
    "path": "notes-off.svg"
  },
  {
    "name": "notification",
    "label": "Notification",
    "path": "notification.svg"
  },
  {
    "name": "notification-off",
    "label": "Notification Off",
    "path": "notification-off.svg"
  },
  {
    "name": "number",
    "label": "Number",
    "path": "number.svg"
  },
  {
    "name": "number-0",
    "label": "Number 0",
    "path": "number-0.svg"
  },
  {
    "name": "number-0-small",
    "label": "Number 0 Small",
    "path": "number-0-small.svg"
  },
  {
    "name": "number-1",
    "label": "Number 1",
    "path": "number-1.svg"
  },
  {
    "name": "number-1-small",
    "label": "Number 1 Small",
    "path": "number-1-small.svg"
  },
  {
    "name": "number-10",
    "label": "Number 10",
    "path": "number-10.svg"
  },
  {
    "name": "number-10-small",
    "label": "Number 10 Small",
    "path": "number-10-small.svg"
  },
  {
    "name": "number-100-small",
    "label": "Number 100 Small",
    "path": "number-100-small.svg"
  },
  {
    "name": "number-11",
    "label": "Number 11",
    "path": "number-11.svg"
  },
  {
    "name": "number-11-small",
    "label": "Number 11 Small",
    "path": "number-11-small.svg"
  },
  {
    "name": "number-12-small",
    "label": "Number 12 Small",
    "path": "number-12-small.svg"
  },
  {
    "name": "number-123",
    "label": "Number 123",
    "path": "number-123.svg"
  },
  {
    "name": "number-13-small",
    "label": "Number 13 Small",
    "path": "number-13-small.svg"
  },
  {
    "name": "number-14-small",
    "label": "Number 14 Small",
    "path": "number-14-small.svg"
  },
  {
    "name": "number-15-small",
    "label": "Number 15 Small",
    "path": "number-15-small.svg"
  },
  {
    "name": "number-16-small",
    "label": "Number 16 Small",
    "path": "number-16-small.svg"
  },
  {
    "name": "number-17-small",
    "label": "Number 17 Small",
    "path": "number-17-small.svg"
  },
  {
    "name": "number-18-small",
    "label": "Number 18 Small",
    "path": "number-18-small.svg"
  },
  {
    "name": "number-19-small",
    "label": "Number 19 Small",
    "path": "number-19-small.svg"
  },
  {
    "name": "number-2",
    "label": "Number 2",
    "path": "number-2.svg"
  },
  {
    "name": "number-2-small",
    "label": "Number 2 Small",
    "path": "number-2-small.svg"
  },
  {
    "name": "number-20-small",
    "label": "Number 20 Small",
    "path": "number-20-small.svg"
  },
  {
    "name": "number-21-small",
    "label": "Number 21 Small",
    "path": "number-21-small.svg"
  },
  {
    "name": "number-22-small",
    "label": "Number 22 Small",
    "path": "number-22-small.svg"
  },
  {
    "name": "number-23-small",
    "label": "Number 23 Small",
    "path": "number-23-small.svg"
  },
  {
    "name": "number-24-small",
    "label": "Number 24 Small",
    "path": "number-24-small.svg"
  },
  {
    "name": "number-25-small",
    "label": "Number 25 Small",
    "path": "number-25-small.svg"
  },
  {
    "name": "number-26-small",
    "label": "Number 26 Small",
    "path": "number-26-small.svg"
  },
  {
    "name": "number-27-small",
    "label": "Number 27 Small",
    "path": "number-27-small.svg"
  },
  {
    "name": "number-28-small",
    "label": "Number 28 Small",
    "path": "number-28-small.svg"
  },
  {
    "name": "number-29-small",
    "label": "Number 29 Small",
    "path": "number-29-small.svg"
  },
  {
    "name": "number-3",
    "label": "Number 3",
    "path": "number-3.svg"
  },
  {
    "name": "number-3-small",
    "label": "Number 3 Small",
    "path": "number-3-small.svg"
  },
  {
    "name": "number-30-small",
    "label": "Number 30 Small",
    "path": "number-30-small.svg"
  },
  {
    "name": "number-31-small",
    "label": "Number 31 Small",
    "path": "number-31-small.svg"
  },
  {
    "name": "number-32-small",
    "label": "Number 32 Small",
    "path": "number-32-small.svg"
  },
  {
    "name": "number-33-small",
    "label": "Number 33 Small",
    "path": "number-33-small.svg"
  },
  {
    "name": "number-34-small",
    "label": "Number 34 Small",
    "path": "number-34-small.svg"
  },
  {
    "name": "number-35-small",
    "label": "Number 35 Small",
    "path": "number-35-small.svg"
  },
  {
    "name": "number-36-small",
    "label": "Number 36 Small",
    "path": "number-36-small.svg"
  },
  {
    "name": "number-37-small",
    "label": "Number 37 Small",
    "path": "number-37-small.svg"
  },
  {
    "name": "number-38-small",
    "label": "Number 38 Small",
    "path": "number-38-small.svg"
  },
  {
    "name": "number-39-small",
    "label": "Number 39 Small",
    "path": "number-39-small.svg"
  },
  {
    "name": "number-4",
    "label": "Number 4",
    "path": "number-4.svg"
  },
  {
    "name": "number-4-small",
    "label": "Number 4 Small",
    "path": "number-4-small.svg"
  },
  {
    "name": "number-40-small",
    "label": "Number 40 Small",
    "path": "number-40-small.svg"
  },
  {
    "name": "number-41-small",
    "label": "Number 41 Small",
    "path": "number-41-small.svg"
  },
  {
    "name": "number-42-small",
    "label": "Number 42 Small",
    "path": "number-42-small.svg"
  },
  {
    "name": "number-43-small",
    "label": "Number 43 Small",
    "path": "number-43-small.svg"
  },
  {
    "name": "number-44-small",
    "label": "Number 44 Small",
    "path": "number-44-small.svg"
  },
  {
    "name": "number-45-small",
    "label": "Number 45 Small",
    "path": "number-45-small.svg"
  },
  {
    "name": "number-46-small",
    "label": "Number 46 Small",
    "path": "number-46-small.svg"
  },
  {
    "name": "number-47-small",
    "label": "Number 47 Small",
    "path": "number-47-small.svg"
  },
  {
    "name": "number-48-small",
    "label": "Number 48 Small",
    "path": "number-48-small.svg"
  },
  {
    "name": "number-49-small",
    "label": "Number 49 Small",
    "path": "number-49-small.svg"
  },
  {
    "name": "number-5",
    "label": "Number 5",
    "path": "number-5.svg"
  },
  {
    "name": "number-5-small",
    "label": "Number 5 Small",
    "path": "number-5-small.svg"
  },
  {
    "name": "number-50-small",
    "label": "Number 50 Small",
    "path": "number-50-small.svg"
  },
  {
    "name": "number-51-small",
    "label": "Number 51 Small",
    "path": "number-51-small.svg"
  },
  {
    "name": "number-52-small",
    "label": "Number 52 Small",
    "path": "number-52-small.svg"
  },
  {
    "name": "number-53-small",
    "label": "Number 53 Small",
    "path": "number-53-small.svg"
  },
  {
    "name": "number-54-small",
    "label": "Number 54 Small",
    "path": "number-54-small.svg"
  },
  {
    "name": "number-55-small",
    "label": "Number 55 Small",
    "path": "number-55-small.svg"
  },
  {
    "name": "number-56-small",
    "label": "Number 56 Small",
    "path": "number-56-small.svg"
  },
  {
    "name": "number-57-small",
    "label": "Number 57 Small",
    "path": "number-57-small.svg"
  },
  {
    "name": "number-58-small",
    "label": "Number 58 Small",
    "path": "number-58-small.svg"
  },
  {
    "name": "number-59-small",
    "label": "Number 59 Small",
    "path": "number-59-small.svg"
  },
  {
    "name": "number-6",
    "label": "Number 6",
    "path": "number-6.svg"
  },
  {
    "name": "number-6-small",
    "label": "Number 6 Small",
    "path": "number-6-small.svg"
  },
  {
    "name": "number-60-small",
    "label": "Number 60 Small",
    "path": "number-60-small.svg"
  },
  {
    "name": "number-61-small",
    "label": "Number 61 Small",
    "path": "number-61-small.svg"
  },
  {
    "name": "number-62-small",
    "label": "Number 62 Small",
    "path": "number-62-small.svg"
  },
  {
    "name": "number-63-small",
    "label": "Number 63 Small",
    "path": "number-63-small.svg"
  },
  {
    "name": "number-64-small",
    "label": "Number 64 Small",
    "path": "number-64-small.svg"
  },
  {
    "name": "number-65-small",
    "label": "Number 65 Small",
    "path": "number-65-small.svg"
  },
  {
    "name": "number-66-small",
    "label": "Number 66 Small",
    "path": "number-66-small.svg"
  },
  {
    "name": "number-67-small",
    "label": "Number 67 Small",
    "path": "number-67-small.svg"
  },
  {
    "name": "number-68-small",
    "label": "Number 68 Small",
    "path": "number-68-small.svg"
  },
  {
    "name": "number-69-small",
    "label": "Number 69 Small",
    "path": "number-69-small.svg"
  },
  {
    "name": "number-7",
    "label": "Number 7",
    "path": "number-7.svg"
  },
  {
    "name": "number-7-small",
    "label": "Number 7 Small",
    "path": "number-7-small.svg"
  },
  {
    "name": "number-70-small",
    "label": "Number 70 Small",
    "path": "number-70-small.svg"
  },
  {
    "name": "number-71-small",
    "label": "Number 71 Small",
    "path": "number-71-small.svg"
  },
  {
    "name": "number-72-small",
    "label": "Number 72 Small",
    "path": "number-72-small.svg"
  },
  {
    "name": "number-73-small",
    "label": "Number 73 Small",
    "path": "number-73-small.svg"
  },
  {
    "name": "number-74-small",
    "label": "Number 74 Small",
    "path": "number-74-small.svg"
  },
  {
    "name": "number-75-small",
    "label": "Number 75 Small",
    "path": "number-75-small.svg"
  },
  {
    "name": "number-76-small",
    "label": "Number 76 Small",
    "path": "number-76-small.svg"
  },
  {
    "name": "number-77-small",
    "label": "Number 77 Small",
    "path": "number-77-small.svg"
  },
  {
    "name": "number-78-small",
    "label": "Number 78 Small",
    "path": "number-78-small.svg"
  },
  {
    "name": "number-79-small",
    "label": "Number 79 Small",
    "path": "number-79-small.svg"
  },
  {
    "name": "number-8",
    "label": "Number 8",
    "path": "number-8.svg"
  },
  {
    "name": "number-8-small",
    "label": "Number 8 Small",
    "path": "number-8-small.svg"
  },
  {
    "name": "number-80-small",
    "label": "Number 80 Small",
    "path": "number-80-small.svg"
  },
  {
    "name": "number-81-small",
    "label": "Number 81 Small",
    "path": "number-81-small.svg"
  },
  {
    "name": "number-82-small",
    "label": "Number 82 Small",
    "path": "number-82-small.svg"
  },
  {
    "name": "number-83-small",
    "label": "Number 83 Small",
    "path": "number-83-small.svg"
  },
  {
    "name": "number-84-small",
    "label": "Number 84 Small",
    "path": "number-84-small.svg"
  },
  {
    "name": "number-85-small",
    "label": "Number 85 Small",
    "path": "number-85-small.svg"
  },
  {
    "name": "number-86-small",
    "label": "Number 86 Small",
    "path": "number-86-small.svg"
  },
  {
    "name": "number-87-small",
    "label": "Number 87 Small",
    "path": "number-87-small.svg"
  },
  {
    "name": "number-88-small",
    "label": "Number 88 Small",
    "path": "number-88-small.svg"
  },
  {
    "name": "number-89-small",
    "label": "Number 89 Small",
    "path": "number-89-small.svg"
  },
  {
    "name": "number-9",
    "label": "Number 9",
    "path": "number-9.svg"
  },
  {
    "name": "number-9-small",
    "label": "Number 9 Small",
    "path": "number-9-small.svg"
  },
  {
    "name": "number-90-small",
    "label": "Number 90 Small",
    "path": "number-90-small.svg"
  },
  {
    "name": "number-91-small",
    "label": "Number 91 Small",
    "path": "number-91-small.svg"
  },
  {
    "name": "number-92-small",
    "label": "Number 92 Small",
    "path": "number-92-small.svg"
  },
  {
    "name": "number-93-small",
    "label": "Number 93 Small",
    "path": "number-93-small.svg"
  },
  {
    "name": "number-94-small",
    "label": "Number 94 Small",
    "path": "number-94-small.svg"
  },
  {
    "name": "number-95-small",
    "label": "Number 95 Small",
    "path": "number-95-small.svg"
  },
  {
    "name": "number-96-small",
    "label": "Number 96 Small",
    "path": "number-96-small.svg"
  },
  {
    "name": "number-97-small",
    "label": "Number 97 Small",
    "path": "number-97-small.svg"
  },
  {
    "name": "number-98-small",
    "label": "Number 98 Small",
    "path": "number-98-small.svg"
  },
  {
    "name": "number-99-small",
    "label": "Number 99 Small",
    "path": "number-99-small.svg"
  },
  {
    "name": "numbers",
    "label": "Numbers",
    "path": "numbers.svg"
  },
  {
    "name": "nurse",
    "label": "Nurse",
    "path": "nurse.svg"
  },
  {
    "name": "nut",
    "label": "Nut",
    "path": "nut.svg"
  },
  {
    "name": "object-scan",
    "label": "Object Scan",
    "path": "object-scan.svg"
  },
  {
    "name": "octagon",
    "label": "Octagon",
    "path": "octagon.svg"
  },
  {
    "name": "octagon-minus",
    "label": "Octagon Minus",
    "path": "octagon-minus.svg"
  },
  {
    "name": "octagon-minus-2",
    "label": "Octagon Minus 2",
    "path": "octagon-minus-2.svg"
  },
  {
    "name": "octagon-off",
    "label": "Octagon Off",
    "path": "octagon-off.svg"
  },
  {
    "name": "octagon-plus",
    "label": "Octagon Plus",
    "path": "octagon-plus.svg"
  },
  {
    "name": "octagon-plus-2",
    "label": "Octagon Plus 2",
    "path": "octagon-plus-2.svg"
  },
  {
    "name": "octahedron",
    "label": "Octahedron",
    "path": "octahedron.svg"
  },
  {
    "name": "octahedron-off",
    "label": "Octahedron Off",
    "path": "octahedron-off.svg"
  },
  {
    "name": "octahedron-plus",
    "label": "Octahedron Plus",
    "path": "octahedron-plus.svg"
  },
  {
    "name": "old",
    "label": "Old",
    "path": "old.svg"
  },
  {
    "name": "olympics",
    "label": "Olympics",
    "path": "olympics.svg"
  },
  {
    "name": "olympics-off",
    "label": "Olympics Off",
    "path": "olympics-off.svg"
  },
  {
    "name": "om",
    "label": "Om",
    "path": "om.svg"
  },
  {
    "name": "omega",
    "label": "Omega",
    "path": "omega.svg"
  },
  {
    "name": "option",
    "label": "Option",
    "path": "option.svg"
  },
  {
    "name": "outbound",
    "label": "Outbound",
    "path": "outbound.svg"
  },
  {
    "name": "outlet",
    "label": "Outlet",
    "path": "outlet.svg"
  },
  {
    "name": "oval",
    "label": "Oval",
    "path": "oval.svg"
  },
  {
    "name": "oval-vertical",
    "label": "Oval Vertical",
    "path": "oval-vertical.svg"
  },
  {
    "name": "overline",
    "label": "Overline",
    "path": "overline.svg"
  },
  {
    "name": "package",
    "label": "Package",
    "path": "package.svg"
  },
  {
    "name": "package-export",
    "label": "Package Export",
    "path": "package-export.svg"
  },
  {
    "name": "package-import",
    "label": "Package Import",
    "path": "package-import.svg"
  },
  {
    "name": "package-off",
    "label": "Package Off",
    "path": "package-off.svg"
  },
  {
    "name": "packages",
    "label": "Packages",
    "path": "packages.svg"
  },
  {
    "name": "pacman",
    "label": "Pacman",
    "path": "pacman.svg"
  },
  {
    "name": "page-break",
    "label": "Page Break",
    "path": "page-break.svg"
  },
  {
    "name": "paint",
    "label": "Paint",
    "path": "paint.svg"
  },
  {
    "name": "paint-off",
    "label": "Paint Off",
    "path": "paint-off.svg"
  },
  {
    "name": "palette",
    "label": "Palette",
    "path": "palette.svg"
  },
  {
    "name": "palette-off",
    "label": "Palette Off",
    "path": "palette-off.svg"
  },
  {
    "name": "panorama-horizontal",
    "label": "Panorama Horizontal",
    "path": "panorama-horizontal.svg"
  },
  {
    "name": "panorama-horizontal-off",
    "label": "Panorama Horizontal Off",
    "path": "panorama-horizontal-off.svg"
  },
  {
    "name": "panorama-vertical",
    "label": "Panorama Vertical",
    "path": "panorama-vertical.svg"
  },
  {
    "name": "panorama-vertical-off",
    "label": "Panorama Vertical Off",
    "path": "panorama-vertical-off.svg"
  },
  {
    "name": "paper-bag",
    "label": "Paper Bag",
    "path": "paper-bag.svg"
  },
  {
    "name": "paper-bag-off",
    "label": "Paper Bag Off",
    "path": "paper-bag-off.svg"
  },
  {
    "name": "paperclip",
    "label": "Paperclip",
    "path": "paperclip.svg"
  },
  {
    "name": "parachute",
    "label": "Parachute",
    "path": "parachute.svg"
  },
  {
    "name": "parachute-off",
    "label": "Parachute Off",
    "path": "parachute-off.svg"
  },
  {
    "name": "parentheses",
    "label": "Parentheses",
    "path": "parentheses.svg"
  },
  {
    "name": "parentheses-off",
    "label": "Parentheses Off",
    "path": "parentheses-off.svg"
  },
  {
    "name": "parking",
    "label": "Parking",
    "path": "parking.svg"
  },
  {
    "name": "parking-circle",
    "label": "Parking Circle",
    "path": "parking-circle.svg"
  },
  {
    "name": "parking-off",
    "label": "Parking Off",
    "path": "parking-off.svg"
  },
  {
    "name": "password",
    "label": "Password",
    "path": "password.svg"
  },
  {
    "name": "password-fingerprint",
    "label": "Password Fingerprint",
    "path": "password-fingerprint.svg"
  },
  {
    "name": "password-mobile-phone",
    "label": "Password Mobile Phone",
    "path": "password-mobile-phone.svg"
  },
  {
    "name": "password-user",
    "label": "Password User",
    "path": "password-user.svg"
  },
  {
    "name": "paw",
    "label": "Paw",
    "path": "paw.svg"
  },
  {
    "name": "paw-off",
    "label": "Paw Off",
    "path": "paw-off.svg"
  },
  {
    "name": "paywall",
    "label": "Paywall",
    "path": "paywall.svg"
  },
  {
    "name": "pdf",
    "label": "Pdf",
    "path": "pdf.svg"
  },
  {
    "name": "peace",
    "label": "Peace",
    "path": "peace.svg"
  },
  {
    "name": "pencil",
    "label": "Pencil",
    "path": "pencil.svg"
  },
  {
    "name": "pencil-bolt",
    "label": "Pencil Bolt",
    "path": "pencil-bolt.svg"
  },
  {
    "name": "pencil-cancel",
    "label": "Pencil Cancel",
    "path": "pencil-cancel.svg"
  },
  {
    "name": "pencil-check",
    "label": "Pencil Check",
    "path": "pencil-check.svg"
  },
  {
    "name": "pencil-code",
    "label": "Pencil Code",
    "path": "pencil-code.svg"
  },
  {
    "name": "pencil-cog",
    "label": "Pencil Cog",
    "path": "pencil-cog.svg"
  },
  {
    "name": "pencil-discount",
    "label": "Pencil Discount",
    "path": "pencil-discount.svg"
  },
  {
    "name": "pencil-dollar",
    "label": "Pencil Dollar",
    "path": "pencil-dollar.svg"
  },
  {
    "name": "pencil-down",
    "label": "Pencil Down",
    "path": "pencil-down.svg"
  },
  {
    "name": "pencil-exclamation",
    "label": "Pencil Exclamation",
    "path": "pencil-exclamation.svg"
  },
  {
    "name": "pencil-heart",
    "label": "Pencil Heart",
    "path": "pencil-heart.svg"
  },
  {
    "name": "pencil-minus",
    "label": "Pencil Minus",
    "path": "pencil-minus.svg"
  },
  {
    "name": "pencil-off",
    "label": "Pencil Off",
    "path": "pencil-off.svg"
  },
  {
    "name": "pencil-pause",
    "label": "Pencil Pause",
    "path": "pencil-pause.svg"
  },
  {
    "name": "pencil-pin",
    "label": "Pencil Pin",
    "path": "pencil-pin.svg"
  },
  {
    "name": "pencil-plus",
    "label": "Pencil Plus",
    "path": "pencil-plus.svg"
  },
  {
    "name": "pencil-question",
    "label": "Pencil Question",
    "path": "pencil-question.svg"
  },
  {
    "name": "pencil-search",
    "label": "Pencil Search",
    "path": "pencil-search.svg"
  },
  {
    "name": "pencil-share",
    "label": "Pencil Share",
    "path": "pencil-share.svg"
  },
  {
    "name": "pencil-star",
    "label": "Pencil Star",
    "path": "pencil-star.svg"
  },
  {
    "name": "pencil-up",
    "label": "Pencil Up",
    "path": "pencil-up.svg"
  },
  {
    "name": "pencil-x",
    "label": "Pencil X",
    "path": "pencil-x.svg"
  },
  {
    "name": "pennant",
    "label": "Pennant",
    "path": "pennant.svg"
  },
  {
    "name": "pennant-2",
    "label": "Pennant 2",
    "path": "pennant-2.svg"
  },
  {
    "name": "pennant-off",
    "label": "Pennant Off",
    "path": "pennant-off.svg"
  },
  {
    "name": "pentagon",
    "label": "Pentagon",
    "path": "pentagon.svg"
  },
  {
    "name": "pentagon-minus",
    "label": "Pentagon Minus",
    "path": "pentagon-minus.svg"
  },
  {
    "name": "pentagon-number-0",
    "label": "Pentagon Number 0",
    "path": "pentagon-number-0.svg"
  },
  {
    "name": "pentagon-number-1",
    "label": "Pentagon Number 1",
    "path": "pentagon-number-1.svg"
  },
  {
    "name": "pentagon-number-2",
    "label": "Pentagon Number 2",
    "path": "pentagon-number-2.svg"
  },
  {
    "name": "pentagon-number-3",
    "label": "Pentagon Number 3",
    "path": "pentagon-number-3.svg"
  },
  {
    "name": "pentagon-number-4",
    "label": "Pentagon Number 4",
    "path": "pentagon-number-4.svg"
  },
  {
    "name": "pentagon-number-5",
    "label": "Pentagon Number 5",
    "path": "pentagon-number-5.svg"
  },
  {
    "name": "pentagon-number-6",
    "label": "Pentagon Number 6",
    "path": "pentagon-number-6.svg"
  },
  {
    "name": "pentagon-number-7",
    "label": "Pentagon Number 7",
    "path": "pentagon-number-7.svg"
  },
  {
    "name": "pentagon-number-8",
    "label": "Pentagon Number 8",
    "path": "pentagon-number-8.svg"
  },
  {
    "name": "pentagon-number-9",
    "label": "Pentagon Number 9",
    "path": "pentagon-number-9.svg"
  },
  {
    "name": "pentagon-off",
    "label": "Pentagon Off",
    "path": "pentagon-off.svg"
  },
  {
    "name": "pentagon-plus",
    "label": "Pentagon Plus",
    "path": "pentagon-plus.svg"
  },
  {
    "name": "pentagon-x",
    "label": "Pentagon X",
    "path": "pentagon-x.svg"
  },
  {
    "name": "pentagram",
    "label": "Pentagram",
    "path": "pentagram.svg"
  },
  {
    "name": "pepper",
    "label": "Pepper",
    "path": "pepper.svg"
  },
  {
    "name": "pepper-off",
    "label": "Pepper Off",
    "path": "pepper-off.svg"
  },
  {
    "name": "percentage",
    "label": "Percentage",
    "path": "percentage.svg"
  },
  {
    "name": "percentage-0",
    "label": "Percentage 0",
    "path": "percentage-0.svg"
  },
  {
    "name": "percentage-10",
    "label": "Percentage 10",
    "path": "percentage-10.svg"
  },
  {
    "name": "percentage-100",
    "label": "Percentage 100",
    "path": "percentage-100.svg"
  },
  {
    "name": "percentage-20",
    "label": "Percentage 20",
    "path": "percentage-20.svg"
  },
  {
    "name": "percentage-25",
    "label": "Percentage 25",
    "path": "percentage-25.svg"
  },
  {
    "name": "percentage-30",
    "label": "Percentage 30",
    "path": "percentage-30.svg"
  },
  {
    "name": "percentage-33",
    "label": "Percentage 33",
    "path": "percentage-33.svg"
  },
  {
    "name": "percentage-40",
    "label": "Percentage 40",
    "path": "percentage-40.svg"
  },
  {
    "name": "percentage-50",
    "label": "Percentage 50",
    "path": "percentage-50.svg"
  },
  {
    "name": "percentage-60",
    "label": "Percentage 60",
    "path": "percentage-60.svg"
  },
  {
    "name": "percentage-66",
    "label": "Percentage 66",
    "path": "percentage-66.svg"
  },
  {
    "name": "percentage-70",
    "label": "Percentage 70",
    "path": "percentage-70.svg"
  },
  {
    "name": "percentage-75",
    "label": "Percentage 75",
    "path": "percentage-75.svg"
  },
  {
    "name": "percentage-80",
    "label": "Percentage 80",
    "path": "percentage-80.svg"
  },
  {
    "name": "percentage-90",
    "label": "Percentage 90",
    "path": "percentage-90.svg"
  },
  {
    "name": "perfume",
    "label": "Perfume",
    "path": "perfume.svg"
  },
  {
    "name": "perspective",
    "label": "Perspective",
    "path": "perspective.svg"
  },
  {
    "name": "perspective-off",
    "label": "Perspective Off",
    "path": "perspective-off.svg"
  },
  {
    "name": "phone",
    "label": "Phone",
    "path": "phone.svg"
  },
  {
    "name": "phone-call",
    "label": "Phone Call",
    "path": "phone-call.svg"
  },
  {
    "name": "phone-calling",
    "label": "Phone Calling",
    "path": "phone-calling.svg"
  },
  {
    "name": "phone-check",
    "label": "Phone Check",
    "path": "phone-check.svg"
  },
  {
    "name": "phone-done",
    "label": "Phone Done",
    "path": "phone-done.svg"
  },
  {
    "name": "phone-end",
    "label": "Phone End",
    "path": "phone-end.svg"
  },
  {
    "name": "phone-incoming",
    "label": "Phone Incoming",
    "path": "phone-incoming.svg"
  },
  {
    "name": "phone-off",
    "label": "Phone Off",
    "path": "phone-off.svg"
  },
  {
    "name": "phone-outgoing",
    "label": "Phone Outgoing",
    "path": "phone-outgoing.svg"
  },
  {
    "name": "phone-pause",
    "label": "Phone Pause",
    "path": "phone-pause.svg"
  },
  {
    "name": "phone-plus",
    "label": "Phone Plus",
    "path": "phone-plus.svg"
  },
  {
    "name": "phone-ringing",
    "label": "Phone Ringing",
    "path": "phone-ringing.svg"
  },
  {
    "name": "phone-spark",
    "label": "Phone Spark",
    "path": "phone-spark.svg"
  },
  {
    "name": "phone-x",
    "label": "Phone X",
    "path": "phone-x.svg"
  },
  {
    "name": "photo",
    "label": "Photo",
    "path": "photo.svg"
  },
  {
    "name": "photo-ai",
    "label": "Photo Ai",
    "path": "photo-ai.svg"
  },
  {
    "name": "photo-bitcoin",
    "label": "Photo Bitcoin",
    "path": "photo-bitcoin.svg"
  },
  {
    "name": "photo-bolt",
    "label": "Photo Bolt",
    "path": "photo-bolt.svg"
  },
  {
    "name": "photo-cancel",
    "label": "Photo Cancel",
    "path": "photo-cancel.svg"
  },
  {
    "name": "photo-check",
    "label": "Photo Check",
    "path": "photo-check.svg"
  },
  {
    "name": "photo-circle",
    "label": "Photo Circle",
    "path": "photo-circle.svg"
  },
  {
    "name": "photo-circle-minus",
    "label": "Photo Circle Minus",
    "path": "photo-circle-minus.svg"
  },
  {
    "name": "photo-circle-plus",
    "label": "Photo Circle Plus",
    "path": "photo-circle-plus.svg"
  },
  {
    "name": "photo-code",
    "label": "Photo Code",
    "path": "photo-code.svg"
  },
  {
    "name": "photo-cog",
    "label": "Photo Cog",
    "path": "photo-cog.svg"
  },
  {
    "name": "photo-dollar",
    "label": "Photo Dollar",
    "path": "photo-dollar.svg"
  },
  {
    "name": "photo-down",
    "label": "Photo Down",
    "path": "photo-down.svg"
  },
  {
    "name": "photo-edit",
    "label": "Photo Edit",
    "path": "photo-edit.svg"
  },
  {
    "name": "photo-exclamation",
    "label": "Photo Exclamation",
    "path": "photo-exclamation.svg"
  },
  {
    "name": "photo-heart",
    "label": "Photo Heart",
    "path": "photo-heart.svg"
  },
  {
    "name": "photo-hexagon",
    "label": "Photo Hexagon",
    "path": "photo-hexagon.svg"
  },
  {
    "name": "photo-minus",
    "label": "Photo Minus",
    "path": "photo-minus.svg"
  },
  {
    "name": "photo-off",
    "label": "Photo Off",
    "path": "photo-off.svg"
  },
  {
    "name": "photo-pause",
    "label": "Photo Pause",
    "path": "photo-pause.svg"
  },
  {
    "name": "photo-pentagon",
    "label": "Photo Pentagon",
    "path": "photo-pentagon.svg"
  },
  {
    "name": "photo-pin",
    "label": "Photo Pin",
    "path": "photo-pin.svg"
  },
  {
    "name": "photo-plus",
    "label": "Photo Plus",
    "path": "photo-plus.svg"
  },
  {
    "name": "photo-question",
    "label": "Photo Question",
    "path": "photo-question.svg"
  },
  {
    "name": "photo-scan",
    "label": "Photo Scan",
    "path": "photo-scan.svg"
  },
  {
    "name": "photo-search",
    "label": "Photo Search",
    "path": "photo-search.svg"
  },
  {
    "name": "photo-sensor",
    "label": "Photo Sensor",
    "path": "photo-sensor.svg"
  },
  {
    "name": "photo-sensor-2",
    "label": "Photo Sensor 2",
    "path": "photo-sensor-2.svg"
  },
  {
    "name": "photo-sensor-3",
    "label": "Photo Sensor 3",
    "path": "photo-sensor-3.svg"
  },
  {
    "name": "photo-share",
    "label": "Photo Share",
    "path": "photo-share.svg"
  },
  {
    "name": "photo-shield",
    "label": "Photo Shield",
    "path": "photo-shield.svg"
  },
  {
    "name": "photo-spark",
    "label": "Photo Spark",
    "path": "photo-spark.svg"
  },
  {
    "name": "photo-square-rounded",
    "label": "Photo Square Rounded",
    "path": "photo-square-rounded.svg"
  },
  {
    "name": "photo-star",
    "label": "Photo Star",
    "path": "photo-star.svg"
  },
  {
    "name": "photo-up",
    "label": "Photo Up",
    "path": "photo-up.svg"
  },
  {
    "name": "photo-video",
    "label": "Photo Video",
    "path": "photo-video.svg"
  },
  {
    "name": "photo-x",
    "label": "Photo X",
    "path": "photo-x.svg"
  },
  {
    "name": "physotherapist",
    "label": "Physotherapist",
    "path": "physotherapist.svg"
  },
  {
    "name": "piano",
    "label": "Piano",
    "path": "piano.svg"
  },
  {
    "name": "pick",
    "label": "Pick",
    "path": "pick.svg"
  },
  {
    "name": "picnic-table",
    "label": "Picnic Table",
    "path": "picnic-table.svg"
  },
  {
    "name": "picture-in-picture",
    "label": "Picture In Picture",
    "path": "picture-in-picture.svg"
  },
  {
    "name": "picture-in-picture-off",
    "label": "Picture In Picture Off",
    "path": "picture-in-picture-off.svg"
  },
  {
    "name": "picture-in-picture-on",
    "label": "Picture In Picture On",
    "path": "picture-in-picture-on.svg"
  },
  {
    "name": "picture-in-picture-top",
    "label": "Picture In Picture Top",
    "path": "picture-in-picture-top.svg"
  },
  {
    "name": "pig",
    "label": "Pig",
    "path": "pig.svg"
  },
  {
    "name": "pig-money",
    "label": "Pig Money",
    "path": "pig-money.svg"
  },
  {
    "name": "pig-off",
    "label": "Pig Off",
    "path": "pig-off.svg"
  },
  {
    "name": "pilcrow",
    "label": "Pilcrow",
    "path": "pilcrow.svg"
  },
  {
    "name": "pilcrow-left",
    "label": "Pilcrow Left",
    "path": "pilcrow-left.svg"
  },
  {
    "name": "pilcrow-right",
    "label": "Pilcrow Right",
    "path": "pilcrow-right.svg"
  },
  {
    "name": "pill",
    "label": "Pill",
    "path": "pill.svg"
  },
  {
    "name": "pill-off",
    "label": "Pill Off",
    "path": "pill-off.svg"
  },
  {
    "name": "pills",
    "label": "Pills",
    "path": "pills.svg"
  },
  {
    "name": "pin",
    "label": "Pin",
    "path": "pin.svg"
  },
  {
    "name": "pin-end",
    "label": "Pin End",
    "path": "pin-end.svg"
  },
  {
    "name": "pin-invoke",
    "label": "Pin Invoke",
    "path": "pin-invoke.svg"
  },
  {
    "name": "ping-pong",
    "label": "Ping Pong",
    "path": "ping-pong.svg"
  },
  {
    "name": "pinned",
    "label": "Pinned",
    "path": "pinned.svg"
  },
  {
    "name": "pinned-off",
    "label": "Pinned Off",
    "path": "pinned-off.svg"
  },
  {
    "name": "pizza",
    "label": "Pizza",
    "path": "pizza.svg"
  },
  {
    "name": "pizza-off",
    "label": "Pizza Off",
    "path": "pizza-off.svg"
  },
  {
    "name": "placeholder",
    "label": "Placeholder",
    "path": "placeholder.svg"
  },
  {
    "name": "plane",
    "label": "Plane",
    "path": "plane.svg"
  },
  {
    "name": "plane-arrival",
    "label": "Plane Arrival",
    "path": "plane-arrival.svg"
  },
  {
    "name": "plane-departure",
    "label": "Plane Departure",
    "path": "plane-departure.svg"
  },
  {
    "name": "plane-inflight",
    "label": "Plane Inflight",
    "path": "plane-inflight.svg"
  },
  {
    "name": "plane-off",
    "label": "Plane Off",
    "path": "plane-off.svg"
  },
  {
    "name": "plane-tilt",
    "label": "Plane Tilt",
    "path": "plane-tilt.svg"
  },
  {
    "name": "planet",
    "label": "Planet",
    "path": "planet.svg"
  },
  {
    "name": "planet-off",
    "label": "Planet Off",
    "path": "planet-off.svg"
  },
  {
    "name": "plant",
    "label": "Plant",
    "path": "plant.svg"
  },
  {
    "name": "plant-2",
    "label": "Plant 2",
    "path": "plant-2.svg"
  },
  {
    "name": "plant-2-off",
    "label": "Plant 2 Off",
    "path": "plant-2-off.svg"
  },
  {
    "name": "plant-off",
    "label": "Plant Off",
    "path": "plant-off.svg"
  },
  {
    "name": "play-basketball",
    "label": "Play Basketball",
    "path": "play-basketball.svg"
  },
  {
    "name": "play-card",
    "label": "Play Card",
    "path": "play-card.svg"
  },
  {
    "name": "play-card-1",
    "label": "Play Card 1",
    "path": "play-card-1.svg"
  },
  {
    "name": "play-card-10",
    "label": "Play Card 10",
    "path": "play-card-10.svg"
  },
  {
    "name": "play-card-2",
    "label": "Play Card 2",
    "path": "play-card-2.svg"
  },
  {
    "name": "play-card-3",
    "label": "Play Card 3",
    "path": "play-card-3.svg"
  },
  {
    "name": "play-card-4",
    "label": "Play Card 4",
    "path": "play-card-4.svg"
  },
  {
    "name": "play-card-5",
    "label": "Play Card 5",
    "path": "play-card-5.svg"
  },
  {
    "name": "play-card-6",
    "label": "Play Card 6",
    "path": "play-card-6.svg"
  },
  {
    "name": "play-card-7",
    "label": "Play Card 7",
    "path": "play-card-7.svg"
  },
  {
    "name": "play-card-8",
    "label": "Play Card 8",
    "path": "play-card-8.svg"
  },
  {
    "name": "play-card-9",
    "label": "Play Card 9",
    "path": "play-card-9.svg"
  },
  {
    "name": "play-card-a",
    "label": "Play Card A",
    "path": "play-card-a.svg"
  },
  {
    "name": "play-card-j",
    "label": "Play Card J",
    "path": "play-card-j.svg"
  },
  {
    "name": "play-card-k",
    "label": "Play Card K",
    "path": "play-card-k.svg"
  },
  {
    "name": "play-card-off",
    "label": "Play Card Off",
    "path": "play-card-off.svg"
  },
  {
    "name": "play-card-q",
    "label": "Play Card Q",
    "path": "play-card-q.svg"
  },
  {
    "name": "play-card-star",
    "label": "Play Card Star",
    "path": "play-card-star.svg"
  },
  {
    "name": "play-football",
    "label": "Play Football",
    "path": "play-football.svg"
  },
  {
    "name": "play-handball",
    "label": "Play Handball",
    "path": "play-handball.svg"
  },
  {
    "name": "play-volleyball",
    "label": "Play Volleyball",
    "path": "play-volleyball.svg"
  },
  {
    "name": "player-eject",
    "label": "Player Eject",
    "path": "player-eject.svg"
  },
  {
    "name": "player-pause",
    "label": "Player Pause",
    "path": "player-pause.svg"
  },
  {
    "name": "player-play",
    "label": "Player Play",
    "path": "player-play.svg"
  },
  {
    "name": "player-record",
    "label": "Player Record",
    "path": "player-record.svg"
  },
  {
    "name": "player-skip-back",
    "label": "Player Skip Back",
    "path": "player-skip-back.svg"
  },
  {
    "name": "player-skip-forward",
    "label": "Player Skip Forward",
    "path": "player-skip-forward.svg"
  },
  {
    "name": "player-stop",
    "label": "Player Stop",
    "path": "player-stop.svg"
  },
  {
    "name": "player-track-next",
    "label": "Player Track Next",
    "path": "player-track-next.svg"
  },
  {
    "name": "player-track-prev",
    "label": "Player Track Prev",
    "path": "player-track-prev.svg"
  },
  {
    "name": "playlist",
    "label": "Playlist",
    "path": "playlist.svg"
  },
  {
    "name": "playlist-add",
    "label": "Playlist Add",
    "path": "playlist-add.svg"
  },
  {
    "name": "playlist-off",
    "label": "Playlist Off",
    "path": "playlist-off.svg"
  },
  {
    "name": "playlist-x",
    "label": "Playlist X",
    "path": "playlist-x.svg"
  },
  {
    "name": "playstation-circle",
    "label": "Playstation Circle",
    "path": "playstation-circle.svg"
  },
  {
    "name": "playstation-square",
    "label": "Playstation Square",
    "path": "playstation-square.svg"
  },
  {
    "name": "playstation-triangle",
    "label": "Playstation Triangle",
    "path": "playstation-triangle.svg"
  },
  {
    "name": "playstation-x",
    "label": "Playstation X",
    "path": "playstation-x.svg"
  },
  {
    "name": "plug",
    "label": "Plug",
    "path": "plug.svg"
  },
  {
    "name": "plug-connected",
    "label": "Plug Connected",
    "path": "plug-connected.svg"
  },
  {
    "name": "plug-connected-x",
    "label": "Plug Connected X",
    "path": "plug-connected-x.svg"
  },
  {
    "name": "plug-off",
    "label": "Plug Off",
    "path": "plug-off.svg"
  },
  {
    "name": "plug-x",
    "label": "Plug X",
    "path": "plug-x.svg"
  },
  {
    "name": "plus",
    "label": "Plus",
    "path": "plus.svg"
  },
  {
    "name": "plus-equal",
    "label": "Plus Equal",
    "path": "plus-equal.svg"
  },
  {
    "name": "plus-minus",
    "label": "Plus Minus",
    "path": "plus-minus.svg"
  },
  {
    "name": "png",
    "label": "Png",
    "path": "png.svg"
  },
  {
    "name": "podium",
    "label": "Podium",
    "path": "podium.svg"
  },
  {
    "name": "podium-off",
    "label": "Podium Off",
    "path": "podium-off.svg"
  },
  {
    "name": "point",
    "label": "Point",
    "path": "point.svg"
  },
  {
    "name": "point-off",
    "label": "Point Off",
    "path": "point-off.svg"
  },
  {
    "name": "pointer",
    "label": "Pointer",
    "path": "pointer.svg"
  },
  {
    "name": "pointer-bolt",
    "label": "Pointer Bolt",
    "path": "pointer-bolt.svg"
  },
  {
    "name": "pointer-cancel",
    "label": "Pointer Cancel",
    "path": "pointer-cancel.svg"
  },
  {
    "name": "pointer-check",
    "label": "Pointer Check",
    "path": "pointer-check.svg"
  },
  {
    "name": "pointer-code",
    "label": "Pointer Code",
    "path": "pointer-code.svg"
  },
  {
    "name": "pointer-cog",
    "label": "Pointer Cog",
    "path": "pointer-cog.svg"
  },
  {
    "name": "pointer-dollar",
    "label": "Pointer Dollar",
    "path": "pointer-dollar.svg"
  },
  {
    "name": "pointer-down",
    "label": "Pointer Down",
    "path": "pointer-down.svg"
  },
  {
    "name": "pointer-exclamation",
    "label": "Pointer Exclamation",
    "path": "pointer-exclamation.svg"
  },
  {
    "name": "pointer-heart",
    "label": "Pointer Heart",
    "path": "pointer-heart.svg"
  },
  {
    "name": "pointer-minus",
    "label": "Pointer Minus",
    "path": "pointer-minus.svg"
  },
  {
    "name": "pointer-off",
    "label": "Pointer Off",
    "path": "pointer-off.svg"
  },
  {
    "name": "pointer-pause",
    "label": "Pointer Pause",
    "path": "pointer-pause.svg"
  },
  {
    "name": "pointer-pin",
    "label": "Pointer Pin",
    "path": "pointer-pin.svg"
  },
  {
    "name": "pointer-plus",
    "label": "Pointer Plus",
    "path": "pointer-plus.svg"
  },
  {
    "name": "pointer-question",
    "label": "Pointer Question",
    "path": "pointer-question.svg"
  },
  {
    "name": "pointer-search",
    "label": "Pointer Search",
    "path": "pointer-search.svg"
  },
  {
    "name": "pointer-share",
    "label": "Pointer Share",
    "path": "pointer-share.svg"
  },
  {
    "name": "pointer-star",
    "label": "Pointer Star",
    "path": "pointer-star.svg"
  },
  {
    "name": "pointer-up",
    "label": "Pointer Up",
    "path": "pointer-up.svg"
  },
  {
    "name": "pointer-x",
    "label": "Pointer X",
    "path": "pointer-x.svg"
  },
  {
    "name": "pokeball",
    "label": "Pokeball",
    "path": "pokeball.svg"
  },
  {
    "name": "pokeball-off",
    "label": "Pokeball Off",
    "path": "pokeball-off.svg"
  },
  {
    "name": "poker-chip",
    "label": "Poker Chip",
    "path": "poker-chip.svg"
  },
  {
    "name": "polaroid",
    "label": "Polaroid",
    "path": "polaroid.svg"
  },
  {
    "name": "polygon",
    "label": "Polygon",
    "path": "polygon.svg"
  },
  {
    "name": "polygon-off",
    "label": "Polygon Off",
    "path": "polygon-off.svg"
  },
  {
    "name": "poo",
    "label": "Poo",
    "path": "poo.svg"
  },
  {
    "name": "pool",
    "label": "Pool",
    "path": "pool.svg"
  },
  {
    "name": "pool-off",
    "label": "Pool Off",
    "path": "pool-off.svg"
  },
  {
    "name": "power",
    "label": "Power",
    "path": "power.svg"
  },
  {
    "name": "pray",
    "label": "Pray",
    "path": "pray.svg"
  },
  {
    "name": "premium-rights",
    "label": "Premium Rights",
    "path": "premium-rights.svg"
  },
  {
    "name": "prescription",
    "label": "Prescription",
    "path": "prescription.svg"
  },
  {
    "name": "presentation",
    "label": "Presentation",
    "path": "presentation.svg"
  },
  {
    "name": "presentation-analytics",
    "label": "Presentation Analytics",
    "path": "presentation-analytics.svg"
  },
  {
    "name": "presentation-off",
    "label": "Presentation Off",
    "path": "presentation-off.svg"
  },
  {
    "name": "printer",
    "label": "Printer",
    "path": "printer.svg"
  },
  {
    "name": "printer-off",
    "label": "Printer Off",
    "path": "printer-off.svg"
  },
  {
    "name": "prism",
    "label": "Prism",
    "path": "prism.svg"
  },
  {
    "name": "prism-light",
    "label": "Prism Light",
    "path": "prism-light.svg"
  },
  {
    "name": "prism-off",
    "label": "Prism Off",
    "path": "prism-off.svg"
  },
  {
    "name": "prism-plus",
    "label": "Prism Plus",
    "path": "prism-plus.svg"
  },
  {
    "name": "prison",
    "label": "Prison",
    "path": "prison.svg"
  },
  {
    "name": "progress",
    "label": "Progress",
    "path": "progress.svg"
  },
  {
    "name": "progress-alert",
    "label": "Progress Alert",
    "path": "progress-alert.svg"
  },
  {
    "name": "progress-bolt",
    "label": "Progress Bolt",
    "path": "progress-bolt.svg"
  },
  {
    "name": "progress-check",
    "label": "Progress Check",
    "path": "progress-check.svg"
  },
  {
    "name": "progress-down",
    "label": "Progress Down",
    "path": "progress-down.svg"
  },
  {
    "name": "progress-help",
    "label": "Progress Help",
    "path": "progress-help.svg"
  },
  {
    "name": "progress-x",
    "label": "Progress X",
    "path": "progress-x.svg"
  },
  {
    "name": "prompt",
    "label": "Prompt",
    "path": "prompt.svg"
  },
  {
    "name": "prong",
    "label": "Prong",
    "path": "prong.svg"
  },
  {
    "name": "propeller",
    "label": "Propeller",
    "path": "propeller.svg"
  },
  {
    "name": "propeller-off",
    "label": "Propeller Off",
    "path": "propeller-off.svg"
  },
  {
    "name": "protocol",
    "label": "Protocol",
    "path": "protocol.svg"
  },
  {
    "name": "pumpkin-scary",
    "label": "Pumpkin Scary",
    "path": "pumpkin-scary.svg"
  },
  {
    "name": "puzzle",
    "label": "Puzzle",
    "path": "puzzle.svg"
  },
  {
    "name": "puzzle-2",
    "label": "Puzzle 2",
    "path": "puzzle-2.svg"
  },
  {
    "name": "puzzle-off",
    "label": "Puzzle Off",
    "path": "puzzle-off.svg"
  },
  {
    "name": "pyramid",
    "label": "Pyramid",
    "path": "pyramid.svg"
  },
  {
    "name": "pyramid-off",
    "label": "Pyramid Off",
    "path": "pyramid-off.svg"
  },
  {
    "name": "pyramid-plus",
    "label": "Pyramid Plus",
    "path": "pyramid-plus.svg"
  },
  {
    "name": "qrcode",
    "label": "Qrcode",
    "path": "qrcode.svg"
  },
  {
    "name": "qrcode-off",
    "label": "Qrcode Off",
    "path": "qrcode-off.svg"
  },
  {
    "name": "question-mark",
    "label": "Question Mark",
    "path": "question-mark.svg"
  },
  {
    "name": "quote",
    "label": "Quote",
    "path": "quote.svg"
  },
  {
    "name": "quote-off",
    "label": "Quote Off",
    "path": "quote-off.svg"
  },
  {
    "name": "quotes",
    "label": "Quotes",
    "path": "quotes.svg"
  },
  {
    "name": "radar",
    "label": "Radar",
    "path": "radar.svg"
  },
  {
    "name": "radar-2",
    "label": "Radar 2",
    "path": "radar-2.svg"
  },
  {
    "name": "radar-off",
    "label": "Radar Off",
    "path": "radar-off.svg"
  },
  {
    "name": "radio",
    "label": "Radio",
    "path": "radio.svg"
  },
  {
    "name": "radio-off",
    "label": "Radio Off",
    "path": "radio-off.svg"
  },
  {
    "name": "radioactive",
    "label": "Radioactive",
    "path": "radioactive.svg"
  },
  {
    "name": "radioactive-off",
    "label": "Radioactive Off",
    "path": "radioactive-off.svg"
  },
  {
    "name": "radius-bottom-left",
    "label": "Radius Bottom Left",
    "path": "radius-bottom-left.svg"
  },
  {
    "name": "radius-bottom-right",
    "label": "Radius Bottom Right",
    "path": "radius-bottom-right.svg"
  },
  {
    "name": "radius-top-left",
    "label": "Radius Top Left",
    "path": "radius-top-left.svg"
  },
  {
    "name": "radius-top-right",
    "label": "Radius Top Right",
    "path": "radius-top-right.svg"
  },
  {
    "name": "rainbow",
    "label": "Rainbow",
    "path": "rainbow.svg"
  },
  {
    "name": "rainbow-off",
    "label": "Rainbow Off",
    "path": "rainbow-off.svg"
  },
  {
    "name": "rating-12-plus",
    "label": "Rating 12 Plus",
    "path": "rating-12-plus.svg"
  },
  {
    "name": "rating-14-plus",
    "label": "Rating 14 Plus",
    "path": "rating-14-plus.svg"
  },
  {
    "name": "rating-16-plus",
    "label": "Rating 16 Plus",
    "path": "rating-16-plus.svg"
  },
  {
    "name": "rating-18-plus",
    "label": "Rating 18 Plus",
    "path": "rating-18-plus.svg"
  },
  {
    "name": "rating-21-plus",
    "label": "Rating 21 Plus",
    "path": "rating-21-plus.svg"
  },
  {
    "name": "razor",
    "label": "Razor",
    "path": "razor.svg"
  },
  {
    "name": "razor-electric",
    "label": "Razor Electric",
    "path": "razor-electric.svg"
  },
  {
    "name": "receipt",
    "label": "Receipt",
    "path": "receipt.svg"
  },
  {
    "name": "receipt-2",
    "label": "Receipt 2",
    "path": "receipt-2.svg"
  },
  {
    "name": "receipt-bitcoin",
    "label": "Receipt Bitcoin",
    "path": "receipt-bitcoin.svg"
  },
  {
    "name": "receipt-dollar",
    "label": "Receipt Dollar",
    "path": "receipt-dollar.svg"
  },
  {
    "name": "receipt-euro",
    "label": "Receipt Euro",
    "path": "receipt-euro.svg"
  },
  {
    "name": "receipt-off",
    "label": "Receipt Off",
    "path": "receipt-off.svg"
  },
  {
    "name": "receipt-pound",
    "label": "Receipt Pound",
    "path": "receipt-pound.svg"
  },
  {
    "name": "receipt-refund",
    "label": "Receipt Refund",
    "path": "receipt-refund.svg"
  },
  {
    "name": "receipt-rupee",
    "label": "Receipt Rupee",
    "path": "receipt-rupee.svg"
  },
  {
    "name": "receipt-tax",
    "label": "Receipt Tax",
    "path": "receipt-tax.svg"
  },
  {
    "name": "receipt-yen",
    "label": "Receipt Yen",
    "path": "receipt-yen.svg"
  },
  {
    "name": "receipt-yuan",
    "label": "Receipt Yuan",
    "path": "receipt-yuan.svg"
  },
  {
    "name": "recharging",
    "label": "Recharging",
    "path": "recharging.svg"
  },
  {
    "name": "record-mail",
    "label": "Record Mail",
    "path": "record-mail.svg"
  },
  {
    "name": "record-mail-off",
    "label": "Record Mail Off",
    "path": "record-mail-off.svg"
  },
  {
    "name": "rectangle",
    "label": "Rectangle",
    "path": "rectangle.svg"
  },
  {
    "name": "rectangle-rounded-bottom",
    "label": "Rectangle Rounded Bottom",
    "path": "rectangle-rounded-bottom.svg"
  },
  {
    "name": "rectangle-rounded-top",
    "label": "Rectangle Rounded Top",
    "path": "rectangle-rounded-top.svg"
  },
  {
    "name": "rectangle-vertical",
    "label": "Rectangle Vertical",
    "path": "rectangle-vertical.svg"
  },
  {
    "name": "rectangular-prism",
    "label": "Rectangular Prism",
    "path": "rectangular-prism.svg"
  },
  {
    "name": "rectangular-prism-off",
    "label": "Rectangular Prism Off",
    "path": "rectangular-prism-off.svg"
  },
  {
    "name": "rectangular-prism-plus",
    "label": "Rectangular Prism Plus",
    "path": "rectangular-prism-plus.svg"
  },
  {
    "name": "recycle",
    "label": "Recycle",
    "path": "recycle.svg"
  },
  {
    "name": "recycle-off",
    "label": "Recycle Off",
    "path": "recycle-off.svg"
  },
  {
    "name": "refresh",
    "label": "Refresh",
    "path": "refresh.svg"
  },
  {
    "name": "refresh-alert",
    "label": "Refresh Alert",
    "path": "refresh-alert.svg"
  },
  {
    "name": "refresh-dot",
    "label": "Refresh Dot",
    "path": "refresh-dot.svg"
  },
  {
    "name": "refresh-off",
    "label": "Refresh Off",
    "path": "refresh-off.svg"
  },
  {
    "name": "regex",
    "label": "Regex",
    "path": "regex.svg"
  },
  {
    "name": "regex-off",
    "label": "Regex Off",
    "path": "regex-off.svg"
  },
  {
    "name": "registered",
    "label": "Registered",
    "path": "registered.svg"
  },
  {
    "name": "relation-many-to-many",
    "label": "Relation Many To Many",
    "path": "relation-many-to-many.svg"
  },
  {
    "name": "relation-one-to-many",
    "label": "Relation One To Many",
    "path": "relation-one-to-many.svg"
  },
  {
    "name": "relation-one-to-one",
    "label": "Relation One To One",
    "path": "relation-one-to-one.svg"
  },
  {
    "name": "reload",
    "label": "Reload",
    "path": "reload.svg"
  },
  {
    "name": "reorder",
    "label": "Reorder",
    "path": "reorder.svg"
  },
  {
    "name": "repeat",
    "label": "Repeat",
    "path": "repeat.svg"
  },
  {
    "name": "repeat-off",
    "label": "Repeat Off",
    "path": "repeat-off.svg"
  },
  {
    "name": "repeat-once",
    "label": "Repeat Once",
    "path": "repeat-once.svg"
  },
  {
    "name": "replace",
    "label": "Replace",
    "path": "replace.svg"
  },
  {
    "name": "replace-off",
    "label": "Replace Off",
    "path": "replace-off.svg"
  },
  {
    "name": "replace-user",
    "label": "Replace User",
    "path": "replace-user.svg"
  },
  {
    "name": "report",
    "label": "Report",
    "path": "report.svg"
  },
  {
    "name": "report-analytics",
    "label": "Report Analytics",
    "path": "report-analytics.svg"
  },
  {
    "name": "report-medical",
    "label": "Report Medical",
    "path": "report-medical.svg"
  },
  {
    "name": "report-money",
    "label": "Report Money",
    "path": "report-money.svg"
  },
  {
    "name": "report-off",
    "label": "Report Off",
    "path": "report-off.svg"
  },
  {
    "name": "report-search",
    "label": "Report Search",
    "path": "report-search.svg"
  },
  {
    "name": "reserved-line",
    "label": "Reserved Line",
    "path": "reserved-line.svg"
  },
  {
    "name": "resize",
    "label": "Resize",
    "path": "resize.svg"
  },
  {
    "name": "restore",
    "label": "Restore",
    "path": "restore.svg"
  },
  {
    "name": "rewind-backward-10",
    "label": "Rewind Backward 10",
    "path": "rewind-backward-10.svg"
  },
  {
    "name": "rewind-backward-15",
    "label": "Rewind Backward 15",
    "path": "rewind-backward-15.svg"
  },
  {
    "name": "rewind-backward-20",
    "label": "Rewind Backward 20",
    "path": "rewind-backward-20.svg"
  },
  {
    "name": "rewind-backward-30",
    "label": "Rewind Backward 30",
    "path": "rewind-backward-30.svg"
  },
  {
    "name": "rewind-backward-40",
    "label": "Rewind Backward 40",
    "path": "rewind-backward-40.svg"
  },
  {
    "name": "rewind-backward-5",
    "label": "Rewind Backward 5",
    "path": "rewind-backward-5.svg"
  },
  {
    "name": "rewind-backward-50",
    "label": "Rewind Backward 50",
    "path": "rewind-backward-50.svg"
  },
  {
    "name": "rewind-backward-60",
    "label": "Rewind Backward 60",
    "path": "rewind-backward-60.svg"
  },
  {
    "name": "rewind-forward-10",
    "label": "Rewind Forward 10",
    "path": "rewind-forward-10.svg"
  },
  {
    "name": "rewind-forward-15",
    "label": "Rewind Forward 15",
    "path": "rewind-forward-15.svg"
  },
  {
    "name": "rewind-forward-20",
    "label": "Rewind Forward 20",
    "path": "rewind-forward-20.svg"
  },
  {
    "name": "rewind-forward-30",
    "label": "Rewind Forward 30",
    "path": "rewind-forward-30.svg"
  },
  {
    "name": "rewind-forward-40",
    "label": "Rewind Forward 40",
    "path": "rewind-forward-40.svg"
  },
  {
    "name": "rewind-forward-5",
    "label": "Rewind Forward 5",
    "path": "rewind-forward-5.svg"
  },
  {
    "name": "rewind-forward-50",
    "label": "Rewind Forward 50",
    "path": "rewind-forward-50.svg"
  },
  {
    "name": "rewind-forward-60",
    "label": "Rewind Forward 60",
    "path": "rewind-forward-60.svg"
  },
  {
    "name": "ribbon-health",
    "label": "Ribbon Health",
    "path": "ribbon-health.svg"
  },
  {
    "name": "rings",
    "label": "Rings",
    "path": "rings.svg"
  },
  {
    "name": "ripple",
    "label": "Ripple",
    "path": "ripple.svg"
  },
  {
    "name": "ripple-down",
    "label": "Ripple Down",
    "path": "ripple-down.svg"
  },
  {
    "name": "ripple-off",
    "label": "Ripple Off",
    "path": "ripple-off.svg"
  },
  {
    "name": "ripple-up",
    "label": "Ripple Up",
    "path": "ripple-up.svg"
  },
  {
    "name": "road",
    "label": "Road",
    "path": "road.svg"
  },
  {
    "name": "road-off",
    "label": "Road Off",
    "path": "road-off.svg"
  },
  {
    "name": "road-sign",
    "label": "Road Sign",
    "path": "road-sign.svg"
  },
  {
    "name": "robot",
    "label": "Robot",
    "path": "robot.svg"
  },
  {
    "name": "robot-face",
    "label": "Robot Face",
    "path": "robot-face.svg"
  },
  {
    "name": "robot-off",
    "label": "Robot Off",
    "path": "robot-off.svg"
  },
  {
    "name": "rocket",
    "label": "Rocket",
    "path": "rocket.svg"
  },
  {
    "name": "rocket-off",
    "label": "Rocket Off",
    "path": "rocket-off.svg"
  },
  {
    "name": "roller-skating",
    "label": "Roller Skating",
    "path": "roller-skating.svg"
  },
  {
    "name": "rollercoaster",
    "label": "Rollercoaster",
    "path": "rollercoaster.svg"
  },
  {
    "name": "rollercoaster-off",
    "label": "Rollercoaster Off",
    "path": "rollercoaster-off.svg"
  },
  {
    "name": "rosette",
    "label": "Rosette",
    "path": "rosette.svg"
  },
  {
    "name": "rosette-asterisk",
    "label": "Rosette Asterisk",
    "path": "rosette-asterisk.svg"
  },
  {
    "name": "rosette-discount",
    "label": "Rosette Discount",
    "path": "rosette-discount.svg"
  },
  {
    "name": "rosette-discount-check",
    "label": "Rosette Discount Check",
    "path": "rosette-discount-check.svg"
  },
  {
    "name": "rosette-discount-check-off",
    "label": "Rosette Discount Check Off",
    "path": "rosette-discount-check-off.svg"
  },
  {
    "name": "rosette-discount-off",
    "label": "Rosette Discount Off",
    "path": "rosette-discount-off.svg"
  },
  {
    "name": "rosette-number-0",
    "label": "Rosette Number 0",
    "path": "rosette-number-0.svg"
  },
  {
    "name": "rosette-number-1",
    "label": "Rosette Number 1",
    "path": "rosette-number-1.svg"
  },
  {
    "name": "rosette-number-2",
    "label": "Rosette Number 2",
    "path": "rosette-number-2.svg"
  },
  {
    "name": "rosette-number-3",
    "label": "Rosette Number 3",
    "path": "rosette-number-3.svg"
  },
  {
    "name": "rosette-number-4",
    "label": "Rosette Number 4",
    "path": "rosette-number-4.svg"
  },
  {
    "name": "rosette-number-5",
    "label": "Rosette Number 5",
    "path": "rosette-number-5.svg"
  },
  {
    "name": "rosette-number-6",
    "label": "Rosette Number 6",
    "path": "rosette-number-6.svg"
  },
  {
    "name": "rosette-number-7",
    "label": "Rosette Number 7",
    "path": "rosette-number-7.svg"
  },
  {
    "name": "rosette-number-8",
    "label": "Rosette Number 8",
    "path": "rosette-number-8.svg"
  },
  {
    "name": "rosette-number-9",
    "label": "Rosette Number 9",
    "path": "rosette-number-9.svg"
  },
  {
    "name": "rotate",
    "label": "Rotate",
    "path": "rotate.svg"
  },
  {
    "name": "rotate-2",
    "label": "Rotate 2",
    "path": "rotate-2.svg"
  },
  {
    "name": "rotate-360",
    "label": "Rotate 360",
    "path": "rotate-360.svg"
  },
  {
    "name": "rotate-3d",
    "label": "Rotate 3d",
    "path": "rotate-3d.svg"
  },
  {
    "name": "rotate-clockwise",
    "label": "Rotate Clockwise",
    "path": "rotate-clockwise.svg"
  },
  {
    "name": "rotate-clockwise-2",
    "label": "Rotate Clockwise 2",
    "path": "rotate-clockwise-2.svg"
  },
  {
    "name": "rotate-dot",
    "label": "Rotate Dot",
    "path": "rotate-dot.svg"
  },
  {
    "name": "rotate-rectangle",
    "label": "Rotate Rectangle",
    "path": "rotate-rectangle.svg"
  },
  {
    "name": "route",
    "label": "Route",
    "path": "route.svg"
  },
  {
    "name": "route-2",
    "label": "Route 2",
    "path": "route-2.svg"
  },
  {
    "name": "route-alt-left",
    "label": "Route Alt Left",
    "path": "route-alt-left.svg"
  },
  {
    "name": "route-alt-right",
    "label": "Route Alt Right",
    "path": "route-alt-right.svg"
  },
  {
    "name": "route-off",
    "label": "Route Off",
    "path": "route-off.svg"
  },
  {
    "name": "route-scan",
    "label": "Route Scan",
    "path": "route-scan.svg"
  },
  {
    "name": "route-square",
    "label": "Route Square",
    "path": "route-square.svg"
  },
  {
    "name": "route-square-2",
    "label": "Route Square 2",
    "path": "route-square-2.svg"
  },
  {
    "name": "route-x",
    "label": "Route X",
    "path": "route-x.svg"
  },
  {
    "name": "route-x-2",
    "label": "Route X 2",
    "path": "route-x-2.svg"
  },
  {
    "name": "router",
    "label": "Router",
    "path": "router.svg"
  },
  {
    "name": "router-off",
    "label": "Router Off",
    "path": "router-off.svg"
  },
  {
    "name": "row-insert-bottom",
    "label": "Row Insert Bottom",
    "path": "row-insert-bottom.svg"
  },
  {
    "name": "row-insert-top",
    "label": "Row Insert Top",
    "path": "row-insert-top.svg"
  },
  {
    "name": "row-remove",
    "label": "Row Remove",
    "path": "row-remove.svg"
  },
  {
    "name": "rss",
    "label": "Rss",
    "path": "rss.svg"
  },
  {
    "name": "rubber-stamp",
    "label": "Rubber Stamp",
    "path": "rubber-stamp.svg"
  },
  {
    "name": "rubber-stamp-off",
    "label": "Rubber Stamp Off",
    "path": "rubber-stamp-off.svg"
  },
  {
    "name": "ruler",
    "label": "Ruler",
    "path": "ruler.svg"
  },
  {
    "name": "ruler-2",
    "label": "Ruler 2",
    "path": "ruler-2.svg"
  },
  {
    "name": "ruler-2-off",
    "label": "Ruler 2 Off",
    "path": "ruler-2-off.svg"
  },
  {
    "name": "ruler-3",
    "label": "Ruler 3",
    "path": "ruler-3.svg"
  },
  {
    "name": "ruler-measure",
    "label": "Ruler Measure",
    "path": "ruler-measure.svg"
  },
  {
    "name": "ruler-measure-2",
    "label": "Ruler Measure 2",
    "path": "ruler-measure-2.svg"
  },
  {
    "name": "ruler-off",
    "label": "Ruler Off",
    "path": "ruler-off.svg"
  },
  {
    "name": "run",
    "label": "Run",
    "path": "run.svg"
  },
  {
    "name": "rv-truck",
    "label": "Rv Truck",
    "path": "rv-truck.svg"
  },
  {
    "name": "s-turn-down",
    "label": "S Turn Down",
    "path": "s-turn-down.svg"
  },
  {
    "name": "s-turn-left",
    "label": "S Turn Left",
    "path": "s-turn-left.svg"
  },
  {
    "name": "s-turn-right",
    "label": "S Turn Right",
    "path": "s-turn-right.svg"
  },
  {
    "name": "s-turn-up",
    "label": "S Turn Up",
    "path": "s-turn-up.svg"
  },
  {
    "name": "sailboat",
    "label": "Sailboat",
    "path": "sailboat.svg"
  },
  {
    "name": "sailboat-2",
    "label": "Sailboat 2",
    "path": "sailboat-2.svg"
  },
  {
    "name": "sailboat-off",
    "label": "Sailboat Off",
    "path": "sailboat-off.svg"
  },
  {
    "name": "salad",
    "label": "Salad",
    "path": "salad.svg"
  },
  {
    "name": "salt",
    "label": "Salt",
    "path": "salt.svg"
  },
  {
    "name": "sandbox",
    "label": "Sandbox",
    "path": "sandbox.svg"
  },
  {
    "name": "satellite",
    "label": "Satellite",
    "path": "satellite.svg"
  },
  {
    "name": "satellite-off",
    "label": "Satellite Off",
    "path": "satellite-off.svg"
  },
  {
    "name": "sausage",
    "label": "Sausage",
    "path": "sausage.svg"
  },
  {
    "name": "scale",
    "label": "Scale",
    "path": "scale.svg"
  },
  {
    "name": "scale-off",
    "label": "Scale Off",
    "path": "scale-off.svg"
  },
  {
    "name": "scale-outline",
    "label": "Scale Outline",
    "path": "scale-outline.svg"
  },
  {
    "name": "scale-outline-off",
    "label": "Scale Outline Off",
    "path": "scale-outline-off.svg"
  },
  {
    "name": "scan",
    "label": "Scan",
    "path": "scan.svg"
  },
  {
    "name": "scan-eye",
    "label": "Scan Eye",
    "path": "scan-eye.svg"
  },
  {
    "name": "scan-position",
    "label": "Scan Position",
    "path": "scan-position.svg"
  },
  {
    "name": "schema",
    "label": "Schema",
    "path": "schema.svg"
  },
  {
    "name": "schema-off",
    "label": "Schema Off",
    "path": "schema-off.svg"
  },
  {
    "name": "school",
    "label": "School",
    "path": "school.svg"
  },
  {
    "name": "school-bell",
    "label": "School Bell",
    "path": "school-bell.svg"
  },
  {
    "name": "school-off",
    "label": "School Off",
    "path": "school-off.svg"
  },
  {
    "name": "scissors",
    "label": "Scissors",
    "path": "scissors.svg"
  },
  {
    "name": "scissors-off",
    "label": "Scissors Off",
    "path": "scissors-off.svg"
  },
  {
    "name": "scooter",
    "label": "Scooter",
    "path": "scooter.svg"
  },
  {
    "name": "scooter-electric",
    "label": "Scooter Electric",
    "path": "scooter-electric.svg"
  },
  {
    "name": "scoreboard",
    "label": "Scoreboard",
    "path": "scoreboard.svg"
  },
  {
    "name": "screen-share",
    "label": "Screen Share",
    "path": "screen-share.svg"
  },
  {
    "name": "screen-share-off",
    "label": "Screen Share Off",
    "path": "screen-share-off.svg"
  },
  {
    "name": "screenshot",
    "label": "Screenshot",
    "path": "screenshot.svg"
  },
  {
    "name": "scribble",
    "label": "Scribble",
    "path": "scribble.svg"
  },
  {
    "name": "scribble-off",
    "label": "Scribble Off",
    "path": "scribble-off.svg"
  },
  {
    "name": "script",
    "label": "Script",
    "path": "script.svg"
  },
  {
    "name": "script-minus",
    "label": "Script Minus",
    "path": "script-minus.svg"
  },
  {
    "name": "script-plus",
    "label": "Script Plus",
    "path": "script-plus.svg"
  },
  {
    "name": "script-x",
    "label": "Script X",
    "path": "script-x.svg"
  },
  {
    "name": "scuba-diving",
    "label": "Scuba Diving",
    "path": "scuba-diving.svg"
  },
  {
    "name": "scuba-diving-tank",
    "label": "Scuba Diving Tank",
    "path": "scuba-diving-tank.svg"
  },
  {
    "name": "scuba-mask",
    "label": "Scuba Mask",
    "path": "scuba-mask.svg"
  },
  {
    "name": "scuba-mask-off",
    "label": "Scuba Mask Off",
    "path": "scuba-mask-off.svg"
  },
  {
    "name": "sdk",
    "label": "Sdk",
    "path": "sdk.svg"
  },
  {
    "name": "search",
    "label": "Search",
    "path": "search.svg"
  },
  {
    "name": "search-off",
    "label": "Search Off",
    "path": "search-off.svg"
  },
  {
    "name": "section",
    "label": "Section",
    "path": "section.svg"
  },
  {
    "name": "section-sign",
    "label": "Section Sign",
    "path": "section-sign.svg"
  },
  {
    "name": "seedling",
    "label": "Seedling",
    "path": "seedling.svg"
  },
  {
    "name": "seedling-off",
    "label": "Seedling Off",
    "path": "seedling-off.svg"
  },
  {
    "name": "select",
    "label": "Select",
    "path": "select.svg"
  },
  {
    "name": "select-all",
    "label": "Select All",
    "path": "select-all.svg"
  },
  {
    "name": "selector",
    "label": "Selector",
    "path": "selector.svg"
  },
  {
    "name": "send",
    "label": "Send",
    "path": "send.svg"
  },
  {
    "name": "send-2",
    "label": "Send 2",
    "path": "send-2.svg"
  },
  {
    "name": "send-off",
    "label": "Send Off",
    "path": "send-off.svg"
  },
  {
    "name": "seo",
    "label": "Seo",
    "path": "seo.svg"
  },
  {
    "name": "separator",
    "label": "Separator",
    "path": "separator.svg"
  },
  {
    "name": "separator-horizontal",
    "label": "Separator Horizontal",
    "path": "separator-horizontal.svg"
  },
  {
    "name": "separator-vertical",
    "label": "Separator Vertical",
    "path": "separator-vertical.svg"
  },
  {
    "name": "server",
    "label": "Server",
    "path": "server.svg"
  },
  {
    "name": "server-2",
    "label": "Server 2",
    "path": "server-2.svg"
  },
  {
    "name": "server-bolt",
    "label": "Server Bolt",
    "path": "server-bolt.svg"
  },
  {
    "name": "server-cog",
    "label": "Server Cog",
    "path": "server-cog.svg"
  },
  {
    "name": "server-off",
    "label": "Server Off",
    "path": "server-off.svg"
  },
  {
    "name": "server-spark",
    "label": "Server Spark",
    "path": "server-spark.svg"
  },
  {
    "name": "servicemark",
    "label": "Servicemark",
    "path": "servicemark.svg"
  },
  {
    "name": "settings",
    "label": "Settings",
    "path": "settings.svg"
  },
  {
    "name": "settings-2",
    "label": "Settings 2",
    "path": "settings-2.svg"
  },
  {
    "name": "settings-ai",
    "label": "Settings Ai",
    "path": "settings-ai.svg"
  },
  {
    "name": "settings-automation",
    "label": "Settings Automation",
    "path": "settings-automation.svg"
  },
  {
    "name": "settings-bolt",
    "label": "Settings Bolt",
    "path": "settings-bolt.svg"
  },
  {
    "name": "settings-cancel",
    "label": "Settings Cancel",
    "path": "settings-cancel.svg"
  },
  {
    "name": "settings-check",
    "label": "Settings Check",
    "path": "settings-check.svg"
  },
  {
    "name": "settings-code",
    "label": "Settings Code",
    "path": "settings-code.svg"
  },
  {
    "name": "settings-cog",
    "label": "Settings Cog",
    "path": "settings-cog.svg"
  },
  {
    "name": "settings-dollar",
    "label": "Settings Dollar",
    "path": "settings-dollar.svg"
  },
  {
    "name": "settings-down",
    "label": "Settings Down",
    "path": "settings-down.svg"
  },
  {
    "name": "settings-exclamation",
    "label": "Settings Exclamation",
    "path": "settings-exclamation.svg"
  },
  {
    "name": "settings-heart",
    "label": "Settings Heart",
    "path": "settings-heart.svg"
  },
  {
    "name": "settings-minus",
    "label": "Settings Minus",
    "path": "settings-minus.svg"
  },
  {
    "name": "settings-off",
    "label": "Settings Off",
    "path": "settings-off.svg"
  },
  {
    "name": "settings-pause",
    "label": "Settings Pause",
    "path": "settings-pause.svg"
  },
  {
    "name": "settings-pin",
    "label": "Settings Pin",
    "path": "settings-pin.svg"
  },
  {
    "name": "settings-plus",
    "label": "Settings Plus",
    "path": "settings-plus.svg"
  },
  {
    "name": "settings-question",
    "label": "Settings Question",
    "path": "settings-question.svg"
  },
  {
    "name": "settings-search",
    "label": "Settings Search",
    "path": "settings-search.svg"
  },
  {
    "name": "settings-share",
    "label": "Settings Share",
    "path": "settings-share.svg"
  },
  {
    "name": "settings-spark",
    "label": "Settings Spark",
    "path": "settings-spark.svg"
  },
  {
    "name": "settings-star",
    "label": "Settings Star",
    "path": "settings-star.svg"
  },
  {
    "name": "settings-up",
    "label": "Settings Up",
    "path": "settings-up.svg"
  },
  {
    "name": "settings-x",
    "label": "Settings X",
    "path": "settings-x.svg"
  },
  {
    "name": "shadow",
    "label": "Shadow",
    "path": "shadow.svg"
  },
  {
    "name": "shadow-off",
    "label": "Shadow Off",
    "path": "shadow-off.svg"
  },
  {
    "name": "shape",
    "label": "Shape",
    "path": "shape.svg"
  },
  {
    "name": "shape-2",
    "label": "Shape 2",
    "path": "shape-2.svg"
  },
  {
    "name": "shape-3",
    "label": "Shape 3",
    "path": "shape-3.svg"
  },
  {
    "name": "shape-off",
    "label": "Shape Off",
    "path": "shape-off.svg"
  },
  {
    "name": "share",
    "label": "Share",
    "path": "share.svg"
  },
  {
    "name": "share-2",
    "label": "Share 2",
    "path": "share-2.svg"
  },
  {
    "name": "share-3",
    "label": "Share 3",
    "path": "share-3.svg"
  },
  {
    "name": "share-off",
    "label": "Share Off",
    "path": "share-off.svg"
  },
  {
    "name": "shareplay",
    "label": "Shareplay",
    "path": "shareplay.svg"
  },
  {
    "name": "shield",
    "label": "Shield",
    "path": "shield.svg"
  },
  {
    "name": "shield-bolt",
    "label": "Shield Bolt",
    "path": "shield-bolt.svg"
  },
  {
    "name": "shield-cancel",
    "label": "Shield Cancel",
    "path": "shield-cancel.svg"
  },
  {
    "name": "shield-check",
    "label": "Shield Check",
    "path": "shield-check.svg"
  },
  {
    "name": "shield-checkered",
    "label": "Shield Checkered",
    "path": "shield-checkered.svg"
  },
  {
    "name": "shield-chevron",
    "label": "Shield Chevron",
    "path": "shield-chevron.svg"
  },
  {
    "name": "shield-code",
    "label": "Shield Code",
    "path": "shield-code.svg"
  },
  {
    "name": "shield-cog",
    "label": "Shield Cog",
    "path": "shield-cog.svg"
  },
  {
    "name": "shield-dollar",
    "label": "Shield Dollar",
    "path": "shield-dollar.svg"
  },
  {
    "name": "shield-down",
    "label": "Shield Down",
    "path": "shield-down.svg"
  },
  {
    "name": "shield-exclamation",
    "label": "Shield Exclamation",
    "path": "shield-exclamation.svg"
  },
  {
    "name": "shield-half",
    "label": "Shield Half",
    "path": "shield-half.svg"
  },
  {
    "name": "shield-heart",
    "label": "Shield Heart",
    "path": "shield-heart.svg"
  },
  {
    "name": "shield-lock",
    "label": "Shield Lock",
    "path": "shield-lock.svg"
  },
  {
    "name": "shield-minus",
    "label": "Shield Minus",
    "path": "shield-minus.svg"
  },
  {
    "name": "shield-off",
    "label": "Shield Off",
    "path": "shield-off.svg"
  },
  {
    "name": "shield-pause",
    "label": "Shield Pause",
    "path": "shield-pause.svg"
  },
  {
    "name": "shield-pin",
    "label": "Shield Pin",
    "path": "shield-pin.svg"
  },
  {
    "name": "shield-plus",
    "label": "Shield Plus",
    "path": "shield-plus.svg"
  },
  {
    "name": "shield-question",
    "label": "Shield Question",
    "path": "shield-question.svg"
  },
  {
    "name": "shield-search",
    "label": "Shield Search",
    "path": "shield-search.svg"
  },
  {
    "name": "shield-share",
    "label": "Shield Share",
    "path": "shield-share.svg"
  },
  {
    "name": "shield-star",
    "label": "Shield Star",
    "path": "shield-star.svg"
  },
  {
    "name": "shield-up",
    "label": "Shield Up",
    "path": "shield-up.svg"
  },
  {
    "name": "shield-x",
    "label": "Shield X",
    "path": "shield-x.svg"
  },
  {
    "name": "ship",
    "label": "Ship",
    "path": "ship.svg"
  },
  {
    "name": "ship-off",
    "label": "Ship Off",
    "path": "ship-off.svg"
  },
  {
    "name": "shirt",
    "label": "Shirt",
    "path": "shirt.svg"
  },
  {
    "name": "shirt-off",
    "label": "Shirt Off",
    "path": "shirt-off.svg"
  },
  {
    "name": "shirt-sport",
    "label": "Shirt Sport",
    "path": "shirt-sport.svg"
  },
  {
    "name": "shoe",
    "label": "Shoe",
    "path": "shoe.svg"
  },
  {
    "name": "shoe-off",
    "label": "Shoe Off",
    "path": "shoe-off.svg"
  },
  {
    "name": "shopping-bag",
    "label": "Shopping Bag",
    "path": "shopping-bag.svg"
  },
  {
    "name": "shopping-bag-check",
    "label": "Shopping Bag Check",
    "path": "shopping-bag-check.svg"
  },
  {
    "name": "shopping-bag-discount",
    "label": "Shopping Bag Discount",
    "path": "shopping-bag-discount.svg"
  },
  {
    "name": "shopping-bag-edit",
    "label": "Shopping Bag Edit",
    "path": "shopping-bag-edit.svg"
  },
  {
    "name": "shopping-bag-exclamation",
    "label": "Shopping Bag Exclamation",
    "path": "shopping-bag-exclamation.svg"
  },
  {
    "name": "shopping-bag-heart",
    "label": "Shopping Bag Heart",
    "path": "shopping-bag-heart.svg"
  },
  {
    "name": "shopping-bag-minus",
    "label": "Shopping Bag Minus",
    "path": "shopping-bag-minus.svg"
  },
  {
    "name": "shopping-bag-plus",
    "label": "Shopping Bag Plus",
    "path": "shopping-bag-plus.svg"
  },
  {
    "name": "shopping-bag-search",
    "label": "Shopping Bag Search",
    "path": "shopping-bag-search.svg"
  },
  {
    "name": "shopping-bag-x",
    "label": "Shopping Bag X",
    "path": "shopping-bag-x.svg"
  },
  {
    "name": "shopping-cart",
    "label": "Shopping Cart",
    "path": "shopping-cart.svg"
  },
  {
    "name": "shopping-cart-bolt",
    "label": "Shopping Cart Bolt",
    "path": "shopping-cart-bolt.svg"
  },
  {
    "name": "shopping-cart-cancel",
    "label": "Shopping Cart Cancel",
    "path": "shopping-cart-cancel.svg"
  },
  {
    "name": "shopping-cart-check",
    "label": "Shopping Cart Check",
    "path": "shopping-cart-check.svg"
  },
  {
    "name": "shopping-cart-code",
    "label": "Shopping Cart Code",
    "path": "shopping-cart-code.svg"
  },
  {
    "name": "shopping-cart-cog",
    "label": "Shopping Cart Cog",
    "path": "shopping-cart-cog.svg"
  },
  {
    "name": "shopping-cart-copy",
    "label": "Shopping Cart Copy",
    "path": "shopping-cart-copy.svg"
  },
  {
    "name": "shopping-cart-discount",
    "label": "Shopping Cart Discount",
    "path": "shopping-cart-discount.svg"
  },
  {
    "name": "shopping-cart-dollar",
    "label": "Shopping Cart Dollar",
    "path": "shopping-cart-dollar.svg"
  },
  {
    "name": "shopping-cart-down",
    "label": "Shopping Cart Down",
    "path": "shopping-cart-down.svg"
  },
  {
    "name": "shopping-cart-exclamation",
    "label": "Shopping Cart Exclamation",
    "path": "shopping-cart-exclamation.svg"
  },
  {
    "name": "shopping-cart-heart",
    "label": "Shopping Cart Heart",
    "path": "shopping-cart-heart.svg"
  },
  {
    "name": "shopping-cart-minus",
    "label": "Shopping Cart Minus",
    "path": "shopping-cart-minus.svg"
  },
  {
    "name": "shopping-cart-off",
    "label": "Shopping Cart Off",
    "path": "shopping-cart-off.svg"
  },
  {
    "name": "shopping-cart-pause",
    "label": "Shopping Cart Pause",
    "path": "shopping-cart-pause.svg"
  },
  {
    "name": "shopping-cart-pin",
    "label": "Shopping Cart Pin",
    "path": "shopping-cart-pin.svg"
  },
  {
    "name": "shopping-cart-plus",
    "label": "Shopping Cart Plus",
    "path": "shopping-cart-plus.svg"
  },
  {
    "name": "shopping-cart-question",
    "label": "Shopping Cart Question",
    "path": "shopping-cart-question.svg"
  },
  {
    "name": "shopping-cart-search",
    "label": "Shopping Cart Search",
    "path": "shopping-cart-search.svg"
  },
  {
    "name": "shopping-cart-share",
    "label": "Shopping Cart Share",
    "path": "shopping-cart-share.svg"
  },
  {
    "name": "shopping-cart-star",
    "label": "Shopping Cart Star",
    "path": "shopping-cart-star.svg"
  },
  {
    "name": "shopping-cart-up",
    "label": "Shopping Cart Up",
    "path": "shopping-cart-up.svg"
  },
  {
    "name": "shopping-cart-x",
    "label": "Shopping Cart X",
    "path": "shopping-cart-x.svg"
  },
  {
    "name": "shovel",
    "label": "Shovel",
    "path": "shovel.svg"
  },
  {
    "name": "shovel-pitchforks",
    "label": "Shovel Pitchforks",
    "path": "shovel-pitchforks.svg"
  },
  {
    "name": "shredder",
    "label": "Shredder",
    "path": "shredder.svg"
  },
  {
    "name": "sign-left",
    "label": "Sign Left",
    "path": "sign-left.svg"
  },
  {
    "name": "sign-right",
    "label": "Sign Right",
    "path": "sign-right.svg"
  },
  {
    "name": "signal-2g",
    "label": "Signal 2g",
    "path": "signal-2g.svg"
  },
  {
    "name": "signal-3g",
    "label": "Signal 3g",
    "path": "signal-3g.svg"
  },
  {
    "name": "signal-4g",
    "label": "Signal 4g",
    "path": "signal-4g.svg"
  },
  {
    "name": "signal-4g-plus",
    "label": "Signal 4g Plus",
    "path": "signal-4g-plus.svg"
  },
  {
    "name": "signal-5g",
    "label": "Signal 5g",
    "path": "signal-5g.svg"
  },
  {
    "name": "signal-6g",
    "label": "Signal 6g",
    "path": "signal-6g.svg"
  },
  {
    "name": "signal-e",
    "label": "Signal E",
    "path": "signal-e.svg"
  },
  {
    "name": "signal-g",
    "label": "Signal G",
    "path": "signal-g.svg"
  },
  {
    "name": "signal-h",
    "label": "Signal H",
    "path": "signal-h.svg"
  },
  {
    "name": "signal-h-plus",
    "label": "Signal H Plus",
    "path": "signal-h-plus.svg"
  },
  {
    "name": "signal-lte",
    "label": "Signal Lte",
    "path": "signal-lte.svg"
  },
  {
    "name": "signature",
    "label": "Signature",
    "path": "signature.svg"
  },
  {
    "name": "signature-off",
    "label": "Signature Off",
    "path": "signature-off.svg"
  },
  {
    "name": "sitemap",
    "label": "Sitemap",
    "path": "sitemap.svg"
  },
  {
    "name": "sitemap-off",
    "label": "Sitemap Off",
    "path": "sitemap-off.svg"
  },
  {
    "name": "skateboard",
    "label": "Skateboard",
    "path": "skateboard.svg"
  },
  {
    "name": "skateboard-off",
    "label": "Skateboard Off",
    "path": "skateboard-off.svg"
  },
  {
    "name": "skateboarding",
    "label": "Skateboarding",
    "path": "skateboarding.svg"
  },
  {
    "name": "skew-x",
    "label": "Skew X",
    "path": "skew-x.svg"
  },
  {
    "name": "skew-y",
    "label": "Skew Y",
    "path": "skew-y.svg"
  },
  {
    "name": "ski-jumping",
    "label": "Ski Jumping",
    "path": "ski-jumping.svg"
  },
  {
    "name": "skull",
    "label": "Skull",
    "path": "skull.svg"
  },
  {
    "name": "slash",
    "label": "Slash",
    "path": "slash.svg"
  },
  {
    "name": "slashes",
    "label": "Slashes",
    "path": "slashes.svg"
  },
  {
    "name": "sleigh",
    "label": "Sleigh",
    "path": "sleigh.svg"
  },
  {
    "name": "slice",
    "label": "Slice",
    "path": "slice.svg"
  },
  {
    "name": "slideshow",
    "label": "Slideshow",
    "path": "slideshow.svg"
  },
  {
    "name": "smart-home",
    "label": "Smart Home",
    "path": "smart-home.svg"
  },
  {
    "name": "smart-home-off",
    "label": "Smart Home Off",
    "path": "smart-home-off.svg"
  },
  {
    "name": "smoking",
    "label": "Smoking",
    "path": "smoking.svg"
  },
  {
    "name": "smoking-no",
    "label": "Smoking No",
    "path": "smoking-no.svg"
  },
  {
    "name": "snowboarding",
    "label": "Snowboarding",
    "path": "snowboarding.svg"
  },
  {
    "name": "snowflake",
    "label": "Snowflake",
    "path": "snowflake.svg"
  },
  {
    "name": "snowflake-off",
    "label": "Snowflake Off",
    "path": "snowflake-off.svg"
  },
  {
    "name": "snowman",
    "label": "Snowman",
    "path": "snowman.svg"
  },
  {
    "name": "soccer-field",
    "label": "Soccer Field",
    "path": "soccer-field.svg"
  },
  {
    "name": "social",
    "label": "Social",
    "path": "social.svg"
  },
  {
    "name": "social-off",
    "label": "Social Off",
    "path": "social-off.svg"
  },
  {
    "name": "sock",
    "label": "Sock",
    "path": "sock.svg"
  },
  {
    "name": "sofa",
    "label": "Sofa",
    "path": "sofa.svg"
  },
  {
    "name": "sofa-off",
    "label": "Sofa Off",
    "path": "sofa-off.svg"
  },
  {
    "name": "solar-electricity",
    "label": "Solar Electricity",
    "path": "solar-electricity.svg"
  },
  {
    "name": "solar-panel",
    "label": "Solar Panel",
    "path": "solar-panel.svg"
  },
  {
    "name": "solar-panel-2",
    "label": "Solar Panel 2",
    "path": "solar-panel-2.svg"
  },
  {
    "name": "sort-0-9",
    "label": "Sort 0 9",
    "path": "sort-0-9.svg"
  },
  {
    "name": "sort-9-0",
    "label": "Sort 9 0",
    "path": "sort-9-0.svg"
  },
  {
    "name": "sort-a-z",
    "label": "Sort A Z",
    "path": "sort-a-z.svg"
  },
  {
    "name": "sort-ascending",
    "label": "Sort Ascending",
    "path": "sort-ascending.svg"
  },
  {
    "name": "sort-ascending-2",
    "label": "Sort Ascending 2",
    "path": "sort-ascending-2.svg"
  },
  {
    "name": "sort-ascending-letters",
    "label": "Sort Ascending Letters",
    "path": "sort-ascending-letters.svg"
  },
  {
    "name": "sort-ascending-numbers",
    "label": "Sort Ascending Numbers",
    "path": "sort-ascending-numbers.svg"
  },
  {
    "name": "sort-ascending-shapes",
    "label": "Sort Ascending Shapes",
    "path": "sort-ascending-shapes.svg"
  },
  {
    "name": "sort-ascending-small-big",
    "label": "Sort Ascending Small Big",
    "path": "sort-ascending-small-big.svg"
  },
  {
    "name": "sort-descending",
    "label": "Sort Descending",
    "path": "sort-descending.svg"
  },
  {
    "name": "sort-descending-2",
    "label": "Sort Descending 2",
    "path": "sort-descending-2.svg"
  },
  {
    "name": "sort-descending-letters",
    "label": "Sort Descending Letters",
    "path": "sort-descending-letters.svg"
  },
  {
    "name": "sort-descending-numbers",
    "label": "Sort Descending Numbers",
    "path": "sort-descending-numbers.svg"
  },
  {
    "name": "sort-descending-shapes",
    "label": "Sort Descending Shapes",
    "path": "sort-descending-shapes.svg"
  },
  {
    "name": "sort-descending-small-big",
    "label": "Sort Descending Small Big",
    "path": "sort-descending-small-big.svg"
  },
  {
    "name": "sort-z-a",
    "label": "Sort Z A",
    "path": "sort-z-a.svg"
  },
  {
    "name": "sos",
    "label": "Sos",
    "path": "sos.svg"
  },
  {
    "name": "soup",
    "label": "Soup",
    "path": "soup.svg"
  },
  {
    "name": "soup-off",
    "label": "Soup Off",
    "path": "soup-off.svg"
  },
  {
    "name": "source-code",
    "label": "Source Code",
    "path": "source-code.svg"
  },
  {
    "name": "space",
    "label": "Space",
    "path": "space.svg"
  },
  {
    "name": "space-off",
    "label": "Space Off",
    "path": "space-off.svg"
  },
  {
    "name": "spaces",
    "label": "Spaces",
    "path": "spaces.svg"
  },
  {
    "name": "spacing-horizontal",
    "label": "Spacing Horizontal",
    "path": "spacing-horizontal.svg"
  },
  {
    "name": "spacing-vertical",
    "label": "Spacing Vertical",
    "path": "spacing-vertical.svg"
  },
  {
    "name": "spade",
    "label": "Spade",
    "path": "spade.svg"
  },
  {
    "name": "sparkles",
    "label": "Sparkles",
    "path": "sparkles.svg"
  },
  {
    "name": "sparkles-2",
    "label": "Sparkles 2",
    "path": "sparkles-2.svg"
  },
  {
    "name": "speakerphone",
    "label": "Speakerphone",
    "path": "speakerphone.svg"
  },
  {
    "name": "speedboat",
    "label": "Speedboat",
    "path": "speedboat.svg"
  },
  {
    "name": "sphere",
    "label": "Sphere",
    "path": "sphere.svg"
  },
  {
    "name": "sphere-off",
    "label": "Sphere Off",
    "path": "sphere-off.svg"
  },
  {
    "name": "sphere-plus",
    "label": "Sphere Plus",
    "path": "sphere-plus.svg"
  },
  {
    "name": "spider",
    "label": "Spider",
    "path": "spider.svg"
  },
  {
    "name": "spiral",
    "label": "Spiral",
    "path": "spiral.svg"
  },
  {
    "name": "spiral-off",
    "label": "Spiral Off",
    "path": "spiral-off.svg"
  },
  {
    "name": "sport-billard",
    "label": "Sport Billard",
    "path": "sport-billard.svg"
  },
  {
    "name": "spray",
    "label": "Spray",
    "path": "spray.svg"
  },
  {
    "name": "spy",
    "label": "Spy",
    "path": "spy.svg"
  },
  {
    "name": "spy-off",
    "label": "Spy Off",
    "path": "spy-off.svg"
  },
  {
    "name": "sql",
    "label": "Sql",
    "path": "sql.svg"
  },
  {
    "name": "square",
    "label": "Square",
    "path": "square.svg"
  },
  {
    "name": "square-arrow-down",
    "label": "Square Arrow Down",
    "path": "square-arrow-down.svg"
  },
  {
    "name": "square-arrow-left",
    "label": "Square Arrow Left",
    "path": "square-arrow-left.svg"
  },
  {
    "name": "square-arrow-right",
    "label": "Square Arrow Right",
    "path": "square-arrow-right.svg"
  },
  {
    "name": "square-arrow-up",
    "label": "Square Arrow Up",
    "path": "square-arrow-up.svg"
  },
  {
    "name": "square-asterisk",
    "label": "Square Asterisk",
    "path": "square-asterisk.svg"
  },
  {
    "name": "square-check",
    "label": "Square Check",
    "path": "square-check.svg"
  },
  {
    "name": "square-chevron-down",
    "label": "Square Chevron Down",
    "path": "square-chevron-down.svg"
  },
  {
    "name": "square-chevron-left",
    "label": "Square Chevron Left",
    "path": "square-chevron-left.svg"
  },
  {
    "name": "square-chevron-right",
    "label": "Square Chevron Right",
    "path": "square-chevron-right.svg"
  },
  {
    "name": "square-chevron-up",
    "label": "Square Chevron Up",
    "path": "square-chevron-up.svg"
  },
  {
    "name": "square-chevrons-down",
    "label": "Square Chevrons Down",
    "path": "square-chevrons-down.svg"
  },
  {
    "name": "square-chevrons-left",
    "label": "Square Chevrons Left",
    "path": "square-chevrons-left.svg"
  },
  {
    "name": "square-chevrons-right",
    "label": "Square Chevrons Right",
    "path": "square-chevrons-right.svg"
  },
  {
    "name": "square-chevrons-up",
    "label": "Square Chevrons Up",
    "path": "square-chevrons-up.svg"
  },
  {
    "name": "square-dashed",
    "label": "Square Dashed",
    "path": "square-dashed.svg"
  },
  {
    "name": "square-dot",
    "label": "Square Dot",
    "path": "square-dot.svg"
  },
  {
    "name": "square-f0",
    "label": "Square F0",
    "path": "square-f0.svg"
  },
  {
    "name": "square-f1",
    "label": "Square F1",
    "path": "square-f1.svg"
  },
  {
    "name": "square-f2",
    "label": "Square F2",
    "path": "square-f2.svg"
  },
  {
    "name": "square-f3",
    "label": "Square F3",
    "path": "square-f3.svg"
  },
  {
    "name": "square-f4",
    "label": "Square F4",
    "path": "square-f4.svg"
  },
  {
    "name": "square-f5",
    "label": "Square F5",
    "path": "square-f5.svg"
  },
  {
    "name": "square-f6",
    "label": "Square F6",
    "path": "square-f6.svg"
  },
  {
    "name": "square-f7",
    "label": "Square F7",
    "path": "square-f7.svg"
  },
  {
    "name": "square-f8",
    "label": "Square F8",
    "path": "square-f8.svg"
  },
  {
    "name": "square-f9",
    "label": "Square F9",
    "path": "square-f9.svg"
  },
  {
    "name": "square-forbid",
    "label": "Square Forbid",
    "path": "square-forbid.svg"
  },
  {
    "name": "square-forbid-2",
    "label": "Square Forbid 2",
    "path": "square-forbid-2.svg"
  },
  {
    "name": "square-half",
    "label": "Square Half",
    "path": "square-half.svg"
  },
  {
    "name": "square-key",
    "label": "Square Key",
    "path": "square-key.svg"
  },
  {
    "name": "square-letter-a",
    "label": "Square Letter A",
    "path": "square-letter-a.svg"
  },
  {
    "name": "square-letter-b",
    "label": "Square Letter B",
    "path": "square-letter-b.svg"
  },
  {
    "name": "square-letter-c",
    "label": "Square Letter C",
    "path": "square-letter-c.svg"
  },
  {
    "name": "square-letter-d",
    "label": "Square Letter D",
    "path": "square-letter-d.svg"
  },
  {
    "name": "square-letter-e",
    "label": "Square Letter E",
    "path": "square-letter-e.svg"
  },
  {
    "name": "square-letter-f",
    "label": "Square Letter F",
    "path": "square-letter-f.svg"
  },
  {
    "name": "square-letter-g",
    "label": "Square Letter G",
    "path": "square-letter-g.svg"
  },
  {
    "name": "square-letter-h",
    "label": "Square Letter H",
    "path": "square-letter-h.svg"
  },
  {
    "name": "square-letter-i",
    "label": "Square Letter I",
    "path": "square-letter-i.svg"
  },
  {
    "name": "square-letter-j",
    "label": "Square Letter J",
    "path": "square-letter-j.svg"
  },
  {
    "name": "square-letter-k",
    "label": "Square Letter K",
    "path": "square-letter-k.svg"
  },
  {
    "name": "square-letter-l",
    "label": "Square Letter L",
    "path": "square-letter-l.svg"
  },
  {
    "name": "square-letter-m",
    "label": "Square Letter M",
    "path": "square-letter-m.svg"
  },
  {
    "name": "square-letter-n",
    "label": "Square Letter N",
    "path": "square-letter-n.svg"
  },
  {
    "name": "square-letter-o",
    "label": "Square Letter O",
    "path": "square-letter-o.svg"
  },
  {
    "name": "square-letter-p",
    "label": "Square Letter P",
    "path": "square-letter-p.svg"
  },
  {
    "name": "square-letter-q",
    "label": "Square Letter Q",
    "path": "square-letter-q.svg"
  },
  {
    "name": "square-letter-r",
    "label": "Square Letter R",
    "path": "square-letter-r.svg"
  },
  {
    "name": "square-letter-s",
    "label": "Square Letter S",
    "path": "square-letter-s.svg"
  },
  {
    "name": "square-letter-t",
    "label": "Square Letter T",
    "path": "square-letter-t.svg"
  },
  {
    "name": "square-letter-u",
    "label": "Square Letter U",
    "path": "square-letter-u.svg"
  },
  {
    "name": "square-letter-v",
    "label": "Square Letter V",
    "path": "square-letter-v.svg"
  },
  {
    "name": "square-letter-w",
    "label": "Square Letter W",
    "path": "square-letter-w.svg"
  },
  {
    "name": "square-letter-x",
    "label": "Square Letter X",
    "path": "square-letter-x.svg"
  },
  {
    "name": "square-letter-y",
    "label": "Square Letter Y",
    "path": "square-letter-y.svg"
  },
  {
    "name": "square-letter-z",
    "label": "Square Letter Z",
    "path": "square-letter-z.svg"
  },
  {
    "name": "square-minus",
    "label": "Square Minus",
    "path": "square-minus.svg"
  },
  {
    "name": "square-minus-2",
    "label": "Square Minus 2",
    "path": "square-minus-2.svg"
  },
  {
    "name": "square-number-0",
    "label": "Square Number 0",
    "path": "square-number-0.svg"
  },
  {
    "name": "square-number-1",
    "label": "Square Number 1",
    "path": "square-number-1.svg"
  },
  {
    "name": "square-number-2",
    "label": "Square Number 2",
    "path": "square-number-2.svg"
  },
  {
    "name": "square-number-3",
    "label": "Square Number 3",
    "path": "square-number-3.svg"
  },
  {
    "name": "square-number-4",
    "label": "Square Number 4",
    "path": "square-number-4.svg"
  },
  {
    "name": "square-number-5",
    "label": "Square Number 5",
    "path": "square-number-5.svg"
  },
  {
    "name": "square-number-6",
    "label": "Square Number 6",
    "path": "square-number-6.svg"
  },
  {
    "name": "square-number-7",
    "label": "Square Number 7",
    "path": "square-number-7.svg"
  },
  {
    "name": "square-number-8",
    "label": "Square Number 8",
    "path": "square-number-8.svg"
  },
  {
    "name": "square-number-9",
    "label": "Square Number 9",
    "path": "square-number-9.svg"
  },
  {
    "name": "square-off",
    "label": "Square Off",
    "path": "square-off.svg"
  },
  {
    "name": "square-percentage",
    "label": "Square Percentage",
    "path": "square-percentage.svg"
  },
  {
    "name": "square-plus",
    "label": "Square Plus",
    "path": "square-plus.svg"
  },
  {
    "name": "square-plus-2",
    "label": "Square Plus 2",
    "path": "square-plus-2.svg"
  },
  {
    "name": "square-root",
    "label": "Square Root",
    "path": "square-root.svg"
  },
  {
    "name": "square-root-2",
    "label": "Square Root 2",
    "path": "square-root-2.svg"
  },
  {
    "name": "square-rotated",
    "label": "Square Rotated",
    "path": "square-rotated.svg"
  },
  {
    "name": "square-rotated-asterisk",
    "label": "Square Rotated Asterisk",
    "path": "square-rotated-asterisk.svg"
  },
  {
    "name": "square-rotated-forbid",
    "label": "Square Rotated Forbid",
    "path": "square-rotated-forbid.svg"
  },
  {
    "name": "square-rotated-forbid-2",
    "label": "Square Rotated Forbid 2",
    "path": "square-rotated-forbid-2.svg"
  },
  {
    "name": "square-rotated-off",
    "label": "Square Rotated Off",
    "path": "square-rotated-off.svg"
  },
  {
    "name": "square-rounded",
    "label": "Square Rounded",
    "path": "square-rounded.svg"
  },
  {
    "name": "square-rounded-arrow-down",
    "label": "Square Rounded Arrow Down",
    "path": "square-rounded-arrow-down.svg"
  },
  {
    "name": "square-rounded-arrow-left",
    "label": "Square Rounded Arrow Left",
    "path": "square-rounded-arrow-left.svg"
  },
  {
    "name": "square-rounded-arrow-right",
    "label": "Square Rounded Arrow Right",
    "path": "square-rounded-arrow-right.svg"
  },
  {
    "name": "square-rounded-arrow-up",
    "label": "Square Rounded Arrow Up",
    "path": "square-rounded-arrow-up.svg"
  },
  {
    "name": "square-rounded-check",
    "label": "Square Rounded Check",
    "path": "square-rounded-check.svg"
  },
  {
    "name": "square-rounded-chevron-down",
    "label": "Square Rounded Chevron Down",
    "path": "square-rounded-chevron-down.svg"
  },
  {
    "name": "square-rounded-chevron-left",
    "label": "Square Rounded Chevron Left",
    "path": "square-rounded-chevron-left.svg"
  },
  {
    "name": "square-rounded-chevron-right",
    "label": "Square Rounded Chevron Right",
    "path": "square-rounded-chevron-right.svg"
  },
  {
    "name": "square-rounded-chevron-up",
    "label": "Square Rounded Chevron Up",
    "path": "square-rounded-chevron-up.svg"
  },
  {
    "name": "square-rounded-chevrons-down",
    "label": "Square Rounded Chevrons Down",
    "path": "square-rounded-chevrons-down.svg"
  },
  {
    "name": "square-rounded-chevrons-left",
    "label": "Square Rounded Chevrons Left",
    "path": "square-rounded-chevrons-left.svg"
  },
  {
    "name": "square-rounded-chevrons-right",
    "label": "Square Rounded Chevrons Right",
    "path": "square-rounded-chevrons-right.svg"
  },
  {
    "name": "square-rounded-chevrons-up",
    "label": "Square Rounded Chevrons Up",
    "path": "square-rounded-chevrons-up.svg"
  },
  {
    "name": "square-rounded-letter-a",
    "label": "Square Rounded Letter A",
    "path": "square-rounded-letter-a.svg"
  },
  {
    "name": "square-rounded-letter-b",
    "label": "Square Rounded Letter B",
    "path": "square-rounded-letter-b.svg"
  },
  {
    "name": "square-rounded-letter-c",
    "label": "Square Rounded Letter C",
    "path": "square-rounded-letter-c.svg"
  },
  {
    "name": "square-rounded-letter-d",
    "label": "Square Rounded Letter D",
    "path": "square-rounded-letter-d.svg"
  },
  {
    "name": "square-rounded-letter-e",
    "label": "Square Rounded Letter E",
    "path": "square-rounded-letter-e.svg"
  },
  {
    "name": "square-rounded-letter-f",
    "label": "Square Rounded Letter F",
    "path": "square-rounded-letter-f.svg"
  },
  {
    "name": "square-rounded-letter-g",
    "label": "Square Rounded Letter G",
    "path": "square-rounded-letter-g.svg"
  },
  {
    "name": "square-rounded-letter-h",
    "label": "Square Rounded Letter H",
    "path": "square-rounded-letter-h.svg"
  },
  {
    "name": "square-rounded-letter-i",
    "label": "Square Rounded Letter I",
    "path": "square-rounded-letter-i.svg"
  },
  {
    "name": "square-rounded-letter-j",
    "label": "Square Rounded Letter J",
    "path": "square-rounded-letter-j.svg"
  },
  {
    "name": "square-rounded-letter-k",
    "label": "Square Rounded Letter K",
    "path": "square-rounded-letter-k.svg"
  },
  {
    "name": "square-rounded-letter-l",
    "label": "Square Rounded Letter L",
    "path": "square-rounded-letter-l.svg"
  },
  {
    "name": "square-rounded-letter-m",
    "label": "Square Rounded Letter M",
    "path": "square-rounded-letter-m.svg"
  },
  {
    "name": "square-rounded-letter-n",
    "label": "Square Rounded Letter N",
    "path": "square-rounded-letter-n.svg"
  },
  {
    "name": "square-rounded-letter-o",
    "label": "Square Rounded Letter O",
    "path": "square-rounded-letter-o.svg"
  },
  {
    "name": "square-rounded-letter-p",
    "label": "Square Rounded Letter P",
    "path": "square-rounded-letter-p.svg"
  },
  {
    "name": "square-rounded-letter-q",
    "label": "Square Rounded Letter Q",
    "path": "square-rounded-letter-q.svg"
  },
  {
    "name": "square-rounded-letter-r",
    "label": "Square Rounded Letter R",
    "path": "square-rounded-letter-r.svg"
  },
  {
    "name": "square-rounded-letter-s",
    "label": "Square Rounded Letter S",
    "path": "square-rounded-letter-s.svg"
  },
  {
    "name": "square-rounded-letter-t",
    "label": "Square Rounded Letter T",
    "path": "square-rounded-letter-t.svg"
  },
  {
    "name": "square-rounded-letter-u",
    "label": "Square Rounded Letter U",
    "path": "square-rounded-letter-u.svg"
  },
  {
    "name": "square-rounded-letter-v",
    "label": "Square Rounded Letter V",
    "path": "square-rounded-letter-v.svg"
  },
  {
    "name": "square-rounded-letter-w",
    "label": "Square Rounded Letter W",
    "path": "square-rounded-letter-w.svg"
  },
  {
    "name": "square-rounded-letter-x",
    "label": "Square Rounded Letter X",
    "path": "square-rounded-letter-x.svg"
  },
  {
    "name": "square-rounded-letter-y",
    "label": "Square Rounded Letter Y",
    "path": "square-rounded-letter-y.svg"
  },
  {
    "name": "square-rounded-letter-z",
    "label": "Square Rounded Letter Z",
    "path": "square-rounded-letter-z.svg"
  },
  {
    "name": "square-rounded-minus",
    "label": "Square Rounded Minus",
    "path": "square-rounded-minus.svg"
  },
  {
    "name": "square-rounded-minus-2",
    "label": "Square Rounded Minus 2",
    "path": "square-rounded-minus-2.svg"
  },
  {
    "name": "square-rounded-number-0",
    "label": "Square Rounded Number 0",
    "path": "square-rounded-number-0.svg"
  },
  {
    "name": "square-rounded-number-1",
    "label": "Square Rounded Number 1",
    "path": "square-rounded-number-1.svg"
  },
  {
    "name": "square-rounded-number-2",
    "label": "Square Rounded Number 2",
    "path": "square-rounded-number-2.svg"
  },
  {
    "name": "square-rounded-number-3",
    "label": "Square Rounded Number 3",
    "path": "square-rounded-number-3.svg"
  },
  {
    "name": "square-rounded-number-4",
    "label": "Square Rounded Number 4",
    "path": "square-rounded-number-4.svg"
  },
  {
    "name": "square-rounded-number-5",
    "label": "Square Rounded Number 5",
    "path": "square-rounded-number-5.svg"
  },
  {
    "name": "square-rounded-number-6",
    "label": "Square Rounded Number 6",
    "path": "square-rounded-number-6.svg"
  },
  {
    "name": "square-rounded-number-7",
    "label": "Square Rounded Number 7",
    "path": "square-rounded-number-7.svg"
  },
  {
    "name": "square-rounded-number-8",
    "label": "Square Rounded Number 8",
    "path": "square-rounded-number-8.svg"
  },
  {
    "name": "square-rounded-number-9",
    "label": "Square Rounded Number 9",
    "path": "square-rounded-number-9.svg"
  },
  {
    "name": "square-rounded-percentage",
    "label": "Square Rounded Percentage",
    "path": "square-rounded-percentage.svg"
  },
  {
    "name": "square-rounded-plus",
    "label": "Square Rounded Plus",
    "path": "square-rounded-plus.svg"
  },
  {
    "name": "square-rounded-plus-2",
    "label": "Square Rounded Plus 2",
    "path": "square-rounded-plus-2.svg"
  },
  {
    "name": "square-rounded-x",
    "label": "Square Rounded X",
    "path": "square-rounded-x.svg"
  },
  {
    "name": "square-toggle",
    "label": "Square Toggle",
    "path": "square-toggle.svg"
  },
  {
    "name": "square-toggle-horizontal",
    "label": "Square Toggle Horizontal",
    "path": "square-toggle-horizontal.svg"
  },
  {
    "name": "square-x",
    "label": "Square X",
    "path": "square-x.svg"
  },
  {
    "name": "squares",
    "label": "Squares",
    "path": "squares.svg"
  },
  {
    "name": "squares-diagonal",
    "label": "Squares Diagonal",
    "path": "squares-diagonal.svg"
  },
  {
    "name": "squares-selected",
    "label": "Squares Selected",
    "path": "squares-selected.svg"
  },
  {
    "name": "stack",
    "label": "Stack",
    "path": "stack.svg"
  },
  {
    "name": "stack-2",
    "label": "Stack 2",
    "path": "stack-2.svg"
  },
  {
    "name": "stack-3",
    "label": "Stack 3",
    "path": "stack-3.svg"
  },
  {
    "name": "stack-back",
    "label": "Stack Back",
    "path": "stack-back.svg"
  },
  {
    "name": "stack-backward",
    "label": "Stack Backward",
    "path": "stack-backward.svg"
  },
  {
    "name": "stack-forward",
    "label": "Stack Forward",
    "path": "stack-forward.svg"
  },
  {
    "name": "stack-front",
    "label": "Stack Front",
    "path": "stack-front.svg"
  },
  {
    "name": "stack-middle",
    "label": "Stack Middle",
    "path": "stack-middle.svg"
  },
  {
    "name": "stack-pop",
    "label": "Stack Pop",
    "path": "stack-pop.svg"
  },
  {
    "name": "stack-push",
    "label": "Stack Push",
    "path": "stack-push.svg"
  },
  {
    "name": "stairs",
    "label": "Stairs",
    "path": "stairs.svg"
  },
  {
    "name": "stairs-down",
    "label": "Stairs Down",
    "path": "stairs-down.svg"
  },
  {
    "name": "stairs-up",
    "label": "Stairs Up",
    "path": "stairs-up.svg"
  },
  {
    "name": "star",
    "label": "Star",
    "path": "star.svg"
  },
  {
    "name": "star-half",
    "label": "Star Half",
    "path": "star-half.svg"
  },
  {
    "name": "star-off",
    "label": "Star Off",
    "path": "star-off.svg"
  },
  {
    "name": "stars",
    "label": "Stars",
    "path": "stars.svg"
  },
  {
    "name": "stars-off",
    "label": "Stars Off",
    "path": "stars-off.svg"
  },
  {
    "name": "status-change",
    "label": "Status Change",
    "path": "status-change.svg"
  },
  {
    "name": "steam",
    "label": "Steam",
    "path": "steam.svg"
  },
  {
    "name": "steering-wheel",
    "label": "Steering Wheel",
    "path": "steering-wheel.svg"
  },
  {
    "name": "steering-wheel-off",
    "label": "Steering Wheel Off",
    "path": "steering-wheel-off.svg"
  },
  {
    "name": "step-into",
    "label": "Step Into",
    "path": "step-into.svg"
  },
  {
    "name": "step-out",
    "label": "Step Out",
    "path": "step-out.svg"
  },
  {
    "name": "stereo-glasses",
    "label": "Stereo Glasses",
    "path": "stereo-glasses.svg"
  },
  {
    "name": "stethoscope",
    "label": "Stethoscope",
    "path": "stethoscope.svg"
  },
  {
    "name": "stethoscope-off",
    "label": "Stethoscope Off",
    "path": "stethoscope-off.svg"
  },
  {
    "name": "sticker",
    "label": "Sticker",
    "path": "sticker.svg"
  },
  {
    "name": "sticker-2",
    "label": "Sticker 2",
    "path": "sticker-2.svg"
  },
  {
    "name": "stopwatch",
    "label": "Stopwatch",
    "path": "stopwatch.svg"
  },
  {
    "name": "storm",
    "label": "Storm",
    "path": "storm.svg"
  },
  {
    "name": "storm-off",
    "label": "Storm Off",
    "path": "storm-off.svg"
  },
  {
    "name": "stretching",
    "label": "Stretching",
    "path": "stretching.svg"
  },
  {
    "name": "stretching-2",
    "label": "Stretching 2",
    "path": "stretching-2.svg"
  },
  {
    "name": "strikethrough",
    "label": "Strikethrough",
    "path": "strikethrough.svg"
  },
  {
    "name": "submarine",
    "label": "Submarine",
    "path": "submarine.svg"
  },
  {
    "name": "subscript",
    "label": "Subscript",
    "path": "subscript.svg"
  },
  {
    "name": "subtask",
    "label": "Subtask",
    "path": "subtask.svg"
  },
  {
    "name": "subtitles",
    "label": "Subtitles",
    "path": "subtitles.svg"
  },
  {
    "name": "subtitles-ai",
    "label": "Subtitles Ai",
    "path": "subtitles-ai.svg"
  },
  {
    "name": "subtitles-edit",
    "label": "Subtitles Edit",
    "path": "subtitles-edit.svg"
  },
  {
    "name": "subtitles-off",
    "label": "Subtitles Off",
    "path": "subtitles-off.svg"
  },
  {
    "name": "sum",
    "label": "Sum",
    "path": "sum.svg"
  },
  {
    "name": "sum-off",
    "label": "Sum Off",
    "path": "sum-off.svg"
  },
  {
    "name": "sun",
    "label": "Sun",
    "path": "sun.svg"
  },
  {
    "name": "sun-electricity",
    "label": "Sun Electricity",
    "path": "sun-electricity.svg"
  },
  {
    "name": "sun-high",
    "label": "Sun High",
    "path": "sun-high.svg"
  },
  {
    "name": "sun-low",
    "label": "Sun Low",
    "path": "sun-low.svg"
  },
  {
    "name": "sun-moon",
    "label": "Sun Moon",
    "path": "sun-moon.svg"
  },
  {
    "name": "sun-off",
    "label": "Sun Off",
    "path": "sun-off.svg"
  },
  {
    "name": "sun-wind",
    "label": "Sun Wind",
    "path": "sun-wind.svg"
  },
  {
    "name": "sunglasses",
    "label": "Sunglasses",
    "path": "sunglasses.svg"
  },
  {
    "name": "sunrise",
    "label": "Sunrise",
    "path": "sunrise.svg"
  },
  {
    "name": "sunset",
    "label": "Sunset",
    "path": "sunset.svg"
  },
  {
    "name": "sunset-2",
    "label": "Sunset 2",
    "path": "sunset-2.svg"
  },
  {
    "name": "superscript",
    "label": "Superscript",
    "path": "superscript.svg"
  },
  {
    "name": "svg",
    "label": "Svg",
    "path": "svg.svg"
  },
  {
    "name": "swimming",
    "label": "Swimming",
    "path": "swimming.svg"
  },
  {
    "name": "swipe",
    "label": "Swipe",
    "path": "swipe.svg"
  },
  {
    "name": "swipe-down",
    "label": "Swipe Down",
    "path": "swipe-down.svg"
  },
  {
    "name": "swipe-left",
    "label": "Swipe Left",
    "path": "swipe-left.svg"
  },
  {
    "name": "swipe-right",
    "label": "Swipe Right",
    "path": "swipe-right.svg"
  },
  {
    "name": "swipe-up",
    "label": "Swipe Up",
    "path": "swipe-up.svg"
  },
  {
    "name": "switch",
    "label": "Switch",
    "path": "switch.svg"
  },
  {
    "name": "switch-2",
    "label": "Switch 2",
    "path": "switch-2.svg"
  },
  {
    "name": "switch-3",
    "label": "Switch 3",
    "path": "switch-3.svg"
  },
  {
    "name": "switch-horizontal",
    "label": "Switch Horizontal",
    "path": "switch-horizontal.svg"
  },
  {
    "name": "switch-vertical",
    "label": "Switch Vertical",
    "path": "switch-vertical.svg"
  },
  {
    "name": "sword",
    "label": "Sword",
    "path": "sword.svg"
  },
  {
    "name": "sword-off",
    "label": "Sword Off",
    "path": "sword-off.svg"
  },
  {
    "name": "swords",
    "label": "Swords",
    "path": "swords.svg"
  },
  {
    "name": "table",
    "label": "Table",
    "path": "table.svg"
  },
  {
    "name": "table-alias",
    "label": "Table Alias",
    "path": "table-alias.svg"
  },
  {
    "name": "table-column",
    "label": "Table Column",
    "path": "table-column.svg"
  },
  {
    "name": "table-dashed",
    "label": "Table Dashed",
    "path": "table-dashed.svg"
  },
  {
    "name": "table-down",
    "label": "Table Down",
    "path": "table-down.svg"
  },
  {
    "name": "table-export",
    "label": "Table Export",
    "path": "table-export.svg"
  },
  {
    "name": "table-heart",
    "label": "Table Heart",
    "path": "table-heart.svg"
  },
  {
    "name": "table-import",
    "label": "Table Import",
    "path": "table-import.svg"
  },
  {
    "name": "table-minus",
    "label": "Table Minus",
    "path": "table-minus.svg"
  },
  {
    "name": "table-off",
    "label": "Table Off",
    "path": "table-off.svg"
  },
  {
    "name": "table-options",
    "label": "Table Options",
    "path": "table-options.svg"
  },
  {
    "name": "table-plus",
    "label": "Table Plus",
    "path": "table-plus.svg"
  },
  {
    "name": "table-row",
    "label": "Table Row",
    "path": "table-row.svg"
  },
  {
    "name": "table-share",
    "label": "Table Share",
    "path": "table-share.svg"
  },
  {
    "name": "table-shortcut",
    "label": "Table Shortcut",
    "path": "table-shortcut.svg"
  },
  {
    "name": "table-spark",
    "label": "Table Spark",
    "path": "table-spark.svg"
  },
  {
    "name": "tag",
    "label": "Tag",
    "path": "tag.svg"
  },
  {
    "name": "tag-minus",
    "label": "Tag Minus",
    "path": "tag-minus.svg"
  },
  {
    "name": "tag-off",
    "label": "Tag Off",
    "path": "tag-off.svg"
  },
  {
    "name": "tag-plus",
    "label": "Tag Plus",
    "path": "tag-plus.svg"
  },
  {
    "name": "tag-starred",
    "label": "Tag Starred",
    "path": "tag-starred.svg"
  },
  {
    "name": "tags",
    "label": "Tags",
    "path": "tags.svg"
  },
  {
    "name": "tags-off",
    "label": "Tags Off",
    "path": "tags-off.svg"
  },
  {
    "name": "tallymark-1",
    "label": "Tallymark 1",
    "path": "tallymark-1.svg"
  },
  {
    "name": "tallymark-2",
    "label": "Tallymark 2",
    "path": "tallymark-2.svg"
  },
  {
    "name": "tallymark-3",
    "label": "Tallymark 3",
    "path": "tallymark-3.svg"
  },
  {
    "name": "tallymark-4",
    "label": "Tallymark 4",
    "path": "tallymark-4.svg"
  },
  {
    "name": "tallymarks",
    "label": "Tallymarks",
    "path": "tallymarks.svg"
  },
  {
    "name": "tank",
    "label": "Tank",
    "path": "tank.svg"
  },
  {
    "name": "target",
    "label": "Target",
    "path": "target.svg"
  },
  {
    "name": "target-arrow",
    "label": "Target Arrow",
    "path": "target-arrow.svg"
  },
  {
    "name": "target-off",
    "label": "Target Off",
    "path": "target-off.svg"
  },
  {
    "name": "tax",
    "label": "Tax",
    "path": "tax.svg"
  },
  {
    "name": "tax-euro",
    "label": "Tax Euro",
    "path": "tax-euro.svg"
  },
  {
    "name": "tax-pound",
    "label": "Tax Pound",
    "path": "tax-pound.svg"
  },
  {
    "name": "teapot",
    "label": "Teapot",
    "path": "teapot.svg"
  },
  {
    "name": "telescope",
    "label": "Telescope",
    "path": "telescope.svg"
  },
  {
    "name": "telescope-off",
    "label": "Telescope Off",
    "path": "telescope-off.svg"
  },
  {
    "name": "temperature",
    "label": "Temperature",
    "path": "temperature.svg"
  },
  {
    "name": "temperature-celsius",
    "label": "Temperature Celsius",
    "path": "temperature-celsius.svg"
  },
  {
    "name": "temperature-fahrenheit",
    "label": "Temperature Fahrenheit",
    "path": "temperature-fahrenheit.svg"
  },
  {
    "name": "temperature-minus",
    "label": "Temperature Minus",
    "path": "temperature-minus.svg"
  },
  {
    "name": "temperature-off",
    "label": "Temperature Off",
    "path": "temperature-off.svg"
  },
  {
    "name": "temperature-plus",
    "label": "Temperature Plus",
    "path": "temperature-plus.svg"
  },
  {
    "name": "temperature-snow",
    "label": "Temperature Snow",
    "path": "temperature-snow.svg"
  },
  {
    "name": "temperature-sun",
    "label": "Temperature Sun",
    "path": "temperature-sun.svg"
  },
  {
    "name": "template",
    "label": "Template",
    "path": "template.svg"
  },
  {
    "name": "template-off",
    "label": "Template Off",
    "path": "template-off.svg"
  },
  {
    "name": "tent",
    "label": "Tent",
    "path": "tent.svg"
  },
  {
    "name": "tent-off",
    "label": "Tent Off",
    "path": "tent-off.svg"
  },
  {
    "name": "terminal",
    "label": "Terminal",
    "path": "terminal.svg"
  },
  {
    "name": "terminal-2",
    "label": "Terminal 2",
    "path": "terminal-2.svg"
  },
  {
    "name": "test-pipe",
    "label": "Test Pipe",
    "path": "test-pipe.svg"
  },
  {
    "name": "test-pipe-2",
    "label": "Test Pipe 2",
    "path": "test-pipe-2.svg"
  },
  {
    "name": "test-pipe-off",
    "label": "Test Pipe Off",
    "path": "test-pipe-off.svg"
  },
  {
    "name": "tex",
    "label": "Tex",
    "path": "tex.svg"
  },
  {
    "name": "text-caption",
    "label": "Text Caption",
    "path": "text-caption.svg"
  },
  {
    "name": "text-color",
    "label": "Text Color",
    "path": "text-color.svg"
  },
  {
    "name": "text-decrease",
    "label": "Text Decrease",
    "path": "text-decrease.svg"
  },
  {
    "name": "text-direction-ltr",
    "label": "Text Direction Ltr",
    "path": "text-direction-ltr.svg"
  },
  {
    "name": "text-direction-rtl",
    "label": "Text Direction Rtl",
    "path": "text-direction-rtl.svg"
  },
  {
    "name": "text-grammar",
    "label": "Text Grammar",
    "path": "text-grammar.svg"
  },
  {
    "name": "text-increase",
    "label": "Text Increase",
    "path": "text-increase.svg"
  },
  {
    "name": "text-orientation",
    "label": "Text Orientation",
    "path": "text-orientation.svg"
  },
  {
    "name": "text-plus",
    "label": "Text Plus",
    "path": "text-plus.svg"
  },
  {
    "name": "text-recognition",
    "label": "Text Recognition",
    "path": "text-recognition.svg"
  },
  {
    "name": "text-resize",
    "label": "Text Resize",
    "path": "text-resize.svg"
  },
  {
    "name": "text-scan-2",
    "label": "Text Scan 2",
    "path": "text-scan-2.svg"
  },
  {
    "name": "text-size",
    "label": "Text Size",
    "path": "text-size.svg"
  },
  {
    "name": "text-spellcheck",
    "label": "Text Spellcheck",
    "path": "text-spellcheck.svg"
  },
  {
    "name": "text-wrap",
    "label": "Text Wrap",
    "path": "text-wrap.svg"
  },
  {
    "name": "text-wrap-column",
    "label": "Text Wrap Column",
    "path": "text-wrap-column.svg"
  },
  {
    "name": "text-wrap-disabled",
    "label": "Text Wrap Disabled",
    "path": "text-wrap-disabled.svg"
  },
  {
    "name": "texture",
    "label": "Texture",
    "path": "texture.svg"
  },
  {
    "name": "theater",
    "label": "Theater",
    "path": "theater.svg"
  },
  {
    "name": "thermometer",
    "label": "Thermometer",
    "path": "thermometer.svg"
  },
  {
    "name": "thumb-down",
    "label": "Thumb Down",
    "path": "thumb-down.svg"
  },
  {
    "name": "thumb-down-off",
    "label": "Thumb Down Off",
    "path": "thumb-down-off.svg"
  },
  {
    "name": "thumb-up",
    "label": "Thumb Up",
    "path": "thumb-up.svg"
  },
  {
    "name": "thumb-up-off",
    "label": "Thumb Up Off",
    "path": "thumb-up-off.svg"
  },
  {
    "name": "tic-tac",
    "label": "Tic Tac",
    "path": "tic-tac.svg"
  },
  {
    "name": "ticket",
    "label": "Ticket",
    "path": "ticket.svg"
  },
  {
    "name": "ticket-off",
    "label": "Ticket Off",
    "path": "ticket-off.svg"
  },
  {
    "name": "tie",
    "label": "Tie",
    "path": "tie.svg"
  },
  {
    "name": "tilde",
    "label": "Tilde",
    "path": "tilde.svg"
  },
  {
    "name": "tilt-shift",
    "label": "Tilt Shift",
    "path": "tilt-shift.svg"
  },
  {
    "name": "tilt-shift-off",
    "label": "Tilt Shift Off",
    "path": "tilt-shift-off.svg"
  },
  {
    "name": "time-duration-0",
    "label": "Time Duration 0",
    "path": "time-duration-0.svg"
  },
  {
    "name": "time-duration-10",
    "label": "Time Duration 10",
    "path": "time-duration-10.svg"
  },
  {
    "name": "time-duration-15",
    "label": "Time Duration 15",
    "path": "time-duration-15.svg"
  },
  {
    "name": "time-duration-30",
    "label": "Time Duration 30",
    "path": "time-duration-30.svg"
  },
  {
    "name": "time-duration-45",
    "label": "Time Duration 45",
    "path": "time-duration-45.svg"
  },
  {
    "name": "time-duration-5",
    "label": "Time Duration 5",
    "path": "time-duration-5.svg"
  },
  {
    "name": "time-duration-60",
    "label": "Time Duration 60",
    "path": "time-duration-60.svg"
  },
  {
    "name": "time-duration-90",
    "label": "Time Duration 90",
    "path": "time-duration-90.svg"
  },
  {
    "name": "time-duration-off",
    "label": "Time Duration Off",
    "path": "time-duration-off.svg"
  },
  {
    "name": "timeline",
    "label": "Timeline",
    "path": "timeline.svg"
  },
  {
    "name": "timeline-event",
    "label": "Timeline Event",
    "path": "timeline-event.svg"
  },
  {
    "name": "timeline-event-exclamation",
    "label": "Timeline Event Exclamation",
    "path": "timeline-event-exclamation.svg"
  },
  {
    "name": "timeline-event-minus",
    "label": "Timeline Event Minus",
    "path": "timeline-event-minus.svg"
  },
  {
    "name": "timeline-event-plus",
    "label": "Timeline Event Plus",
    "path": "timeline-event-plus.svg"
  },
  {
    "name": "timeline-event-text",
    "label": "Timeline Event Text",
    "path": "timeline-event-text.svg"
  },
  {
    "name": "timeline-event-x",
    "label": "Timeline Event X",
    "path": "timeline-event-x.svg"
  },
  {
    "name": "timezone",
    "label": "Timezone",
    "path": "timezone.svg"
  },
  {
    "name": "tip-jar",
    "label": "Tip Jar",
    "path": "tip-jar.svg"
  },
  {
    "name": "tip-jar-euro",
    "label": "Tip Jar Euro",
    "path": "tip-jar-euro.svg"
  },
  {
    "name": "tip-jar-pound",
    "label": "Tip Jar Pound",
    "path": "tip-jar-pound.svg"
  },
  {
    "name": "tir",
    "label": "Tir",
    "path": "tir.svg"
  },
  {
    "name": "toggle-left",
    "label": "Toggle Left",
    "path": "toggle-left.svg"
  },
  {
    "name": "toggle-right",
    "label": "Toggle Right",
    "path": "toggle-right.svg"
  },
  {
    "name": "toilet-paper",
    "label": "Toilet Paper",
    "path": "toilet-paper.svg"
  },
  {
    "name": "toilet-paper-off",
    "label": "Toilet Paper Off",
    "path": "toilet-paper-off.svg"
  },
  {
    "name": "toml",
    "label": "Toml",
    "path": "toml.svg"
  },
  {
    "name": "tool",
    "label": "Tool",
    "path": "tool.svg"
  },
  {
    "name": "tools",
    "label": "Tools",
    "path": "tools.svg"
  },
  {
    "name": "tools-kitchen",
    "label": "Tools Kitchen",
    "path": "tools-kitchen.svg"
  },
  {
    "name": "tools-kitchen-2",
    "label": "Tools Kitchen 2",
    "path": "tools-kitchen-2.svg"
  },
  {
    "name": "tools-kitchen-2-off",
    "label": "Tools Kitchen 2 Off",
    "path": "tools-kitchen-2-off.svg"
  },
  {
    "name": "tools-kitchen-3",
    "label": "Tools Kitchen 3",
    "path": "tools-kitchen-3.svg"
  },
  {
    "name": "tools-kitchen-off",
    "label": "Tools Kitchen Off",
    "path": "tools-kitchen-off.svg"
  },
  {
    "name": "tools-off",
    "label": "Tools Off",
    "path": "tools-off.svg"
  },
  {
    "name": "tooltip",
    "label": "Tooltip",
    "path": "tooltip.svg"
  },
  {
    "name": "topology-bus",
    "label": "Topology Bus",
    "path": "topology-bus.svg"
  },
  {
    "name": "topology-complex",
    "label": "Topology Complex",
    "path": "topology-complex.svg"
  },
  {
    "name": "topology-full",
    "label": "Topology Full",
    "path": "topology-full.svg"
  },
  {
    "name": "topology-full-hierarchy",
    "label": "Topology Full Hierarchy",
    "path": "topology-full-hierarchy.svg"
  },
  {
    "name": "topology-ring",
    "label": "Topology Ring",
    "path": "topology-ring.svg"
  },
  {
    "name": "topology-ring-2",
    "label": "Topology Ring 2",
    "path": "topology-ring-2.svg"
  },
  {
    "name": "topology-ring-3",
    "label": "Topology Ring 3",
    "path": "topology-ring-3.svg"
  },
  {
    "name": "topology-star",
    "label": "Topology Star",
    "path": "topology-star.svg"
  },
  {
    "name": "topology-star-2",
    "label": "Topology Star 2",
    "path": "topology-star-2.svg"
  },
  {
    "name": "topology-star-3",
    "label": "Topology Star 3",
    "path": "topology-star-3.svg"
  },
  {
    "name": "topology-star-ring",
    "label": "Topology Star Ring",
    "path": "topology-star-ring.svg"
  },
  {
    "name": "topology-star-ring-2",
    "label": "Topology Star Ring 2",
    "path": "topology-star-ring-2.svg"
  },
  {
    "name": "topology-star-ring-3",
    "label": "Topology Star Ring 3",
    "path": "topology-star-ring-3.svg"
  },
  {
    "name": "torii",
    "label": "Torii",
    "path": "torii.svg"
  },
  {
    "name": "tornado",
    "label": "Tornado",
    "path": "tornado.svg"
  },
  {
    "name": "tournament",
    "label": "Tournament",
    "path": "tournament.svg"
  },
  {
    "name": "tower",
    "label": "Tower",
    "path": "tower.svg"
  },
  {
    "name": "tower-off",
    "label": "Tower Off",
    "path": "tower-off.svg"
  },
  {
    "name": "track",
    "label": "Track",
    "path": "track.svg"
  },
  {
    "name": "tractor",
    "label": "Tractor",
    "path": "tractor.svg"
  },
  {
    "name": "trademark",
    "label": "Trademark",
    "path": "trademark.svg"
  },
  {
    "name": "traffic-cone",
    "label": "Traffic Cone",
    "path": "traffic-cone.svg"
  },
  {
    "name": "traffic-cone-off",
    "label": "Traffic Cone Off",
    "path": "traffic-cone-off.svg"
  },
  {
    "name": "traffic-lights",
    "label": "Traffic Lights",
    "path": "traffic-lights.svg"
  },
  {
    "name": "traffic-lights-off",
    "label": "Traffic Lights Off",
    "path": "traffic-lights-off.svg"
  },
  {
    "name": "train",
    "label": "Train",
    "path": "train.svg"
  },
  {
    "name": "transaction-bitcoin",
    "label": "Transaction Bitcoin",
    "path": "transaction-bitcoin.svg"
  },
  {
    "name": "transaction-dollar",
    "label": "Transaction Dollar",
    "path": "transaction-dollar.svg"
  },
  {
    "name": "transaction-euro",
    "label": "Transaction Euro",
    "path": "transaction-euro.svg"
  },
  {
    "name": "transaction-pound",
    "label": "Transaction Pound",
    "path": "transaction-pound.svg"
  },
  {
    "name": "transaction-rupee",
    "label": "Transaction Rupee",
    "path": "transaction-rupee.svg"
  },
  {
    "name": "transaction-yen",
    "label": "Transaction Yen",
    "path": "transaction-yen.svg"
  },
  {
    "name": "transaction-yuan",
    "label": "Transaction Yuan",
    "path": "transaction-yuan.svg"
  },
  {
    "name": "transfer",
    "label": "Transfer",
    "path": "transfer.svg"
  },
  {
    "name": "transfer-in",
    "label": "Transfer In",
    "path": "transfer-in.svg"
  },
  {
    "name": "transfer-out",
    "label": "Transfer Out",
    "path": "transfer-out.svg"
  },
  {
    "name": "transfer-vertical",
    "label": "Transfer Vertical",
    "path": "transfer-vertical.svg"
  },
  {
    "name": "transform",
    "label": "Transform",
    "path": "transform.svg"
  },
  {
    "name": "transform-point",
    "label": "Transform Point",
    "path": "transform-point.svg"
  },
  {
    "name": "transform-point-bottom-left",
    "label": "Transform Point Bottom Left",
    "path": "transform-point-bottom-left.svg"
  },
  {
    "name": "transform-point-bottom-right",
    "label": "Transform Point Bottom Right",
    "path": "transform-point-bottom-right.svg"
  },
  {
    "name": "transform-point-top-left",
    "label": "Transform Point Top Left",
    "path": "transform-point-top-left.svg"
  },
  {
    "name": "transform-point-top-right",
    "label": "Transform Point Top Right",
    "path": "transform-point-top-right.svg"
  },
  {
    "name": "transition-bottom",
    "label": "Transition Bottom",
    "path": "transition-bottom.svg"
  },
  {
    "name": "transition-left",
    "label": "Transition Left",
    "path": "transition-left.svg"
  },
  {
    "name": "transition-right",
    "label": "Transition Right",
    "path": "transition-right.svg"
  },
  {
    "name": "transition-top",
    "label": "Transition Top",
    "path": "transition-top.svg"
  },
  {
    "name": "trash",
    "label": "Trash",
    "path": "trash.svg"
  },
  {
    "name": "trash-off",
    "label": "Trash Off",
    "path": "trash-off.svg"
  },
  {
    "name": "trash-x",
    "label": "Trash X",
    "path": "trash-x.svg"
  },
  {
    "name": "treadmill",
    "label": "Treadmill",
    "path": "treadmill.svg"
  },
  {
    "name": "tree",
    "label": "Tree",
    "path": "tree.svg"
  },
  {
    "name": "trees",
    "label": "Trees",
    "path": "trees.svg"
  },
  {
    "name": "trekking",
    "label": "Trekking",
    "path": "trekking.svg"
  },
  {
    "name": "trending-down",
    "label": "Trending Down",
    "path": "trending-down.svg"
  },
  {
    "name": "trending-down-2",
    "label": "Trending Down 2",
    "path": "trending-down-2.svg"
  },
  {
    "name": "trending-down-3",
    "label": "Trending Down 3",
    "path": "trending-down-3.svg"
  },
  {
    "name": "trending-up",
    "label": "Trending Up",
    "path": "trending-up.svg"
  },
  {
    "name": "trending-up-2",
    "label": "Trending Up 2",
    "path": "trending-up-2.svg"
  },
  {
    "name": "trending-up-3",
    "label": "Trending Up 3",
    "path": "trending-up-3.svg"
  },
  {
    "name": "triangle",
    "label": "Triangle",
    "path": "triangle.svg"
  },
  {
    "name": "triangle-inverted",
    "label": "Triangle Inverted",
    "path": "triangle-inverted.svg"
  },
  {
    "name": "triangle-minus",
    "label": "Triangle Minus",
    "path": "triangle-minus.svg"
  },
  {
    "name": "triangle-minus-2",
    "label": "Triangle Minus 2",
    "path": "triangle-minus-2.svg"
  },
  {
    "name": "triangle-off",
    "label": "Triangle Off",
    "path": "triangle-off.svg"
  },
  {
    "name": "triangle-plus",
    "label": "Triangle Plus",
    "path": "triangle-plus.svg"
  },
  {
    "name": "triangle-plus-2",
    "label": "Triangle Plus 2",
    "path": "triangle-plus-2.svg"
  },
  {
    "name": "triangle-square-circle",
    "label": "Triangle Square Circle",
    "path": "triangle-square-circle.svg"
  },
  {
    "name": "triangles",
    "label": "Triangles",
    "path": "triangles.svg"
  },
  {
    "name": "trident",
    "label": "Trident",
    "path": "trident.svg"
  },
  {
    "name": "trolley",
    "label": "Trolley",
    "path": "trolley.svg"
  },
  {
    "name": "trophy",
    "label": "Trophy",
    "path": "trophy.svg"
  },
  {
    "name": "trophy-off",
    "label": "Trophy Off",
    "path": "trophy-off.svg"
  },
  {
    "name": "trowel",
    "label": "Trowel",
    "path": "trowel.svg"
  },
  {
    "name": "truck",
    "label": "Truck",
    "path": "truck.svg"
  },
  {
    "name": "truck-delivery",
    "label": "Truck Delivery",
    "path": "truck-delivery.svg"
  },
  {
    "name": "truck-loading",
    "label": "Truck Loading",
    "path": "truck-loading.svg"
  },
  {
    "name": "truck-off",
    "label": "Truck Off",
    "path": "truck-off.svg"
  },
  {
    "name": "truck-return",
    "label": "Truck Return",
    "path": "truck-return.svg"
  },
  {
    "name": "txt",
    "label": "Txt",
    "path": "txt.svg"
  },
  {
    "name": "typeface",
    "label": "Typeface",
    "path": "typeface.svg"
  },
  {
    "name": "typography",
    "label": "Typography",
    "path": "typography.svg"
  },
  {
    "name": "typography-off",
    "label": "Typography Off",
    "path": "typography-off.svg"
  },
  {
    "name": "u-turn-left",
    "label": "U Turn Left",
    "path": "u-turn-left.svg"
  },
  {
    "name": "u-turn-right",
    "label": "U Turn Right",
    "path": "u-turn-right.svg"
  },
  {
    "name": "ufo",
    "label": "Ufo",
    "path": "ufo.svg"
  },
  {
    "name": "ufo-off",
    "label": "Ufo Off",
    "path": "ufo-off.svg"
  },
  {
    "name": "uhd",
    "label": "Uhd",
    "path": "uhd.svg"
  },
  {
    "name": "umbrella",
    "label": "Umbrella",
    "path": "umbrella.svg"
  },
  {
    "name": "umbrella-2",
    "label": "Umbrella 2",
    "path": "umbrella-2.svg"
  },
  {
    "name": "umbrella-closed",
    "label": "Umbrella Closed",
    "path": "umbrella-closed.svg"
  },
  {
    "name": "umbrella-closed-2",
    "label": "Umbrella Closed 2",
    "path": "umbrella-closed-2.svg"
  },
  {
    "name": "umbrella-off",
    "label": "Umbrella Off",
    "path": "umbrella-off.svg"
  },
  {
    "name": "underline",
    "label": "Underline",
    "path": "underline.svg"
  },
  {
    "name": "universe",
    "label": "Universe",
    "path": "universe.svg"
  },
  {
    "name": "unlink",
    "label": "Unlink",
    "path": "unlink.svg"
  },
  {
    "name": "upload",
    "label": "Upload",
    "path": "upload.svg"
  },
  {
    "name": "urgent",
    "label": "Urgent",
    "path": "urgent.svg"
  },
  {
    "name": "usb",
    "label": "Usb",
    "path": "usb.svg"
  },
  {
    "name": "user",
    "label": "User",
    "path": "user.svg"
  },
  {
    "name": "user-bitcoin",
    "label": "User Bitcoin",
    "path": "user-bitcoin.svg"
  },
  {
    "name": "user-bolt",
    "label": "User Bolt",
    "path": "user-bolt.svg"
  },
  {
    "name": "user-cancel",
    "label": "User Cancel",
    "path": "user-cancel.svg"
  },
  {
    "name": "user-check",
    "label": "User Check",
    "path": "user-check.svg"
  },
  {
    "name": "user-circle",
    "label": "User Circle",
    "path": "user-circle.svg"
  },
  {
    "name": "user-code",
    "label": "User Code",
    "path": "user-code.svg"
  },
  {
    "name": "user-cog",
    "label": "User Cog",
    "path": "user-cog.svg"
  },
  {
    "name": "user-dollar",
    "label": "User Dollar",
    "path": "user-dollar.svg"
  },
  {
    "name": "user-down",
    "label": "User Down",
    "path": "user-down.svg"
  },
  {
    "name": "user-edit",
    "label": "User Edit",
    "path": "user-edit.svg"
  },
  {
    "name": "user-exclamation",
    "label": "User Exclamation",
    "path": "user-exclamation.svg"
  },
  {
    "name": "user-heart",
    "label": "User Heart",
    "path": "user-heart.svg"
  },
  {
    "name": "user-hexagon",
    "label": "User Hexagon",
    "path": "user-hexagon.svg"
  },
  {
    "name": "user-minus",
    "label": "User Minus",
    "path": "user-minus.svg"
  },
  {
    "name": "user-off",
    "label": "User Off",
    "path": "user-off.svg"
  },
  {
    "name": "user-pause",
    "label": "User Pause",
    "path": "user-pause.svg"
  },
  {
    "name": "user-pentagon",
    "label": "User Pentagon",
    "path": "user-pentagon.svg"
  },
  {
    "name": "user-pin",
    "label": "User Pin",
    "path": "user-pin.svg"
  },
  {
    "name": "user-plus",
    "label": "User Plus",
    "path": "user-plus.svg"
  },
  {
    "name": "user-question",
    "label": "User Question",
    "path": "user-question.svg"
  },
  {
    "name": "user-scan",
    "label": "User Scan",
    "path": "user-scan.svg"
  },
  {
    "name": "user-screen",
    "label": "User Screen",
    "path": "user-screen.svg"
  },
  {
    "name": "user-search",
    "label": "User Search",
    "path": "user-search.svg"
  },
  {
    "name": "user-share",
    "label": "User Share",
    "path": "user-share.svg"
  },
  {
    "name": "user-shield",
    "label": "User Shield",
    "path": "user-shield.svg"
  },
  {
    "name": "user-square",
    "label": "User Square",
    "path": "user-square.svg"
  },
  {
    "name": "user-square-rounded",
    "label": "User Square Rounded",
    "path": "user-square-rounded.svg"
  },
  {
    "name": "user-star",
    "label": "User Star",
    "path": "user-star.svg"
  },
  {
    "name": "user-up",
    "label": "User Up",
    "path": "user-up.svg"
  },
  {
    "name": "user-x",
    "label": "User X",
    "path": "user-x.svg"
  },
  {
    "name": "users",
    "label": "Users",
    "path": "users.svg"
  },
  {
    "name": "users-group",
    "label": "Users Group",
    "path": "users-group.svg"
  },
  {
    "name": "users-minus",
    "label": "Users Minus",
    "path": "users-minus.svg"
  },
  {
    "name": "users-plus",
    "label": "Users Plus",
    "path": "users-plus.svg"
  },
  {
    "name": "uv-index",
    "label": "Uv Index",
    "path": "uv-index.svg"
  },
  {
    "name": "ux-circle",
    "label": "Ux Circle",
    "path": "ux-circle.svg"
  },
  {
    "name": "vaccine",
    "label": "Vaccine",
    "path": "vaccine.svg"
  },
  {
    "name": "vaccine-bottle",
    "label": "Vaccine Bottle",
    "path": "vaccine-bottle.svg"
  },
  {
    "name": "vaccine-bottle-off",
    "label": "Vaccine Bottle Off",
    "path": "vaccine-bottle-off.svg"
  },
  {
    "name": "vaccine-off",
    "label": "Vaccine Off",
    "path": "vaccine-off.svg"
  },
  {
    "name": "vacuum-cleaner",
    "label": "Vacuum Cleaner",
    "path": "vacuum-cleaner.svg"
  },
  {
    "name": "variable",
    "label": "Variable",
    "path": "variable.svg"
  },
  {
    "name": "variable-minus",
    "label": "Variable Minus",
    "path": "variable-minus.svg"
  },
  {
    "name": "variable-off",
    "label": "Variable Off",
    "path": "variable-off.svg"
  },
  {
    "name": "variable-plus",
    "label": "Variable Plus",
    "path": "variable-plus.svg"
  },
  {
    "name": "vector",
    "label": "Vector",
    "path": "vector.svg"
  },
  {
    "name": "vector-bezier",
    "label": "Vector Bezier",
    "path": "vector-bezier.svg"
  },
  {
    "name": "vector-bezier-2",
    "label": "Vector Bezier 2",
    "path": "vector-bezier-2.svg"
  },
  {
    "name": "vector-bezier-arc",
    "label": "Vector Bezier Arc",
    "path": "vector-bezier-arc.svg"
  },
  {
    "name": "vector-bezier-circle",
    "label": "Vector Bezier Circle",
    "path": "vector-bezier-circle.svg"
  },
  {
    "name": "vector-off",
    "label": "Vector Off",
    "path": "vector-off.svg"
  },
  {
    "name": "vector-spline",
    "label": "Vector Spline",
    "path": "vector-spline.svg"
  },
  {
    "name": "vector-triangle",
    "label": "Vector Triangle",
    "path": "vector-triangle.svg"
  },
  {
    "name": "vector-triangle-off",
    "label": "Vector Triangle Off",
    "path": "vector-triangle-off.svg"
  },
  {
    "name": "venus",
    "label": "Venus",
    "path": "venus.svg"
  },
  {
    "name": "versions",
    "label": "Versions",
    "path": "versions.svg"
  },
  {
    "name": "versions-off",
    "label": "Versions Off",
    "path": "versions-off.svg"
  },
  {
    "name": "video",
    "label": "Video",
    "path": "video.svg"
  },
  {
    "name": "video-minus",
    "label": "Video Minus",
    "path": "video-minus.svg"
  },
  {
    "name": "video-off",
    "label": "Video Off",
    "path": "video-off.svg"
  },
  {
    "name": "video-plus",
    "label": "Video Plus",
    "path": "video-plus.svg"
  },
  {
    "name": "view-360",
    "label": "View 360",
    "path": "view-360.svg"
  },
  {
    "name": "view-360-arrow",
    "label": "View 360 Arrow",
    "path": "view-360-arrow.svg"
  },
  {
    "name": "view-360-number",
    "label": "View 360 Number",
    "path": "view-360-number.svg"
  },
  {
    "name": "view-360-off",
    "label": "View 360 Off",
    "path": "view-360-off.svg"
  },
  {
    "name": "viewfinder",
    "label": "Viewfinder",
    "path": "viewfinder.svg"
  },
  {
    "name": "viewfinder-off",
    "label": "Viewfinder Off",
    "path": "viewfinder-off.svg"
  },
  {
    "name": "viewport-narrow",
    "label": "Viewport Narrow",
    "path": "viewport-narrow.svg"
  },
  {
    "name": "viewport-short",
    "label": "Viewport Short",
    "path": "viewport-short.svg"
  },
  {
    "name": "viewport-tall",
    "label": "Viewport Tall",
    "path": "viewport-tall.svg"
  },
  {
    "name": "viewport-wide",
    "label": "Viewport Wide",
    "path": "viewport-wide.svg"
  },
  {
    "name": "vinyl",
    "label": "Vinyl",
    "path": "vinyl.svg"
  },
  {
    "name": "vip",
    "label": "Vip",
    "path": "vip.svg"
  },
  {
    "name": "vip-off",
    "label": "Vip Off",
    "path": "vip-off.svg"
  },
  {
    "name": "virus",
    "label": "Virus",
    "path": "virus.svg"
  },
  {
    "name": "virus-off",
    "label": "Virus Off",
    "path": "virus-off.svg"
  },
  {
    "name": "virus-search",
    "label": "Virus Search",
    "path": "virus-search.svg"
  },
  {
    "name": "vocabulary",
    "label": "Vocabulary",
    "path": "vocabulary.svg"
  },
  {
    "name": "vocabulary-off",
    "label": "Vocabulary Off",
    "path": "vocabulary-off.svg"
  },
  {
    "name": "volcano",
    "label": "Volcano",
    "path": "volcano.svg"
  },
  {
    "name": "volume",
    "label": "Volume",
    "path": "volume.svg"
  },
  {
    "name": "volume-2",
    "label": "Volume 2",
    "path": "volume-2.svg"
  },
  {
    "name": "volume-3",
    "label": "Volume 3",
    "path": "volume-3.svg"
  },
  {
    "name": "volume-4",
    "label": "Volume 4",
    "path": "volume-4.svg"
  },
  {
    "name": "volume-off",
    "label": "Volume Off",
    "path": "volume-off.svg"
  },
  {
    "name": "vs",
    "label": "Vs",
    "path": "vs.svg"
  },
  {
    "name": "walk",
    "label": "Walk",
    "path": "walk.svg"
  },
  {
    "name": "wall",
    "label": "Wall",
    "path": "wall.svg"
  },
  {
    "name": "wall-off",
    "label": "Wall Off",
    "path": "wall-off.svg"
  },
  {
    "name": "wallet",
    "label": "Wallet",
    "path": "wallet.svg"
  },
  {
    "name": "wallet-off",
    "label": "Wallet Off",
    "path": "wallet-off.svg"
  },
  {
    "name": "wallpaper",
    "label": "Wallpaper",
    "path": "wallpaper.svg"
  },
  {
    "name": "wallpaper-off",
    "label": "Wallpaper Off",
    "path": "wallpaper-off.svg"
  },
  {
    "name": "wand",
    "label": "Wand",
    "path": "wand.svg"
  },
  {
    "name": "wand-off",
    "label": "Wand Off",
    "path": "wand-off.svg"
  },
  {
    "name": "wash",
    "label": "Wash",
    "path": "wash.svg"
  },
  {
    "name": "wash-dry",
    "label": "Wash Dry",
    "path": "wash-dry.svg"
  },
  {
    "name": "wash-dry-1",
    "label": "Wash Dry 1",
    "path": "wash-dry-1.svg"
  },
  {
    "name": "wash-dry-2",
    "label": "Wash Dry 2",
    "path": "wash-dry-2.svg"
  },
  {
    "name": "wash-dry-3",
    "label": "Wash Dry 3",
    "path": "wash-dry-3.svg"
  },
  {
    "name": "wash-dry-a",
    "label": "Wash Dry A",
    "path": "wash-dry-a.svg"
  },
  {
    "name": "wash-dry-dip",
    "label": "Wash Dry Dip",
    "path": "wash-dry-dip.svg"
  },
  {
    "name": "wash-dry-f",
    "label": "Wash Dry F",
    "path": "wash-dry-f.svg"
  },
  {
    "name": "wash-dry-flat",
    "label": "Wash Dry Flat",
    "path": "wash-dry-flat.svg"
  },
  {
    "name": "wash-dry-hang",
    "label": "Wash Dry Hang",
    "path": "wash-dry-hang.svg"
  },
  {
    "name": "wash-dry-off",
    "label": "Wash Dry Off",
    "path": "wash-dry-off.svg"
  },
  {
    "name": "wash-dry-p",
    "label": "Wash Dry P",
    "path": "wash-dry-p.svg"
  },
  {
    "name": "wash-dry-shade",
    "label": "Wash Dry Shade",
    "path": "wash-dry-shade.svg"
  },
  {
    "name": "wash-dry-w",
    "label": "Wash Dry W",
    "path": "wash-dry-w.svg"
  },
  {
    "name": "wash-dryclean",
    "label": "Wash Dryclean",
    "path": "wash-dryclean.svg"
  },
  {
    "name": "wash-dryclean-off",
    "label": "Wash Dryclean Off",
    "path": "wash-dryclean-off.svg"
  },
  {
    "name": "wash-eco",
    "label": "Wash Eco",
    "path": "wash-eco.svg"
  },
  {
    "name": "wash-gentle",
    "label": "Wash Gentle",
    "path": "wash-gentle.svg"
  },
  {
    "name": "wash-hand",
    "label": "Wash Hand",
    "path": "wash-hand.svg"
  },
  {
    "name": "wash-machine",
    "label": "Wash Machine",
    "path": "wash-machine.svg"
  },
  {
    "name": "wash-off",
    "label": "Wash Off",
    "path": "wash-off.svg"
  },
  {
    "name": "wash-press",
    "label": "Wash Press",
    "path": "wash-press.svg"
  },
  {
    "name": "wash-temperature-1",
    "label": "Wash Temperature 1",
    "path": "wash-temperature-1.svg"
  },
  {
    "name": "wash-temperature-2",
    "label": "Wash Temperature 2",
    "path": "wash-temperature-2.svg"
  },
  {
    "name": "wash-temperature-3",
    "label": "Wash Temperature 3",
    "path": "wash-temperature-3.svg"
  },
  {
    "name": "wash-temperature-4",
    "label": "Wash Temperature 4",
    "path": "wash-temperature-4.svg"
  },
  {
    "name": "wash-temperature-5",
    "label": "Wash Temperature 5",
    "path": "wash-temperature-5.svg"
  },
  {
    "name": "wash-temperature-6",
    "label": "Wash Temperature 6",
    "path": "wash-temperature-6.svg"
  },
  {
    "name": "wash-tumble-dry",
    "label": "Wash Tumble Dry",
    "path": "wash-tumble-dry.svg"
  },
  {
    "name": "wash-tumble-off",
    "label": "Wash Tumble Off",
    "path": "wash-tumble-off.svg"
  },
  {
    "name": "waterpolo",
    "label": "Waterpolo",
    "path": "waterpolo.svg"
  },
  {
    "name": "wave-saw-tool",
    "label": "Wave Saw Tool",
    "path": "wave-saw-tool.svg"
  },
  {
    "name": "wave-sine",
    "label": "Wave Sine",
    "path": "wave-sine.svg"
  },
  {
    "name": "wave-square",
    "label": "Wave Square",
    "path": "wave-square.svg"
  },
  {
    "name": "waves-electricity",
    "label": "Waves Electricity",
    "path": "waves-electricity.svg"
  },
  {
    "name": "webhook",
    "label": "Webhook",
    "path": "webhook.svg"
  },
  {
    "name": "webhook-off",
    "label": "Webhook Off",
    "path": "webhook-off.svg"
  },
  {
    "name": "weight",
    "label": "Weight",
    "path": "weight.svg"
  },
  {
    "name": "wheat",
    "label": "Wheat",
    "path": "wheat.svg"
  },
  {
    "name": "wheat-off",
    "label": "Wheat Off",
    "path": "wheat-off.svg"
  },
  {
    "name": "wheel",
    "label": "Wheel",
    "path": "wheel.svg"
  },
  {
    "name": "wheelchair",
    "label": "Wheelchair",
    "path": "wheelchair.svg"
  },
  {
    "name": "wheelchair-off",
    "label": "Wheelchair Off",
    "path": "wheelchair-off.svg"
  },
  {
    "name": "whirl",
    "label": "Whirl",
    "path": "whirl.svg"
  },
  {
    "name": "whisk",
    "label": "Whisk",
    "path": "whisk.svg"
  },
  {
    "name": "wifi",
    "label": "Wifi",
    "path": "wifi.svg"
  },
  {
    "name": "wifi-0",
    "label": "Wifi 0",
    "path": "wifi-0.svg"
  },
  {
    "name": "wifi-1",
    "label": "Wifi 1",
    "path": "wifi-1.svg"
  },
  {
    "name": "wifi-2",
    "label": "Wifi 2",
    "path": "wifi-2.svg"
  },
  {
    "name": "wifi-off",
    "label": "Wifi Off",
    "path": "wifi-off.svg"
  },
  {
    "name": "wind",
    "label": "Wind",
    "path": "wind.svg"
  },
  {
    "name": "wind-electricity",
    "label": "Wind Electricity",
    "path": "wind-electricity.svg"
  },
  {
    "name": "wind-off",
    "label": "Wind Off",
    "path": "wind-off.svg"
  },
  {
    "name": "windmill",
    "label": "Windmill",
    "path": "windmill.svg"
  },
  {
    "name": "windmill-off",
    "label": "Windmill Off",
    "path": "windmill-off.svg"
  },
  {
    "name": "window",
    "label": "Window",
    "path": "window.svg"
  },
  {
    "name": "window-maximize",
    "label": "Window Maximize",
    "path": "window-maximize.svg"
  },
  {
    "name": "window-minimize",
    "label": "Window Minimize",
    "path": "window-minimize.svg"
  },
  {
    "name": "window-off",
    "label": "Window Off",
    "path": "window-off.svg"
  },
  {
    "name": "windsock",
    "label": "Windsock",
    "path": "windsock.svg"
  },
  {
    "name": "wiper",
    "label": "Wiper",
    "path": "wiper.svg"
  },
  {
    "name": "wiper-wash",
    "label": "Wiper Wash",
    "path": "wiper-wash.svg"
  },
  {
    "name": "woman",
    "label": "Woman",
    "path": "woman.svg"
  },
  {
    "name": "wood",
    "label": "Wood",
    "path": "wood.svg"
  },
  {
    "name": "world",
    "label": "World",
    "path": "world.svg"
  },
  {
    "name": "world-bolt",
    "label": "World Bolt",
    "path": "world-bolt.svg"
  },
  {
    "name": "world-cancel",
    "label": "World Cancel",
    "path": "world-cancel.svg"
  },
  {
    "name": "world-check",
    "label": "World Check",
    "path": "world-check.svg"
  },
  {
    "name": "world-code",
    "label": "World Code",
    "path": "world-code.svg"
  },
  {
    "name": "world-cog",
    "label": "World Cog",
    "path": "world-cog.svg"
  },
  {
    "name": "world-dollar",
    "label": "World Dollar",
    "path": "world-dollar.svg"
  },
  {
    "name": "world-down",
    "label": "World Down",
    "path": "world-down.svg"
  },
  {
    "name": "world-download",
    "label": "World Download",
    "path": "world-download.svg"
  },
  {
    "name": "world-exclamation",
    "label": "World Exclamation",
    "path": "world-exclamation.svg"
  },
  {
    "name": "world-heart",
    "label": "World Heart",
    "path": "world-heart.svg"
  },
  {
    "name": "world-latitude",
    "label": "World Latitude",
    "path": "world-latitude.svg"
  },
  {
    "name": "world-longitude",
    "label": "World Longitude",
    "path": "world-longitude.svg"
  },
  {
    "name": "world-minus",
    "label": "World Minus",
    "path": "world-minus.svg"
  },
  {
    "name": "world-off",
    "label": "World Off",
    "path": "world-off.svg"
  },
  {
    "name": "world-pause",
    "label": "World Pause",
    "path": "world-pause.svg"
  },
  {
    "name": "world-pin",
    "label": "World Pin",
    "path": "world-pin.svg"
  },
  {
    "name": "world-plus",
    "label": "World Plus",
    "path": "world-plus.svg"
  },
  {
    "name": "world-question",
    "label": "World Question",
    "path": "world-question.svg"
  },
  {
    "name": "world-search",
    "label": "World Search",
    "path": "world-search.svg"
  },
  {
    "name": "world-share",
    "label": "World Share",
    "path": "world-share.svg"
  },
  {
    "name": "world-star",
    "label": "World Star",
    "path": "world-star.svg"
  },
  {
    "name": "world-up",
    "label": "World Up",
    "path": "world-up.svg"
  },
  {
    "name": "world-upload",
    "label": "World Upload",
    "path": "world-upload.svg"
  },
  {
    "name": "world-www",
    "label": "World Www",
    "path": "world-www.svg"
  },
  {
    "name": "world-x",
    "label": "World X",
    "path": "world-x.svg"
  },
  {
    "name": "wrecking-ball",
    "label": "Wrecking Ball",
    "path": "wrecking-ball.svg"
  },
  {
    "name": "writing",
    "label": "Writing",
    "path": "writing.svg"
  },
  {
    "name": "writing-off",
    "label": "Writing Off",
    "path": "writing-off.svg"
  },
  {
    "name": "writing-sign",
    "label": "Writing Sign",
    "path": "writing-sign.svg"
  },
  {
    "name": "writing-sign-off",
    "label": "Writing Sign Off",
    "path": "writing-sign-off.svg"
  },
  {
    "name": "x",
    "label": "X",
    "path": "x.svg"
  },
  {
    "name": "x-power-y",
    "label": "X Power Y",
    "path": "x-power-y.svg"
  },
  {
    "name": "xbox-a",
    "label": "Xbox A",
    "path": "xbox-a.svg"
  },
  {
    "name": "xbox-b",
    "label": "Xbox B",
    "path": "xbox-b.svg"
  },
  {
    "name": "xbox-x",
    "label": "Xbox X",
    "path": "xbox-x.svg"
  },
  {
    "name": "xbox-y",
    "label": "Xbox Y",
    "path": "xbox-y.svg"
  },
  {
    "name": "xd",
    "label": "Xd",
    "path": "xd.svg"
  },
  {
    "name": "xxx",
    "label": "Xxx",
    "path": "xxx.svg"
  },
  {
    "name": "yin-yang",
    "label": "Yin Yang",
    "path": "yin-yang.svg"
  },
  {
    "name": "yoga",
    "label": "Yoga",
    "path": "yoga.svg"
  },
  {
    "name": "zeppelin",
    "label": "Zeppelin",
    "path": "zeppelin.svg"
  },
  {
    "name": "zeppelin-off",
    "label": "Zeppelin Off",
    "path": "zeppelin-off.svg"
  },
  {
    "name": "zip",
    "label": "Zip",
    "path": "zip.svg"
  },
  {
    "name": "zodiac-aquarius",
    "label": "Zodiac Aquarius",
    "path": "zodiac-aquarius.svg"
  },
  {
    "name": "zodiac-aries",
    "label": "Zodiac Aries",
    "path": "zodiac-aries.svg"
  },
  {
    "name": "zodiac-cancer",
    "label": "Zodiac Cancer",
    "path": "zodiac-cancer.svg"
  },
  {
    "name": "zodiac-capricorn",
    "label": "Zodiac Capricorn",
    "path": "zodiac-capricorn.svg"
  },
  {
    "name": "zodiac-gemini",
    "label": "Zodiac Gemini",
    "path": "zodiac-gemini.svg"
  },
  {
    "name": "zodiac-leo",
    "label": "Zodiac Leo",
    "path": "zodiac-leo.svg"
  },
  {
    "name": "zodiac-libra",
    "label": "Zodiac Libra",
    "path": "zodiac-libra.svg"
  },
  {
    "name": "zodiac-pisces",
    "label": "Zodiac Pisces",
    "path": "zodiac-pisces.svg"
  },
  {
    "name": "zodiac-sagittarius",
    "label": "Zodiac Sagittarius",
    "path": "zodiac-sagittarius.svg"
  },
  {
    "name": "zodiac-scorpio",
    "label": "Zodiac Scorpio",
    "path": "zodiac-scorpio.svg"
  },
  {
    "name": "zodiac-taurus",
    "label": "Zodiac Taurus",
    "path": "zodiac-taurus.svg"
  },
  {
    "name": "zodiac-virgo",
    "label": "Zodiac Virgo",
    "path": "zodiac-virgo.svg"
  },
  {
    "name": "zoom",
    "label": "Zoom",
    "path": "zoom.svg"
  },
  {
    "name": "zoom-cancel",
    "label": "Zoom Cancel",
    "path": "zoom-cancel.svg"
  },
  {
    "name": "zoom-check",
    "label": "Zoom Check",
    "path": "zoom-check.svg"
  },
  {
    "name": "zoom-code",
    "label": "Zoom Code",
    "path": "zoom-code.svg"
  },
  {
    "name": "zoom-exclamation",
    "label": "Zoom Exclamation",
    "path": "zoom-exclamation.svg"
  },
  {
    "name": "zoom-in",
    "label": "Zoom In",
    "path": "zoom-in.svg"
  },
  {
    "name": "zoom-in-area",
    "label": "Zoom In Area",
    "path": "zoom-in-area.svg"
  },
  {
    "name": "zoom-money",
    "label": "Zoom Money",
    "path": "zoom-money.svg"
  },
  {
    "name": "zoom-out",
    "label": "Zoom Out",
    "path": "zoom-out.svg"
  },
  {
    "name": "zoom-out-area",
    "label": "Zoom Out Area",
    "path": "zoom-out-area.svg"
  },
  {
    "name": "zoom-pan",
    "label": "Zoom Pan",
    "path": "zoom-pan.svg"
  },
  {
    "name": "zoom-question",
    "label": "Zoom Question",
    "path": "zoom-question.svg"
  },
  {
    "name": "zoom-replace",
    "label": "Zoom Replace",
    "path": "zoom-replace.svg"
  },
  {
    "name": "zoom-reset",
    "label": "Zoom Reset",
    "path": "zoom-reset.svg"
  },
  {
    "name": "zoom-scan",
    "label": "Zoom Scan",
    "path": "zoom-scan.svg"
  },
  {
    "name": "zzz",
    "label": "Zzz",
    "path": "zzz.svg"
  },
  {
    "name": "zzz-off",
    "label": "Zzz Off",
    "path": "zzz-off.svg"
  }
];

export const getIconPath = (iconName, style = ICON_STYLES.OUTLINE) => {
    return `/icons/${style}/${iconName}.svg`;
};

export const searchIcons = (searchTerm, style = ICON_STYLES.OUTLINE) => {
    const icons = style === ICON_STYLES.FILLED ? FILLED_ICONS : OUTLINE_ICONS;
    if (!searchTerm) return icons;

    const term = searchTerm.toLowerCase();
    return icons.filter(icon =>
        icon.name.toLowerCase().includes(term) ||
        icon.label.toLowerCase().includes(term)
    );
};
